import React, { Component } from "react";
import { Redirect, Link } from "react-router-dom";
import $ from "jquery";
import { Multiselect } from "multiselect-react-dropdown";
import Accordion from "react-bootstrap/Accordion";
import { Select } from "antd";

import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Card,
  Modal,
  Alert,
  Tab,
  Tabs,
  Spinner,
  OverlayTrigger,
  Tooltip,
  Dropdown,
  Image,
  Table,
  ListGroup,
} from "react-bootstrap";
import {
  FaPlus,
  FaSave,
  FaArrowLeft,
  FaRegTrashAlt,
  FaAngleDown,
  FaInfo,
  FaInfoCircle,
  FaRegCheckCircle,
  FaDownload,
  FaFileContract,
  FaBriefcaseMedical,
  FaEye,
  FaTrashAlt,
  FaQuestionCircle,
  FaEllipsisV,
  FaUser,
  FaFilePdf,
  FaFileAlt,
  FaTrash,
  FaCloudUploadAlt,
} from "react-icons/fa";
import "react-dropdown-tree-select/dist/styles.css";

import DropdownTreeSelect from "./DropdownContainer";
import NewReport from "./NewReport";
import AntiemeticTreatmentOption from "./AntiemeticTreatmentOption";
import CasePreview from "./CasePreview";
import ErrorAlert from "./ErrorAlert";
import Loader from "./LoaderModal";
import Side from "./Sidebar";
import Top from "./Topbar";
import Crypt from "../lib/Crypt";
import Constants from "../lib/Constants";
import { DatePicker } from "antd";
import "antd/dist/antd.css";
import moment from "moment";
import C from "../lib/Config";
import {
  classifySaveUserCaseResponse,
  SaveOutcome,
} from "../lib/SaveUserCaseResponse";
import {
  startDiagnosisExtraction,
  startPathologyExtraction,
  ExtractionOutcome,
} from "../lib/ClinicalExtraction";
import AssessFNRisk from "./AssessFNRisk";
import TerminateProtocol from "./TerminateProtocol";
import TreatmentList from "./TreatmentList";
import FollowupList from "./FollowupList";
import ChemoList from "./ChemoList";
import MultipleChemoPopup from "./MultipleChemoPopup";
import NewTreatmentPlan from "./NewTreatmentPlan";
import ProtocolSelectionPopup from "./ProtocolSelectionPopup";
import MultipleTreatmentPopup from "./MultipleTreatmentPopup";
import SkippedCyclesPopup from "./SkippedCyclesPopup";
import PatientWeightChart from "./PatientWeightChart";
import VideoConsent from "./VideoConsent";
import DiagnosisManagement from "./DiagnosisManagement";
import swal from "sweetalert";
import OPVisitManagement from "./OPVisit";
import CurrentDischargeSummary from "./CurrentDischargeSummary";
// import InvestigationReport from "./InvestigationReport";

const dateFormat = "DD/MM/yyyy";
const dateFormat1 = "YYYY/MM/DD";
const premedicationOptions = [
  { label: "Avil (Pheniramine)", value: "Avil (Pheniramine)" },
  { label: "Diphenhydramine (Benadryl)", value: "Diphenhydramine (Benadryl)" },
  { label: "Dexamethasone", value: "Dexamethasone" },
  { label: "Other (please specify)", value: "Other" },
];
const supplementOptions = [
  { label: "Multivitamins", value: "Multivitamins" },
  { label: "Vitamin D", value: "Vitamin D" },
  { label: "Fish Oil (Omega-3 Fatty Acids)", value: "Fish Oil(Omega-3 Fatty Acids)" },
  { label: "Glutamine", value: "Glutamine" },
  { label: "Probiotics", value: "Probiotics" },
  { label: "Curcumin (Turmeric)", value: "Curcumin (Turmeric)" },
  { label: "Zinc", value: "Zinc" },
  { label: "Vitamin C", value: "Vitamin C" },
  { label: "Coenzyme Q10 (CoQ10)", value: "Coenzyme Q10 (CoQ10)" },
  { label: "B-Complex Vitamins", value: "B-Complex Vitamins" },
  { label: "Magnesium", value: "Magnesium" },
  { label: "L-Carnitine", value: "L-Carnitine" },
  { label: "Other (please specify)", value: "Other" },
];

const { Option } = Select;

const customStyles = `
/* CustomValidation.css */
.medication-select-container {
    position: relative;
    margin-bottom: 1rem;
}

.has-validation-message .searchWrapper {
    /* Remove the red outline but keep other styles */
    border-color: #ced4da !important;  /* Use default border color */
    box-shadow: none !important;
}

.validation-message {
    color: #dc3545;
    font-size: 0.875rem;
    margin-top: 0.25rem;
    position: absolute;
    width: 100%;
}

/* Override any Bootstrap validation styles */
.form-control.is-invalid,
.was-validated .form-control:invalid {
    border-color: #ced4da !important;
    background-image: none !important;
    box-shadow: none !important;
}

/* Remove red outline on focus */
.has-validation-message .searchWrapper:focus-within {
    border-color: #86b7fe !important;
    box-shadow: 0 0 0 0.25rem rgba(13, 110, 253, 0.25) !important;
}
`;
export default class PatientProfile extends Component {
  constructor(props) {
    super(props);

    this.treatmentPlanChild = React.createRef();
    this.chemoNewButtonChild = React.createRef();
    this.skippedCyclesChild = React.createRef();
    this.anteiemeticMedChild = React.createRef();
    this.fileInputRef = React.createRef();
    this.diagnosisManagementRef = React.createRef();
    this.followupSnapshot = null;

    this.handlePostDischargeChange = this.handlePostDischargeChange.bind(this);
    this.handlePostDischargeDurationUnitSelect =
      this.handlePostDischargeDurationUnitSelect.bind(this);
    this.removePostDischargeRow = this.removePostDischargeRow.bind(this);
    this.handleAddPostDischargeRow = this.handleAddPostDischargeRow.bind(this);
    this.isPostDischargeRowFilled = this.isPostDischargeRowFilled.bind(this);
    this.handleSavePostDischargeMedsClick =
      this.handleSavePostDischargeMedsClick.bind(this);
    this.getAllPostDischargeMedicines =
      this.getAllPostDischargeMedicines.bind(this);
    this.deletePatientPostDischargeMedicine =
      this.deletePatientPostDischargeMedicine.bind(this);
    this.validatePostDischargeMedRows =
      this.validatePostDischargeMedRows.bind(this);
    // Add bindings for new methods
    this.handlePrescriptionChange = this.handlePrescriptionChange.bind(this);
    this.handlePrescriptionDurationUnitSelect =
      this.handlePrescriptionDurationUnitSelect.bind(this);
    this.removePrescriptionRow = this.removePrescriptionRow.bind(this);
    this.handleAddPrescriptionRow = this.handleAddPrescriptionRow.bind(this);
    this.isPrescriptionRowFilled = this.isPrescriptionRowFilled.bind(this);
    this.handleSaveMedicinesClick = this.handleSaveMedicinesClick.bind(this);
    this.getAllMedicines = this.getAllMedicines.bind(this);
    this.getAllDoses = this.getAllDoses.bind(this);
    this.getAllWhens = this.getAllWhens.bind(this);
    this.saveDose = this.saveDose.bind(this);
    this.saveWhen = this.saveWhen.bind(this);
    this.deletePatientMedicine = this.deletePatientMedicine.bind(this);
    this.validatePrescriptionRows = this.validatePrescriptionRows.bind(this);
    this.state = {
      selectedMedicinesTextMap: {},
      ...this.state,
      postDischargeMedDetails: [
        {
          medicine: null,
          dose: "",
          when: "",
          durationValue: "",
          durationUnit: "Days",
          instructions: "",
          isSaved: false,
        },
      ],
      postDischargeMedErrors: [],
      postDischargeMedArr: [],
      newPostMedInput: {}, // For handling new medicine input
      openPostMedDropdownIndex: -1,
      openPostDischargeDoseIndex: -1,
      openPostDischargeWhenIndex: -1,
      medicinesArr: [], // Ensure this is an empty array
      dosesArr: [],
      whensArr: [],
      antiemeticRegimensMstArr: [],
      antiemeticTreatmentMstArr: [],
      suggestiveTreatementArr: [],
      patTreatmentPlanSummary: [],
      patInactiveTreatmentPlan: [],
      vitalErrors: {},
      medicationErrors: [],
      medicationDetails: [
        {
          // Initialize with one empty row
          medicine: null,
          dose: "",
          when: "",
          duration: "",
          instructions: "",
        },
      ],
      referralErrors: {
        referralSource: "",
        referralDoctorName: "",
        referralHospital: "",
      },
      idProofTypeArr: [
    'Select ID Proof Type', 
    'Aadhaar Card', 
    'PAN Card', 
    'Passport', 
    'Driving License', 
    'Voter ID'
  ],
      idProofType: "",
  idProofNumber: "",
  telphoneNo: "",
  patientType: "",
  referralDoctorName:"",
  referralHospital:"",
  emergencyContactPerson: "",
  emergencyMobileNumber: "",
  primaryConsultant: "",
      date: null,
      uploadProgress: {},
      documents: [],
      prescriptionFiles: [],
      isDragging: false,
      showPrescriptionModal: false,
      prescriptionType: "",
      prescriptionTypeId: "",
      prescriptionTypeError: "",
      prescriptionFileError: "",
      prescriptionPendingFiles: [],
      documentTypeOptions: [],
      documentTypesLoaded: false,
      scanReports: false,
      scanReportsLoading: false,
      scanReportsMsg: null,
      scanReportsMsgIsError: false,
      medicinesArr: [],
      selectedMedicine: null,
      patientMedicines: [],
      pulse: "",
      temperature: "",
      bpSystolic: "",
      bpDiastolic: "",
      spO2: "",
      bloodGlucose: "",
      glucoseTestType: "",
      bsa: "",
      bmi: "",
      isAllergiesSelected: false,
      otherAllergies: "",
      isCommorbitiesSelected: false,
      patTreatmentPlanSummary: [],
      patInactiveTreatmentPlan: [],
      context: this,
      redirectCasePage: false,
      caseStatus: "",
      canCreateTreatmentPlan: false,
      diagnosisDate: '',
      diagnosisPrimarySite: '',
      // [{ siteId, siteName, leadSite }] for the latest diagnosis — the input
      // to the protocol picker. Only handleDiagnosisLoaded populates it.
      diagnosisPrimarySites: [],
      // Set by the protocol picker when the user confirms, and read by
      // NewTreatmentPlan as props.
      preselectedProtocol: null,
      protocolFilterSiteIds: '',
      prefetchedProtocols: null,
      tickerMessage: '',
      isCycleDelay: false,
      cancerSiteArr: [],
      protocolArr: [],
      scheduleMstArr: [],
      patientId: "",
      registrationDate: "",
      caseNo: "",
      firstName: "",
      middleName: "",
      lastName: "",
      emailId: "",
      dob: "",
      patientAge: "",
      genderName: "",
      country: { countryId: null, countryCode: "", countryName: "" },
      phoneNumber1: "",
      doctorId: "",
      doctorName: "",
      instituteDto: { instituteId: null, instituteName: "" },
      height: "",
      heightUnit: 'cm',
      weight: "",
      weightUnit: "",
      weightUnitId: "",
      weightShow: "",
      patientComorbidities: "",
      patientAllergies: "",
      allAllergies: "",
      allergies: "",
      anyOngoingTreatment: "",
      otherOngoingTreatment: "",
      isOngoingTreatmentSelected: false,
      canSiteIdIAD: "",
      canSiteNameIAD: [],
      prevCanSiteIdIAD: "",
      prevCanSiteNameIAD: [],
      pathologyIdIAD: "",
      pathologyIAD: [],
      limbLossIdIAD: "",
      limbLossNameIAD: [],
      mutationIdIA: "",
      mutationNameIA: [],
      patientIniAssessmentDt: this.formatDateMMMDDYYY(new Date()),
      patientIniAssessmentId: "",
      doctorObservation: "",
      pathology: "",
      doctorPrescription: "",
      patTreatPlanIdTmt: "",
      regProtocolIdTmt: "",
      regProtocolNameTmt: "",
      fnRiskTmt: "",
      antiemeticRiskLevel: "",
      scheduleIdTmt: "",
      scheduleNameTmt: "",
      scheduleDaysTmt: "",
      creationDateTmt: this.formatDateMMMDDYYY(new Date()),
      modifiedDateTmt: this.formatDateDDMMYYYY(new Date()),
      onGoingTreatment: "",
      intentTmt: "",
      intentSummary: "",
      treatmentPlanTmt: "",
      additionalConditions: "",
      waiverComments: "",
      consentReceived: "",
      assesFNRiskFlag: "N",
      gcsfMedicinePC: "",
      chemoPhaseRegimenTmt: "",
      cyclesPlannedTmt: "",
      chemoStartDtTmt: "",
      patChemoSittingIdPC: "",
      chemoScheduleIdPC: null,
      followupAppointmentIdPC: null,
      cascadeChangePC: "",
      chemoCycleNumberPC: "",
      treatmentDayNumberPC: "",
      chemoDtPC: "",
      chemoPlannedDtPC: "",
      delayPC: "",
      delayCommentsPC: "",
      reasonForChemoDtChangePC: "",
      treatmentGivenPC: "",
      chemoGivenPC: false,
      updatedDatePC: "",
      createdByIdUserPC: "",
      upcomingChemoCycleNum: "",
      upcomingChemoDt: "",
      lastChemoCycleNumber: "",
      lastChemoCycleDate: "",
      appointmentId: "",
      creationDateFP: "",
      observe: "",
      prescription: "",
      generatedScheduledArr: [],
      waiverConsent: false,
      showHideDemo1: false,
      showHideGenerateButton: false,
      previewModal: false,
      canSitesArr: [],
      prevCanSitesArr: [],
      limbLossArr: [],
      mutationArr: [],
      initialAssesmentErrors: [],
      treatmentPlanErrors: [],
      patChemoSittingErrors: [],
      alertModalshow: false,
      treatmentPlanshow: false,
      followupshow: false,
      newApptStarted: false,
      chemoshow: false,
      saveLoader: false,
      loaderModal: false,
      reportModal: false,
      reportMode: null,
      showConsent: false,
      showAssessFNRisk: false,
      showNewTreatment: false,
      showTreatmentPlanConfirm: false,
      showTerminateProtocol: false,
      terminateTreatmentPlanId: "",
      showMultipleTreatmentPopup: false,
      showSkippedCyclesPopup: false,
      showMultipleChemoPopup: false,
      showTreatmentList: false,
      selectedApptReportData: null,
      followupErrors: [],
      appointmentReports: [],
      patientChemoSittingDosageList: [],
      suggestiveTreatementArr: [],
      buttonEnabled: true,
      pathology: "",
      pathologyMstArr: [],
      cancerStage: "",
      cancerStageMstArr: [],
      alertDismissibleshow: false,
      khoronaScore: "",
      auc: "",
      followupAdverseEffectIdIAD: "",
      selectedAdverseEffectDesc: "",
      savedAdverseEffectDesc: "",
      isChemoTreatmentRecommended: "",
      errorMsgChemoTreatRecommend: "",
      errorMsgAdverseChemoTermination: "",
      creatineClearance: "",
      creatinineWarning: "",
      boneMetasis: "",
      brainMets: "",
      isHospitalStaff: false,
      doctorLoggedIn: false,
      errorAlertshow: false,
      errorAlertclose: false,
      antiemeticRisks: "",
      boneMetasisDrug: "",
      antithromboticDrugs: "",
      postChemoDrugs: "",
      nurseInstructions: "",
      patientInstructions: "",
      pharmacyInstructions: "",
      premedications: "",
      supplements: "",
      antiallergicDrugs: "",
      warningMsgConsent: "",
      consentAttachmentName: "",
      consentAttachmentData: "",
      isCurrentTreatmentTerminated: "",
      key: "summary",
      initAssessmentInnerKey: "diagnosis",
      //terminatedTreatments:[],
      followupAdverseEffectArr: [],
      showFollowupList: false,
      showChemoList: false,
      patAllChemoSittings: [],
      followupReports: [],
      cascadeTreatPlanIds: [],
      dosageFrequency: "",
      treatmentPlanIdTmt: "",
      showAntimetic: false,
      showAntithrombotic: false,
      showGCSF: false,
      showBoneModification: false,
      otherComorbidities: "",
      antiemeticRegimensMstArr: [],
      antiemeticRegimensId: "",
      antiemeticTreatmentMstArr: [],
      tempRegProtocolId: this.props.protocolId,
      showOptionOne: false,
      showOptionTwo: false,
      showOptionThree: false,
      showOptionFour: false,
      showOptionFive: false,
      showOptionSix: false,
      checkOlanzapine510Checkbox: false,
      dexmaetha12Checkbox: false,
      apr125: false,
      apr130: false,
      fosap150: false,
      netuo300: false,
      fosap235: false,
      rolap180: false,
      dolasetronOptTwo: false,
      granisetronOptTwo: false,
      ondansetronOptTwo: false,
      palonosetronOptTwo: false,
      olanzapine510: false,
      pal025: false,
      dex12: false,
      aprDay125: false,
      aprDay130: false,
      fosaDay150: false,
      netupDay300: false,
      fosneDay235: false,
      rDay180: false,
      dolasDay100: false,
      palDay25: false,
      ondanDay: false,
      graniDay10: false,
      patch: false,
      dexamDay12: false,
      olanDayTwo: false,
      apreDayTwo: false,
      dexaDayTwo: false,
      olanzapineDayTwo: false,
      aprep80DayTwo: false,
      dexam8DayTwo: false,
      // emr
      protocolTitle: "",
      chemotherapyDoseAndMethodOfAdministration: "",
      antiemeticRisk: "",
      fnRisk: "",
      nextVisitInstructions: "",
      drugInteractions: "",
      showNewTreatmentPlan: false, // State to manage the display of NewTreatmentPlan
      isConsentProvided: {},
      isPhysicalConsent: {},
      isVideoConsent: {},
      currentCardId: null,
      allergyOptions: [],
      selectedAllergies: [],
      comorbidityOptions: [],
      comorbiditiesArr: [],
      selectedComorbidities: [],
      allergiesArr: [],
      doctorId: "",
      genderArr: [],
      genderMstDto: { genderId: null },
      showVideoConsent: false,
      dob: props.initialDob || "",
      isEditing: false,
      weight: props.initialWeight || "",
      isEditingHeight: false,
      allergyOptions: [],
      selectedAllergies: [],
      comorbidityOptions: [],
      comorbiditiesArr: [],
      selectedComorbidities: [],
      allergiesArr: [],
      doctorId: "",
      genderArr: [],
      genderMstDto: { genderId: null },
      dob: props.initialDob || "",
      isEditing: false,
      weight: props.initialWeight || "",
      isEditingHeight: false,
      anyOngoingTreatmentArr: [
        { name: "Yes", id: 1 },
        { name: "No", id: 2 },
        { name: "Not applicable", id: 3 },
        { name: "Prescribed but not taking", id: 4 },
      ],
      anyOngoingTreatment: null,
    
 bloodGroup: null,
  bloodGroupArr: [
    { name: "Select Blood Group", id: "DEFAULT" },
    { name: "A+", id: "A+" },
    { name: "A-", id: "A-" },
    { name: "B+", id: "B+" },
    { name: "B-", id: "B-" },
    { name: "O+", id: "O+" },
    { name: "O-", id: "O-" },
    { name: "AB+", id: "AB+" },
    { name: "AB-", id: "AB-" },
    { name: "Not known", id: "Not known" }
  ],
      disableForDexamethasone: false,
      premedicationOther: "",
      supplementOther: "",
      patientProfilePictureData: "",
      profilePictureName1: "",
      profilePictureData1: "",
      referralSource: null,
      referralSourceArr: [
        { name: "Self", id: 1 },
        { name: "Google", id: 2 },
        { name: "Social Media", id: 3 },
        { name: "Word of mouth", id: 4 },
        { name: "Hospital", id: 5 },
        { name: "Physician/Doctor", id: 6 },
      ],
      isReferralDoctorSelected: false,
      isReferralHospitalSelected: false,
      referralDoctorName: "",
      referralHospital: "",
      patientRegErrors: {},
      showNewTreatmentPlan: false,
      medicineDetails: [],
      selectedMedicines: [],
      status: "",
      selectedSuggestiveMedicines: [],
      selectedMedicineDetails: [],
      stagingDetails: [
        {
          type: "",
          t: "",
          n: "",
          m: "",
          stage: "",
          date: null,
          isSaved: false,
        },
      ],
      stagingErrors: [],
      stageOptions: ["Stage 1", "Stage 2", "Stage 3", "Stage 4"],
      isRestrictedFieldsVisible: false,
      restrictedStagingDetails: [
        {
          cancerName: "",
          cancerType: "",
          t: "",
          n: "",
          m: "",
          g: "",
          location: "",
          stageGroup: "",
          isSaved: false,
        },
      ],
      restrictedStagingErrors: [],
      registrationTime: "",
      chemoStatus: "",
      chemoStatusOptions: [
        { id: 1, name: "Ongoing" },
        { id: 2, name: "Finished" },
      ],
      statusOptions: [
        { id: 1, name: "Active" },
        { id: 2, name: "Inactive" },
        { id: 3, name: "On Hold" },
        { id: 4, name: "Completed" },
        { id: 5, name: "Default" },
      ],
      dischargeDate: null,
      isEditingDischargeDate: false,
    };
    this.handlePrescriptionChange = this.handlePrescriptionChange.bind(this);
    this.handlePrescriptionDurationUnitSelect =
      this.handlePrescriptionDurationUnitSelect.bind(this);
    this.removePrescriptionRow = this.removePrescriptionRow.bind(this);
    this.handleAddPrescriptionRow = this.handleAddPrescriptionRow.bind(this);
    this.isPrescriptionRowFilled = this.isPrescriptionRowFilled.bind(this);
    this.handleSaveMedicinesClick = this.handleSaveMedicinesClick.bind(this);
    this.loadPrevious = this.loadPrevious.bind(this);
    this.saveDose = this.saveDose.bind(this);
    this.saveWhen = this.saveWhen.bind(this);
    this.deletePatientMedicine = this.deletePatientMedicine.bind(this);
    this.getAllDoses = this.getAllDoses.bind(this);
    this.getAllWhens = this.getAllWhens.bind(this);
    this.toggleDischargeDate = this.toggleDischargeDate.bind(this);
    this.setDischargeDate = this.setDischargeDate.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.saveCaseSummary = this.saveCaseSummary.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.profilePicHandler = this.profilePicHandler.bind(this);
    this.fileReaderHandler = this.fileReaderHandler.bind(this);
    this.fetchMedicineDetails = this.fetchMedicineDetails.bind(this); //newly added
    this.handleChangeCheckOlanzapine510 =
      this.handleChangeCheckOlanzapine510.bind(this);
    this.handleChangeDexmaetha12 = this.handleChangeDexmaetha12.bind(this);
    this.handleChangeApr125 = this.handleChangeApr125.bind(this);
    this.handleChangeApr130 = this.handleChangeApr130.bind(this);
    this.handleChangeFosap150 = this.handleChangeFosap150.bind(this);
    this.handleChangeNetuo300 = this.handleChangeNetuo300.bind(this);
    this.handleChangeFosap235 = this.handleChangeFosap235.bind(this);
    this.handleChangeRolap180 = this.handleChangeRolap180.bind(this);
    this.handleChangeDolasetronOptTwo =
      this.handleChangeDolasetronOptTwo.bind(this);
    this.handleChangeGranisetronOptTwo =
      this.handleChangeGranisetronOptTwo.bind(this);
    this.handleChangeOndansetronOptTwo =
      this.handleChangeOndansetronOptTwo.bind(this);
    this.handleChangePalonosetronOptTwo =
      this.handleChangePalonosetronOptTwo.bind(this);
    this.handleChangeOlanzapine510 = this.handleChangeOlanzapine510.bind(this);
    this.handleChangePal025 = this.handleChangePal025.bind(this);
    this.handleChangeDex12 = this.handleChangeDex12.bind(this);
    this.handleChangeAprDay125 = this.handleChangeAprDay125.bind(this);
    this.handleChangeAprDay130 = this.handleChangeAprDay130.bind(this);
    this.handleChangeFosaDay150 = this.handleChangeFosaDay150.bind(this);
    this.handleChangeNetupDay300 = this.handleChangeNetupDay300.bind(this);
    this.handleChangeFosneDay235 = this.handleChangeFosneDay235.bind(this);
    this.handleChangeRday180 = this.handleChangeRday180.bind(this);
    this.handleChangeDolasDay100 = this.handleChangeDolasDay100.bind(this);
    this.handleChangePalDay25 = this.handleChangePalDay25.bind(this);
    this.handleChangeOndanDay = this.handleChangeOndanDay.bind(this);
    this.handleChangeGraniDay10 = this.handleChangeGraniDay10.bind(this);
    this.handleChangePatch = this.handleChangePatch.bind(this);
    this.handleChangeDexamDay12 = this.handleChangeDexamDay12.bind(this);
    this.handleChangeOlanDayTwo = this.handleChangeOlanDayTwo.bind(this);
    this.handleChangeApreDayTwo = this.handleChangeApreDayTwo.bind(this);
    this.handleChangeDexaDayTwo = this.handleChangeDexaDayTwo.bind(this);
    this.handleChangeOlanzapineDayTwo =
      this.handleChangeOlanzapineDayTwo.bind(this);
    this.handleChangeAprep80DayTwo = this.handleChangeAprep80DayTwo.bind(this);
    this.handleChangeDexam8DayTwo = this.handleChangeDexam8DayTwo.bind(this);
    this.handleChemoSittingChange = this.handleChemoSittingChange.bind(this);
  }
  // reload = () => {
  //     //RELOAD COMPONENT
  //     this.componentDidMount();
  // };

  // Method to handle changes in prescription row inputs
  handlePrescriptionChange = (index, field, value) => {
    const updatedDetails = [...this.state.medicationDetails];

    if (field === "medicine") {
      // Find the medicine in the array
      const selectedMedicine = this.state.medicinesArr.find(
        (m) => m.name === value
      );
      if (selectedMedicine) {
        updatedDetails[index].medicine = selectedMedicine;
      }
    } else {
      updatedDetails[index][field] = value;
    }

    // Clear validation errors for this field
    const updatedErrors = [...this.state.medicationErrors];
    if (updatedErrors[index]) {
      updatedErrors[index] = {
        ...updatedErrors[index],
        [field]: "",
      };
    }

    this.setState({
      medicationDetails: updatedDetails,
      medicationErrors: updatedErrors,
    });
  };


  // Add this method to handle ID Proof Type changes
handleIdProofTypeChange = (event) => {
  const selectedValue = event.target.value;
  this.setState({ 
    idProofType: selectedValue === "Select ID Proof Type" ? "" : selectedValue 
  });
};
  // Add these methods to your PatientProfile component

// Fix the getPatientAdditionalInfo method
getPatientAdditionalInfo = async (patientId = null) => {
  try {
    // Use provided patientId, or get from localStorage, or fallback to state
    const finalPatientId = patientId || localStorage.getItem("PatientpatientId") || this.state.patientId;
    
    if (!finalPatientId) {
      return;
    }

    const response = await fetch(
      `${C.getUrl()}/userCase/patient/additional-info?patientId=${finalPatientId}`
    );
    const data = await response.json();
    
    
    // BACKEND ISSUE DETECTED: data field contains Java object reference instead of JSON
    if (typeof data.data === 'object' && String(data.data).includes('@')) {
    }
    
    if (response.ok && data) {
      let additionalInfo = {};
      
      // Try to find data in various possible locations
      if (data.data && typeof data.data === 'object' && !String(data.data).includes('@')) {
        additionalInfo = data.data;
      } else if (data.message && typeof data.message === 'string') {
        // Check if message looks like JSON before parsing
        if (data.message.startsWith('{') || data.message.startsWith('[')) {
          try {
            additionalInfo = JSON.parse(data.message);
          } catch (parseError) {
            additionalInfo = {};
          }
        }
      }
      
      
      this.setState({
        idProofType: additionalInfo.idProofType || "",
        idProofNumber: additionalInfo.idProofNumber || "",
        patientType : additionalInfo.patientType || "",
        telphoneNo: additionalInfo.telphoneNo || "",
        referralHospital:additionalInfo.referralHospital||"",
        referralDoctorName:additionalInfo.referralDoctorName||"",
        emergencyContactPerson: additionalInfo.emergencyContactPerson || "",
        emergencyMobileNumber: additionalInfo.emergencyMobileNumber || "",
        primaryConsultant: additionalInfo.primaryConsultant || "",
        // Update profile picture if available
        patientProfilePictureData: additionalInfo.profilePictureData || this.state.patientProfilePictureData,
      });
    }
  } catch (error) {
  }
};

// Helper method to handle the response from additional info API
handleAdditionalInfoResponse = (data) => {
  
  if (data && data.statusCode === 200) {
    // Handle case where data is in message field as JSON string
    let additionalInfo = data;
    if (data.message && typeof data.message === 'string') {
      try {
        additionalInfo = JSON.parse(data.message);
      } catch (parseError) {
        additionalInfo = data;
      }
    }
    
    // Update state with the fetched data
    this.setState({
      idProofType: additionalInfo.idProofType || "",
      idProofNumber: additionalInfo.idProofNumber || "",
      patientType : additionalInfo.patientType || "",
      telphoneNo: additionalInfo.telphoneNo || "",
      referralDoctorName:additionalInfo.referralDoctorName||"",
      referralHospital:additionalInfo.referralHospital||"",
      emergencyContactPerson: additionalInfo.emergencyContactPerson || "",
      emergencyMobileNumber: additionalInfo.emergencyMobileNumber || "",
      primaryConsultant: additionalInfo.primaryConsultant || "",
      // Update profile picture if available
      patientProfilePictureData: additionalInfo.profilePictureData || this.state.patientProfilePictureData,
    });
  }
};

// Updated method to handle additional info update properly
updatePatientAdditionalInfo = async () => {
  try {
    // Get patient ID from localStorage first, then fallback to state
    const patientId = localStorage.getItem("PatientpatientId") || this.state.patientId;
    
    if (!patientId) {
      throw new Error("Patient ID is required");
    }

    // Create payload that matches what backend expects
    // Based on the API response, these are the fields the backend can handle
    const payload = {
      idProofType: this.state.idProofType || "",
      idProofNumber: this.state.idProofNumber || "",
      patientType:this.state.patientType || "",
      telphoneNo: this.state.telphoneNo || "",
      referralHospital:this.state.referralHospital||"",
      referralDoctorName:this.state.referralDoctorName||"",
      emergencyContactPerson: this.state.emergencyContactPerson || "",
      emergencyMobileNumber: this.state.emergencyMobileNumber ? parseInt(this.state.emergencyMobileNumber) : null,
      primaryConsultant: this.state.primaryConsultant || "",
      // getPatientSummaryDetails reads these two from patient_additional_info and
      // overwrites whatever updatePatientdetails wrote to the patient table, so they
      // must be sent here as well or the saved value never comes back on reload.
      otherOnGoingTreatment: this.state.isOngoingTreatmentSelected
        ? this.state.otherOngoingTreatment || ""
        : "",
      otherComorbidities: this.state.otherComorbidities || "",
      profilePictureData: this.state.profilePictureData1 || this.state.patientProfilePictureData || "",
      profilePictureName: this.state.profilePictureName1 || "",
    };


    const response = await fetch(
      `${C.getUrl()}/userCase/updatepatientAdditionalInfo/${patientId}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(payload),
      }
    );

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    const result = await response.json();
    
    if (result.statusCode === 200) {
      // Parse the response message to get updated data
      if (result.message) {
        try {
          const updatedData = JSON.parse(result.message);
          // Update state with the returned data
          this.setState({
            idProofType: updatedData.idProofType || "",
            idProofNumber: updatedData.idProofNumber || "",
            patientType:updatedData.patientType || "",
            telphoneNo: updatedData.telphoneNo || "",
            referralDoctorName:updatedData.referralDoctorName||"",
            referralHospital:updatedData.referralHospital||"",
            emergencyContactPerson: updatedData.emergencyContactPerson || "",
            emergencyMobileNumber: updatedData.emergencyMobileNumber || "",
            primaryConsultant: updatedData.primaryConsultant || "",
            patientProfilePictureData: updatedData.profilePictureData || "",
          });
        } catch (parseError) {
        }
      }
      return { success: true, data: result };
    } else {
      throw new Error(result.message || "Failed to update additional information");
    }
  } catch (error) {
    throw error;
  }
};

  // Add this method to your class component
  getAllDoses = async () => {
    try {
      this.setState({ loadingDoses: true });
      const res = await fetch(`${C.getUrl()}/patientOpVisit/getAllDoseMaster`);
      const resObj = await res.json();

      if (resObj && resObj.message) {
        try {
          let data = JSON.parse(resObj.message);
          const dosesArray = Array.isArray(data) ? data : [];

          // Sort doses alphabetically
          const doses = dosesArray
            .map((d) => ({
              id: d.doseId,
              name: d.doseName,
              doseId: d.doseId,
            }))
            .sort((a, b) => a.name.localeCompare(b.name));

          this.setState({ dosesArr: doses });
        } catch (parseErr) {
          this.setState({ dosesArr: [] });
        }
      } else {
        this.setState({ dosesArr: [] });
      }
    } catch (err) {
      swal({
        title: "Error!",
        text: "Error fetching doses: " + err.message,
        icon: "error",
        buttons: false,
        timer: 2000,
      });
    } finally {
      this.setState({ loadingDoses: false });
    }
  };

  // Add this method to your class component
  getAllWhens = async () => {
    try {
      this.setState({ loadingWhens: true });

      // Corrected endpoint URL
      const res = await fetch(`${C.getUrl()}/patientOpVisit/getAllWhenMaster`);
      const resObj = await res.json();

      if (resObj && resObj.message) {
        try {
          let data = JSON.parse(resObj.message);
          const whensArray = Array.isArray(data) ? data : [];

          // Sort whens alphabetically
          const whens = whensArray
            .map((d) => ({
              id: d.whenId,
              name: d.whenName,
              whenId: d.whenId,
            }))
            .sort((a, b) => a.name.localeCompare(b.name));

          this.setState({ whensArr: whens });
        } catch (parseErr) {
          this.setState({ whensArr: [] });
        }
      } else {
        this.setState({ whensArr: [] });
      }
    } catch (err) {
      swal({
        title: "Error!",
        text: "Error fetching whens: " + err.message,
        icon: "error",
        buttons: false,
        timer: 2000,
      });
    } finally {
      this.setState({ loadingWhens: false });
    }
  };

  handlePrescriptionDurationUnitSelect = (index, unit) => {
    const updatedDetails = [...this.state.medicationDetails];
    updatedDetails[index].durationUnit = unit;

    // If there's a value, format the duration correctly
    if (updatedDetails[index].durationValue) {
      updatedDetails[
        index
      ].duration = `${updatedDetails[index].durationValue} ${unit}`;
    }

    this.setState({ medicationDetails: updatedDetails });
  };

  // Remove a row from the prescription table
  removePrescriptionRow = (index) => {
    const updatedDetails = [...this.state.medicationDetails];
    updatedDetails.splice(index, 1);

    // If all rows are removed, add an empty one
    if (updatedDetails.length === 0) {
      updatedDetails.push({
        medicine: null,
        dose: "",
        when: "",
        durationValue: "",
        durationUnit: "Days",
        instructions: "",
        isSaved: false,
      });
    }

    this.setState({ medicationDetails: updatedDetails });
  };

  // Check if a prescription row has content
  isPrescriptionRowFilled = (index) => {
    const row = this.state.medicationDetails[index];
    return (
      row.medicine ||
      row.dose ||
      row.when ||
      row.durationValue ||
      row.instructions
    );
  };

  // Add a new empty row to the prescription table
  handleAddPrescriptionRow = () => {
    this.setState((prevState) => ({
      medicationDetails: [
        ...prevState.medicationDetails,
        {
          medicine: null,
          dose: "",
          when: "",
          durationValue: "",
          durationUnit: "Days",
          instructions: "",
          isSaved: false,
        },
      ],
    }));
  };

  // Check if a prescription row has content
  isPrescriptionRowFilled(index) {
    const row = this.state.medicationDetails[index];
    return (
      row.medicine ||
      row.dose ||
      row.when ||
      row.durationValue ||
      row.instructions
    );
  }

  // Load previous prescriptions
  loadPrevious(type) {
    if (type === "prescription") {
      this.getPatientMedicines(this.state.patientId);
    }
  }

  // Add this method to your class component
  saveDose = async (doseName) => {
    try {
      // Get userId from localStorage
      const userId = localStorage.getItem("userId") || "1";

      // Prepare the payload with the correct structure
      const payload = {
        doseName: doseName,
        doseDescription: `${doseName} description`,
        activeInd: "Y",
        createdByDTO: { userId: parseInt(userId) },
        updatedByDTO: { userId: parseInt(userId) },
      };

      // Verify all required fields are present
      if (
        !payload.doseName ||
        !payload.doseDescription ||
        !payload.activeInd ||
        !payload.createdByDTO ||
        !payload.updatedByDTO
      ) {
        throw new Error("Incomplete payload for saving dose");
      }


      // Stringify the payload once and store for use
      const payloadString = JSON.stringify(payload);

      // Log the exact string being sent to ensure it's properly formatted

      // Call the API with the complete payload
      const saveResponse = await fetch(
        `${C.getUrl()}/patientOpVisit/saveDoseMaster`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: payloadString,
        }
      );

      const saveResult = await saveResponse.json();

      // Refresh the dose list
      await this.getAllDoses();

      // Find the newly created dose in the updated list
      const newDose = this.state.dosesArr.find((d) => d.name === doseName);
      if (newDose) {
        return newDose;
      }

      // If it wasn't found, create a temporary one to use in UI
      return {
        id: Date.now(),
        name: doseName,
        doseId: Date.now(),
      };
    } catch (err) {
      swal({
        title: "Error!",
        text: "Error saving dose: " + (err.message || "Unknown error"),
        icon: "error",
        buttons: false,
        timer: 2000,
      });
      return null;
    }
  };

  // Add this method to your class component
  saveWhen = async (whenName) => {
    try {
      // Get userId from localStorage
      const userId = localStorage.getItem("userId") || "1";

      // Prepare the payload with the correct structure
      const payload = {
        whenName: whenName,
        whenDescription: `${whenName} description`,
        activeInd: "Y",
        createdByDTO: { userId: parseInt(userId) },
        updatedByDTO: { userId: parseInt(userId) },
      };


      // Call the API
      const saveResponse = await fetch(
        `${C.getUrl()}/patientOpVisit/saveWhenMaster`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      const saveResult = await saveResponse.json();

      // Refresh the when list
      await this.getAllWhens();

      // Find the newly created when in the updated list
      const newWhen = this.state.whensArr.find((w) => w.name === whenName);
      if (newWhen) {
        return newWhen;
      }

      // If it wasn't found, create a temporary one to use in UI
      return {
        id: Date.now(),
        name: whenName,
        whenId: Date.now(),
      };
    } catch (err) {
      return null;
    }
  };

  // Delete a patient medicine
  deletePatientMedicine = async (medicineListXrefId) => {
    try {
      const response = await fetch(
        C.getUrl() +
          "/additionalMedicationListXref/deactivate/" +
          medicineListXrefId,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();

      if (data.statusCode === 200) {
        swal({
          title: "Success!",
          text: "Medicine removed successfully",
          icon: "success",
          buttons: false,
          timer: 2000,
        });

        // Refresh medicines after successful delete
        await this.getPatientMedicines(this.state.patientId);
        return true;
      } else {
        throw new Error("Failed to remove medicine");
      }
    } catch (err) {
      swal({
        title: "Error!",
        text: "Failed to remove medicine",
        icon: "error",
        buttons: false,
        timer: 2000,
      });
      return false;
    }
  };

  // Handle save medicines button click with API integration
  handleSaveMedicinesClick = async () => {
    // Validate the prescription rows
    const hasErrors = this.validatePrescriptionRows();
    if (hasErrors) {
      return;
    }

    this.setState({ saveLoader: true });

    // Prepare data for saving
    const medicationsToSave = this.state.medicationDetails
      .filter((med) => med.medicine && !med.medicine.medicineListXrefId) // Only save new rows with a medicine selected
      .map((med) => ({
        medicineId: med.medicine.id,
        patientId: this.state.patientId,
        dose: med.dose,
        when: med.when,
        duration: med.durationValue
          ? `${med.durationValue} ${med.durationUnit}`
          : "",
        instructions: med.instructions,
        activeInd: "Y",
      }));

    // No medicines to save
    if (medicationsToSave.length === 0) {
      // Check if all rows are already saved
      const hasUnsavedMedicines = this.state.medicationDetails.some(
        (med) => med.medicine && !med.medicine.medicineListXrefId
      );

      if (!hasUnsavedMedicines) {
        this.setState({ saveLoader: false });
        swal({
          title: "Info",
          text: "All medicines are already saved",
          icon: "info",
          buttons: false,
          timer: 2000,
        });
        return;
      }

      this.setState({ saveLoader: false });
      swal({
        title: "Warning!",
        text: "No medicines to save",
        icon: "warning",
        buttons: false,
        timer: 2000,
      });
      return;
    }

    // Save each medicine using the additionalMedicationListXref/add endpoint
    const savePromises = medicationsToSave.map((medication) =>
      fetch(C.getUrl() + "/additionalMedicationListXref/add", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(medication),
      }).then((res) => res.json())
    );

    Promise.all(savePromises)
      .then((results) => {
        this.setState({ saveLoader: false });

        // Check if all saves were successful
        const allSuccessful = results.every((res) => res.statusCode === 200);

        if (allSuccessful) {
          swal({
            title: "Success!",
            text: "Medicines saved successfully",
            icon: "success",
            buttons: false,
            timer: 2000,
          });

          // Refresh the list of patient medicines
          this.getPatientMedicines(this.state.patientId);
        } else {
          swal({
            title: "Warning!",
            text: "Some medicines may not have been saved correctly",
            icon: "warning",
            buttons: false,
            timer: 2000,
          });
        }
      })
      .catch((err) => {
        this.setState({ saveLoader: false });

        swal({
          title: "Error!",
          text: "Failed to save medicines",
          icon: "error",
          buttons: false,
          timer: 2000,
        });
      });
  };

  // Validate prescription rows
  validatePrescriptionRows = () => {
    let hasErrors = false;
    const errors = [];

    this.state.medicationDetails.forEach((med, index) => {
      const rowErrors = {};

      // Skip validation for empty rows
      if (
        !med.medicine &&
        !med.dose &&
        !med.when &&
        !med.durationValue &&
        !med.instructions
      ) {
        errors[index] = rowErrors;
        return;
      }

      // Validate required fields
      if (!med.medicine) {
        rowErrors.medicine = "Medicine is required";
        hasErrors = true;
      }

      if (!med.dose) {
        rowErrors.dose = "Dose is required";
        hasErrors = true;
      }

      if (!med.when) {
        rowErrors.when = "When is required";
        hasErrors = true;
      }

      if (!med.durationValue) {
        rowErrors.durationValue = "Duration is required";
        hasErrors = true;
      }

      if (!med.instructions) {
        rowErrors.instructions = "Instructions are required";
        hasErrors = true;
      }

      errors[index] = rowErrors;
    });

    this.setState({ medicationErrors: errors });
    return hasErrors;
  };

  // Get patient-specific medicines using the API
  getPatientMedicines = (patientId) => {
    return fetch(
      C.getUrl() +
        "/additionalMedicationListXref/getPatientAdditionalMedications?patientId=" +
        patientId
    )
      .then((res) => res.json())
      .then((res) => {
        if (
          res.statusCode === 200 &&
          res.message &&
          res.message !== "No records found"
        ) {
          const medicines = JSON.parse(res.message);
          const activeMedicines = medicines.filter((m) => m.activeInd === "Y");

          if (activeMedicines.length > 0) {
            // Parse the duration into value and unit
            const medicationDetails = activeMedicines.map((m) => {
              let durationValue = "";
              let durationUnit = "Days";

              if (m.duration) {
                const durParts = m.duration.split(" ");
                if (durParts.length >= 2) {
                  durationValue = durParts[0];
                  durationUnit = durParts[1];
                } else {
                  durationValue = m.duration;
                }
              }

              return {
                medicine: {
                  id: m.medicineId,
                  name: m.medicineName,
                  medicineId: m.medicineId,
                  medicineListXrefId: m.medicineListXrefId,
                },
                dose: m.dose,
                when: m.when,
                durationValue: durationValue,
                durationUnit: durationUnit,
                duration: m.duration,
                instructions: m.instructions,
              };
            });

            this.setState({ medicationDetails: medicationDetails });
          } else {
            // Initialize with one empty row if no active medicines found
            this.setState({
              medicationDetails: [
                {
                  medicine: null,
                  dose: "",
                  when: "",
                  durationValue: "",
                  durationUnit: "Days",
                  instructions: "",
                },
              ],
            });
          }
        } else {
          // Initialize with one empty row if no medicines found
          this.setState({
            medicationDetails: [
              {
                medicine: null,
                dose: "",
                when: "",
                durationValue: "",
                durationUnit: "Days",
                instructions: "",
              },
            ],
          });
        }

        // Load master data for dropdowns
        this.getAllMedicines();
        this.getAllDoses();
        this.getAllWhens();
      })
      .catch((err) => {

        // Initialize with one empty row on error
        this.setState({
          medicationDetails: [
            {
              medicine: null,
              dose: "",
              when: "",
              durationValue: "",
              durationUnit: "Days",
              instructions: "",
            },
          ],
        });

        // Still try to load master data for dropdowns
        this.getAllMedicines();
        this.getAllDoses();
        this.getAllWhens();
      });
  };
  // Add this method in your component
  isRestrictedStagingUser = () => {
    const userId = localStorage.getItem("userId");
    const restrictedUserIds = ["17", "86"];
    return restrictedUserIds.includes(userId);
  };

  getAllAntiemeticRegimens(protocolId) {
    fetch(
      C.getUrl() +
        "/antiemeticTreatment/getAllAntiemeticRegimens?protocolId=" +
        protocolId
    )
      .then((res) => res.json())
      .then((res) => {
        if (res.statusCode == 200) {
          let data = JSON.parse(res.message);
          var arr = [];
          data.map((item, index) => {
            let jsonList = new Object();
            jsonList["key"] = Crypt.getUniqueKey(index);
            jsonList["id"] = item.antiemeticRegimensId;
            jsonList["label"] = item.regimenType;
            arr.push(jsonList);
          });
          this.setState({ antiemeticRegimensMstArr: arr });
        }
      })
      .catch((err) => {
      });
  }

  handleOptionChange = (event) => {
    event.preventDefault();
    if (event.target.value !== "-1") {
      this.setState({ antiemeticRegimensId: event.target.value });

      fetch(
        C.getUrl() +
          "/antiemeticTreatment/getAntiemeticTreatmentDetail?antiemeticRegimensId=" +
          event.target.value
      )
        .then((res) => res.json())
        .then((res) => {
          if (res.statusCode === 200) {
            const data = JSON.parse(res.message);
            this.setState({
              antiemeticTreatmentMstArr: data,
              showOptionOne: true,
              selectedOptions: { "Day-1": [], "Day-2,3,4": [] }, // Reset selections when a new treatment is chosen
            });
          }
        })
        .catch((err) => {
        });
    }
  };

  // Add this method to your class component
  saveDose = async (doseName) => {
    try {
      // Get userId from localStorage
      const userId = localStorage.getItem("userId") || "1";

      // Create a new object with all required fields explicitly set
      const fullPayload = {};
      fullPayload.doseName = doseName;
      fullPayload.doseDescription = `${doseName} description`;
      fullPayload.activeInd = "Y";
      fullPayload.createdByDTO = { userId: parseInt(userId) };
      fullPayload.updatedByDTO = { userId: parseInt(userId) };

      // Log the constructed object

      // Manually stringify with proper formatting
      const manualPayloadString = JSON.stringify({
        doseName: doseName,
        doseDescription: `${doseName} description`,
        activeInd: "Y",
        createdByDTO: { userId: parseInt(userId) },
        updatedByDTO: { userId: parseInt(userId) },
      });


      // Call the API with manually constructed payload
      const saveResponse = await fetch(
        `${C.getUrl()}/patientOpVisit/saveDoseMaster`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: manualPayloadString,
        }
      );

      // Check response status
      if (!saveResponse.ok) {
        throw new Error(
          `API returned ${saveResponse.status}: ${await saveResponse.text()}`
        );
      }

      const saveResult = await saveResponse.json();

      // Refresh the dose list
      await this.getAllDoses();

      // Find the newly created dose in the updated list
      const newDose = this.state.dosesArr.find((d) => d.name === doseName);
      if (newDose) {
        return newDose;
      }

      // If it wasn't found, create a temporary one to use in UI
      return {
        id: Date.now(),
        name: doseName,
        doseId: Date.now(),
      };
    } catch (err) {
      swal({
        title: "Error!",
        text: "Error saving dose: " + (err.message || "Unknown error"),
        icon: "error",
        buttons: false,
        timer: 2000,
      });
      return null;
    }
  };
  // Add this method to your class component
  saveWhen = async (whenName) => {
    try {
      // Get userId from localStorage
      const userId = localStorage.getItem("userId") || "1";

      // Create a properly formatted payload with ALL required fields
      const payload = {
        whenName: whenName,
        whenDescription: `${whenName} description`,
        activeInd: "Y",
        createdByDTO: { userId: parseInt(userId) },
        updatedByDTO: { userId: parseInt(userId) },
      };


      // Call the API with the complete payload
      const saveResponse = await fetch(
        `${C.getUrl()}/patientOpVisit/saveWhenMaster`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload),
        }
      );

      const saveResult = await saveResponse.json();

      // Refresh the when list
      await this.getAllWhens();

      // Find the newly created when in the updated list
      const newWhen = this.state.whensArr.find((w) => w.name === whenName);
      if (newWhen) {
        return newWhen;
      }

      // If it wasn't found, create a temporary one to use in UI
      return {
        id: Date.now(),
        name: whenName,
        whenId: Date.now(),
      };
    } catch (err) {
      swal({
        title: "Error!",
        text: "Error saving when: " + (err.message || "Unknown error"),
        icon: "error",
        buttons: false,
        timer: 2000,
      });
      return null;
    }
  };

  handleChange(event) {
    var treatmentCMedHT3RA = document.getElementById("checkTreatmentC");
    var treatmentCMedNK1RA = document.getElementById("checkTreatmentB");
    var treatmentAMedNK1RA = document.getElementById("checkTreatmentA");
    var treatmentAMedOptTwo = document.getElementById("checkTreatmentOptTwo");

    if (event.target.name === "group3") {
      treatmentCMedHT3RA.disabled = false;
    }
    if (event.target.name === "group2") {
      treatmentCMedNK1RA.disabled = false;
    }
    if (event.target.name === "group1") {
      treatmentAMedNK1RA.disabled = false;
    }
    if (event.target.name === "group4") {
      treatmentAMedOptTwo.disabled = false;
    }
  }

  setAntiemeticRisksValue = (value, dayLabel) => {
    this.setState((prevState) => {
      const updatedSelectedOptions = { ...prevState.selectedOptions };

      // Ensure dayLabel is initialized as an array if not already
      if (!Array.isArray(updatedSelectedOptions[dayLabel])) {
        updatedSelectedOptions[dayLabel] = [];
      }

      // Toggle selection of options
      if (updatedSelectedOptions[dayLabel].includes(value)) {
        updatedSelectedOptions[dayLabel] = updatedSelectedOptions[
          dayLabel
        ].filter((opt) => opt !== value);
      } else {
        updatedSelectedOptions[dayLabel].push(value);
      }

      return { selectedOptions: updatedSelectedOptions };
    });
  };

  handleChangeCheckOlanzapine510(event) {
    this.setState({ checkOlanzapine510Checkbox: event.target.checked });
    this.onChange(event);
  }

  handleChangeDexmaetha12(event) {
    this.setState({ dexmaetha12Checkbox: event.target.checked });
    this.onChange(event);
  }

  handleChangeApr125(event) {
    this.setState({ apr125: event.target.checked });
    this.onChange(event);
  }

  handleChangeApr130(event) {
    this.setState({ apr130: event.target.checked });
    this.onChange(event);
  }

  handleChangeFosap150(event) {
    this.setState({ fosap150: event.target.checked });
    this.onChange(event);
  }

  handleChangeNetuo300(event) {
    this.setState({ netuo300: event.target.checked });
    this.onChange(event);
  }

  handleChangeFosap235(event) {
    this.setState({ fosap235: event.target.checked });
    this.onChange(event);
  }

  handleChangeRolap180(event) {
    this.setState({ rolap180: event.target.checked });
    this.onChange(event);
  }

  handleChangeDolasetronOptTwo(event) {
    this.setState({ dolasetronOptTwo: event.target.checked });
    this.onChange(event);
  }

  handleChangeGranisetronOptTwo(event) {
    this.setState({ granisetronOptTwo: event.target.checked });
    this.onChange(event);
  }

  handleChangeOndansetronOptTwo(event) {
    this.setState({ ondansetronOptTwo: event.target.checked });
    this.onChange(event);
  }

  handleChangePalonosetronOptTwo(event) {
    this.setState({ palonosetronOptTwo: event.target.checked });
    this.onChange(event);
  }

  handleChangeOlanzapine510(event) {
    this.setState({ olanzapine510: event.target.checked });
    this.onChange(event);
  }

  handleChangePal025(event) {
    this.setState({ pal025: event.target.checked });
    this.onChange(event);
  }

  handleChangeDex12(event) {
    this.setState({ dex12: event.target.checked });
    this.onChange(event);
  }

  handleChangeAprDay125(event) {
    this.setState({ aprDay125: event.target.checked });
    this.onChange(event);
  }

  handleChangeAprDay130(event) {
    this.setState({ aprDay130: event.target.checked });
    this.onChange(event);
  }

  handleChangeFosaDay150(event) {
    this.setState({ fosaDay150: event.target.checked });
    this.onChange(event);
  }

  handleChangeNetupDay300(event) {
    this.setState({ netupDay300: event.target.checked });
    this.onChange(event);
  }

  handleChangeFosneDay235(event) {
    this.setState({ fosneDay235: event.target.checked });
    this.onChange(event);
  }

  handleChangeRday180(event) {
    this.setState({ rday180: event.target.checked });
    this.onChange(event);
  }

  handleChangeDolasDay100(event) {
    this.setState({ dolasDay100: event.target.checked });
    this.onChange(event);
  }

  handleChangePalDay25(event) {
    this.setState({ palDay25: event.target.checked });
    this.onChange(event);
  }

  handleChangeOndanDay(event) {
    this.setState({ ondanDay: event.target.checked });
    this.onChange(event);
  }

  handleChangeGraniDay10(event) {
    this.setState({ graniDay10: event.target.checked });
    this.onChange(event);
  }

  handleChangePatch(event) {
    this.setState({ patch: event.target.checked });
    this.onChange(event);
  }

  handleChangeDexamDay12(event) {
    this.setState({ dexamDay12: event.target.checked });
    this.onChange(event);
  }

  handleChangeOlanDayTwo(event) {
    this.setState({ olanDayTwo: event.target.checked });
    this.onChange(event);
  }

  handleChangeApreDayTwo(event) {
    this.setState({ apreDayTwo: event.target.checked });
    this.onChange(event);
  }

  handleChangeDexaDayTwo(event) {
    this.setState({ dexaDayTwo: event.target.checked });
    this.onChange(event);
  }

  handleChangeOlanzapineDayTwo(event) {
    this.setState({ olanzapineDayTwo: event.target.checked });
    this.onChange(event);
  }

  handleChangeAprep80DayTwo(event) {
    this.setState({ aprep80DayTwo: event.target.checked });
    this.onChange(event);
  }

  handleChangeDexam8DayTwo(event) {
    this.setState({ dexam8DayTwo: event.target.checked });
    this.onChange(event);
  }

  handleChemoStatusChange = (event) => {
    this.setState({ chemoStatus: event.target.value });
  };

  handleStatusChange = (event) => {
    this.setState({ status: event.target.value });
  };

  reportHandler = (mode, data) => {
    let isThisValidForm = false;
    if (this.validateFollowupReport()) {
      isThisValidForm = true;
    }

    if (isThisValidForm) {
      this.submitFollowupReport();

      switch (mode) {
        case Constants.MODE_NEW_REPORT:
          this.setState({
            reportModal: true,
            reportMode: mode,
            selectedApptReportData: data,
          });
          break;

        case Constants.MODE_VIEW_REPORT:
          this.setState({
            reportModal: true,
            reportMode: mode,
            selectedApptReportData: data,
          });
          break;

        default:
          break;
      }
    }
  };
  closeReportHandler = () => {
    this.setState({ reportModal: false, reportMode: null });
  };
  reportSavedSuccessHandler = () => {
    this.setState({ reportModal: false, reportMode: null });
    this.getFollowupAppiontment();
  };
  openPreviewModalHandler = () => {
    this.setState({ previewModal: true });
  };
  closePreviewModalHandler = () => {
    this.setState({ previewModal: false });
  };
  showAlertDismissible = () => {
    this.setState({ alertDismissibleshow: true });
  };
  setAssesFNRiskFlag = (value) => {
    if (value != "undefined") this.setState({ assesFNRiskFlag: value });
  };

  componentDidMount() {
    //$("#uncontrolled-tab-example-tab-chemotherapy").hide();

    if (this.props.location && this.props.location.search) {
      let patientId = this.props.location.search.slice(3);
      this.setState({ patientId: patientId });

      // Add this line to ensure the patient ID is available for DiagnosisManagement
      localStorage.setItem("PatientpatientId", patientId);

      let data = JSON.parse(localStorage.getItem("userRoleDto"));
      let roleIdFromCache = data.roleId;
      if (roleIdFromCache === 3) {
        this.setState({ isHospitalStaff: true });
      }
      if (roleIdFromCache === 2) {
        this.setState({ doctorLoggedIn: true });
      }
      if (patientId) {
        this.setState({ loaderModal: true });
        // Add medicine fetch here
        this.getPatientMedicines(patientId);
        this.getPatientPostDischargeMedicines(patientId);
        this.getAllMedicines();
        this.getAllPostDischargeMedicines();
        this.getPatientCaseDetail(patientId);
        this.fetchPatientDocuments(patientId);
        this.fetchDocumentTypes();
        this.getPatientStaging(patientId);
        this.getPatientAdditionalInfo(patientId);
        const medicineIds = this.state.suggestiveTreatementArr.map(
          (medicine) => medicine.medicineId
        );
        if (medicineIds && medicineIds.length > 0) {
          this.fetchMedicineDetails(medicineIds);
        }
      } else {
      }
    }

    // Register diagnostic function globally
    window.diagnose3Col = () => {
      const rowEl = document.querySelector('[data-test-3col-row]');
      if (!rowEl) {
        return;
      }
      const rowComputed = window.getComputedStyle(rowEl);
      
      // Check ENTIRE parent chain for width constraints
      let current = rowEl.parentElement;
      let level = 0;
      while (current && level < 10) {
        const comp = window.getComputedStyle(current);
        const tag = current.tagName.toLowerCase();
        const className = current.className || "";
        current = current.parentElement;
        level++;
      }
      
      const cols = Array.from(document.querySelectorAll('[data-test-col-1], [data-test-col-2], [data-test-col-3]'));
      cols.forEach((col, idx) => {
        const colComp = window.getComputedStyle(col);
      });
    };

    this.setState({ key: "summary" });
    if (localStorage.getItem("ActTabkey") != "") {
      this.setState({ key: localStorage.getItem("ActTabkey") });
      this.getAllMedicines();
      this.getAllAllergies();
      this.getAllComorbidites();
      this.getAllGenders();
      if (this.props.patientId) {
        this.getPatientCaseDetail(this.props.patientId);
      }
      const { patientId } = this.props;
      this.setState({ patientId: patientId });

      // Also set localStorage when patientId is from props
      if (patientId) {
        localStorage.setItem("PatientpatientId", patientId);
        this.getPatientMedicines(patientId);
      }
    }
    if (this.state.patientId) {
      this.getPatientPostDischargeMedicines(this.state.patientId);
      this.getAllPostDischargeMedicines();
      this.getPatientHeightWeight();
    }

    // Ticker: compute once now, then recompute from state on a configurable interval.
    this.refreshTicker();
    this.tickerTimer = setInterval(this.refreshTicker, C.TickerRefreshMs);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.patientId !== this.props.patientId) {
      this.getPatientStaging(this.props.patientId);
    }
    if (
      prevState.suggestiveTreatementArr !== this.state.suggestiveTreatementArr
    ) {
      const medicineNames = this.state.suggestiveTreatementArr
        .map((arr) => arr[0]?.children[0]?.value)
        .filter((name) => name);

      this.setState(
        { selectedMedicines: medicineNames, medicineDetails: [], suggestiveMedicineNames: medicineNames },
        () => { medicineNames.forEach((name) => this.fetchMedicineDetails(name)); }
      );
    }
  }
  componentWillUnmount() {
    this._isUnmounted = true;
    localStorage.setItem("ActTabkey", "summary");
    if (this.tickerTimer) {
      clearInterval(this.tickerTimer);
    }
  }

  // Guard against async fetch/timer callbacks calling setState after unmount
  // (avoids the "state update on an unmounted component" memory-leak warning).
  setState(state, callback) {
    if (this._isUnmounted) {
      return;
    }
    super.setState(state, callback);
  }

  isAOCUser = () => {
    const userId = localStorage.getItem("userId");
    return userId === "86";
  };

  fetchMedicineDetails = (medicineName) => {
    const url = C.getUrl() + `/medicine/getDetailsByMedicineName?medicineName=${encodeURIComponent(medicineName)}`;
    fetch(url)
      .then((res) => {
        if (!res.ok) {
          throw new Error("Network response was not ok");
        }
        return res.json();
      })
      .then((res) => {
        if (res.statusCode === 451) {
          return;
        }
        const dataArray = JSON.parse(res.message);
        if (!dataArray || dataArray.length === 0) {
          return;
        }
        const formattedDetails = dataArray.map((detail) => ({
          label: `${detail.medicineName}`,
          value: `${detail.medicineName}-${detail.companyName}-${detail.brandName}`,
          className: "hiddenRadio",
          expanded: true,
          disabled: false,
          selected: false,
          children: [
            {
              label: `${detail.companyName} : ${detail.brandName}`,
              value: `${detail.medicineName}-${detail.companyName}-${detail.brandName}`,
              selected: false,
            },
          ],
        }));
        this.setState((prevState) => ({
          medicineDetails: [...prevState.medicineDetails, ...formattedDetails],
        }));
      })
      .catch((err) => {
        console.error("[fetchMedicineDetails] Error for", medicineName, ":", err);
      });
  };

  handleMedicineSelect = (medicineName, isSelected, callback) => {
    this.setState((prevState) => {
      let updatedSelectedMedicines = [...prevState.selectedMedicines];
      let updatedMedicineDetails = [...prevState.medicineDetails];

      if (isSelected) {
        if (!updatedSelectedMedicines.includes(medicineName)) {
          updatedSelectedMedicines.push(medicineName);
          // Note: fetchMedicineDetails is async and has its own setState.
          // The callback passed to handleMedicineSelect will run after this outer setState completes,
          // but not necessarily after fetchMedicineDetails completes its own async operations and setState.
          this.fetchMedicineDetails(medicineName);
        }
      } else {
        updatedSelectedMedicines = updatedSelectedMedicines.filter((m) => m !== medicineName);
        updatedMedicineDetails = updatedMedicineDetails.filter((detail) => detail.label !== medicineName);
      }
      return { selectedMedicines: updatedSelectedMedicines, medicineDetails: updatedMedicineDetails };
    }, callback); // Execute the callback after state is updated
  };

  // 1. Get all medicines
  getAllMedicines = async () => {
    try {
      const res = await fetch(
        C.getUrl() + "/additionalMedicationListMaster/getAllMedicines"
      );
      const resObj = await res.json();
      let data = JSON.parse(resObj.message);
      const medicines = data.map((d) => ({
        id: d.medicineId,
        name: d.medicineName,
        medicineId: d.medicineId,
      }));

      this.setState({ medicinesArr: medicines });
      return medicines;
    } catch (err) {
      // swal({
      //   title: "Warning!",
      //   text: "Error fetching medicines: " + err,
      //   icon: "error",
      //   buttons: false,
      //   timer: 2000,
      // });
      return [];
    }
  };

  saveMedicine = async (medicineName, searchBoxRef) => {
    try {
      // Save new medicine
      const saveResponse = await fetch(
        C.getUrl() + "/additionalMedicationListMaster/saveMedicine",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({
            medicineName,
            activeInd: "Y",
            createdById: 1,
            updatedById: 1,
            creationDate: moment().format("YYYY-MM-DD"),
            updatedDate: moment().format("YYYY-MM-DD"),
          }),
        }
      );

      const saveResult = await saveResponse.json();

      if (saveResult.status === "success" || saveResult.statusCode === 200) {
        // Immediately fetch updated list
        await this.getAllMedicines();

        swal({
          title: "Success!",
          text: "Medicine added successfully",
          icon: "success",
          buttons: false,
          timer: 2000,
        });

        // Find the newly added medicine in the refreshed list
        const newMedicine = this.state.medicinesArr.find(
          (med) => med.name.toLowerCase() === medicineName.toLowerCase()
        );

        return newMedicine || { id: Date.now(), name: medicineName };
      }

      return false;
    } catch (err) {
      swal({
        title: "Error!",
        text: "Failed to add medicine: " + err,
        icon: "error",
        buttons: false,
        timer: 2000,
      });
      return false;
    }
  };

  // 4. Save patient medicines
  savePatientMedicines = () => {
    const promises = this.state.medicationDetails.map((detail) => {
      if (!detail.medicine) return null;

      const data = {
        medicineId: detail.medicine.medicineId,
        patientId: this.state.patientId,
        dose: detail.dose,
        when: detail.when,
        duration: detail.duration,
        instructions: detail.instructions,
        activeInd: "Y",
      };
      return fetch(C.getUrl() + "/medicineListXref/add", {
        method: "PUT",
        mode: "cors",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(data),
      });
    });
    Promise.all(promises.filter((p) => p))
      .then(() => {
        swal({
          title: "Success!",
          text: "Medications saved successfully",
          icon: "success",
          buttons: false,
          timer: 2000,
        });
        this.getPatientMedicines(this.state.patientId);
      })
      .catch((err) => {
        swal({
          title: "Error!",
          text: "Failed to save medications: " + err,
          icon: "error",
          buttons: false,
          timer: 2000,
        });
      });
  };

  getPatientCaseDetail(patientId) {
    // Validate patientId before making API call
    if (!patientId || patientId === 'undefined' || patientId === undefined) {
      return;
    }

    return fetch(
      C.getUrl() + "/userCase/getPatientSummaryDetails?patientId=" + patientId
    )
      .then((res) => res.json())
      .then((res) => {
        let resObj = res;
        let parsed;
        try {
          parsed = JSON.parse(resObj.message);
        } catch(e) {
          console.error('[getPatientCaseDetail] JSON.parse failed:', e);
          return;
        }
        this.setCaseDetail(parsed);
      })
      .catch((err) => {
        console.error('[getPatientCaseDetail] fetch error:', err);
      });
  }

  getKhoranaScore(patientId) {
    return fetch(C.getUrl() + "/protocol/getKhoranaScore/" + patientId)
      .then((res) => res.json())
      .then((res) => {
        if (res.statusCode === 200 && res.data != null) {
          this.setState({ khoronaScore: res.data });
        }
      })
      .catch((err) => {
      });
  }

  getCreatinineClearance(patientId) {
    return fetch(C.getUrl() + "/userCase/getCreatinineClearance?patientId=" + patientId)
      .then((res) => res.json())
      .then((res) => {
        // The payload is a JSON *string* in `message`, hence the second parse.
        // This wrapper has no `response` field — reading one is why this endpoint
        // never rendered. Do not reintroduce it.
        if (res.statusCode === 200 && res.message) {
          const data = JSON.parse(res.message);
          // creatinineClearance comes back as a JSON number, auc as a string —
          // don't assume both are numeric. Coalesce with ?? rather than || so a
          // legitimate 0 survives; an undefined here would flip the read-only
          // input from controlled to uncontrolled and blank it silently.
          //
          // `warning` is present only when the server capped the value. The cap
          // is server config and can change, so the string is rendered verbatim
          // and the threshold is never restated in our own copy. Presence check,
          // not truthiness: the key is absent in the normal case. Always assign
          // it so a warning from a previously loaded patient/sitting cannot
          // linger on screen.
          this.setState({
            creatineClearance: data.creatinineClearance ?? "",
            auc: data.auc ?? "",
            creatinineWarning: "warning" in data ? data.warning : "",
          });
        }
      })
      .catch((err) => {
        console.error("[getCreatinineClearance] failed:", err);
      });
  }

  setCaseDetail(caseDetail) {
 let bloodGroupValue = "Not known";
  if (caseDetail.patientDetailsDto && caseDetail.patientDetailsDto.bloodGroup) {
    bloodGroupValue = caseDetail.patientDetailsDto.bloodGroup;
  }
  
  // Parse DOB with proper date handling to avoid UTC timezone shifts
  let parsedDob = caseDetail.dob;
  
  if (caseDetail.dob) {
    // Try to parse the date with multiple formats to handle corrupted data
    const dobMoment = moment(caseDetail.dob, ['DD/MM/YYYY', 'YYYY-MM-DD', 'MMM DD, YYYY', 'ddd MMM DD, YYYY']);
    
    if (dobMoment.isValid()) {
      parsedDob = dobMoment.format('YYYY-MM-DD');
    } else {
    }
  }

    this.setState({
      dob: parsedDob,
      emailId: caseDetail.emailId,
      phoneNumber1: caseDetail.phoneNumber1,
      caseStatus: caseDetail.status,
       bloodGroup: bloodGroupValue,
    });
    this.setState({ caseStatus: caseDetail.status });

    // Extract and set registration time if available
    if (caseDetail.patientDetailsDto?.registrationDate) {
      const registrationDateTime =
        caseDetail.patientDetailsDto.registrationDate;
      const date = new Date(registrationDateTime);

      // Format the date and time
      const formattedDateTime = date
        .toLocaleString("en-GB", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
          hour12: false,
        })
        .replace(/\//g, "-");

      this.setState({ registrationTime: formattedDateTime });
    }

    // Set restricted fields if available
    if (caseDetail.patientDetailsDto) {
      // Handle discharge date
      let dischargeDateValue = null;
      if (caseDetail.patientDetailsDto.dischargeDate) {
        try {
          // Parse and validate the discharge date
          const parsedDate = moment(
            caseDetail.patientDetailsDto.dischargeDate,
            [
              "MMM D, YYYY", // Format from API: "Feb 3, 1993"
              "YYYY-MM-DD", // ISO format
              "DD/MM/YYYY", // Alternative format
              moment.ISO_8601, // Handle ISO format
            ]
          );

          if (parsedDate.isValid()) {
            dischargeDateValue = parsedDate;
          }
        } catch (error) {
        }
      }

      this.setState({
        category: caseDetail.patientDetailsDto.category || "",
        company: caseDetail.patientDetailsDto.company || "",
        tarrif: caseDetail.patientDetailsDto.tarrif || "",
        payType: caseDetail.patientDetailsDto.payType || "",
        status: caseDetail.patientDetailsDto.status || "",
        dischargeDate: dischargeDateValue,
        mrNo: caseDetail.patientDetailsDto.mrNo,
         bloodGroup: caseDetail.patientDetailsDto.bloodGroup || "Not known",
    }, () => {
  
      });
    }

    // Check for restricted fields visibility
    const userId = localStorage.getItem("userId");
    const instituteId = caseDetail.patientDetailsDto?.instituteDto?.instituteId;

    if (
      userId === "90" ||
      instituteId === 30 ||
      userId === "74" ||
      instituteId === 22
    ) {
      this.setState({ isRestrictedFieldsVisible: true });
    } else {
      this.setState({ isRestrictedFieldsVisible: false });
    }

    this.setPatientDetail(caseDetail.patientDetailsDto);
    // Process and format allergies and comorbidities if they exist
    const allergiesList = caseDetail.patientDetailsDto?.patientAllergies || [];
    const comorbiditiesList =
      caseDetail.patientDetailsDto?.patientComorbidities || [];

    const formattedAllergies = allergiesList
      .filter((allergy) => allergy.allergiesMstDTO.allergiesId !== 9)
      .map((allergy) => allergy.allergiesMstDTO.allergiesName)
      .join(", ");

    const formattedComorbidities = comorbiditiesList
      .filter(
        (comorbidity) => comorbidity.comorbiditiesDto.comorbiditiesId !== 39
      )
      .map((comorbidity) => comorbidity.comorbiditiesDto.comorbiditiesName)
      .join(", ");

    // Store formatted strings in state
    this.setState({
      formattedAllergies,
      formattedComorbidities,
    });
    // Handle allergies selection similar to comorbidities
    const selectedAllergies = allergiesList.map((allergy) => ({
      id: allergy.allergiesMstDTO.allergiesId,
      name: allergy.allergiesMstDTO.allergiesName,
    }));
    const isOtherAllergySelected = selectedAllergies.some(
      (allergy) => allergy.id === 9
    );

    const selectedComorbidities = comorbiditiesList.map((comorbidity) => ({
      id: comorbidity.comorbiditiesDto.comorbiditiesId,
      name: comorbidity.comorbiditiesDto.comorbiditiesName,
    }));
    const isOtherSpecifySelected = selectedComorbidities.some(
      (comorbidity) => comorbidity.id === 39
    );
    this.setState({
      selectedComorbidities,
      isCommorbitiesSelected: isOtherSpecifySelected,
      otherComorbidities: isOtherSpecifySelected
        ? caseDetail.patientDetailsDto.otherComorbidities
        : "",
    });
    this.setState({
      selectedAllergies,
      isAllergiesSelected: isOtherAllergySelected,
      otherAllergies: isOtherAllergySelected
        ? caseDetail.patientDetailsDto.allergies
        : "",
    });
    if (caseDetail.patInitiAssesmentDto) {
      if (
        caseDetail.patInitiAssesmentDto.patientCancerSiteDTOList &&
        caseDetail.patInitiAssesmentDto.patientCancerSiteDTOList.size !== 0
      ) {
        let patCancerSiteList =
          caseDetail.patInitiAssesmentDto.patientCancerSiteDTOList;
        var selectedCancerSiteName = [];
        patCancerSiteList.map(function (d) {
          selectedCancerSiteName.push(d.cancerSiteMstDto.cancerSiteName);
        });
        this.setState({ canSiteNameIAD: selectedCancerSiteName });
      }
    }
    // Storing patientPictureData in state
    if (
      caseDetail.patientDetailsDto &&
      caseDetail.patientDetailsDto.profilePictureData
    ) {
      this.setState({
        patientProfilePictureData:
          caseDetail.patientDetailsDto.profilePictureData,
      });
    } else {
      this.setState({ patientProfilePictureData: "" }); // Reset if no picture is available
    }
    if (caseDetail.patTreatmentPlanDTO) {
      let patTreatmentPlan = caseDetail.patTreatmentPlanDTO;
      if (patTreatmentPlan.consentAttachmentName) {
        this.setState({
          consentAttachmentData: patTreatmentPlan.consentAttachmentData,
        });
        this.setState({
          consentAttachmentName: patTreatmentPlan.consentAttachmentName,
        });
      }
      if (patTreatmentPlan.patientTreatmentPlanId) {
        this.setState({
          patTreatPlanIdTmt: patTreatmentPlan.patientTreatmentPlanId,
        });
      }
      if (
        patTreatmentPlan.protocolMstDTO &&
        patTreatmentPlan.protocolMstDTO.protocolId !== 0
      ) {
        this.setState({
          regProtocolIdTmt: patTreatmentPlan.protocolMstDTO.protocolId,
        });
        this.setState({
          regProtocolNameTmt: patTreatmentPlan.protocolMstDTO.protocolName,
        });
      }
      if (
        patTreatmentPlan.scheduleMstDTO &&
        patTreatmentPlan.scheduleMstDTO.scheduleId !== 0
      ) {
        this.setState({
          scheduleIdTmt: patTreatmentPlan.scheduleMstDTO.scheduleId,
        });
        this.setState({
          scheduleNameTmt: patTreatmentPlan.scheduleMstDTO.scheduleName,
        });
      }
      if (patTreatmentPlan.intent) {
        this.setState({ intentTmt: patTreatmentPlan.intent });
        this.setState({
          intentSummary:
            patTreatmentPlan.intent === "C" ? "Curative" : "Palliative",
        });
      }
      this.setState({ cyclesPlannedTmt: patTreatmentPlan.cyclesPlanned });
      //this.setState({ planNo: patTreatmentPlan.planNo });
    }
    if (caseDetail.patientChemoSittingDTO) {
      let chemosetting = caseDetail.patientChemoSittingDTO;
      this.setState({ patChemoSittingIdPC: chemosetting.patChemoSittingId });
      this.setState({
        upcomingChemoCycleNum: chemosetting.nextChemoCycleNumber,
      });
      this.setState({
        upcomingChemoDt:
          chemosetting.nextChemoCycleDate != null
            ? this.formatDateDDMMYYYY(chemosetting.nextChemoCycleDate)
            : "",
      });
      this.setState({
        lastChemoCycleNumber: chemosetting.previousChemoCycleNumber,
      });
      this.setState({
        lastChemoCycleDate: chemosetting.previousChemoCycleDate,
      });
    }
    this.setState({ loaderModal: false });
    let patientId = this.state.patientId;
    this.getInitialAssessmentDetails(patientId);
    this.getTreatmentPlanDetails(patientId);
    this.getChemoSittingDetails(patientId);
    this.getFollowupAppiontment();
    this.getAllChemoSitting();
    this.getAllCancerSite();
    this.getAllCancerSitesForPrevCancerSites();
    this.getAllLimbLossMstData();
    this.getAllMutation();
    //this.getAllSchedule();
    this.getPathology();
    this.getCancerStage();
    //this.getAllProtocols();
    this.getAllAdverseEffectMaster();
    this.getKhoranaScore(patientId);
    setTimeout(this.refreshTicker, 0);
  }
  getAllCancerSitesForPrevCancerSites = async () => {
    fetch(C.getUrl() + "/cancerSite/getAllCancerSitesForPrevCancerSites")
      .then((res) => res.json())
      .then((res) => {
        let resObj = JSON.parse(res.message);
        var arr = [];
        resObj.map(function (d) {
          arr.push({ id: d.selectionId, name: d.selectionValue });
        });
        this.setState({ prevCanSitesArr: arr });
      })
      .catch((err) => {
      });
  };
  getChemoSittingDetails(patientId) {
    return fetch(
      C.getUrl() + "/userCase/getChemoSittingDetails?patientId=" + patientId
    )
      .then((res) => res.json())
      .then((res) => {
        let resObj = res;
        this.setChemoSetting(JSON.parse(resObj.message));
      })
      .catch((err) => {
      });
  }

  getTreatmentPlanDetails(patientId) {
    return fetch(C.getUrl() + "/userCase/getTreatmentPlanDetails?patientId=" + patientId)
      .then((res) => res.json())
      .then((res) => {
        let parsed;
        try {
          parsed = JSON.parse(res.message);
        } catch(e) {
          console.error('[getTreatmentPlanDetails] JSON.parse failed:', e);
          return;
        }
        this.setTreatmentPlan(parsed);
      })
      .catch((err) => {
        console.error('[getTreatmentPlanDetails] fetch error:', err);
      });
  }

  getInitialAssessmentDetails(patientId) {
    return fetch(
      C.getUrl() +
        "/userCase/getInitialAssessmentDetails?patientId=" +
        patientId
    )
      .then((res) => res.json())
      .then((res) => {
        let resObj = res;
        this.setInitialAssesmentDetail(JSON.parse(resObj.message));
      })
      .catch((err) => {
      });
  }

  setChemoSetting(caseDetail) {
    if (caseDetail.patientChemoSittingDTO) {
      let chemosetting = caseDetail.patientChemoSittingDTO;
      this.setState({ patChemoSittingIdPC: chemosetting.patChemoSittingId });
      this.setState({ cascadeChangePC: chemosetting.cascadeChange });
      this.setState({ chemoCycleNumberPC: chemosetting.chemoCycleNumber });
      //alert(this.formatDateMMDDYY(chemosetting.chemoDt));
      // if( this.formatDateMMDDYY(chemosetting.chemoDt) != '' ){
      //     alert("Alert:1111 "+ this.formatDateMMDDYY(chemosetting.chemoDt));
      //     this.setState({ chemoDtPC: this.formatDateMMDDYY(chemosetting.chemoDt) });
      // }else {
      //     alert("Alert: "+ this.formatDateMMDDYY(chemosetting.chemoDt));
      //     this.setState({ chemoDtPC: new Date() });
      // }
      this.setState({ chemoDtPC: this.formatDateDDMMYYYY(chemosetting.chemoDt) });
      this.setState({
        chemoPlannedDtPC: this.formatDateDDMMYYYY(chemosetting.chemoPlannedDt),
      });
      this.setState({ delayPC: chemosetting.delay });
      this.setState({ isCycleDelay: chemosetting.delay });
      this.setState({ delayCommentsPC: chemosetting.delayComments });
      this.setState({
        reasonForChemoDtChangePC: chemosetting.reasonForChemoDtChange,
      });
      this.setState({ treatmentGivenPC: chemosetting.treatmentGiven });
      this.setState({ chemoGivenPC: chemosetting.chemoGiven === 1 });
      this.setState({
        updatedDatePC: this.formatDateDDMMYYYY(chemosetting.updatedDate),
      });
      this.setState({ createdByIdUserPC: chemosetting.createdByIdUser });
      this.setState({
        upcomingChemoCycleNum: chemosetting.nextChemoCycleNumber,
      });
      this.setState({
        upcomingChemoDt:
          chemosetting.nextChemoCycleDate != null
            ? this.formatDateDDMMYYYY(chemosetting.nextChemoCycleDate)
            : "",
      });
      this.setState({
        lastChemoCycleNumber: chemosetting.previousChemoCycleNumber,
      });
      this.setState({
        lastChemoCycleDate: chemosetting.previousChemoCycleDate,
      });
      // Tolerate both the current misspelled DTO field and a corrected one, so a
      // future backend rename cannot silently blank this value. See the matching
      // note in getCreatinineClearance().
      this.setState({
        creatineClearance:
          chemosetting.serumCreatinineCleaerance ??
          chemosetting.serumCreatinineClearance ??
          "",
      });
      this.setState({ gcsfMedicinePC: chemosetting.gcsfMedicine });
      this.setState({ antiemeticRisks: chemosetting.antiemeticDrugs });
      this.setState({ boneMetasisDrug: chemosetting.boneMetasisDrug });
      this.setState({ antithromboticDrugs: chemosetting.antithromboticDrugs });
      this.setState({ postChemoDrugs: chemosetting.postChemoDrugs });
      this.setState({ nurseInstructions: chemosetting.nurseInstructions });
      this.setState({ patientInstructions: chemosetting.patientInstructions });
      this.setState({
        pharmacyInstructions: chemosetting.pharmacyInstructions,
      });
      // Use functional setState to avoid overwriting a value the user may have
      // already selected while this async API response was in flight.
      this.setState(prevState => {
        const resolved = prevState.premedications || chemosetting.premedications || "";
        console.log("[ChemoSitting Load] premedications resolve", {
          fromState: prevState.premedications,
          fromApi: chemosetting.premedications,
          resolved,
        });
        return { premedications: resolved };
      });
      this.setState(prevState => {
        const resolved = prevState.supplements || chemosetting.supplements || "";
        console.log("[ChemoSitting Load] supplements resolve", {
          fromState: prevState.supplements,
          fromApi: chemosetting.supplements,
          resolved,
        });
        return { supplements: resolved };
      });
      this.setState({ antiallergicDrugs: chemosetting.antiallergicDrugs });
      this.setState({ chemoScheduleIdPC: chemosetting.chemoScheduleId || null });
      this.fetchTreatmentDayForSitting(
        chemosetting.chemoScheduleId,
        chemosetting.chemoCycleNumber
      );
      this.setState({ followupAppointmentIdPC: chemosetting.followupAppointmentId || null });
      this.setState({ cascadeTreatPlanIds: [] });
      if (
        chemosetting.patientChemoSittingDosageDTOList &&
        chemosetting.patientChemoSittingDosageDTOList.length !== 0
      ) {
        let patientChemoSittingDosageList = [];
        chemosetting.patientChemoSittingDosageDTOList.forEach((obj) => {
          let data = {
            patientChemoSittingDId: obj.patientChemoSittingDId,
            chemoMedicineDosage: {
              chemoMedicineDId: obj.chemoMedicineDosage.chemoMedicineDId,
            },
            patientChemoSitting: {
              patChemoSittingId: obj.patientChemoSitting.patChemoSittingId,
            },
          };
          patientChemoSittingDosageList.push(data);
        });
        this.setState({
          patientChemoSittingDosageList: patientChemoSittingDosageList,
        });
      }
      this.getAntiemeticMedicineByChemoId(chemosetting.patChemoSittingId);
    }
  }

  fetchTreatmentDayForSitting(chemoScheduleId, chemoCycleNumber) {
    if ((!chemoScheduleId && !chemoCycleNumber) || !this.state.patientId) {
      this.setState({ treatmentDayNumberPC: "" });
      return;
    }
    fetch(
      C.getUrl() +
        "/userCase/getTreatmentDataForNewChemo?patientId=" +
        this.state.patientId
    )
      .then((res) => res.json())
      .then((res) => {
        if (res.statusCode === 200 && res.message) {
          const treatmentData = JSON.parse(res.message);
          const schedules =
            (treatmentData && treatmentData.length > 0
              ? treatmentData[0].chemoSchedules
              : []) || [];
          // Older sittings recorded before the ChemoSchedule FK was added
          // won't have a chemoScheduleId, so fall back to matching by
          // cycle number when the FK lookup comes up empty.
          let matchedSchedule = chemoScheduleId
            ? schedules.find(
                (schedule) =>
                  String(schedule.chemoScheduleId) === String(chemoScheduleId)
              )
            : null;
          if (!matchedSchedule && chemoCycleNumber) {
            matchedSchedule = schedules.find(
              (schedule) =>
                String(schedule.chemoCycleNumber) === String(chemoCycleNumber)
            );
          }
          this.setState({
            treatmentDayNumberPC: matchedSchedule
              ? matchedSchedule.treatmentDayNumber
              : "",
          });
        }
      })
      .catch((err) => {
        console.error("Error fetching treatment day for sitting:", err);
        this.setState({ treatmentDayNumberPC: "" });
      });
  }

  getAntiemeticMedicineByChemoId(patChemoSittingId) {
    return fetch(
      C.getUrl() +
        "/antiemeticTreatment/getAntiemeticMedicineByChemoId?patChemoSittingId=" +
        patChemoSittingId
    )
      .then((res) => res.json())
      .then((res) => {
        let obj = res;
        if (
          obj.statusCode == 200 &&
          obj !== null &&
          obj !== "undefined" &&
          obj.length != 0
        ) {
          let data = JSON.parse(obj.message);
          //console.log(' getAntiemeticMedicineForTeatment :: ' + JSON.stringify(data));
          this.setState({ antiemeticRiskLevel: data.antiemeticRiskLevel });
          this.setState({ regProtocolIdTmt: data.protocolId });
          this.getAllAntiemeticRegimens(data.protocolId);
        }
      })
      .catch((err) => {
      });
  }

  setTreatmentPlan(caseDetail) {
    if (caseDetail) {
      this.setState({
        patTreatmentPlanSummary: caseDetail.patientTreatmentPlanDTOList,
        canCreateTreatmentPlan: caseDetail.canCreateTreatmentPlan === true,
        diagnosisDate: caseDetail.diagnosisDate || '',
        diagnosisPrimarySite: caseDetail.primarySite || '',
      });
    } else {
      $("#uncontrolled-tab-example-tab-chemotherapy").hide();
      this.setState({ alertDismissibleshow: true, canCreateTreatmentPlan: false });
      //$("#contentMsg").show();
    }
    this.getAllTerminatedTreatments();
    setTimeout(this.refreshTicker, 0);
  }

  generatePlanNumber(mrNo, patientTreatmentPlanId) {
    // Get current year's last two digits
    const currentYear = new Date().getFullYear().toString().slice(-2);

    // Ensure mrNo is a string and padded with zeros if needed
    const formattedMrNo = mrNo.toString().padStart(4, "0");

    // Create the plan number in the format CE-MrNo-PatientTreatmentPlanId-YY
    return `CE-${formattedMrNo}-${patientTreatmentPlanId}-${currentYear}`;
  }

  getAllTerminatedTreatments() {
    fetch(
      C.getUrl() + "/userCase/getTerminatedTreatments/" + this.state.patientId
    )
      .then((res) => res.json())
      .then((res) => {
        let obj = res;
        if (
          obj.statusCode == 200 &&
          obj !== null &&
          obj !== "undefined" &&
          obj.length != 0
        ) {
          let data = JSON.parse(obj.message);
          this.setState({ patInactiveTreatmentPlan: data });
        }
      })
      .catch((err) => {
      });
  }

  treatmentPlanSavedSuccessHandler = (objmsg) => {
    let tempPatTreatmentPlanSummary = this.state.patTreatmentPlanSummary;
    let patTreatmentPlanSummaryFinalArr = [];
    let flag = false;
    tempPatTreatmentPlanSummary.forEach(function (obj) {
      if (obj.patientTreatmentPlanId == objmsg.patientTreatmentPlanId) {
        obj = objmsg;
        flag = true;
        patTreatmentPlanSummaryFinalArr.push(obj);
      } else {
        patTreatmentPlanSummaryFinalArr.push(obj);
      }
    });
    //console.log("tempPatTreatmentPlanSummary : "+JSON.stringify(tempPatTreatmentPlanSummary));
    //console.log("objmsg : "+flag);

    if (flag == false) {
      patTreatmentPlanSummaryFinalArr.push(objmsg);
    }
    //console.log("tempPatTreatmentPlanSummary after inser : "+JSON.stringify(tempPatTreatmentPlanSummary));
    this.setState({ patTreatmentPlanSummary: patTreatmentPlanSummaryFinalArr });
  };

  doSetMultipleTreatmentPlanIdHandler = (
    treatmentObj,
    protocolObj,
    cascadeTreatPlanIds,
    warningMsgConsent
  ) => {
    //alert("setMultipleTreatmentPlanIdHandler values : " + treatmentObj + " protocol : "+protocolObj+" cascadeTreatPlanIds "+ cascadeTreatPlanIds);
    const patientId = this.state.patientId;
    this.getKhoranaScore(patientId);
    this.getCreatinineClearance(patientId);
    this.setState({ boneMetasisDrug: "" });
    this.setState({ warningMsgConsent: warningMsgConsent });
    //this.setState({ antithromboticDrugs: ''});
    this.getSuggestiveTreatment(treatmentObj);
    this.getAntiemeticMedicineForTeatment(treatmentObj);
    this.getProtocolDetail(protocolObj);
    this.setState({ patChemoSittingIdPC: "" });
    // this.setState({ chemoDtPC: this.formatDateMMDDYY(new Date()) });
    this.setState({ chemoDtPC: new Date() });
    this.setState({ treatmentGivenPC: "" });
    this.setState({ chemoGivenPC: false });
    this.setState({ patientChemoSittingDosageList: [] });
    this.setState({ gcsfMedicinePC: "" });
    this.setState({ assesFNRiskFlag: "N" });
    this.setState({ antiemeticRisks: "" });
    this.setState({ postChemoDrugs: "" });
    this.setState({ nurseInstructions: "" });
    this.setState({ patientInstructions: "" });
    this.setState({ pharmacyInstructions: "" });
    this.setState({ premedications: "" });
    this.setState({ supplements: "" });
    this.setState({ antiallergicDrugs: "" });
    this.setState({ cascadeTreatPlanIds: cascadeTreatPlanIds });
    setTimeout(() => {
      this.setState({ antithromboticDrugs: "" });
    }, 4000);
  };

  setMultipleTreatmentPlanIdHandler = (
    treatmentObj,
    protocolObj,
    cascadeTreatPlanIds,
    warningMsgConsent
  ) => {
    // Chemo-date validation is no longer done here. The save-time gate
    // (saveUserCase / BE-DA-04) now runs on every chemo-sitting save that
    // resolves a schedule, independent of cascadeTreatPlanIds, and returns
    // the same 451 block / 200+subErrors warnings on the Save response
    // (handled in saveChemoSitting). See docs/NewChemo-Flow.md §7.
    this.doSetMultipleTreatmentPlanIdHandler(
      treatmentObj,
      protocolObj,
      cascadeTreatPlanIds,
      warningMsgConsent
    );
  };

  getProtocolDetail(protocolId) {
    return fetch(C.getUrl() + "/protocol/getProtocolDetails/" + protocolId)
      .then((res) => res.json())
      .then((res) => {
        let resObj = res;
        let protolObj = JSON.parse(resObj.message);
        this.setState({ fnRiskTmt: protolObj.fnRisk });
      })
      .catch((err) => {
      });
  }

  radioChange = (e) => {
    this.setState({
      groupThree: e.target.value,
    });
    let antithromboticDrugs = e.target.value;
    this.setState({ antithromboticDrugs: antithromboticDrugs });
  };
  getAntiemeticMedicineForTeatment(treatmentObj) {
    let data = treatmentObj;

    return fetch(
      C.getUrl() + "/antiemeticTreatment/getAntiemeticMedicineForTeatment",
      {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
        },
      }
    )
      .then((res) => res.json())
      .then((res) => {
        let obj = res;
        if (
          obj.statusCode == 200 &&
          obj !== null &&
          obj !== "undefined" &&
          obj.length != 0
        ) {
          let data = JSON.parse(obj.message);
          //console.log(' getAntiemeticMedicineForTeatment :: ' + JSON.stringify(data));
          this.setState({ antiemeticRiskLevel: data.antiemeticRiskLevel });
          this.setState({ regProtocolIdTmt: data.protocolId });
          this.getAllAntiemeticRegimens(data.protocolId);
        }
      })
      .catch((err) => {
      });
  }

  setInitialAssesmentDetail(caseDetail) {
    if (caseDetail.patInitiAssesmentDto) {
      let initialAssessment = caseDetail.patInitiAssesmentDto;
      //this.getPatientMedicines(this.state.patientId);
      this.setState({
        patientIniAssessmentId: initialAssessment.patientIniAssessmentId,
      });
      this.setState({
        patientIniAssessmentDt: this.formatDateMMMDDYYY(
          initialAssessment.patientIniAssessmentDt
        ),
      });
      //this.setState({ doctorPrescription: initialAssessment.doctorPrescription });
      this.setState({ doctorObservation: initialAssessment.doctorObservation });
      this.setState({ pathology: initialAssessment.pathologyText });
      /*
            if(initialAssessment.pathologyMasterDTO !== undefined
                && initialAssessment.pathologyMasterDTO.pathologyId != ''){
                this.setState({ pathology: initialAssessment.pathologyMasterDTO.pathologyId });

                var selectedPathology = [];
                selectedPathology.push({ id: initialAssessment.pathologyMasterDTO.pathologyId, label: initialAssessment.pathologyMasterDTO.pathologyName });
                this.setState({ pathologyIdIAD: selectedPathology });
            } */
      if (
        initialAssessment.stageMasterDTO !== undefined &&
        initialAssessment.stageMasterDTO.stageId != ""
      ) {
        this.setState({
          cancerStage: initialAssessment.stageMasterDTO.stageId,
        });
      }
      this.setState({ boneMetasis: initialAssessment.boneMetasis });
      this.setState({ brainMets: initialAssessment.brainMets });
      if (
        caseDetail.patInitiAssesmentDto.patientCancerSiteDTOList &&
        caseDetail.patInitiAssesmentDto.patientCancerSiteDTOList.size !== 0
      ) {
        let patCancerSiteList =
          caseDetail.patInitiAssesmentDto.patientCancerSiteDTOList;
        var selectedCancerSite = [];
        var selectedCancerSiteName = [];
        patCancerSiteList.map(function (d) {
          selectedCancerSite.push({
            id: d.cancerSiteMstDto.cancerSiteId,
            name: d.cancerSiteMstDto.cancerSiteName,
          });
          selectedCancerSiteName.push(d.cancerSiteMstDto.cancerSiteName);
        });
        this.setState({ canSiteIdIAD: selectedCancerSite });
        this.setState({ canSiteNameIAD: selectedCancerSiteName });
      }
      if (
        caseDetail.patInitiAssesmentDto.patientPrevCancerSiteDTOList &&
        caseDetail.patInitiAssesmentDto.patientPrevCancerSiteDTOList.size !== 0
      ) {
        let patPrevCancerSiteList =
          caseDetail.patInitiAssesmentDto.patientPrevCancerSiteDTOList;
        var selectedCancerSite = [];
        var selectedCancerSiteName = [];
        patPrevCancerSiteList.map(function (d) {
          selectedCancerSite.push({
            id: d.cancerSiteMstDTO.cancerSiteId,
            name: d.cancerSiteMstDTO.cancerSiteName,
          });
          selectedCancerSiteName.push(d.cancerSiteMstDTO.cancerSiteName);
        });
        this.setState({ prevCanSiteIdIAD: selectedCancerSite });
        this.setState({ prevCanSiteNameIAD: selectedCancerSiteName });
      }
      if (
        caseDetail.patInitiAssesmentDto.patientLimbLossDTOList &&
        caseDetail.patInitiAssesmentDto.patientLimbLossDTOList.size !== 0
      ) {
        let patLimbLossList =
          caseDetail.patInitiAssesmentDto.patientLimbLossDTOList;
        var selectedLimbLoss = [];
        var selectedLimbLossName = [];
        patLimbLossList.map(function (d) {
          selectedLimbLoss.push({
            id: d.limbLossMasterDTO.limbLossId,
            name: d.limbLossMasterDTO.limbLossName,
          });
          selectedLimbLossName.push(d.limbLossMasterDTO.limbLossId);
        });
        this.setState({ limbLossIdIAD: selectedLimbLoss });
        this.setState({ limbLossNameIAD: selectedLimbLossName });
      }
      if (
        caseDetail.patInitiAssesmentDto.patientMutationXrefList &&
        caseDetail.patInitiAssesmentDto.patientMutationXrefList.size !== 0
      ) {
        let patientMutationXrefList =
          caseDetail.patInitiAssesmentDto.patientMutationXrefList;
        var selectedMutationId = [];
        var selectedMutationName = [];
        patientMutationXrefList.map(function (d) {
          selectedMutationId.push({
            id: d.mutationMstDTO.mutationId,
            name: d.mutationMstDTO.mutationName,
          });
          selectedMutationName.push(d.mutationMstDTO.mutationName);
        });
        this.setState({ mutationIdIA: selectedMutationId });
        this.setState({ mutationNameIA: selectedMutationName });
      }
    }
    setTimeout(this.refreshTicker, 0);
  }

  setPatientDetail(obj) {
    if (obj) {
      this.setState({ patientId: obj.patientID });
      this.setState({ registrationDate: obj.registrationDate });
      this.setState({ caseNo: obj.caseId });
      this.setState({ doctorId: obj.doctor.userId });
      this.setState({
        doctorName: "Dr " + obj.doctor.firstName + " " + obj.doctor.lastName,
      });
      this.setState({ firstName: obj.firstName });
      this.setState({ middleName: obj.middleName });
      this.setState({ lastName: obj.lastName });
      this.setState({ emailId: obj.emailId });
      this.setState({ dob: obj.dob });
      this.setState({ patientAge: this.getPatientAge(obj.dob) });
      this.setState({ genderName: obj.genderMstDto.genderName });
      this.setState({ phoneNumber1: obj.phoneNumber1 });
      this.setState({ instituteDto: obj.instituteDto });
      this.setState({ weight: obj.weight });
      this.setState({ height: obj.height });
      this.setState({ heightUnit: obj.heightUnitDto?.unitName?.toLowerCase() || 'cm' });
      this.setState({ weightUnit: obj.weightUnitDto?.unitName || '' });
      this.setState({ weightUnitId: obj.weightUnitDto?.unitId || '' });
      this.setState({
        weightShow: obj.weight + (obj.weightUnitDto ? " " + obj.weightUnitDto.unitName : ''),
      });
      this.setState({
        isCurrentTreatmentTerminated: obj.isCurrentTreatTerminated,
      });
      this.setState({ anyOngoingTreatment: obj.onGoingTreatment });
      this.setState({ profilePictureName1: obj.profilePictureName1 });
      this.setState({ profilePictureData1: obj.profilePictureData1 });
       // Add bloodGroup here
    this.setState({ bloodGroup: obj.bloodGroup });

      if (obj.dischargeDate) {
        this.setState({ dischargeDate: obj.dischargeDate });
      }
      const isOngoingTreatmentSelected = obj.onGoingTreatment === "Yes";
      this.setState({
        isOngoingTreatmentSelected: isOngoingTreatmentSelected,
        otherOngoingTreatment: isOngoingTreatmentSelected
          ? obj.otherOngoingTreatment || ""
          : "",
      });
      this.setState({
        referralSource: obj.referralSource,
        isReferralDoctorSelected: obj.referralSource === "Physician/Doctor",
        isReferralHospitalSelected: obj.referralSource === "Hospital",
        referralDoctorName: obj.referralDoctorName || "",
        referralHospital: obj.referralHospital || "",
      });
      if (obj.patientAllergies) {
        const selectedAllergies = obj.patientAllergies.map((allergy) => ({
          id: allergy.allergiesMstDTO.allergiesId,
          name: allergy.allergiesMstDTO.allergiesName,
        }));
        this.setState({ selectedAllergies });
      }
      if (obj.patientComorbidities) {
        const selectedComorbidities = obj.patientComorbidities.map(
          (comorbidity) => ({
            id: comorbidity.comorbiditiesDto.comorbiditiesId,
            name: comorbidity.comorbiditiesDto.comorbiditiesName,
          })
        );
        this.setState({ selectedComorbidities });
      }
      if (obj.allergies !== undefined && obj.allergies != "") {
        this.setState({ allergies: obj.allergies });
      }
      if (
        obj.otherComorbidities !== undefined &&
        obj.otherComorbidities != ""
      ) {
        this.setState({ otherComorbidities: obj.otherComorbidities });
      }
      if (obj.onGoingTreatment !== undefined && obj.onGoingTreatment != "") {
        this.setState({ onGoingTreatment: obj.onGoingTreatment });
      }

      // Store individual patient details from state to localStorage
      localStorage.setItem("PatientfirstName", this.state.firstName);
      localStorage.setItem("PatientlastName", this.state.lastName);
      localStorage.setItem("PatientpatientId", this.state.patientId);

      // Refresh ticker once the above state updates have flushed.
      setTimeout(this.refreshTicker, 0);
    }
  }

  handleMedicationChange = (e) => {
    const value = e.target.value;

    if (value === "Other") {
      this.setState({
        premedications: "Other",
        premedicationOther: this.state.premedicationOther, // Keep the current value in the text box
        disableForDexamethasone: false, // Reset the disable flag if "Other" is selected
      });
    } else if (value === "Dexamethasone") {
      // If Dexamethasone is selected, enable the disabling logic
      this.setState({
        premedications: value,
        premedicationOther: "", // Reset the text box if not 'Other'
        disableForDexamethasone: true, // Enable disabling of certain antiemetic options
      });
    } else {
      this.setState({
        premedications: value,
        premedicationOther: "", // Reset the text box if not 'Other'
        disableForDexamethasone: false, // Reset the disable flag for other options
      });
    }
  };

  handleSupplementChange = (e) => {
    const value = e.target.value;

    if (value === "Other") {
      this.setState({
        supplements: "Other",
        supplementOther: this.state.supplementOther, // Keep the current value in the text box
      });
    } else {
      this.setState({
        supplements: value,
        supplementOther: "", // Reset the text box if not 'Other'
      });
    }
  };

  getAllCancerSite = async () => {
    fetch(C.getUrl() + "/cancerSite/getAllCancerSites")
      .then((res) => res.json())
      .then((res) => {
        let resObj = JSON.parse(res.message);
        var arr = [];
        resObj.map(function (d) {
          arr.push({ id: d.selectionId, name: d.selectionValue });
        });
        this.setState({ canSitesArr: arr });
      })
      .catch((err) => {
      });
  };

  getPathology = async () => {
    fetch(C.getUrl() + "/pathologyMaster/getallPathologyMasters")
      .then((res) => res.json())
      .then((res) => {
        let data = JSON.parse(res.message);
        var arr = [];
        data.map((d, index) => {
          let jsonList = new Object();
          jsonList["key"] = Crypt.getUniqueKey(index);
          jsonList["id"] = d.selectionId;
          jsonList["label"] = d.selectionValue;
          arr.push(jsonList);
        });
        this.setState({ pathologyMstArr: arr });
      })
      .catch((err) => {
      });
  };

  getAllLimbLossMstData = async () => {
    fetch(C.getUrl() + "/limbLossMst/getAllLimbLoss")
      .then((res) => res.json())
      .then((res) => {
        let resObj = JSON.parse(res.message);
        var arr = [];
        resObj.map(function (d) {
          arr.push({ id: d.selectionId, name: d.selectionValue });
        });
        this.setState({ limbLossArr: arr });
      })
      .catch((err) => {
      });
  };

  getAllMutation = async () => {
    fetch(C.getUrl() + "/mutation/getAll")
      .then((res) => res.json())
      .then((res) => {
        let resObj = JSON.parse(res.message);
        var arr = [];
        resObj.map(function (d) {
          arr.push({ id: d.selectionId, name: d.selectionValue });
        });
        this.setState({ mutationArr: arr });
      })
      .catch((err) => {
      });
  };

  getAllAdverseEffectMaster = async () => {
    fetch(C.getUrl() + "/adverseEffectMaster/getAllAdverseEffectMaster")
      .then((res) => res.json())
      .then((res) => {
        let resObj = JSON.parse(res.message);
        var arr = [];
        resObj.map(function (d) {
          arr.push({
            id: d.selectionId,
            name: d.selectionValue,
            desc: d.selectionDesc,
          });
        });
        this.setState({ followupAdverseEffectArr: arr });
      })
      .catch((err) => {
      });
  };

  handleChange(event) {
    if (event.target.name == "pathology") {
      this.setState({ pathology: event.target.value });
    }
    if (event.target.name === "doctorObservation") {
      this.setState({ doctorObservation: event.target.value });
    }
    // if (event.target.name === 'doctorPrescription') {
    //     this.setState({ doctorPrescription: event.target.value });
    // }
    if (event.target.name === "cancerStage") {
      this.setState({ cancerStage: event.target.value });
    }
    if (event.target.name === "boneMetasis") {
      this.setState({ boneMetasis: event.target.value });
    }
    if (event.target.name === "brainMets") {
      this.setState({ brainMets: event.target.value });
    }
    if (event.target.name === "otherComorbidities") {
      this.setState({ otherComorbidities: event.target.value });
    }
    if (event.target.name === "otherAllergies") {
      this.setState({ otherAllergies: event.target.value });
    }
  }

  getCancerStage = async () => {
    fetch(C.getUrl() + "/stageMaster/getallStages/")
      .then((res) => res.json())
      .then((res) => {
        let data = JSON.parse(res.message);
        var arr = [];
        data.map((item, index) => {
          let jsonList = new Object();
          jsonList["key"] = Crypt.getUniqueKey(index);
          jsonList["id"] = item.stageId;
          jsonList["label"] = item.stageName;
          arr.push(jsonList);
        });
        this.setState({ cancerStageMstArr: arr }, this.refreshTicker);
      })
      .catch((err) => {
      });
  };

  handleChemoSittingChange(event) {
    if (event.target.name === "cycleDelay") {
      this.setState({
        isCycleDelay: event.target.value === "Y" ? true : false,
        delayPC: event.target.value,
      });
    }
    if (event.target.name === "treatmentGivenPC") {
      this.setState({ treatmentGivenPC: event.target.value });
    }
    if (event.target.name === "delayCommentPC") {
      this.setState({ delayCommentsPC: event.target.value });
    }
    if (event.target.name === "reasonForChemoDtChangePC") {
      this.setState({ reasonForChemoDtChangePC: event.target.value });
    }
    if (event.target.name === "cascadeFuture") {
      this.setState({ cascadeChangePC: event.target.value });
    }
    if (event.target.name === "gcsfMedicinePC") {
      this.setState({ gcsfMedicinePC: event.target.value });
    }
  }
  // Dedicated handler for the "Date of Chemotherapy" DatePicker.
  // antd's DatePicker.onChange passes (moment, dateString) — there is no
  // event.target, so it must not be routed through handleChemoSittingChange.
  // Store the value in the same DD-MM-YYYY string format used everywhere
  // else for chemoDtPC (see formatDateDDMMYYYY / setChemoSetting).
  handleChemoDtChange = (date, dateString) => {
    this.setState({ chemoDtPC: date ? this.formatDateDDMMYYYY(date) : "" });
  };
  setGCSFMedicineSelected = (value) => {
    this.setState({ gcsfMedicinePC: value });
  };
  getPatientWeight() {
    return this.state.weight + " " + this.state.weightUnit;
  }

// Modify the handleFollowupReportChange method to update patient height in the patient table
handleFollowupReportChange(event) {
  const { name, value } = event.target;
  
  // Existing functionality for other fields
  if (name === "observe") {
    this.setState({ observe: value });
  } else if (name === "prescription") {
    this.setState({ prescription: value });
  } else if (name === "weightFollowup") {
    this.setState({ weight: value });
  } else if (name === "heightFollowup") {
    // Update height in state
    this.setState({ height: value }, () => {
      // Also update the patient record with the new height
      // We pass both height and weight to make sure we don't lose weight data
      this.updatePatientHeightWeight(value, this.state.weight)
        .then(result => {
          if (result.success) {
          } else {
          }
        })
        .catch(error => {
        });
    });
  }
}
  validateInitialAssesment() {
    let formIsValid = true;
    let errors = {};
    if (
      this.state.canSiteIdIAD === null ||
      this.state.canSiteIdIAD.length === 0
    ) {
      errors["canSiteIdIAD"] = "Please select Current Diagnosis";
      formIsValid = false;
    }
    if (
      this.state.mutationIdIA === null ||
      this.state.mutationIdIA.length === 0
    ) {
      errors["mutationIdIA"] = "Please select Mutation";
      formIsValid = false;
    }
    if (
      this.state.doctorObservation === null ||
      this.state.doctorObservation === ""
    ) {
      errors["doctorObservation"] = "Please enter Doctor Observation";
      formIsValid = false;
    }
    // if (this.state.doctorPrescription === null || this.state.doctorPrescription === "") {
    //     errors["doctorPrescription"] = "Please enter Doctor Prescription";
    //     formIsValid = false;
    // }
    if (this.state.pathology === null || this.state.pathology === "") {
      errors["pathology"] = "Please enter Pathology";
      formIsValid = false;
    }

    // Validate Cancer Stage
    if (this.state.cancerStage === null || this.state.cancerStage === "") {
      errors["cancerStage"] = "Please select Cancer Stage";
      formIsValid = false;
    }

    // Validate Limb Loss
    if (
      this.state.limbLossIdIAD === null ||
      this.state.limbLossIdIAD.length === 0
    ) {
      errors["limbLossIdIAD"] = "Please select Limb Loss";
      formIsValid = false;
    }

    // Validate Previous Cancer History
    if (
      this.state.prevCanSiteIdIAD === null ||
      this.state.prevCanSiteIdIAD.length === 0
    ) {
      errors["prevCanSiteIdIAD"] = "Please select Previous Cancer History";
      formIsValid = false;
    }
    this.setState({ initialAssesmentErrors: errors });
    return formIsValid;
  }

  saveInitialAssesment(event) {
    event.disabled = true;
    this.setState({ saveLoader: true });

    // First get initial assessment data from DiagnosisManagement component
    if (this.diagnosisManagementRef && this.diagnosisManagementRef.current) {
      // Get initial assessment data from child component - this returns an object, not a Promise
      const initialData =
        this.diagnosisManagementRef.current.getInitialAssessmentData();

      // Process cancer site data
      var cancerSiteList = [];
      if (
        initialData.canSiteIdIAD !== null &&
        initialData.canSiteIdIAD.length !== 0
      ) {
        initialData.canSiteIdIAD.forEach(function (obj) {
          let data = {
            cancerSiteMstDto: {
              cancerSiteId: obj.id,
            },
          };
          cancerSiteList.push(data);
        });
      }

      // Process previous cancer site data
      var prevCancerSiteList = [];
      if (
        initialData.prevCanSiteIdIAD !== null &&
        initialData.prevCanSiteIdIAD.length !== 0
      ) {
        initialData.prevCanSiteIdIAD.forEach(function (obj) {
          let dataObject = {
            cancerSiteMstDTO: {
              cancerSiteId: obj.id,
            },
          };
          prevCancerSiteList.push(dataObject);
        });
      }

      // Process limb loss data
      var limbLossList = [];
      if (
        initialData.limbLossIdIAD !== null &&
        initialData.limbLossIdIAD.length !== 0
      ) {
        initialData.limbLossIdIAD.forEach(function (obj) {
          let dataObject = {
            limbLossMasterDTO: {
              limbLossId: obj.id,
            },
          };
          limbLossList.push(dataObject);
        });
      }

      // Process mutation data
      var mutationList = [];
      if (
        initialData.mutationIdIA !== null &&
        initialData.mutationIdIA.length !== 0
      ) {
        initialData.mutationIdIA.forEach(function (obj) {
          let data = {
            mutationMstDTO: {
              mutationId: obj.id,
            },
          };
          mutationList.push(data);
        });
      }

      // Create payload for initial assessment API
      let data = {
        status: "I",
        patInitiAssesmentDto: {
          creationDate: new Date(),
          doctorObservation: initialData.doctorObservation,
          pathologyText: initialData.pathology,
          pathology: initialData.pathologyText || initialData.pathology, // Use pathology as fallback
          patientDTO: {
            patientID: this.state.patientId,
          },
          createdByIdUser: {
            userId: this.state.doctorId,
          },
          stageMasterDTO: {
            stageId: initialData.cancerStage,
          },
          patientCancerSiteDTOList: cancerSiteList,
          patientPrevCancerSiteDTOList: prevCancerSiteList,
          patientLimbLossDTOList: limbLossList,
          patientMutationXrefList: mutationList,
          boneMetasis: initialData.boneMetasis,
          brainMets: initialData.brainMets,
        },
      };

      this.setState({ caseStatus: "I" });

      // Save initial assessment data
      fetch(C.getUrl() + "/userCase/saveUserCase", {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => res.json())
        .then(async (res) => {
          const result = classifySaveUserCaseResponse(res);
          if (result.outcome !== SaveOutcome.SUCCESS) {
            this.setState({ saveLoader: false });
            swal({
              title: result.outcome === SaveOutcome.BLOCKED ? "Cannot Save" : "Error!",
              text: result.message,
              icon: "error",
              buttons: false,
              timer: 3000,
            });
          } else {
            if (result.warnings) {
              swal({
                title: "Saved with Warnings",
                text: result.warnings.join("\n"),
                icon: "warning",
                buttons: false,
                timer: 3000,
              });
            }
            let objmsg = result.saved;

            if (objmsg != null && objmsg.patientIniAssessmentId != 0) {
              // Set the initial assessment ID in state
              this.setState(
                { patientIniAssessmentId: objmsg.patientIniAssessmentId },
                async () => {
                  try {
                    // Check if the diagnosisManagementRef exists and has the component
                    if (
                      this.diagnosisManagementRef &&
                      this.diagnosisManagementRef.current
                    ) {

                      // Call the saveDiagnosis method on the diagnosis component
                      const diagnosisResult =
                        await this.diagnosisManagementRef.current.saveDiagnosis(
                          objmsg.patientIniAssessmentId
                        );


                      // Handle any errors from saving diagnosis
                      if (diagnosisResult && !diagnosisResult.success) {
                        swal({
                          title: "Warning!",
                          text:
                            "Initial assessment was saved but there was an issue saving diagnosis: " +
                            diagnosisResult.error,
                          icon: "warning",
                          buttons: false,
                          timer: 3000,
                        });
                      } else {
                        swal({
                          title: "Success!",
                          text: "Initial assessment and diagnosis saved successfully!",
                          icon: "success",
                          buttons: false,
                          timer: 2000,
                        });
                      }
                    } else {
                      swal({
                        title: "Warning!",
                        text: "Initial assessment saved but diagnosis component not found",
                        icon: "warning",
                        buttons: false,
                        timer: 3000,
                      });
                    }
                  } catch (diagErr) {
                    swal({
                      title: "Warning!",
                      text: "Initial assessment was saved but there was an issue saving diagnosis",
                      icon: "warning",
                      buttons: false,
                      timer: 2000,
                    });
                  } finally {
                    // Complete the save process and reload page
                    setTimeout(() => {
                      this.setState({
                        saveLoader: false,
                        alertModalshow: false,
                      });
                      window.location.reload(false);
                    }, 2000);
                  }
                }
              );
            } else {
              // If no initial assessment ID, just complete normally
              this.setState({ alertModalshow: true });
              setTimeout(() => {
                this.setState({ saveLoader: false, alertModalshow: false });
                window.location.reload(false);
              }, 2000);
            }
          }
        })
        .catch((err) => {
          this.setState({ saveLoader: false, errorAlertshow: true });
          setTimeout(() => {
            this.setState({ errorAlertshow: false });
          }, 3000);
        });
    } else {
      this.setState({ saveLoader: false });
      swal({
        title: "Error!",
        text: "Cannot access diagnosis component. Please refresh the page and try again.",
        icon: "error",
        buttons: false,
        timer: 3000,
      });
    }
  }

  getPatientMedicines = async (patientId) => {
    try {
      const response = await fetch(
        C.getUrl() +
          "/additionalMedicationListXref/getPatientAdditionalMedications?patientId=" +
          patientId
      );

      const resObj = await response.json();

      if (
        resObj.statusCode === 200 &&
        resObj.message &&
        resObj.message !== "No records found"
      ) {
        const medicines = JSON.parse(resObj.message);
        const activeMedicines = medicines.filter((m) => m.activeInd === "Y");

        if (activeMedicines.length > 0) {
          // Parse the duration into value and unit
          const medicationDetails = activeMedicines.map((m) => {
            let durationValue = "";
            let durationUnit = "Days";

            if (m.duration) {
              const durParts = m.duration.split(" ");
              if (durParts.length >= 2) {
                durationValue = durParts[0];
                durationUnit = durParts[1];
              } else {
                durationValue = m.duration;
              }
            }

            return {
              medicine: {
                id: m.medicineId,
                name: m.medicineName,
                medicineId: m.medicineId,
                medicineListXrefId: m.medicineListXrefId,
              },
              dose: m.dose,
              when: m.when,
              durationValue: durationValue,
              durationUnit: durationUnit,
              duration: m.duration,
              instructions: m.instructions,
              isSaved: true,
            };
          });

          this.setState({ medicationDetails: medicationDetails });
        } else {
          // Initialize with one empty row if no active medicines found
          this.setState({
            medicationDetails: [
              {
                medicine: null,
                dose: "",
                when: "",
                durationValue: "",
                durationUnit: "Days",
                instructions: "",
                isSaved: false,
              },
            ],
          });
        }
      } else {
        // Initialize with one empty row if no medicines found
        this.setState({
          medicationDetails: [
            {
              medicine: null,
              dose: "",
              when: "",
              durationValue: "",
              durationUnit: "Days",
              instructions: "",
              isSaved: false,
            },
          ],
        });
      }

      // Load master data for dropdowns
      await Promise.all([
        this.getAllMedicines(),
        this.getAllDoses(),
        this.getAllWhens(),
      ]);
    } catch (err) {

      // Initialize with one empty row on error
      this.setState({
        medicationDetails: [
          {
            medicine: null,
            dose: "",
            when: "",
            durationValue: "",
            durationUnit: "Days",
            instructions: "",
            isSaved: false,
          },
        ],
      });

      // Still try to load master data for dropdowns
      await Promise.all([
        this.getAllMedicines(),
        this.getAllDoses(),
        this.getAllWhens(),
      ]);
    }
  };

  validateFollowupReport() {
    let formIsValid = true;
    let errors = {};
    if (this.state.observe === null || this.state.observe === "") {
      errors["observe"] = "Please enter Observations";
      formIsValid = false;
    }
    if (this.state.prescription === null || this.state.prescription === "") {
      errors["prescription"] = "Please enter Prescription";
      formIsValid = false;
    }
    if (this.state.height === null || this.state.height === "") {
      errors["height"] = "Please enter Height";
      formIsValid = false;
    }
    if (this.state.weight === null || this.state.weight === "") {
      errors["weight"] = "Please enter Weight";
      formIsValid = false;
    }
    this.setState({ followupErrors: errors });
    return formIsValid;
  }

  captureFollowupSnapshot(data) {
    this.followupSnapshot = {
      creationDateFP: data.appointmentDt,
      observe: data.doctorObservation || "",
      prescription: data.doctorPrescription || "",
      pulse: data.pulse || "",
      temperature: data.temperature || "",
      bpSystolic: data.bpSystolic || "",
      bpDiastolic: data.bpDiastolic || "",
      spO2: data.spO2 || "",
      bloodGlucose: data.bloodGlucose || "",
      glucoseTestType: data.glucoseTestType || "",
      bsa: data.bsa || "",
      bmi: data.bmi || "",
      weight: data.weight || "",
      adverseEffectIds: (data.followupAdverseEffectDTOList || [])
        .map((e) => e.reportParameterMstDTO.reportParamId)
        .sort()
        .join(","),
    };
  }

  isFollowupDirty() {
    if (!this.followupSnapshot) return true;
    const s = this.followupSnapshot;
    const n = (v) => (v === null || v === undefined ? "" : String(v));
    const currentAdverseIds = (this.state.followupAdverseEffectIdIAD || [])
      .map((e) => e.id)
      .sort()
      .join(",");
    return (
      n(this.state.creationDateFP) !== n(s.creationDateFP) ||
      n(this.state.observe) !== n(s.observe) ||
      n(this.state.prescription) !== n(s.prescription) ||
      n(this.state.pulse) !== n(s.pulse) ||
      n(this.state.temperature) !== n(s.temperature) ||
      n(this.state.bpSystolic) !== n(s.bpSystolic) ||
      n(this.state.bpDiastolic) !== n(s.bpDiastolic) ||
      n(this.state.spO2) !== n(s.spO2) ||
      n(this.state.bloodGlucose) !== n(s.bloodGlucose) ||
      n(this.state.glucoseTestType) !== n(s.glucoseTestType) ||
      n(this.state.bsa) !== n(s.bsa) ||
      n(this.state.bmi) !== n(s.bmi) ||
      n(this.state.weight) !== n(s.weight) ||
      currentAdverseIds !== s.adverseEffectIds
    );
  }

  // First gate for '+New Appt.' on the Pre Chemotherapy Vitals tab.
  // Checks the patient's eligible chemo schedule and shows a confirmation/info
  // dialog before anything else runs. Only the "good to go" (200) case, on OK,
  // continues into the skipped-cycles check; all other outcomes end the flow.
  async handleNewApptClick() {
    try {
      const res = await fetch(
        C.getUrl() +
          "/userCase/getEligibleChemoSchedule?patientId=" +
          this.state.patientId
      );
      const json = await res.json();
      const data = json && json.data ? json.data : {};
      const protocolName =
        (data.patTreatmentPlanDTO &&
          data.patTreatmentPlanDTO.protocolMstDTO &&
          data.patTreatmentPlanDTO.protocolMstDTO.protocolName) ||
        "";
      const cycle = data.chemoCycleNumber;
      const day = data.treatmentDayNumber;
      // ISO datetime at midnight UTC — read as a date-only value in UTC to
      // avoid an off-by-one-day shift in negative-offset timezones.
      const chemoDt = data.chemoDt
        ? moment.utc(data.chemoDt).format("DD-MMM-YYYY")
        : "";

      switch (json && json.statusCode) {
        case 200: {
          const confirmed = await swal({
            title: "Chemotherapy Eligibility",
            text: `Eligible date for ${protocolName}, cycle ${cycle} day ${day} falls on ${chemoDt}. Do you want to proceed?`,
            icon: "info",
            buttons: { cancel: "Cancel", confirm: { text: "OK", value: true } },
          });
          if (!confirmed) return;
          this.runSkippedCyclesCheck();
          return;
        }
        case 450:
          await swal({
            title: "Chemotherapy Eligibility",
            text: `Eligible date for ${protocolName}, cycle ${cycle} day ${day} falls on ${chemoDt}. Please take an appointment for that date and revisit the hospital.`,
            icon: "warning",
            button: "OK",
          });
          return;
        case 452:
          await swal({
            title: "Chemotherapy Eligibility",
            text: `Eligible date for ${protocolName}, cycle ${cycle} day ${day} was on ${chemoDt}. Please consult the Oncologist and create a new treatment plan.`,
            icon: "warning",
            button: "OK",
          });
          return;
        case 451:
          await swal({
            title: "Chemotherapy Eligibility",
            text: "Chemotherapy schedule for the patient is over or no treatment is planned yet. Please consult the Oncologist and create a new treatment plan.",
            icon: "warning",
            button: "OK",
          });
          return;
        default:
          await swal({
            title: "Error",
            text: "Unable to verify chemo eligibility. Please try again.",
            icon: "error",
            button: "OK",
          });
          return;
      }
    } catch (err) {
      console.log("Eligible-chemo check failed: " + err);
      await swal({
        title: "Error",
        text: "Unable to verify chemo eligibility. Please try again.",
        icon: "error",
        button: "OK",
      });
    }
  }

  // Second gate for '+New Appt.': checks for skippable chemo cycles before
  // today; if any exist, prompt the clinician to register a deviation,
  // otherwise proceed with the existing new-appointment flow.
  async runSkippedCyclesCheck() {
    try {
      const d = new Date();
      const toDate = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
      const res = await fetch(
        C.getUrl() +
          "/userCase/getChemoScheduleListBeforeDate?patientId=" +
          this.state.patientId +
          "&toDate=" +
          toDate
      );
      const json = await res.json();
      const list =
        json && json.statusCode === 200 && Array.isArray(json.data)
          ? json.data
          : [];
      if (list.length === 0) {
        this.addNewFollowup();
        return;
      }
      this.setState({ showSkippedCyclesPopup: true });
      this.skippedCyclesChild.current.setRows(list);
    } catch (err) {
      console.log("Skip-cycle check failed: " + err);
      this.addNewFollowup(); // graceful degradation — don't block appt creation if GET fails
    }
  }

  closeSkippedCyclesPopup = () => {
    this.setState({ showSkippedCyclesPopup: false });
  };

  async addNewFollowup(event) {
    this.followupSnapshot = null;
    let advereffect = [];
    if (
      this.state.followupAdverseEffectIdIAD !== null &&
      this.state.followupAdverseEffectIdIAD.length !== 0
    ) {
      this.state.followupAdverseEffectIdIAD.forEach(function (obj) {
        let data = {
          reportParameterMstDTO: {
            reportParamName: obj.name,
          },
        };
        advereffect.push(data);
      });
    }

    let tempData = {
      appointmentId: this.state.appointmentId,
      appointmentDt: this.state.creationDateFP,
      doctorObservation: this.state.observe,
      pulse: this.state.pulse,
      temperature: this.state.temperature,
      bpSystolic: this.state.bpSystolic,
      bpDiastolic: this.state.bpDiastolic,
      spO2: this.state.spO2,
      bloodGlucose: this.state.bloodGlucose,
      glucoseTestType: this.state.glucoseTestType,
      bsa: this.state.bsa,
      bmi: this.state.bmi,
      doctorPrescription: this.state.prescription,
      appointmentReports: this.state.appointmentReports,
      weight: this.state.weight,
      height: this.state.height,
      heightUnit: this.state.heightUnit || 'cm',
      weightUnitDto: {
        unitId: this.state.weightUnitId || 1,
        unitName: this.state.weightUnit || 'KG',
      },
      followupAdverseEffectIdIAD: this.state.followupAdverseEffectIdIAD,
      followupAdverseEffectDTOList: advereffect,
    };
    this.setState({
      followupReports: this.state.followupReports.concat(tempData),
      newApptStarted: true,
    });
    this.setState({ appointmentId: "" });
    // this.setState({ creationDateFP: this.formatDateMMDDYY(new Date()) });
    this.setState({ creationDateFP: new Date() });
    this.setState({ observe: "" });
    this.setState({ prescription: "" });
    this.setState({ appointmentReports: [] });
    this.setState({ followupAdverseEffectIdIAD: [] });
    this.setState(
      {
        selectedAdverseEffectDesc: "",
        pulse: "",
        temperature: "",
        bpSystolic: "",
        bpDiastolic: "",
        spO2: "",
        bloodGlucose: "",
        glucoseTestType: "",
        bsa: "",
        bmi: "",
        height: "",
        weight: "",
      },
      () => { this.forceUpdate(); }
    );

    // Pre-fill vitals from today's OpVisit (last vitals record)
    try {
      const res = await fetch(C.getUrl() + "/patientOpVisit/get/" + this.state.patientId);
      if (res.ok) {
        const data = await res.json();
        let visits = [];
        if (Array.isArray(data)) {
          visits = data;
        } else if (data.statusCode === 200 && data.message) {
          visits = typeof data.message === "string" ? JSON.parse(data.message) : data.message;
        }

        const today = new Date();
        const todayStr = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;

        // Apply same +1 day UTC correction used in OPVisit.js
        const correctDate = (dateStr) => {
          if (!dateStr) return "";
          const d = new Date(dateStr + "T00:00:00Z");
          d.setUTCDate(d.getUTCDate() + 1);
          return `${d.getUTCFullYear()}-${String(d.getUTCMonth() + 1).padStart(2, "0")}-${String(d.getUTCDate()).padStart(2, "0")}`;
        };

        const todayVisit = Array.isArray(visits)
          ? visits.find((v) => correctDate(v.visitDate) === todayStr)
          : null;

        if (todayVisit && Array.isArray(todayVisit.vitalsList) && todayVisit.vitalsList.length > 0) {
          const sorted = [...todayVisit.vitalsList].sort((a, b) => (a.sequenceNumber || 0) - (b.sequenceNumber || 0));
          const v = sorted[sorted.length - 1];

          const bpParts = (v.bp || v.bloodPressure || "").split("/");
          const glucoseTypeMap = { "Fasting": "fasting", "Random": "random", "Pre Meal": "postPrandial" };
          this.setState({
            height: v.height || "",
            weight: v.weight || "",
            pulse: v.pulse || "",
            temperature: v.temperature || "",
            bpSystolic: bpParts[0] || "",
            bpDiastolic: bpParts[1] || "",
            spO2: v.spo2 || "",
            bloodGlucose: v.bloodGlucose || "",
            glucoseTestType: glucoseTypeMap[v.glucoseTestType] || "",
            bsa: v.bsa || "",
            bmi: v.bmi || "",
          });
        }
      }
    } catch (err) {
      // silently ignore — form stays cleared
    }
  }

  submitFollowupReport = async (event) => {
    if (!this.isFollowupDirty()) {
      return;
    }
    let isThisValidForm = false;
    if (this.validateFollowupReport()) {
      isThisValidForm = true;
    }
    if (!isThisValidForm) {
      return;
    }
    var adverseEffectList = [];
    if (
      this.state.followupAdverseEffectIdIAD !== null &&
      this.state.followupAdverseEffectIdIAD.length !== 0
    ) {
      var tempAppointmentId = this.state.appointmentId
        ? this.state.appointmentId
        : null;
      this.state.followupAdverseEffectIdIAD.forEach(function (obj) {
        let data = {
          followupAdverseEffectXrefId: obj.followupAdverseEffectXrefId,
          followupAppointmentDTO: {
            appointmentId: tempAppointmentId,
          },
          reportParameterMstDTO: {
            reportParamId: obj.id,
          },
        };
        adverseEffectList.push(data);
      });
    }
    let data = {
      appointmentDt: this.state.creationDateFP
        ? new Date(this.state.creationDateFP)
        : new Date(),
      doctorObservation: this.state.observe,
      doctorPrescription: this.state.prescription,
      pulse: this.state.pulse,
      temperature: this.state.temperature,
      bpSystolic: this.state.bpSystolic,
      bpDiastolic: this.state.bpDiastolic,
      spO2: this.state.spO2,
      bloodGlucose: this.state.bloodGlucose,
      glucoseTestType: this.state.glucoseTestType,
      bsa: this.state.bsa,
      bmi: this.state.bmi,
      appointmentId: this.state.appointmentId
        ? this.state.appointmentId
        : null,
      weight: this.state.weight,
      height: this.state.height,
      heightUnit: this.state.heightUnit || 'cm',
      weightUnitDto: {
        unitId: this.state.weightUnitId || 1,
        unitName: this.state.weightUnit || 'KG',
      },
      patient: {
        patientID: this.state.patientId,
        weight: this.state.weight,
        height: this.state.height,
      },
      createdByIdUser: {
        userId: this.state.doctorId,
      },
      followupAdverseEffectDTOList: adverseEffectList,
    };
    this.setState({ saveLoader: true });
    return fetch(C.getUrl() + "/followupAppt/saveUpdate", {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        if (!res.ok) throw new Error(`Server error: ${res.status}`);
        return res.json();
      })
      .then((res) => {
        let obj = res;
        let error = obj.subErrors;
        if (error) {
          this.setState({ saveLoader: false });
          alert(error);
        } else {
          let objmsg = null;
          try { objmsg = JSON.parse(obj.message); } catch (e) {}
          this.setState({
            saveLoader: false,
            followupshow: true,
            appointmentId:
              objmsg != null && objmsg.appointmentId != null
                ? objmsg.appointmentId
                : this.state.appointmentId,
          });
          // Recalculate Khorana Score and Creatinine Clearance using the
          // just-saved appointment data (weight/BMI feed these values)
          if (this.state.patientId) {
            this.getKhoranaScore(this.state.patientId);
            this.getCreatinineClearance(this.state.patientId);
          }
          this.captureFollowupSnapshot({
            appointmentDt: this.state.creationDateFP,
            doctorObservation: this.state.observe,
            doctorPrescription: this.state.prescription,
            pulse: this.state.pulse,
            temperature: this.state.temperature,
            bpSystolic: this.state.bpSystolic,
            bpDiastolic: this.state.bpDiastolic,
            spO2: this.state.spO2,
            bloodGlucose: this.state.bloodGlucose,
            glucoseTestType: this.state.glucoseTestType,
            bsa: this.state.bsa,
            bmi: this.state.bmi,
            weight: this.state.weight,
            followupAdverseEffectDTOList: (this.state.followupAdverseEffectIdIAD || []).map((e) => ({
              reportParameterMstDTO: { reportParamId: e.id },
            })),
          });
          setTimeout(() => {
            this.setState({ followupshow: false });
          }, 3000);
          return true;
        }
      })
      .catch((err) => {
        console.log("Error : " + err);
        this.setState({ saveLoader: false, errorAlertshow: true });
        setTimeout(() => {
          this.setState({ errorAlertshow: false });
        }, 3000);
      });
  };

  getPatientHeightWeight = async () => {
    try {
      const patientId = this.state.patientId;
      if (!patientId) return;
      
      
      const response = await fetch(`${C.getUrl()}/userCase/getPatientSummaryDetails?patientId=${patientId}`);
      const data = await response.json();
      
      
      if (data.statusCode === 200 && data.message) {
        const patientDetails = JSON.parse(data.message).patientDetailsDto;
        if (patientDetails) {
          // Store the original values for debugging
          const heightValue = patientDetails.height ? parseFloat(patientDetails.height) : "";
          const weightValue = patientDetails.weight ? parseFloat(patientDetails.weight) : "";
          
          
          this.setState({ 
            height: heightValue,
            weight: weightValue
          }, () => {
            
            if (heightValue && weightValue) {
              this.calculateBMI(weightValue, heightValue);
            }
          });
        }
      }
    } catch (error) {
    }
  };


  getFollowupAppiontment() {
    return fetch(C.getUrl() + "/followupAppt/findAll/" + this.state.patientId)
      .then((res) => res.json())
      .then((res) => {
        let resObj = res;
        if (resObj.statusCode == 200) {
          let data = JSON.parse(resObj.message);
          this.setState({ appointmentId: data.appointmentId });
          this.setState({ creationDateFP: data.appointmentDt });
          this.setState({ observe: data.doctorObservation });
          this.setState({ prescription: data.doctorPrescription });
          this.setState({
            //height: data.height || "",
            weight: data.weight || "",
            pulse: data.pulse || "",
            temperature: data.temperature || "",
            bpSystolic: data.bpSystolic || "",
            bpDiastolic: data.bpDiastolic || "",
            spO2: data.spO2 || "",
            bloodGlucose: data.bloodGlucose || "",
            glucoseTestType: data.glucoseTestType || "",
            bsa: data.bsa || "",
            bmi: data.bmi || "",
          });
          if (
            data.followUpAppointments != null &&
            data.followUpAppointments.length != 0
          ) {
            this.setState({ followupReports: data.followUpAppointments });
          }
          if (
            data.appointmentReports != null &&
            data.appointmentReports.length != 0
          ) {
            this.setState({ appointmentReports: data.appointmentReports });
          } else {
            var selectedAdverseEffect = [];
            this.setState({ appointmentReports: selectedAdverseEffect });
          }
          if (
            data.followupAdverseEffectDTOList &&
            data.followupAdverseEffectDTOList.size !== 0
          ) {
            let followupAdverseEffectDTOList =
              data.followupAdverseEffectDTOList;
            var selectedAdverseEffect = [];
            var selectedAdverseEffectName = [];
            var selectedAdverseEffectDesc = []; // New array to hold descriptions
            followupAdverseEffectDTOList.map(function (d) {
              selectedAdverseEffect.push({
                id: d.reportParameterMstDTO.reportParamId,
                name: (
                  <>
                    <span style={{ paddingRight: "5px" }}>
                      {d.reportParameterMstDTO.reportParamName}
                    </span>
                    <FaInfoCircle
                      title={d.reportParameterMstDTO.reportParamDesc}
                    />
                  </>
                ),
                followupAdverseEffectXrefId: d.followupAdverseEffectXrefId,
              });
              selectedAdverseEffectName.push(
                d.reportParameterMstDTO.reportParamName
              );
              selectedAdverseEffectDesc.push(
                `${d.reportParameterMstDTO.reportParamName}: ${d.reportParameterMstDTO.reportParamDesc}`
              ); // Collect descriptions
            });
            this.setState({
              followupAdverseEffectIdIAD: selectedAdverseEffect,
              selectedAdverseEffectDesc: selectedAdverseEffectDesc.join("\n"), // Update the state with the descriptions
            });
          }
          this.captureFollowupSnapshot(data);
        }
      })
      .catch((err) => {
      });
  }
  getAllChemoSitting() {
    return fetch(
      C.getUrl() + "/userCase/getAllChemoSitting/" + this.state.patientId
    )
      .then((res) => res.json())
      .then((res) => {
        let resObj = res;
        if (resObj.statusCode == 200) {
          let data = JSON.parse(resObj.message);
          if (data != null && data.length != 0) {
            this.setState({ patAllChemoSittings: data }, this.refreshTicker);
          }
        }
      })
      .catch((err) => {
      });
  }

  // Get patient-specific post discharge medicines using the API
  getPatientPostDischargeMedicines = (patientId) => {
    return fetch(
      C.getUrl() +
        "/postDischargeMedicationXref/getPatientPostDischargeMedications?patientId=" +
        patientId
    )
      .then((res) => res.json())
      .then((res) => {
        if (
          res.statusCode === 200 &&
          res.message &&
          res.message !== "No records found"
        ) {
          const medicines = JSON.parse(res.message);

          if (medicines.length > 0) {
            // Parse the duration into value and unit
            const postDischargeMedDetails = medicines.map((m) => {
              let durationValue = "";
              let durationUnit = "Days";

              if (m.duration) {
                const durParts = m.duration.split(" ");
                if (durParts.length >= 2) {
                  durationValue = durParts[0];
                  durationUnit = durParts[1];
                } else {
                  durationValue = m.duration;
                }
              }

              return {
                medicine: {
                  id: m.medicineId,
                  name: m.medicineName,
                  medicineId: m.medicineId,
                  medicineListXrefId: m.medicineListXrefId,
                },
                dose: m.dose,
                when: m.when,
                durationValue: durationValue,
                durationUnit: durationUnit,
                duration: m.duration,
                instructions: m.instructions,
                isSaved: true,
              };
            });

            this.setState({ postDischargeMedDetails: postDischargeMedDetails });
          } else {
            // Initialize with one empty row if no medicines found
            this.setState({
              postDischargeMedDetails: [
                {
                  medicine: null,
                  dose: "",
                  when: "",
                  durationValue: "",
                  durationUnit: "Days",
                  instructions: "",
                  isSaved: false,
                },
              ],
            });
          }
        } else {
          // Initialize with one empty row if no medicines found
          this.setState({
            postDischargeMedDetails: [
              {
                medicine: null,
                dose: "",
                when: "",
                durationValue: "",
                durationUnit: "Days",
                instructions: "",
                isSaved: false,
              },
            ],
          });
        }

        // Load master data for dropdowns
        this.getAllMedicines();
        this.getAllDoses();
        this.getAllWhens();
      })
      .catch((err) => {

        // Initialize with one empty row on error
        this.setState({
          postDischargeMedDetails: [
            {
              medicine: null,
              dose: "",
              when: "",
              durationValue: "",
              durationUnit: "Days",
              instructions: "",
              isSaved: false,
            },
          ],
        });

        // Still try to load master data for dropdowns
        this.getAllMedicines();
        this.getAllDoses();
        this.getAllWhens();
      });
  };

  // Get all medicines for post discharge
  getAllPostDischargeMedicines = async () => {
    try {
      const res = await fetch(
        C.getUrl() + "/postDischargeMedicationMaster/getAllMedicines"
      );
      const resObj = await res.json();
      if (resObj.statusCode === 200) {
        let data = JSON.parse(resObj.message);
        const medicines = data.map((d) => ({
          id: d.medicineId,
          name: d.medicineName,
          medicineId: d.medicineId,
        }));

        this.setState({ postDischargeMedArr: medicines });
        return medicines;
      }
      return [];
    } catch (err) {
      swal({
        title: "Warning!",
        text: "Error fetching post discharge medicines: " + err,
        icon: "error",
        buttons: false,
        timer: 2000,
      });
      return [];
    }
  };

  // Save a new post discharge medicine
  savePostDischargeMedicine = async (medicineName, searchBoxRef) => {
    try {
      const medicineListDTO = {
        medicineName,
        activeInd: "Y",
      };

      // Save new medicine
      const saveResponse = await fetch(
        C.getUrl() + "/postDischargeMedicationMaster/saveMedicine",
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(medicineListDTO),
        }
      );

      const saveResult = await saveResponse.json();

      if (saveResult.statusCode === 200) {
        // Immediately fetch updated list
        await this.getAllPostDischargeMedicines();

        swal({
          title: "Success!",
          text: "Post discharge medicine added successfully",
          icon: "success",
          buttons: false,
          timer: 2000,
        });

        // Find the newly added medicine in the refreshed list
        const newMedicine = this.state.postDischargeMedArr.find(
          (med) => med.name.toLowerCase() === medicineName.toLowerCase()
        );

        return newMedicine || { id: Date.now(), name: medicineName };
      }

      return false;
    } catch (err) {
      swal({
        title: "Error!",
        text: "Failed to add post discharge medicine: " + err,
        icon: "error",
        buttons: false,
        timer: 2000,
      });
      return false;
    }
  };

  handlePostDischargeChange = (index, field, value) => {

    const updatedDetails = [...this.state.postDischargeMedDetails];

    if (field === "medicine") {
      // Find the medicine in the array
      const selectedMedicine = this.state.postDischargeMedArr.find(
        (m) => m.name === value
      );


      if (selectedMedicine) {
        updatedDetails[index].medicine = {
          id: selectedMedicine.id,
          name: selectedMedicine.name,
          medicineId: selectedMedicine.medicineId,
        };
      }
    } else {
      updatedDetails[index][field] = value;
    }

    // Clear validation errors for this field
    const updatedErrors = [...this.state.postDischargeMedErrors];
    if (updatedErrors[index]) {
      updatedErrors[index] = {
        ...updatedErrors[index],
        [field]: "",
      };
    }

    this.setState(
      {
        postDischargeMedDetails: updatedDetails,
        postDischargeMedErrors: updatedErrors,
      },
      () => {
      }
    );
  };

  // Handle duration unit selection for post discharge medications
  handlePostDischargeDurationUnitSelect = (index, unit) => {
    const updatedDetails = [...this.state.postDischargeMedDetails];
    updatedDetails[index].durationUnit = unit;

    // If there's a value, format the duration correctly
    if (updatedDetails[index].durationValue) {
      updatedDetails[
        index
      ].duration = `${updatedDetails[index].durationValue} ${unit}`;
    }

    this.setState({ postDischargeMedDetails: updatedDetails });
  };

  // Remove a row from the post discharge medication table
  removePostDischargeRow = (index) => {
    const updatedDetails = [...this.state.postDischargeMedDetails];
    updatedDetails.splice(index, 1);

    // If all rows are removed, add an empty one
    if (updatedDetails.length === 0) {
      updatedDetails.push({
        medicine: null,
        dose: "",
        when: "",
        durationValue: "",
        durationUnit: "Days",
        instructions: "",
        isSaved: false,
      });
    }

    this.setState({ postDischargeMedDetails: updatedDetails });
  };

  // Check if a post discharge medication row has content
  isPostDischargeRowFilled = (index) => {
    const row = this.state.postDischargeMedDetails[index];
    return (
      row.medicine ||
      row.dose ||
      row.when ||
      row.durationValue ||
      row.instructions
    );
  };

  // Add a new empty row to the post discharge medication table
  handleAddPostDischargeRow = () => {
    this.setState((prevState) => ({
      postDischargeMedDetails: [
        ...prevState.postDischargeMedDetails,
        {
          medicine: null,
          dose: "",
          when: "",
          durationValue: "",
          durationUnit: "Days",
          instructions: "",
          isSaved: false,
        },
      ],
    }));
  };

  // Delete a patient post discharge medicine
  deletePatientPostDischargeMedicine = async (xrefId) => {
    try {
      const response = await fetch(
        C.getUrl() + "/postDischargeMedicationXref/deactivate/" + xrefId,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      const data = await response.json();

      if (data.statusCode === 200) {
        swal({
          title: "Success!",
          text: "Post discharge medicine removed successfully",
          icon: "success",
          buttons: false,
          timer: 2000,
        });

        // Refresh medicines after successful delete
        await this.getPatientPostDischargeMedicines(this.state.patientId);
        return true;
      } else {
        throw new Error("Failed to remove post discharge medicine");
      }
    } catch (err) {
      swal({
        title: "Error!",
        text: "Failed to remove post discharge medicine",
        icon: "error",
        buttons: false,
        timer: 2000,
      });
      return false;
    }
  };

  // Validate post discharge medication rows
  validatePostDischargeMedRows = () => {
    let hasErrors = false;
    const errors = [];

    this.state.postDischargeMedDetails.forEach((med, index) => {
      const rowErrors = {};

      // Skip validation for empty rows
      if (
        !med.medicine &&
        !med.dose &&
        !med.when &&
        !med.durationValue &&
        !med.instructions
      ) {
        errors[index] = rowErrors;
        return;
      }

      // Validate required fields
      if (!med.medicine) {
        rowErrors.medicine = "Medicine is required";
        hasErrors = true;
      }

      if (!med.dose) {
        rowErrors.dose = "Dose is required";
        hasErrors = true;
      }

      if (!med.when) {
        rowErrors.when = "When is required";
        hasErrors = true;
      }

      if (!med.durationValue) {
        rowErrors.durationValue = "Duration is required";
        hasErrors = true;
      }

      if (!med.instructions) {
        rowErrors.instructions = "Instructions are required";
        hasErrors = true;
      }

      errors[index] = rowErrors;
    });

    this.setState({ postDischargeMedErrors: errors });
    return hasErrors;
  };

  // Handle save post discharge medicines button click
  handleSavePostDischargeMedsClick = async () => {
    // Validate the post discharge medication rows
    const hasErrors = this.validatePostDischargeMedRows();
    if (hasErrors) {
      return;
    }

    this.setState({ saveLoader: true });

    // Prepare data for saving
    const medicationsToSave = this.state.postDischargeMedDetails
      .filter((med) => med.medicine && !med.medicine.medicineListXrefId) // Only save new rows with a medicine selected
      .map((med) => ({
        medicineId: med.medicine.id,
        patientId: this.state.patientId,
        dose: med.dose,
        when: med.when,
        duration: med.durationValue
          ? `${med.durationValue} ${med.durationUnit}`
          : "",
        instructions: med.instructions,
        activeInd: "Y",
      }));

    // No medicines to save
    if (medicationsToSave.length === 0) {
      // Check if all rows are already saved
      const hasUnsavedMedicines = this.state.postDischargeMedDetails.some(
        (med) => med.medicine && !med.medicine.medicineListXrefId
      );

      if (!hasUnsavedMedicines) {
        this.setState({ saveLoader: false });
        swal({
          title: "Info",
          text: "All post discharge medicines are already saved",
          icon: "info",
          buttons: false,
          timer: 2000,
        });
        return;
      }

      this.setState({ saveLoader: false });
      swal({
        title: "Warning!",
        text: "No post discharge medicines to save",
        icon: "warning",
        buttons: false,
        timer: 2000,
      });
      return;
    }

    // Save each medicine using the post discharge medication API
    const savePromises = medicationsToSave.map((medication) =>
      fetch(C.getUrl() + "/postDischargeMedicationXref/add", {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(medication),
      }).then((res) => res.json())
    );

    Promise.all(savePromises)
      .then((results) => {
        this.setState({ saveLoader: false });

        // Check if all saves were successful
        const allSuccessful = results.every((res) => res.statusCode === 200);

        if (allSuccessful) {
          swal({
            title: "Success!",
            text: "Post discharge medicines saved successfully",
            icon: "success",
            buttons: false,
            timer: 2000,
          });

          // Refresh the list of patient post discharge medicines
          this.getPatientPostDischargeMedicines(this.state.patientId);
        } else {
          swal({
            title: "Warning!",
            text: "Some post discharge medicines may not have been saved correctly",
            icon: "warning",
            buttons: false,
            timer: 2000,
          });
        }
      })
      .catch((err) => {
        this.setState({ saveLoader: false });

        swal({
          title: "Error!",
          text: "Failed to save post discharge medicines",
          icon: "error",
          buttons: false,
          timer: 2000,
        });
      });
  };

  saveConsentForm(event) {
    if (this.state.treatmentPlanIdTmt != 0) {
      let data = {
        consentReceived: "Y",
        additionalConditions: this.state.additionalConditions,
        waiveOffConsent: this.state.waiverComments,
        consentAttachmentData: this.state.consentAttachmentData,
        consentAttachmentName: this.state.consentAttachmentName,
        patientTreatmentPlanId: this.state.treatmentPlanIdTmt,
        patientDTO: {
          patientID: this.props.patientId,
        },
      };
      return fetch(C.getUrl() + "/userCase/changeConsentStatus", {
        method: "POST",
        mode: "cors",
        body: JSON.stringify(data),
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((res) => res.json())
        .then((res) => {
          let obj = res;
          let error = obj.subErrors;
          if (error !== null && error !== "") {
            alert(error);
          } else {
            this.setState({ showConsent: false, consentMsgshow: true });
            setTimeout(() => {
              this.setState({ consentMsgshow: false });
            }, 3000);
          }
        })
        .catch((err) => {
          this.setState({ errorAlertshow: true });
          setTimeout(() => {
            this.setState({ errorAlertshow: false });
          }, 3000);
        });
    }
  }

  validateChemoSitting() {
    let formIsValid = true;
    let errors = {};
    if (
      this.state.treatmentGivenPC === null ||
      this.state.treatmentGivenPC === ""
    ) {
      errors["treatmentGivenPC"] = "Please enter Treatment Given";
      formIsValid = false;
    }
    // NOTE: "Chemo Given" required-field validations temporarily disabled.
    // Re-enable once the Chemo Date state/display mismatch is fixed.
    // if (this.state.chemoGivenPC) {
    //   const premedicationsValue =
    //     this.state.premedications === "Other"
    //       ? this.state.premedicationOther
    //       : this.state.premedications;
    //   const supplementsValue =
    //     this.state.supplements === "Other"
    //       ? this.state.supplementOther
    //       : this.state.supplements;
    //   const requiredFields = [
    //     ["chemoDtPC", "Chemo Date", this.state.chemoDtPC],
    //     ["chemoPlannedDtPC", "Chemo Planned Date", this.state.chemoPlannedDtPC],
    //     ["gcsfMedicinePC", "GCSF Medicine", this.state.gcsfMedicinePC],
    //     ["patientChemoSittingDosageList", "Chemo Dosage", this.state.patientChemoSittingDosageList && this.state.patientChemoSittingDosageList.length > 0 ? "set" : ""],
    //     ["antiemeticRisks", "Antiemetic Drugs", this.state.antiemeticRisks],
    //     ["boneMetasisDrug", "Bone Metasis Drug", this.state.boneMetasisDrug],
    //     ["antithromboticDrugs", "Antithrombotic Drugs", this.state.antithromboticDrugs],
    //     ["postChemoDrugs", "Post Chemo Drugs", this.state.postChemoDrugs],
    //     ["nurseInstructions", "Nurse Instructions", this.state.nurseInstructions],
    //     ["patientInstructions", "Patient Instructions", this.state.patientInstructions],
    //     ["pharmacyInstructions", "Pharmacy Instructions", this.state.pharmacyInstructions],
    //     ["premedications", "Pre-Medications", premedicationsValue],
    //     ["supplements", "Supplements", supplementsValue],
    //     ["antiallergicDrugs", "Antiallergic Drugs", this.state.antiallergicDrugs],
    //   ];
    //   const missingLabels = [];
    //   requiredFields.forEach(([field, label, value]) => {
    //     if (value === null || value === undefined || value === "") {
    //       errors[field] = `Please enter ${label}`;
    //       missingLabels.push(label);
    //     }
    //   });
    //   if (missingLabels.length > 0) {
    //     formIsValid = false;
    //     swal({
    //       title: "Incomplete Chemotherapy Sitting",
    //       text:
    //         "Please complete the following before marking Chemo Given: " +
    //         missingLabels.join(", "),
    //       icon: "warning",
    //       button: "OK",
    //     });
    //   }
    // }
    this.setState({ patChemoSittingErrors: errors });
    return formIsValid;
  }
  closeAssessFNRiskModal = () => {
    this.setState({ showAssessFNRisk: false });
  };
  closeNewTreatmentPlan = () => {
    this.setState({ showNewTreatment: false });
  };
  closeTerminateProtocol = () => {
    this.setState({ showTerminateProtocol: false });
  };
  closeMultipleTreatmentPopup = () => {
    this.setState({ showMultipleTreatmentPopup: false });
  };
  closeMultipleChemoPopup = () => {
    this.setState({ showMultipleChemoPopup: false });
  };
  addNewChemoSitting(event) {
    return fetch(
      C.getUrl() + "/userCase/nextChemoDetail/" + this.state.patientId
    )
      .then((res) => res.json())
      .then((res) => {
        let resObj = res;
        if (resObj.statusCode == 200) {
          let tempData = {
            patChemoSittingId: this.state.patChemoSittingIdPC,
            cascadeChange: this.state.cascadeChangePC
              ? this.state.cascadeChangePC
              : "N",
            chemoCycleNumber: this.state.chemoCycleNumberPC,
            chemoDt: this.state.chemoDtPC,
            chemoPlannedDt: this.state.chemoPlannedDtPC,
            delay: this.state.delayPC ? this.state.delayPC : "N",
            delayComments: this.state.delayCommentsPC,
            reasonForChemoDtChange: this.state.reasonForChemoDtChangePC
              ? this.state.reasonForChemoDtChangePC
              : "",
            treatmentGiven: this.state.treatmentGivenPC,
            nextChemoCycleDate: this.state.upcomingChemoDt
              ? new Date(this.state.upcomingChemoDt)
              : "",
            patientChemoSittingDosageList:
              this.state.patientChemoSittingDosageList,
          };

          let data = JSON.parse(resObj.message);
          this.setState({ chemoScheduleIdPC: data.chemoScheduleId || null });
          this.setState({ patChemoSittingIdPC: "" });
          this.setState({
            chemoCycleNumberPC: this.state.upcomingChemoCycleNum,
          });
          this.setState({ chemoDtPC: this.formatDateDDMMYYYY(new Date()) });
          this.setState({ treatmentGivenPC: "" });
          this.setState({ chemoGivenPC: false });
          this.setState({ delayCommentsPC: "" });
          this.setState({ reasonForChemoDtChangePC: "" });
          this.setState({
            chemoPlannedDtPC: this.formatDateDDMMYYYY(this.state.upcomingChemoDt),
          });
          this.setState({
            upcomingChemoDt:
              this.state.upcomingChemoCycleNum == this.state.cyclesPlannedTmt
                ? this.state.chemoPlannedDtPC
                : this.formatDateDDMMYYYY(data.nextChemoCycleDate),
          });
          this.setState({ patientChemoSittingDosageList: [] });
          this.setState({ gcsfMedicinePC: "" });
          this.setState({ assesFNRiskFlag: "N" });
          this.setState({ antiemeticRisks: "" });
          this.setState({ boneMetasisDrug: "" });
          this.setState({ antithromboticDrugs: "" });
          this.setState({ postChemoDrugs: "" });
          this.setState({ nurseInstructions: "" });
          this.setState({ patientInstructions: "" });
          this.setState({ pharmacyInstructions: "" });
          this.setState({ premedications: "" });
          this.setState({ supplements: "" });
          this.setState({ antiallergicDrugs: "" });
          if (
            this.formatDateDDMMYYYY(new Date()) <
            this.formatDateDDMMYYYY(this.state.chemoPlannedDtPC)
          ) {
            this.setState({ delayPC: "N" });
            this.setState({ isCycleDelay: false });
          } else {
            this.setState({ delayPC: "Y" });
            this.setState({ isCycleDelay: true });
          }
          this.setState({ cascadeChangePC: "N" });
          if (this.state.isCurrentTreatmentTerminated == "N") {
            this.checkPatientAdverseEffectTermination();
          }
          this.setState({
            patAllChemoSittings:
              this.state.patAllChemoSittings.concat(tempData),
          }, this.refreshTicker);
        }
      })
      .catch((err) => {
      });
  }

  async submitChemoSitting(event) {
    let isThisValidForm = false;
    if (this.validateChemoSitting()) {
      isThisValidForm = true;
    }
    if (isThisValidForm) {
      try {

        // Prepare the data object
        const premedicationsValue =
          this.state.premedications === "Other"
            ? this.state.premedicationOther
            : this.state.premedications;
        const supplementsValue =
          this.state.supplements === "Other"
            ? this.state.supplementOther
            : this.state.supplements;

        let data = {
          status: "C",
          patientChemoSittingDTO: {
            patChemoSittingId: this.state.patChemoSittingIdPC,
            chemoDt: this.state.chemoDtPC,
            chemoPlannedDt: this.state.chemoPlannedDtPC,
            gcsfMedicine: this.state.gcsfMedicinePC,
            treatmentGiven: this.state.treatmentGivenPC,
            chemoGiven: this.state.chemoGivenPC ? 1 : 0,
            createdByIdUser: { userId: this.state.doctorId },
            patientChemoSittingDosageDTOList:
              this.state.patientChemoSittingDosageList,
            antiemeticDrugs: this.state.antiemeticRisks,
            boneMetasisDrug: this.state.boneMetasisDrug,
            antithromboticDrugs: this.state.antithromboticDrugs,
            postChemoDrugs: this.state.postChemoDrugs,
            nurseInstructions: this.state.nurseInstructions,
            patientInstructions: this.state.patientInstructions,
            pharmacyInstructions: this.state.pharmacyInstructions,
            // Use the processed values for premedications and supplements
            premedications: premedicationsValue,
            supplements: supplementsValue,
            antiallergicDrugs: this.state.antiallergicDrugs,
            //warningMsgConsent: this.state.warningMsgConsent,
            patientDTO: { patientID: this.state.patientId },
            cascadeTreatPlanIds: this.state.cascadeTreatPlanIds,
            chemoScheduleId: this.state.chemoScheduleIdPC,
          },
          patientId: this.state.patientId,
        };

        console.log("[ChemoSitting Save] payload being POSTed", {
          patChemoSittingIdPC: this.state.patChemoSittingIdPC,
          isNewSitting:
            !this.state.patChemoSittingIdPC ||
            this.state.patChemoSittingIdPC === "0",
          rawPremedicationsState: this.state.premedications,
          rawPremedicationOther: this.state.premedicationOther,
          premedicationsSent: premedicationsValue,
          rawSupplementsState: this.state.supplements,
          rawSupplementOther: this.state.supplementOther,
          supplementsSent: supplementsValue,
          chemoScheduleIdPC: this.state.chemoScheduleIdPC,
        });

        if (this.state.caseStatus === "T") {
          this.setState({ caseStatus: "C" });
        }

        // NOTE: this reads the template with the PRE-save sitting id (empty string for a
        // brand-new sitting), so it can never reflect what we are about to save.
        await this.getChemoTemplateForNurse();
        /*
                // Post the chemotherapy template data to updatePharmacy API
                const chemoDatatoEMR = {
                    firstname: this.state.firstName,
                    lastname: this.state.lastName,
                    dosage: this.state.treatmentGivenPC,
                    patient_id: this.state.patientId,
                    protocolTitle: this.state.protocolTitle,
                    chemotherapyDoseAndMethodOfAdministration: this.state.chemotherapyDoseAndMethodOfAdministration,
                    antiemeticRisk: this.state.antiemeticRisk,
                    fnRisk: this.state.fnRisk,
                    nextVisitInstructions: this.state.nextVisitInstructions,
                    drugInteractions: this.state.drugInteractions,
                    cyclesPlanned: this.state.cyclesPlanned,
                    chemoStartDt: this.state.chemoStartDt,
                    dosageFrequency: this.state.dosageFrequency,
                    chemoCycleNumber: this.state.chemoCycleNumber,
                    scheduleName: this.state.scheduleName,
                    antiemeticRisks: this.state.antiemeticRisks,
                    gcsfMedicinePC: this.state.gcsfMedicinePC,
                    antithromboticDrugs: this.state.antithromboticDrugs
                };
    
    
                // Call the updatePharmacy API
                let pharmacyResponse = await fetch('http://localhost:8001/updatePharmacy', {
                    method: 'PUT',
                    mode: 'cors',
                    body: JSON.stringify(chemoDatatoEMR),
                    headers: { 'Content-Type': 'application/json' }
                });
                pharmacyResponse = await pharmacyResponse.json();
                */
        // Call the saveUserCase API
        let userCaseResponse = await fetch(
          C.getUrl() + "/userCase/saveUserCase",
          {
            method: "POST",
            mode: "cors",
            body: JSON.stringify(data),
            headers: { "Content-Type": "application/json" },
          }
        );
        userCaseResponse = await userCaseResponse.json();

        const result = classifySaveUserCaseResponse(userCaseResponse);
        console.log("[ChemoSitting Save] saveUserCase response", {
          outcome: result.outcome,
          savedPatChemoSittingId: result.saved && result.saved.patChemoSittingId,
          savedPremedications: result.saved && result.saved.premedications,
          savedSupplements: result.saved && result.saved.supplements,
          warnings: result.warnings,
          raw: userCaseResponse,
        });
        if (result.outcome === SaveOutcome.SUCCESS) {
          const objmsg = result.saved || {};
          this.setState({
            patChemoSittingIdPC: objmsg.patChemoSittingId,
            saveLoader: true,
            chemoshow: true,
            buttonEnabled: false,
          });
          if (result.warnings) {
            swal({
              title: "Saved with Warnings",
              text: result.warnings.join("\n"),
              icon: "warning",
              button: "OK",
            }).then(() => { window.location.reload(false); });
          } else {
            setTimeout(() => {
              this.setState({ saveLoader: false, chemoshow: false });
            }, 3000);
            window.location.reload(false);
          }
        } else if (result.outcome === SaveOutcome.BLOCKED) {
          swal({ title: "Cannot Save", text: result.message, icon: "error", button: "OK" });
        } else {
          swal({ title: "Error", text: result.message, icon: "error", button: "OK" });
        }
      } catch (err) {
        this.setState({ errorAlertshow: true });
        setTimeout(() => {
          this.setState({ errorAlertshow: false });
        }, 3000);
      }
    }
  }

  getChemoTemplateForNurse() {
    const chemoSittingId = this.state.patChemoSittingIdPC;
    return fetch(
      C.getUrl() + `/userCase/getChemoTemplateForNurse/${chemoSittingId}`
    )
      .then((res) => res.json())
      .then((res) => {
        if (res.statusCode === 200 && res.message !== "No record found.") {
          const tempData = JSON.parse(res.message);

          this.setState({
            protocolTitle: tempData.protocolName || "Nil",
            chemotherapyDoseAndMethodOfAdministration:
              tempData.chemotherapyDoseAndMethodOfAdministration || "Nil",
            antiemeticRisk: tempData.antiemeticRisk || "Nil",
            fnRisk: tempData.fnRisk || "Nil",
            nextVisitInstructions: tempData.nextVisitInstructions || "Nil",
            drugInteractions: tempData.drugInteractions || "Nil",
          });
        }
      })
      .catch((err) => {
      });
  }

  deleteReport(data) {
    let deldata = {
      apptXReportId: data.apptXReportId,
    };
    return fetch(C.getUrl() + "/followupAppt/deleteReport", {
      method: "DELETE",
      mode: "cors",
      body: JSON.stringify(deldata),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        let obj = res;
        let error = obj.subErrors;
        if (error !== null && error !== "" && error !== "undefined") {
          alert(error);
        } else {
          alert(obj.message);
          this.getFollowupAppiontment();
        }
      })
      .catch((err) => {
        this.setState({ errorAlertshow: true });
        setTimeout(() => {
          this.setState({ errorAlertshow: false });
        }, 3000);
      });
  }

  formatDateMMMDDYYY(date) {
    if (date !== undefined && date !== "") {
      // Use moment to parse date properly without timezone issues
      const parsedDate = moment(date, ['DD/MM/YYYY', 'YYYY-MM-DD', 'MMM DD, YYYY', 'ddd MMM DD, YYYY']);
      if (parsedDate.isValid()) {
        return parsedDate.format('MMM DD, YYYY');
      }
      return "";
    }
    return "";
  }

  // Builds the Case Profile ticker message from data already in state (no fetching).
  buildTickerMessage() {
    const name = `${this.state.firstName || ""} ${this.state.lastName || ""}`.trim();
    if (!name) {
      return "";
    }

    const pronoun =
      (this.state.genderName || "").toLowerCase() === "male" ? "He" : "She";
    const primarySite = this.state.diagnosisPrimarySite || "";
    const hasDiagnosis = !!primarySite || this.state.canCreateTreatmentPlan === true;

    // Current Diagnosis = cancer site name(s) from the Initial Assessment.
    const diagnosisSites = Array.isArray(this.state.canSiteNameIAD)
      ? this.state.canSiteNameIAD.filter(Boolean)
      : [];
    const currentDiagnosis = diagnosisSites.join(", ");

    // Cancer Stage = label for the selected stageId, resolved via the stage master list.
    const stageArr = Array.isArray(this.state.cancerStageMstArr)
      ? this.state.cancerStageMstArr
      : [];
    const stageMatch = stageArr.find(
      (s) => String(s.id) === String(this.state.cancerStage)
    );
    const cancerStageLabel = stageMatch ? stageMatch.label : "";
    const plans = this.state.patTreatmentPlanSummary;
    const hasPlan = Array.isArray(plans) && plans.length > 0;
    const protocolName =
      hasPlan && plans[0].protocolMstDTO ? plans[0].protocolMstDTO.protocolName || "" : "";

    // Derive the last chemo date. Two sources, because the backend's
    // /getAllChemoSitting EXCLUDES the current sitting:
    //   1. patAllChemoSittings — the historical sitting records.
    //   2. the current sitting (patientChemoSittingDTO → chemoDtPC), included only
    //      when chemo was actually given (chemoGivenPC), so today's given chemo shows.
    // Parse with moment (not `new Date`) so a "DD-MM-YYYY" value is handled too.
    const chemoSittings = Array.isArray(this.state.patAllChemoSittings)
      ? this.state.patAllChemoSittings
      : [];
    const parseChemoDate = (v) => {
      const m = moment(v, [
        "DD-MM-YYYY",
        "DD/MM/YYYY",
        "YYYY-MM-DD",
        "MMM DD, YYYY",
        "ddd MMM DD, YYYY",
        moment.ISO_8601,
      ]);
      return m.isValid() ? m : null;
    };
    let lastChemoMoment = null;
    const considerChemoDate = (v) => {
      const m = parseChemoDate(v);
      if (m && (!lastChemoMoment || m.isAfter(lastChemoMoment))) {
        lastChemoMoment = m;
      }
    };
    chemoSittings.forEach((s) => considerChemoDate(s.chemoDt));
    // Current sitting — only if chemo was given (guards against an in-progress/planned one).
    if (this.state.chemoGivenPC && this.state.chemoDtPC) {
      considerChemoDate(this.state.chemoDtPC);
    }
    if (!lastChemoMoment && this.state.lastChemoCycleDate) {
      lastChemoMoment = parseChemoDate(this.state.lastChemoCycleDate);
    }
    const lastChemoDt = lastChemoMoment ? lastChemoMoment.format("DD-MM-YYYY") : "";
    const hasChemo = !!lastChemoMoment;

    // "primary site <primarySite>, current diagnosis <...> and cancer stage <...>"
    // — each optional clause is dropped if its data hasn't loaded yet.
    let diagnosedWith = `primary site ${primarySite}`;
    const dxExtras = [];
    if (currentDiagnosis) {
      dxExtras.push(`current diagnosis ${currentDiagnosis}`);
    }
    if (cancerStageLabel) {
      dxExtras.push(`cancer stage ${cancerStageLabel}`);
    }
    if (dxExtras.length) {
      diagnosedWith += `, ${dxExtras.join(" and ")}`;
    }

    // Case 1: No diagnosis records.
    if (!hasDiagnosis) {
      return `${name} does not have any diagnosis records. Please add diagnosis details in 'Initial Assessment' section.`;
    }
    // Case 2: Diagnosis present but no active treatment plan.
    if (!hasPlan) {
      return `${name} is diagnosed with ${diagnosedWith}. Please create a treatment plan for chemotherapy sitting.`;
    }
    // Case 3: Diagnosis + plan but no chemo sitting.
    if (!hasChemo) {
      return `${name} is diagnosed with ${diagnosedWith}. ${pronoun} is under ${protocolName} treatment. Check for chemo schedule for chemotherapy sitting appointment.`;
    }
    // Case 4: Diagnosis + plan + chemo sitting.
    return `${name} is diagnosed with ${diagnosedWith}. ${pronoun} is under ${protocolName} treatment. Last chemotherapy was given on ${lastChemoDt}. Check for chemo schedule for next chemotherapy sitting appointment.`;
  }

  refreshTicker = () => {
    this.setState({ tickerMessage: this.buildTickerMessage() });
  };

  formatDateDDMMYYYY(date) {
    if (date !== undefined && date !== "") {
      // Use moment to parse date properly without timezone issues
      const parsedDate = moment(date, ['DD/MM/YYYY', 'YYYY-MM-DD', 'MMM DD, YYYY', 'ddd MMM DD, YYYY']);
      if (parsedDate.isValid()) {
        return parsedDate.format('DD-MM-YYYY');
      }
      return "";
    }
    return "";
  }

  setNextChemoDate(date) {
    // Ensure consistent storage as formatted string
    let formattedDate = "";
    if (date) {
      // Handle moment object, Date object, or string
      formattedDate = this.formatDateDDMMYYYY(date);
    }
    this.setState({ upcomingChemoDt: formattedDate });
  }

  // Helper function to safely parse DOB for DatePicker display
  parseDobForDatePicker(dob) {
    if (!dob) return null;
    const m = moment(dob, ['DD/MM/YYYY', 'YYYY-MM-DD', 'MMM DD, YYYY']);
    return m.isValid() ? m : null;
  }
  resetReportTab() {
    this.setState({ observe: "" });
    this.setState({ prescription: "" });
    this.setState({ creationDateFP: new Date() });
  }

  setCanserSites(value) {
    this.setState({ canSiteIdIAD: value });
  }

  setPrevCanserSites(value) {
    this.setState({ prevCanSiteIdIAD: value });
  }

  setLimbLoss(value) {
    this.setState({ limbLossIdIAD: value });
  }

  setMutations(value) {
    this.setState({ mutationIdIA: value });
  }

  setFollowupAdverseEffect = (value) => {
    // Find the descriptions of the selected adverse effects with their names
    const selectedDescriptions = value
      .map((item) => {
        let name;
        let desc = item.desc || "";

        // Check if item.name is an object (React element) and extract the name accordingly
        if (React.isValidElement(item.name)) {
          const childrenArray = React.Children.toArray(
            item.name.props.children
          );
          name =
            childrenArray.length > 0
              ? childrenArray
                  .map((child) => (typeof child === "string" ? child : ""))
                  .join("")
              : "Unknown";
          desc = item.name.props.title || desc;
        } else {
          name = item.name || "Unknown";
        }

        return `${name}: ${desc}`;
      })
      .join("\n");

    // Update the state with the selected adverse effects and their descriptions
    this.setState({
      followupAdverseEffectIdIAD: value,
      selectedAdverseEffectDesc: selectedDescriptions,
    });
  };

  validatePatientDetail() {
    let formIsValid = true;
    return formIsValid;
  }

  getPatientAge(dob) {
    let birthDate = new Date(dob);
    let otherDate = new Date();
    var years = otherDate.getFullYear() - birthDate.getFullYear();
    if (
      otherDate.getMonth() < birthDate.getMonth() ||
      (otherDate.getMonth() === birthDate.getMonth() &&
        otherDate.getDate() < birthDate.getDate())
    ) {
      years--;
    }
    return years;
  }

  onTreeDataChange = (currentNode, selectedNodes) => {
    const { value, checked, medicineStandardMsg, label } = currentNode;

    this.handleMedicineSelect(value, checked, () => {
      if (checked) {
        // SELECTION LOGIC
        // Construct the text without any details. Details will be added by handleMedicineDetailSelect.
        const primaryMessage = medicineStandardMsg || label;
        const newText = `${value} - ${primaryMessage}`;

        this.setState(prevState => {
          const newTextMap = { ...prevState.selectedMedicinesTextMap, [value]: newText };
          return {
            selectedMedicinesTextMap: newTextMap,
            treatmentGivenPC: Object.values(newTextMap).join('\n')
          };
        });

      } else {
        // DESELECTION LOGIC
        this.setState(prevState => {
          const { [value]: _, ...remainingTextMap } = prevState.selectedMedicinesTextMap;
          return {
            selectedMedicinesTextMap: remainingTextMap,
            treatmentGivenPC: Object.values(remainingTextMap).join('\n')
          };
        });
      }
    });
  };

  // Also update the onChange handler for medicine details section
  handleMedicineDetailSelect = (currentNode, selectedNodes) => {
    const detailKey = `detail_${currentNode.value}`;
    const parentEntry = this.state.medicineDetails.find(d => d.value === currentNode.value);
    const medicineName = parentEntry ? parentEntry.label : '';
    const medicineInfo = medicineName && medicineName !== currentNode.label
      ? `(${medicineName} - ${currentNode.label})`
      : currentNode.label || "";

    if (currentNode.checked) {
      this.setState(prevState => {
        const newTextMap = { ...prevState.selectedMedicinesTextMap, [detailKey]: medicineInfo };
        return {
          selectedMedicinesTextMap: newTextMap,
          treatmentGivenPC: Object.values(newTextMap).join('\n')
        };
      });
    } else {
      this.setState(prevState => {
        const { [detailKey]: _, ...remainingTextMap } = prevState.selectedMedicinesTextMap;
        return {
          selectedMedicinesTextMap: remainingTextMap,
          treatmentGivenPC: Object.values(remainingTextMap).join('\n')
        };
      });
    }
  };
  
  getSuggestiveTreatment(treatmentObj) {
    let data = treatmentObj;

    return fetch(C.getUrl() + "/userCase/suggestiveTreatment", {
      method: "POST",
      mode: "cors",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((res) => {
        let obj = res;
        if (obj !== null && obj !== "undefined" && obj.length != 0) {
          //alert("Med : "+JSON.stringify(obj));
          this.setState({ suggestiveTreatementArr: obj });
          //console.log("Med : "+JSON.stringify(obj));
          this.storeRecommendedMedicine(obj);
        }
      })
      .catch((err) => {
      });
  }

  //Save all recommended medicine
  storeRecommendedMedicine(suggestedMedicine) {
    if (suggestedMedicine != null && suggestedMedicine.length != 0) {
      let patientChemoSittingDosageList = [];
      let medicineNames = new Set();
      suggestedMedicine.forEach((obj) => {
        //console.log(JSON.stringify(obj[0].children[0]));
        //Getting medicine dosage data from each array
        let medicineDosage = obj[0].children[0];
        let patChemoMedDosage = {
          patientChemoSittingDId: 0,
          chemoMedicineDosage: {
            chemoMedicineDId: medicineDosage.chemoMedicineDId,
          },
          treatmentPlanDTO: {
            patientTreatmentPlanId: medicineDosage.treatmentPlanId,
          },
        };
        patientChemoSittingDosageList.push(patChemoMedDosage);
      });
      //console.log("All recommended dosage "+JSON.stringify(patientChemoSittingDosageList));
      this.setState({
        patientChemoSittingDosageList: patientChemoSittingDosageList,
      });
    }
  }

  cancelHandler = () => {
    this.setState({ redirectCasePage: true });
  };
  handleTreatPlanChange = (event) => {
    this.setState({ waiverComments: event.target.value }); // Update waiverComments on text area change
  };

  consentWaive = (event, cardId) => {
    const { isConsentProvided } = this.state;
    if (event.target.checked) {
      if (!this.state.waiverComments) {
        this.setState({ waiverComments: "Physical consent has been taken." }); // Set default message
      }
      this.setState({
        waiverConsent: true,
        isConsentProvided: { ...isConsentProvided, [cardId]: true }, // Use cardId parameter
      });
      $("#uncontrolled-tab-example-tab-chemotherapy").show();
    } else {
      this.setState({
        waiverConsent: false,
        isConsentProvided: { ...isConsentProvided, [cardId]: false }, // Use cardId parameter
      });
      $("#uncontrolled-tab-example-tab-chemotherapy").hide();
    }
  };

  showAlertDismissible = () => {
    this.setState({ alertDismissibleshow: true });
  };

  setAntiemeticRisks = (e) => {
    if (
      this.state.antiemeticRisks == "" ||
      this.state.antiemeticRisks === undefined
    ) {
      if (e.target.checked == true) {
        this.setState({ antiemeticRisks: e.target.value });
      } else {
        var antiemeticRisks = this.state.antiemeticRisks;
        if (antiemeticRisks.indexOf(e.target.value + ", ") !== -1) {
          var ret = antiemeticRisks.replace(e.target.value + ", ", "");
          this.setState({ antiemeticRisks: ret });
        } else {
          var ret = antiemeticRisks.replace(e.target.value, "");
          this.setState({ antiemeticRisks: ret });
        }
      }
    } else {
      if (e.target.checked == true) {
        if (this.state.antiemeticRisks != "") {
          var antiemeticRisks = this.state.antiemeticRisks;
          if (!antiemeticRisks.includes(e.target.value)) {
            antiemeticRisks = antiemeticRisks + ", " + e.target.value;
            this.setState({ antiemeticRisks: antiemeticRisks });
          }
        } else {
          antiemeticRisks = e.target.value;
          this.setState({ antiemeticRisks: antiemeticRisks });
        }
      } else {
        var antiemeticRisks = this.state.antiemeticRisks;
        if (antiemeticRisks.indexOf(e.target.value + ", ") !== -1) {
          var ret = antiemeticRisks.replace(e.target.value + ", ", "");
          this.setState({ antiemeticRisks: ret });
        } else {
          var ret = antiemeticRisks.replace(e.target.value, "");
          this.setState({ antiemeticRisks: ret });
        }
      }
    }
  };

  handleSaveAntiemeticTreatment = () => {
    // Logic to gather selected treatment options
    const selectedTreatment = this.gatherSelectedAntiemeticTreatment(); // Implement this function based on your existing logic

    // Update the state with the selected treatment and close the modal
    this.setState({
      antiemeticRisks: selectedTreatment,
      showAntimetic: false,
    });
  };

  gatherSelectedAntiemeticTreatment = () => {
    const selectedOptions = this.state.selectedOptions;
    const selectedTreatment = Object.keys(selectedOptions)
      .map((day) => {
        const cleanedOptions = selectedOptions[day].map(v => v.replace(/ \(choose one\)/g, ""));
        return `${day}: ${cleanedOptions.join(", ")}`;
      })
      .join("\n");

    return selectedTreatment;
  };

  consentAttachmentHandler = (e, cardId) => {
    const file = e.target.files[0];
    if (!file) {
      alert("No file selected");
      return;
    }


    const fileType = file.type;
    const validFileType = this.isValidFileType(fileType);

    if (file && validFileType) {
      const reader = new FileReader();
      reader.onload = this.fileReaderHandler.bind(this, fileType);
      reader.readAsArrayBuffer(file); // Use ArrayBuffer for binary data

      // Set the file name in the state
      this.setState({
        consentAttachmentName: file.name,
        waiverComments: "Consent provided through attachment.", // Add default comment
        isConsentProvided: {
          ...this.state.isConsentProvided,
          [this.state.currentCardId]: true,
        }, // Ensure correct cardId
      });
    } else {
      alert("Please upload a valid image or video only.");
    }
  };

  fileReaderHandler = (fileType, readerEvent) => {
    let binaryString = new Uint8Array(readerEvent.target.result);
    let base64String = btoa(
      binaryString.reduce((data, byte) => data + String.fromCharCode(byte), "")
    );

    let data = null;

    if (fileType.startsWith("image/")) {
      data = "data:image/" + fileType.split("/")[1] + ";base64," + base64String;
    } else if (fileType.startsWith("video/")) {
      data = "data:video/" + fileType.split("/")[1] + ";base64," + base64String;
    } else if (fileType === "application/pdf") {
      data = "data:application/pdf;base64," + base64String;
    }

    this.setState({
      consentAttachmentData: data,
    });
  };

  isValidFileType = (type) => {
    switch (type) {
      case "image/png":
      case "image/jpeg":
      case "image/jpg":
      case "video/mp4":
      case "video/ogg":
      case "video/webm":
      case "application/pdf":
        return true;
      default:
        return false;
    }
  };

  radioChange = (e) => {
    this.setState({
      groupThree: e.target.value,
    });
    let antithromboticDrugs = e.target.value;
    this.setState({ antithromboticDrugs: antithromboticDrugs });
  };

  radioGCSFChange = (e) => {
    this.setState({
      groupTwo: e.target.value,
    });
    let gcsfMedicinePC = e.target.value;
    this.setState({ gcsfMedicinePC: gcsfMedicinePC });
  };

  radioButtonBone = (e) => {
    this.setState({
      groupTwo: e.target.value,
    });
    let boneMetasisDrug = e.target.value;
    this.setState({ boneMetasisDrug: boneMetasisDrug });
  };
  closePreviewModalHandler = () => {
    this.setState({ previewModal: false });
  };

  viewFollowupList = () => {
    this.setState({ showFollowupList: true });
  };

  closeFollowupList = () => {
    this.setState({ showFollowupList: false });
  };

  viewChemoList = () => {
    this.setState({ showChemoList: true });
  };

  closeChemoList = () => {
    this.setState({ showChemoList: false });
  };

  viewTreatmentList = () => {
    this.setState({ showTreatmentList: true });
  };

  closeTreatmentList = () => {
    this.setState({ showTreatmentList: false });
  };

  setTreatmentPlanIdForEdit(tempTreatmentPlan) {
    this.setState({
      showNewTreatment: true,
      treatmentPlanIdTmt: tempTreatmentPlan.patientTreatmentPlanId,
      // Editing has its own protocol already. Clearing here stops anything
      // chosen in the protocol picker earlier in this session from following
      // the user into an unrelated plan.
      preselectedProtocol: null,
      prefetchedProtocols: null,
    });
    this.treatmentPlanChild.current.getTreatmentPlanDetail(
      tempTreatmentPlan.patientTreatmentPlanId
    );

    if (
      this.state.patientAllergies !== "" ||
      this.state.allergies !== "" ||
      this.state.patientComorbidities !== "" ||
      this.state.otherComorbidities !== ""
    ) {
      this.treatmentPlanChild.current.setPatientAllergiePopup(
        this.state.patientAllergies + " " + this.state.allergies
      );
      this.treatmentPlanChild.current.setPatientComorbitiesPopup(
        this.state.patientComorbidities + " " + this.state.otherComorbidities
      );
    }
  }

  handleDiagnosisLoaded = (hasDiagnosis, latestDiagnosisDate, latestPrimarySite, latestPrimarySites) => {
    this.setState({
      canCreateTreatmentPlan: hasDiagnosis,
      diagnosisDate: latestDiagnosisDate || '',
      diagnosisPrimarySite: latestPrimarySite || '',
      // Only this path carries the site IDs. setTreatmentPlan() also writes
      // diagnosisPrimarySite, but from caseDetail.primarySite — a name with no
      // ids — so it deliberately leaves this array alone.
      diagnosisPrimarySites: latestPrimarySites || [],
    }, this.refreshTicker);
  };

  // The protocol picker has confirmed. Stash what the treatment plan form needs
  // BEFORE opening it: NewTreatmentPlan reads all three as props inside the
  // componentDidUpdate branch that fires when showNewTreatment flips, so they
  // have to be on state by the time setTreatmentPlanIdForAdd runs.
  handleProtocolConfirmed = ({ protocol, siteIdsForPlan, prefetchedProtocols }) => {
    this.setState({
      showTreatmentPlanConfirm: false,
      preselectedProtocol: protocol || null,
      protocolFilterSiteIds: siteIdsForPlan || '',
      prefetchedProtocols: prefetchedProtocols || null,
    }, () => {
      this.setTreatmentPlanIdForAdd();
    });
  };

  setTreatmentPlanIdForAdd() {
    this.setState({ showNewTreatment: true, treatmentPlanIdTmt: 0 });
    this.treatmentPlanChild.current.setPatientAllergiePopup(
      this.state.patientAllergies + " " + this.state.allergies
    );
    this.treatmentPlanChild.current.setPatientComorbitiesPopup(
      this.state.patientComorbidities + " " + this.state.otherComorbidities
    );
  }

  showConsentFormForSave(tempTreatmentPlan) {
    this.setState({
      showConsent: true,
      treatmentPlanIdTmt: tempTreatmentPlan.patientTreatmentPlanId,
      currentCardId: tempTreatmentPlan.patientTreatmentPlanId, // Correctly set currentCardId
      waiverConsent: false,
      waiverComments: "",
      consentAttachmentName: "",
      isConsentProvided: {
        ...this.state.isConsentProvided,
        [tempTreatmentPlan.patientTreatmentPlanId]: false,
      }, // Reset state for the specific card
    });
  }

  getTreatmentDataForNewChemo() {
    const isTodayAppointment =
      new Date(this.state.creationDateFP).setHours(0, 0, 0, 0) ===
      new Date().setHours(0, 0, 0, 0);
    if (!this.state.newApptStarted && !isTodayAppointment) {
      swal({
        title: "Appointment Required",
        text: "Please create an appointment and update pre-chemo vitals",
        icon: "warning",
        button: "OK",
      }).then(() => {
        this.setKey("report");
      });
      return;
    }
    this.setState({ showMultipleTreatmentPopup: true });
    this.chemoNewButtonChild.current.getTreatmentDataForNewChemo(
      this.state.patientId
    );
  }
  setKey(k) {
    this.setState({ key: k });
    localStorage.setItem("ActTabkey", k);
  }

  closeVideoConsent = () => {
    this.setState({ showVideoConsent: false });
  };
  onSelectVideo = (videoFile, cardId) => {
    if (!videoFile) {
      alert("No video file selected");
      return;
    }


    const dataTransfer = new DataTransfer();
    dataTransfer.items.add(videoFile);
    this.fileInputRef.current.files = dataTransfer.files;

    const reader = new FileReader();
    reader.onload = (event) => {
      const binaryString = new Uint8Array(event.target.result);
      const base64String = btoa(
        binaryString.reduce(
          (data, byte) => data + String.fromCharCode(byte),
          ""
        )
      );

      const videoData = `data:video/${
        videoFile.type.split("/")[1]
      };base64,${base64String}`;

      this.setState((prevState) => ({
        consentAttachmentData: videoData, // Set the video data
        consentAttachmentName: videoFile.name, // Set the video file name
        waiverComments: "Consent provided through video.", // Add default comment
        isConsentProvided: {
          ...this.state.isConsentProvided,
          [this.state.currentCardId]: true,
        }, // Ensure correct cardId
        showVideoConsent: false, // Automatically close the video consent modal
      }));
    };

    reader.readAsArrayBuffer(videoFile); // Read the file as ArrayBuffer
  };

  handleDateChange(date, dateString) {
    this.setState({ dob: dateString });
  }

  setAllergies(selectedList) {
    this.setState({ selectedAllergies: selectedList });
  }

  handleDateChange = (date) => {
    this.setState({ dischargeDate: date.format("DD/MM/YYYY") });
  };

  setComorbidities(selectedList) {
    this.setState({ selectedComorbidities: selectedList });
    let isOtherSpecifySelected = false;
    selectedList.forEach((item) => {
      if (item.id === 39) {
        // Check if "Other - Specify" is selected
        isOtherSpecifySelected = true;
      }
    });

    this.setState({ isCommorbitiesSelected: isOtherSpecifySelected });

    // Clear other comorbidities field if "Other - Specify" is deselected
    if (!isOtherSpecifySelected) {
      this.setState({ otherComorbidities: "" });
    }
  }

  handleChange(event) {
    const { name, value } = event.target;
    this.setState({ [name]: value });
  }
  handleDateChange(date, dateString) {
    this.setState({ dob: dateString });
  }
  getAllAllergies() {
    return fetch(C.getUrl() + "/allergies/getAllAlergies")
      .then((res) => res.json())
      .then((res) => {
        let resObj = res;
        var arr = [];
        resObj.map(function (d) {
          arr.push({ id: d.allergiesId, name: d.allergiesName });
        });
        this.setState({ allergiesArr: arr });
      })
      .catch((err) => {
      });
  }

  getAllComorbidites() {
    return fetch(C.getUrl() + "/comorbidities/getAllcomorbidities")
      .then((res) => res.json())
      .then((res) => {
        let resObj = res;
        var arr = [];
        resObj.map(function (d) {
          arr.push({ id: d.comorbiditiesId, name: d.comorbiditiesName });
        });
        this.setState({ comorbiditiesArr: arr });
      })
      .catch((err) => {
      });
  }
  getAllGenders() {
    return fetch(C.getUrl() + "/genderMaster/getAllGenders")
      .then((res) => res.json())
      .then((res) => {
        let resObj = res;
        let msg = resObj.message;
        let data = JSON.parse(msg);
        const arr = data.map((d) => ({
          id: d.genderId,
          name: d.genderName,
        }));
        this.setState({ genderArr: arr });
      })
      .catch((err) => {
        swal({
          title: "Warning!",
          text: "Error : " + err,
          icon: "error",
          buttons: false,
          timer: 2000,
        });
      });
  }
  resetRegistrationForm() {
    this.setState({
      anyOngoingTreatment: null,
      referralSource: null,
      isReferralDoctorSelected: false,
      referralDoctorName: "",
      referralHospital: "",
    });
  }

  validatePhoneNumber = (phoneNumber) => {
    const phoneRegex = /^\d{10}$/;
    return phoneRegex.test(phoneNumber);
  };

  validateForm = () => {
    let errors = {};
    let formIsValid = true;

    // Check if height is zero or empty
    if (!this.state.height || Number(this.state.height) <= 0) {
      errors["height"] = "Height must be a positive number.";
      formIsValid = false;
    } else if (this.state.height.toString().length > 3) {
      errors["height"] = "Height must be less than or equal to 3 digits.";
      formIsValid = false;
    }

    // Check if weight is zero or empty
    if (!this.state.weight || Number(this.state.weight) <= 0) {
      errors["weight"] = "Weight must be a positive number.";
      formIsValid = false;
    }

    // Check for mandatory fields
    // if (!this.state.emailId) {
    //   errors["emailId"] = "Email address is required.";
    //   formIsValid = false;
    // }

    if (!this.state.phoneNumber1) {
      errors["phoneNumber1"] = "Phone number is required.";
      formIsValid = false;
    } else if (!this.validatePhoneNumber(this.state.phoneNumber1)) {
      errors["phoneNumber1"] = "Phone number must be exactly 10 digits";
      formIsValid = false;
    }

    this.setState({ patientRegErrors: errors });
    return formIsValid;
  };

  
 // Update the saveCaseSummary method to properly handle additional info
saveCaseSummary = async () => {
  // Add logging before the save operation

  if (!this.validateForm() || !this.validateReferralFields()) {
    return;
  }

  this.setState({ saveLoader: true });

  try {
    // Get patient ID from localStorage first, then fallback to state
    const patientId = localStorage.getItem("PatientpatientId") || this.state.patientId;
    
    if (!patientId) {
      throw new Error("Patient ID is required");
    }

    // First, update the main patient details
    const {
      emailId,
      phoneNumber1,
      weight,
      dob,
      height,
      selectedAllergies,
      selectedComorbidities,
      otherComorbidities,
      doctorId,
      anyOngoingTreatment,
      otherOngoingTreatment,
      profilePictureData1,
      profilePictureName1,
      status,
      dischargeDate,
    } = this.state;

    const allergiesData = selectedAllergies.map((allergy) => ({
      allergiesMstDTO: {
        allergiesId: allergy.id,
        allergiesName: allergy.name,
      },
    }));

    const comorbiditiesData = selectedComorbidities.map((comorbidity) => ({
      comorbiditiesDto: {
        comorbiditiesId: comorbidity.id,
        comorbiditiesName: comorbidity.name,
      },
    }));

    // Helper function to format DOB correctly
    const formatDobForSave = (dobValue) => {
      if (!dobValue) return null;
      
      // If it's already a moment object, use it directly
      if (moment.isMoment(dobValue)) {
        return dobValue.format('YYYY-MM-DD');
      }
      
      // If it's a string, parse with multiple format attempts
      const parsed = moment(dobValue, ['DD/MM/YYYY', 'YYYY-MM-DD', 'MMM DD, YYYY', 'ddd MMM DD, YYYY'], true);
      if (parsed.isValid()) {
        return parsed.format('YYYY-MM-DD');
      }
      
      return null;
    };

    const mainPayload = {
      patientID: parseInt(patientId),
      emailId: emailId,
      phoneNumber1: phoneNumber1,
      onGoingTreatment: anyOngoingTreatment,
      otherOngoingTreatment: otherOngoingTreatment || "",
      weight: Number(weight),
      dob: formatDobForSave(dob),
      height: Number(height),
      patientAllergies: allergiesData,
      allergies: this.state.otherAllergies || "",
      patientComorbidities: comorbiditiesData,
      otherComorbidities: otherComorbidities || "",
      doctor: {
        userId: doctorId,
      },
      profilePictureData: profilePictureData1,
      profilePictureName: profilePictureName1,
      referralSource: this.state.referralSource,
      referralDoctorName: this.state.isReferralDoctorSelected
        ? this.state.referralDoctorName
        : "",
      referralHospital: this.state.isReferralHospitalSelected
        ? this.state.referralHospital
        : "",
      status: status || "",
      dischargeDate: this.state.dischargeDate
        ? moment(this.state.dischargeDate, ['DD/MM/yyyy', 'YYYY-MM-DD', 'MMM DD, YYYY']).format("YYYY-MM-DD")
        : null,

         // Ensure bloodGroup is properly included
      bloodGroup: this.state.bloodGroup || null,
    };


    // Update main patient details
    const mainResponse = await fetch(
      C.getUrl() + "/userCase/updatePatientdetails",
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(mainPayload),
      }
    );

    const mainResult = await mainResponse.json();

    if (mainResult.subErrors && mainResult.subErrors.length > 0) {
      throw new Error(mainResult.subErrors.join(", "));
    }

    // Now update additional patient information
    try {
      await this.updatePatientAdditionalInfo();
    } catch (additionalError) {
      // Don't throw error, just log warning since main update succeeded
    }

    swal({
      title: "Success!",
      text: "Patient details updated successfully!",
      icon: "success",
      buttons: false,
      timer: 2000,
    });

    // Refresh all data
    await this.getPatientCaseDetail(patientId);
    await this.getPatientAdditionalInfo(patientId);
    
    // Clear profile picture data after successful save
    this.setState({
      profilePictureName1: "",
      profilePictureData1: "",
    });

  } catch (err) {
    swal({
      title: "Error!",
      text: "An error occurred while updating the details: " + err.message,
      icon: "error",
      buttons: false,
      timer: 3000,
    });
  } finally {
    this.setState({ saveLoader: false });
  }
};
  // saveCaseSummary = async () => {
  //   if (!this.validateForm() || !this.validateReferralFields()) {
  //     return;
  //   }

  //   const {
  //     patientId,
  //     emailId,
  //     phoneNumber1,
  //     weight,
  //     dob,
  //     height,
  //     selectedAllergies,
  //     selectedComorbidities,
  //     otherComorbidities,
  //     doctorId,
  //     anyOngoingTreatment,
  //     otherOngoingTreatment,
  //     profilePictureData1,
  //     profilePictureName1,
  //     status,
  //     dischargeDate,
  //      bloodGroup, // Add this line
  //   } = this.state;
  //   const allergiesData = selectedAllergies.map((allergy) => ({
  //     allergiesMstDTO: {
  //       allergiesId: allergy.id,
  //       allergiesName: allergy.name,
  //     },
  //   }));

  //   const comorbiditiesData = selectedComorbidities.map((comorbidity) => ({
  //     comorbiditiesDto: {
  //       comorbiditiesId: comorbidity.id,
  //       comorbiditiesName: comorbidity.name,
  //     },
  //   }));

  //   const payload = {
  //     patientID: patientId,
  //     emailId: emailId,
  //     phoneNumber1: phoneNumber1,
  //     onGoingTreatment: anyOngoingTreatment,
  //     otherOngoingTreatment: otherOngoingTreatment || "",
  //     weight: Number(weight),
  //     dob: new Date(dob).toISOString().split("T")[0],
  //     height: Number(height),
  //     patientAllergies: allergiesData,
  //     allergies: this.state.otherAllergies || "",
  //     patientComorbidities: comorbiditiesData,
  //     otherComorbidities: otherComorbidities || "",

  //     doctor: {
  //       userId: doctorId,
  //     },
  //     profilePictureData: profilePictureData1,
  //     profilePictureName: profilePictureName1,
  //     referralSource: this.state.referralSource,
  //     referralDoctorName: this.state.isReferralDoctorSelected
  //       ? this.state.referralDoctorName
  //       : "",
  //     referralHospital: this.state.isReferralHospitalSelected
  //       ? this.state.referralHospital
  //       : "",
  //     status: status || "",
  //     dischargeDate: this.state.dischargeDate
  //       ? moment(this.state.dischargeDate).format("YYYY-MM-DD")
  //       : null,
  //        bloodGroup: this.state.bloodGroup, // Make sure this is correctly placed
  //   };
  //   // Log the exact payload being sent
  // console.log("=== PAYLOAD BEING SENT ===");
  // console.log(JSON.stringify(payload, null, 2));
  // console.log("Payload bloodGroup specifically:", payload.bloodGroup);

  //   this.setState({ saveLoader: true });

  //   try {
  //     const response = await fetch(
  //       C.getUrl() + "/userCase/updatePatientdetails",
  //       {
  //         method: "PUT",
  //         headers: {
  //           "Content-Type": "application/json",
  //         },
  //         body: JSON.stringify(payload),
  //       }
  //     );

  //     const res = await response.json();
  //     console.log("API Response:", res); 

  //     if (res.subErrors) {
  //       swal({
  //         title: "Error!",
  //         text: res.subErrors.join(", "),
  //         icon: "error",
  //         buttons: false,
  //         timer: 3000,
  //       });
  //     } else {
  //       swal({
  //         title: "Success!",
  //         text: "Details updated successfully!",
  //         icon: "success",
  //         buttons: false,
  //         timer: 2000,
  //       });

  //         // After successfully saving main details, save additional info
  //   await this.updatePatientAdditionalInfo();

  //   swal({
  //     title: "Success!",
  //     text: "All details updated successfully!",
  //     icon: "success",
  //     buttons: false,
  //     timer: 2000,
  //   });
  
  //       this.getPatientCaseDetail(patientId); // Refresh data after saving
  //       // Clear profile picture data after successful save
  //       this.setState({
  //         profilePictureName1: "",
  //         profilePictureData1: "",
  //       });
  //     }
  //   } catch (err) {
  //     console.error("Error updating details:", err);
  //     swal({
  //       title: "Error!",
  //       text: "An error occurred while updating the details.",
  //       icon: "error",
  //       buttons: false,
  //       timer: 500,
  //     });
  //   } finally {
  //     this.setState({ saveLoader: false }); // Reset loading state
  //   }
  // };


  toggleEditing = () => {
    this.setState((prevState) => ({ isEditing: !prevState.isEditing }));
  };

  handleHeightChange = (e) => {
    this.setState({ height: e.target.value });
  };

  toggleEditingHeight = () => {
    this.setState((prevState) => ({
      isEditingHeight: !prevState.isEditingHeight,
    }));
  };

  handleChange1(event) {
    if (event.target.name === "anyOngoingTreatment") {
      this.setState({
        anyOngoingTreatmentDto: { anyOngoingTreatmentId: event.target.value },
        isShowAssociatedWIthDoctor:
          event.target.value === "1" || event.target.value === "4"
            ? true
            : false,
        anyOngoingTreatment:
          event.target.options[event.target.selectedIndex].text,
      });
    }
  }
  setDOB(date) {
    // Normalize the date to YYYY-MM-DD string format for consistent storage
    
    let normalizedDate = "";
    if (date) {
      if (moment.isMoment(date)) {
        normalizedDate = date.format('YYYY-MM-DD');
      } else if (typeof date === 'string') {
        const parsed = moment(date, ['DD/MM/YYYY', 'YYYY-MM-DD', 'MMM DD, YYYY']);
        if (parsed.isValid()) {
          normalizedDate = parsed.format('YYYY-MM-DD');
        } else {
          normalizedDate = date; // Keep original if parsing fails
        }
      } else {
        // Try to parse as Date object
        const parsed = moment(date);
        if (parsed.isValid()) {
          normalizedDate = parsed.format('YYYY-MM-DD');
        }
      }
    }
    this.setState({ dob: normalizedDate });
  }

  profilePicHandler(e) {
    let file = e.target.files[0];
    let fileType = e.target.files[0].type;
    let validFileType = this.isValidFileType(fileType);

    if (file && validFileType) {
      const reader = new FileReader();
      reader.onload = (readerEvent) => {
        let binaryString = readerEvent.target.result;
        let imageData = "data:image/jpeg;base64," + btoa(binaryString);
        this.setState({
          profilePictureData1: imageData,
          profilePictureName1: e.target.files[0].name,
          patientProfilePictureData: imageData,
        });
      };
      reader.readAsBinaryString(file);
      this.setState({
        profilePictureName1: e.target.files[0].name,
      });
    }
  }

  fileReaderHandler(readerEvent) {
    let binaryString = readerEvent.target.result;
    let imageData = "data:image/jpeg;base64," + btoa(binaryString);
    this.setState({
      profilePictureData: imageData,
    });
  }

  isValidFileType(type) {
    switch (type) {
      case "image/png":
      case "image/jpeg":
      case "image/jpg":
        return true;
      default:
        return false;
    }
  }

  // Handle dropdown change for any ongoing treatment
  handleOngoingTreatmentChange = (event) => {
    const selectedOptionText =
      event.target.options[event.target.selectedIndex].text;

    // Show text area only if "Yes" is selected
    const isOngoingTreatmentSelected = selectedOptionText === "Yes";

    this.setState({
      anyOngoingTreatment: selectedOptionText,
      isOngoingTreatmentSelected,
      otherOngoingTreatment: isOngoingTreatmentSelected
        ? this.state.otherOngoingTreatment
        : "", // Clear if not "Yes"
    });
  };

  // Handle change in text area input for otherOngoingTreatment
  handleOtherOngoingTreatmentChange = (event) => {
    this.setState({ otherOngoingTreatment: event.target.value });
  };
  getDefaultProfileImage = () => {
    const { genderName } = this.state;

    switch (genderName.toLowerCase()) {
      case "male":
        return `${process.env.PUBLIC_URL}/img/profile-male.png`;
      case "female":
        return `${process.env.PUBLIC_URL}/img/Female-profile.jpg`;
      default:
        return `${process.env.PUBLIC_URL}/img/user-profile-image.jpg`;
    }
  };
  // Update the handlers
  handleReferralSourceChange = (event) => {
    const selectedValue = event.target.value;

    this.setState({
      referralSource: selectedValue,
      isReferralDoctorSelected: selectedValue === "Physician/Doctor", // Match exact string from array
      isReferralHospitalSelected: selectedValue === "Hospital",
      referralDoctorName:
        selectedValue === "Physician/Doctor"
          ? this.state.referralDoctorName
          : "",
      referralHospital:
        selectedValue === "Hospital" ? this.state.referralHospital : "",
      referralErrors: {
        referralSource: "",
        referralDoctorName: "",
        referralHospital: "",
      },
    });
  };

  handleReferralDoctorNameChange = (event) => {
    this.setState({
      referralDoctorName: event.target.value,
      referralErrors: {
        ...this.state.referralErrors,
        referralDoctorName: "",
      },
    });
  };

  handleReferralHospitalChange = (event) => {
    this.setState({
      referralHospital: event.target.value,
      referralErrors: {
        ...this.state.referralErrors,
        referralHospital: "",
      },
    });
  };

  // Test with minimal payload
testBloodGroupSave = async () => {
  const testPayload = {
    patientID: parseInt(this.state.patientId),
    bloodGroup: this.state.bloodGroup,
    // Add only required fields that backend needs
    emailId: this.state.emailId,
    phoneNumber1: this.state.phoneNumber1,
  };


  try {
    const response = await fetch(
      C.getUrl() + "/userCase/updatePatientdetails",
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(testPayload),
      }
    );

    const res = await response.json();
  } catch (err) {
  }
};

// 1. Fix the handleBloodGroupChange method
handleBloodGroupChange = (event) => {
  const value = event.target.value === "DEFAULT" ? null : event.target.value;
  
  // Validate the value - make sure it matches the exact values from your array
  if (value && !["A+", "A-", "B+", "B-", "O+", "O-", "AB+", "AB-", "Not known"].includes(value)) {
    return;
  }
  
  // Clear any validation errors
  this.setState({ 
    bloodGroup: value,
    patientRegErrors: {
      ...this.state.patientRegErrors,
      bloodGroup: ""
    }
  }, () => {
  });
};
  // Add validation function
  validateReferralFields = () => {
    const errors = {
      referralSource: "",
      referralDoctorName: "",
      referralHospital: "",
    };
    let isValid = true;

    if (
      this.state.isReferralHospitalSelected &&
      !this.state.referralHospital.trim()
    ) {
      errors.referralHospital = `Please enter referring hospital's name`;
      isValid = false;
    }

    this.setState({ referralErrors: errors });
    return isValid;
  };

  addMedicationDetail = () => {
    this.setState((prevState) => ({
      medicationDetails: [
        ...prevState.medicationDetails,
        {
          medicine: null,
          dose: "",
          when: "",
          duration: "",
          instructions: "",
          isSaved: false,
        },
      ],
    }));
  };

  // Update removeMedicationDetail method to call the deactivate API
  removeMedicationDetail = async (index) => {
    const medicationToRemove = this.state.medicationDetails[index];

    if (
      medicationToRemove.medicine &&
      medicationToRemove.medicine.medicineListXrefId
    ) {
      try {
        this.setState({ saveLoader: true });

        const response = await fetch(
          C.getUrl() +
            "/medicineListXref/deactivate/" +
            medicationToRemove.medicine.medicineListXrefId,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        const data = await response.json();

        if (data.statusCode === 200) {
          // Remove only this medicine from the UI
          const medicationDetails = [...this.state.medicationDetails];
          medicationDetails.splice(index, 1);
          this.setState({
            medicationDetails,
            saveLoader: false,
          });

          // Refresh the medicines list from server to ensure sync
          await this.getPatientMedicines(this.state.patientId);

          swal({
            title: "Success!",
            text: "Medicine removed successfully",
            icon: "success",
            buttons: false,
            timer: 2000,
          });
        } else {
          this.setState({ saveLoader: false });
          swal({
            title: "Error!",
            text: "Failed to remove medicine",
            icon: "error",
            buttons: false,
            timer: 2000,
          });
        }
      } catch (err) {
        this.setState({ saveLoader: false });
        swal({
          title: "Error!",
          text: "Failed to remove medicine: " + err,
          icon: "error",
          buttons: false,
          timer: 2000,
        });
      }
    } else {
      // For unsaved medicines, just remove from state
      const medicationDetails = [...this.state.medicationDetails];
      medicationDetails.splice(index, 1);
      this.setState({ medicationDetails });
    }
  };

  validateMedicationDetails = () => {
    let formIsValid = true;
    let newMedicationErrors = [];
    let hasAnyMedicine = false; // Flag to check if any medicine is selected

    this.state.medicationDetails.forEach((detail, index) => {
      let rowErrors = {};

      if (detail.medicine) {
        hasAnyMedicine = true;
        if (!detail.dose) {
          rowErrors.dose = "Please select dose";
          formIsValid = false;
        }
        if (!detail.when) {
          rowErrors.when = "Please select when to take";
          formIsValid = false;
        }
        if (!detail.duration) {
          rowErrors.duration = "Please select duration";
          formIsValid = false;
        }
        if (!detail.instructions?.trim()) {
          rowErrors.instructions = "Please enter instructions";
          formIsValid = false;
        }
      } else {
        // If it's an empty row, add validation for medicine selection
        rowErrors.medicine = "Please select medicine";
        formIsValid = false;
      }

      newMedicationErrors[index] = rowErrors;
    });

    // If no medicine is selected at all, show error message
    if (!hasAnyMedicine) {
      swal({
        title: "Warning!",
        text: "Please add at least one medicine with complete details",
        icon: "warning",
        buttons: false,
        timer: 2000,
      });
      formIsValid = false;
    }

    this.setState({ medicationErrors: newMedicationErrors });
    return formIsValid;
  };

  saveMedicationDetails = async () => {
    const unsavedMedications = this.state.medicationDetails.filter(
      (detail) => detail.medicine !== null && !detail.isSaved
    );

    if (unsavedMedications.length === 0) {
      swal({
        title: "Warning!",
        text: "No new medicines to save. Please add details first.",
        icon: "warning",
        buttons: false,
        timer: 2000,
      });
      return;
    }

    if (!this.validateMedicationDetails()) {
      return;
    }

    this.setState({ saveLoader: true });

    try {
      const medicationsData = unsavedMedications.map((detail) => ({
        medicineId: detail.medicine.id,
        patientId: this.state.patientId,
        dose: detail.dose,
        when: detail.when,
        duration: detail.duration,
        instructions: detail.instructions,
        activeInd: "Y",
      }));

      const saveMedicationPromises = medicationsData.map((medication) =>
        fetch(C.getUrl() + "/medicineListXref/add", {
          method: "PUT",
          mode: "cors",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(medication),
        }).then((res) => res.json())
      );

      await Promise.all(saveMedicationPromises);

      // Update saved status
      const updatedMedicationDetails = this.state.medicationDetails.map(
        (detail) =>
          detail.medicine !== null && !detail.isSaved
            ? { ...detail, isSaved: true }
            : detail
      );

      this.setState({
        medicationDetails: updatedMedicationDetails,
        saveLoader: false,
      });

      swal({
        title: "Success!",
        text: "Medicines saved successfully",
        icon: "success",
        buttons: false,
        timer: 2000,
      });

      await this.getPatientMedicines(this.state.patientId);
    } catch (err) {
      this.setState({ saveLoader: false });
      swal({
        title: "Error!",
        text: "Failed to save medicines",
        icon: "error",
        buttons: false,
        timer: 2000,
      });
    }
  };

  handleInputChange = (e) => {
    const { name, value } = e.target;

    // Add validation for specific fields
    switch (name) {
      case "pulse":
        if (value === "" || (value >= 0 && value <= 210)) {
          this.setState({ [name]: value });
        }
        break;

      case "temperature":
        if (value === "" || (value >= 0 && value <= 109)) {
          this.setState({ [name]: value });
        }
        break;

      case "bpSystolic":
      case "bpDiastolic":
        if (value === "" || (value >= 0 && value <= 300)) {
          this.setState({ [name]: value });
        }
        break;

      case "spO2":
        if (value === "" || (value >= 0 && value <= 100)) {
          this.setState({ [name]: value });
        }
        break;

      case "bloodGlucose":
        if (value === "" || (value >= 0 && value <= 700)) {
          this.setState({ [name]: value });
        }
        break;

      case "glucoseTestType":
        this.setState({ [name]: value });
        break;

      default:
        this.setState({ [name]: value });
    }
  };

  fetchPatientDocuments = (patientId) => {
    if (!patientId) return;
    this.setState({ loading: true });
    fetch(C.getUrl() + "/documents/getPrescriptionById?patientId=" + patientId)
      .then((res) => res.json())
      .then((res) => {
        if (res.serviceStatus === "SUCCESS_WITH_MULTIPLE_DATA") {
          const documents = res.objectList?.[0] || [];

          if (documents.length > 0) {
            const processedDocs = documents.map((item, index) => ({
              key: Crypt.getUniqueKey(index),
              id: item.documentId,
              fileName: item.fileName,
              documentTypeId: item.documentTypeId,
              documentType: item.documentType || item.type || "",
              contentType: item.contentType || "",
              fileSize: item.fileSize,
              uploadDate: item.uploadDate,
              createdDate: item.createdDate,
              activeInd: item.activeInd,
              patientId: item.patientId,
            }));

            this.setState({
              documents: processedDocs,
              loading: false,
              loaderModal: false,
              error: null,
            });
          } else {
            this.setState({
              documents: [],
              loading: false,
              loaderModal: false,
              error: null,
            });
          }
        } else {
          this.setState({
            error: "Please upload the document",
            loading: false,
            loaderModal: false,
            documents: [],
          });
        }
      })
      .catch((err) => {
        this.setState({
          error: "Error fetching documents",
          loading: false,
          loaderModal: false,
          documents: [],
        });
      });
  };

  // Mirrors the server-side allowlist. Extensions, not MIME types: several of
  // these have unreliable browser MIME values and would not be selectable.
  // .dcm (DICOM) was dropped on 11-Aug-2026 — DICOM is not in use. Documents
  // already stored keep listing and downloading; this gates uploads only.
  allowedDocumentExtensions = [
    "pdf",
    "jpg",
    "jpeg",
    "png",
    "gif",
    "bmp",
    "webp",
    "tif",
    "tiff",
    "txt",
    "csv",
    "rtf",
  ];

  // 5 MB, matching the server cap (was 50 MB, which existed only to fit DICOM
  // studies). Measured on the file as it sits on disk — the server applies its
  // limit to the decoded bytes, not to the larger base64 we transmit.
  maxDocumentSizeBytes = 5 * 1024 * 1024;

  getDocumentAcceptAttr = () =>
    this.allowedDocumentExtensions.map((ext) => `.${ext}`).join(",");

  // Master list feeding the Type dropdown. This endpoint uses the project's
  // other envelope (ApiResponse): the payload arrives as a JSON string inside
  // `message`. statusCode 451 means "no active types", i.e. an empty list.
  fetchDocumentTypes = () => {
    return fetch(C.getUrl() + "/documentTypeMaster/getAllDocumentTypes")
      .then((res) => res.json())
      .then((res) => {
        let options = [];
        if (res && res.statusCode === 200) {
          try {
            options = JSON.parse(res.message || "[]");
          } catch (e) {
            options = [];
          }
        }
        this.setState({
          documentTypeOptions: Array.isArray(options) ? options : [],
          documentTypesLoaded: true,
        });
      })
      .catch(() => {
        this.setState({ documentTypeOptions: [], documentTypesLoaded: true });
      });
  };

  // Keeps only the file types the server accepts, warning about the rest
  filterAllowedFiles = (files) => {
    const accepted = [];
    const rejectedType = [];
    const rejectedSize = [];

    files.forEach((file) => {
      const ext = (file.name.split(".").pop() || "").toLowerCase();
      if (!file.name.includes(".") || !this.allowedDocumentExtensions.includes(ext)) {
        rejectedType.push(file.name);
      } else if (file.size > this.maxDocumentSizeBytes) {
        rejectedSize.push(file.name);
      } else {
        accepted.push(file);
      }
    });

    const messages = [];
    if (rejectedType.length > 0) {
      messages.push(
        `${rejectedType.join(", ")} - file type not accepted. Allowed types: ${this.allowedDocumentExtensions.join(", ")}.`
      );
    }
    if (rejectedSize.length > 0) {
      messages.push(
        `${rejectedSize.join(", ")} - exceeds the maximum allowed size of 5 MB.`
      );
    }
    if (messages.length > 0) {
      swal({
        title: "Some files could not be added",
        text: messages.join("\n\n"),
        icon: "warning",
      });
    }

    return accepted;
  };

  openPrescriptionModal = (files = []) => {
    if (!this.state.documentTypesLoaded) {
      this.fetchDocumentTypes();
    }
    this.setState({
      showPrescriptionModal: true,
      prescriptionType: "",
      prescriptionTypeId: "",
      prescriptionTypeError: "",
      prescriptionFileError: "",
      prescriptionPendingFiles: files,
    });
  };

  closePrescriptionModal = () => {
    if (this.fileInput) {
      this.fileInput.value = "";
    }
    this.setState({
      showPrescriptionModal: false,
      prescriptionType: "",
      prescriptionTypeId: "",
      prescriptionTypeError: "",
      prescriptionFileError: "",
      prescriptionPendingFiles: [],
    });
  };

  // Files chosen from inside the popup (Browse)
  handleFileSelect = (event) => {
    const files = this.filterAllowedFiles(Array.from(event.target.files || []));
    event.target.value = "";
    if (files.length > 0) {
      this.setState({
        prescriptionPendingFiles: files,
        prescriptionFileError: "",
      });
    }
  };

  submitPrescriptionUpload = () => {
    const files = this.state.prescriptionPendingFiles || [];
    const hasTypeMaster = this.state.documentTypeOptions.length > 0;
    const documentTypeId = this.state.prescriptionTypeId;
    const documentType = (this.state.prescriptionType || "").trim();

    // Both checks run together so the popup flags everything that is missing
    // in one pass instead of one error at a time.
    const typeError =
      hasTypeMaster && !documentTypeId
        ? "Please select the type of report."
        : !hasTypeMaster && !documentType
        ? "Please enter the type of report."
        : "";
    const fileError = files.length === 0 ? "Please select at least one file." : "";

    if (typeError || fileError) {
      this.setState({
        prescriptionTypeError: typeError,
        prescriptionFileError: fileError,
      });
      return;
    }

    // Master-driven when the dropdown loaded; otherwise fall back to the
    // backend's transitional resolve-by-name path (case-insensitive, and
    // rejected outright if the name matches no master row).
    const typePayload = hasTypeMaster
      ? { documentTypeId: Number(documentTypeId) }
      : { documentType };

    files.forEach((file) => this.readAndUploadPrescription(file, typePayload));
    this.closePrescriptionModal();
  };

  readAndUploadPrescription = (file, typePayload) => {
    // Initialize progress for this file
    this.setState((prevState) => ({
      uploadProgress: {
        ...prevState.uploadProgress,
        [file.name]: 0,
      },
    }));

    const reader = new FileReader();
    reader.onload = (e) => {
      this.uploadDocument({
        patientId: this.state.patientId,
        fileName: file.name,
        // Keep the FileReader data-URL prefix: it lets the server cross-check
        // the declared MIME type against the file extension.
        fileData: e.target.result,
        ...typePayload,
        uploadDate: new Date(),
        createdBy: 1,
      });
    };
    reader.onprogress = (e) => {
      if (e.lengthComputable) {
        const progress = Math.round((e.loaded * 50) / e.total); // First 50% for reading
        this.setState((prevState) => ({
          uploadProgress: {
            ...prevState.uploadProgress,
            [file.name]: progress,
          },
        }));
      }
    };
    reader.readAsDataURL(file);
  };

  uploadDocument = (documentDTO) => {
    const fileName = documentDTO.fileName;

    this.setState((prevState) => ({
      uploadProgress: {
        ...prevState.uploadProgress,
        [fileName]: 0,
      },
    }));

    const clearProgress = (delay) => {
      setTimeout(() => {
        this.setState((prevState) => {
          const newProgress = { ...prevState.uploadProgress };
          delete newProgress[fileName];
          return { uploadProgress: newProgress };
        });
      }, delay);
    };

    fetch(C.getUrl() + "/documents/upload", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(documentDTO),
    })
      // The HTTP status has to travel with the body. A 413 is raised by the
      // proxy in front of the app and carries an HTML body, so json() rejects
      // and the request would otherwise collapse into the generic "try again"
      // message, hiding the fact that the file was simply too big to get in.
      .then((res) =>
        res
          .json()
          .catch(() => ({}))
          .then((body) => ({ status: res.status, body }))
      )
      .then(({ status, body: res }) => {
        if (status === 413) {
          // Sent as base64 inside JSON, so the request is ~1.33x the file.
          // Quote the sent size — that is the number the limit applies to.
          const sentSize = this.formatFileSize((documentDTO.fileData || "").length);

          swal({
            title: `Could not upload ${fileName}`,
            text:
              `The server refused this file because the request was too large ` +
              `(${sentSize} sent). Please try a smaller file, or ask your ` +
              `administrator to raise the upload size limit on the server.`,
            icon: "error",
          });

          clearProgress(0);
          return;
        }

        // Set to 100% when upload completes
        this.setState((prevState) => ({
          uploadProgress: {
            ...prevState.uploadProgress,
            [fileName]: 100,
          },
        }));

        // BaseDTO envelope: no statusCode field. Expected rejections come back
        // as HTTP 200 + BUSINESS_VALIDATION_FAILURE, unexpected ones as HTTP
        // 500 + SYSTEM_FAILURE; both carry a user-facing reason in errorMsg.
        if (res.serviceStatus === "SUCCESS") {
          swal({
            title: "Success!",
            text: res.message || "Document uploaded successfully.",
            icon: "success",
            buttons: false,
            timer: 2000,
          });

          // First fetch the updated documents
          this.fetchPatientDocuments(this.state.patientId);

          // Then clear the progress bar after documents are fetched
          clearProgress(1500); // Slightly longer than the fetch delay to ensure list is updated first
        } else {
          swal({
            title: `Could not upload ${fileName}`,
            text: res.errorMsg || "The document could not be uploaded. Please try again.",
            icon: "error",
          });

          clearProgress(0);
        }
      })
      .catch((err) => {
        // Clear progress immediately on error
        clearProgress(0);

        swal({
          title: `Could not upload ${fileName}`,
          text: "The document could not be uploaded. Please try again.",
          icon: "error",
        });
      });
  };

  formatFileSize = (bytes) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const sizes = ["Bytes", "KB", "MB", "GB"];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
  };

  triggerFileInput = () => {
    if (this.fileInput) {
      this.fileInput.click();
    }
  };

  handleDragOver = (e) => {
    e.preventDefault();
    this.setState({ isDragging: true });
  };

  handleDragLeave = (e) => {
    e.preventDefault();
    this.setState({ isDragging: false });
  };

  handleDrop = (e) => {
    e.preventDefault();
    this.setState({ isDragging: false });

    const files = this.filterAllowedFiles(Array.from(e.dataTransfer.files || []));
    if (files.length > 0) {
      // Dropped files still need a report type, so route them through the popup
      this.openPrescriptionModal(files);
    }
  };

  // Instance flag rather than state: setState is async, so two ticks in the
  // same tick would both read a stale scanReportsLoading === false.
  scanReportsInFlight = false;

  // "Scan Reports" queues an AI extraction over the reports uploaded for this
  // patient in the last 24h. Diagnosis and pathology are separate runs and are
  // started together: a run that finds no eligible document is free (it makes
  // no external call), so triggering both is cheaper than asking first.
  //
  // Unchecking is a local reset only. There is no cancel endpoint, and a run
  // already in flight is harmless — its result simply waits to be read.
  handleScanReportsToggle = (e) => {
    const checked = e.target.checked;

    if (!checked) {
      this.setState({ scanReports: false, scanReportsMsg: null, scanReportsMsgIsError: false });
      return;
    }

    // Guard duplicate in-flight requests on rapid re-ticks.
    if (this.scanReportsInFlight) return;

    const patientId = this.state.patientId;
    if (!patientId) {
      swal({
        title: "Error!",
        text: "Please save the patient before scanning reports.",
        icon: "error",
        buttons: false,
        timer: 2000,
      });
      return;
    }

    this.scanReportsInFlight = true;
    this.setState({
      scanReports: true,
      scanReportsLoading: true,
      scanReportsMsg: "Reading uploaded reports…",
      scanReportsMsgIsError: false,
    });

    // Both triggers run in parallel and are classified independently, so a
    // failure on one cannot mask the other's success.
    Promise.all([
      startDiagnosisExtraction(patientId),
      startPathologyExtraction(patientId),
    ])
      .then(([diagnosis, pathology]) => {
        this.scanReportsInFlight = false;
        const results = [diagnosis, pathology];

        if (results.some((r) => r.outcome === ExtractionOutcome.UNAUTHORIZED)) {
          this.setState({
            scanReports: false,
            scanReportsLoading: false,
            scanReportsMsg: null,
            scanReportsMsgIsError: false,
          });
          swal({
            title: "Session expired",
            text: "Please sign in again to scan reports.",
            icon: "warning",
            buttons: false,
            timer: 2500,
          });
          return;
        }

        const started = results.filter((r) => r.outcome === ExtractionOutcome.SUCCESS);

        if (started.length > 0) {
          this.setState({
            scanReportsLoading: false,
            scanReportsMsg:
              "Scan started. The diagnosis result can take a few minutes — open " +
              "Initial Assessment › Diagnosis › Add New Diagnosis to use it.",
            scanReportsMsgIsError: false,
          });
          swal({
            title: "Scan started",
            text: "Reports are being read. Diagnosis extraction can take a few minutes.",
            icon: "success",
            buttons: false,
            timer: 2500,
          });
          return;
        }

        // Nothing started. Business messages are curated by the backend and
        // safe to show as-is; a system failure gets generic retry handling.
        const business = results.find((r) => r.outcome === ExtractionOutcome.BUSINESS);
        const message =
          (business && business.message) ||
          (results[0] && results[0].message) ||
          "The scan could not be started. Please try again.";

        this.setState({
          scanReports: false,
          scanReportsLoading: false,
          scanReportsMsg: message,
          scanReportsMsgIsError: true,
        });
        swal({
          title: business ? "Cannot scan reports" : "Error!",
          text: message,
          icon: business ? "warning" : "error",
          buttons: false,
          timer: 3000,
        });
      })
      .catch(() => {
        this.scanReportsInFlight = false;
        this.setState({
          scanReports: false,
          scanReportsLoading: false,
          scanReportsMsg: "The scan could not be started. Please try again.",
          scanReportsMsgIsError: true,
        });
        swal({
          title: "Error!",
          text: "The scan could not be started. Please try again.",
          icon: "error",
          buttons: false,
          timer: 2000,
        });
      });
  };

  // The list no longer carries the file content, so the bytes are fetched on
  // demand. A plain link/window.open cannot be used: the endpoint is
  // JWT-protected and only fetch() picks up the token from the interceptor.
  downloadPrescription = (doc) => {
    return fetch(C.getUrl() + `/documents/download/${doc.id}`)
      .then((res) => {
        if (!res.ok) {
          throw new Error(`Download failed with status ${res.status}`);
        }
        return res.blob();
      })
      .then((blob) => {
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = doc.fileName || "report";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);
      })
      .catch((error) => {
        swal({
          title: "Error",
          text: "Could not download this document.",
          icon: "error",
          buttons: false,
          timer: 2500,
        });
      });
  };

  confirmRemovePrescription = (doc) => {
    swal({
      title: "Delete report?",
      text: `${doc.fileName} will be removed from this patient's reports.`,
      icon: "warning",
      buttons: ["Cancel", "Delete"],
      dangerMode: true,
    }).then((confirmed) => {
      if (confirmed) {
        this.removePrescription(doc.id);
      }
    });
  };
  removePrescription = (documentId) => {
    this.setState({
      loading: true,
      uploadProgress: {}, // Clear any existing progress bars
    });

    return fetch(C.getUrl() + `/documents/${documentId}`, {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json().catch(() => ({})))
      .then((res) => {
        // BaseDTO envelope - the outcome is in serviceStatus, not statusCode.
        if (res.serviceStatus === "SUCCESS") {
          // First show success message
          swal({
            title: "Success!",
            text: res.message || "Document removed successfully.",
            icon: "success",
            buttons: false,
            timer: 2000,
          });
        } else {
          swal({
            title: "Could not delete the report",
            text: res.errorMsg || "The document could not be deleted. Please try again.",
            icon: "error",
          });
        }

        // Refresh either way so the list reflects the server's actual state
        setTimeout(() => {
          this.fetchPatientDocuments(this.state.patientId);
        }, 1000);
      })
      .catch((err) => {
        swal({
          title: "Error",
          text: "Could not remove the report. Please try again.",
          icon: "error",
          buttons: false,
          timer: 2500,
        });

        setTimeout(() => {
          this.fetchPatientDocuments(this.state.patientId);
        }, 1000);
      })
      .finally(() => {
        this.setState({
          loading: false,
          uploadProgress: {}, // Ensure progress bars are cleared after operation completes
        });
      });
  };

  removeStagingDetail = async (index) => {
    const stagingToRemove = this.state.stagingDetails[index];

    if (stagingToRemove?.stagingId) {
      try {
        this.setState({ saveLoader: true });

        // Construct API URL with query parameter
        const url = `${C.getUrl()}/patientStaging/deactivate?stagingId=${
          stagingToRemove.stagingId
        }`;

        const response = await fetch(url, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        });

        const data = await response.json();

        if (data.statusCode === 200) {
          const stagingDetails = [...this.state.stagingDetails];
          stagingDetails.splice(index, 1);
          this.setState({
            stagingDetails,
            saveLoader: false,
          });

          await this.getPatientStaging(this.props.patientId);

          swal({
            title: "Success!",
            text: "Staging record removed successfully",
            icon: "success",
            buttons: false,
            timer: 2000,
          });
        } else {
          swal({
            title: "Error!",
            text: "Failed to remove staging record.",
            icon: "error",
            buttons: false,
            timer: 2000,
          });
          this.setState({ saveLoader: false });
        }
      } catch (err) {
        swal({
          title: "Error!",
          text: "Something went wrong. Please try again.",
          icon: "error",
          buttons: false,
          timer: 2000,
        });
        this.setState({ saveLoader: false });
      }
    } else {
      const stagingDetails = [...this.state.stagingDetails];
      stagingDetails.splice(index, 1);
      this.setState({ stagingDetails });
    }
  };

  getPatientStaging = (patientId) => {
    if (!patientId) {
      return;
    }

    const isRestrictedUser = this.isRestrictedStagingUser();

    fetch(`${C.getUrl()}/patientStaging/getByPatientId?patientId=${patientId}`)
      .then((res) => res.json())
      .then((res) => {
        if (res.statusCode === 200 && res.message) {
          const stagings = JSON.parse(res.message);
          const activeStaging = stagings.filter((s) => s.activeInd === "Y");

          if (activeStaging.length > 0) {
            if (isRestrictedUser) {
              // Restricted user view
              this.setState({
                restrictedStagingDetails: activeStaging.map((s) => ({
                  stagingId: s.stagingId,
                  cancerName: s.cancerName || "",
                  cancerType: s.cancerType || "",
                  t: s.tStage || "",
                  n: s.nStage || "",
                  m: s.mStage || "",
                  g: s.g || "",
                  location: s.location || "",
                  stageGroup: s.stageGroup || "",
                  isSaved: true,
                  isModified: false,
                })),
              });
            } else {
              // Standard user view - now with isModified flag
              this.setState({
                stagingDetails: activeStaging.map((s) => ({
                  stagingId: s.stagingId,
                  type: s.stagingType || "",
                  t: s.tStage || "",
                  n: s.nStage || "",
                  m: s.mStage || "",
                  stage: s.stage || "",
                  date: s.stagingDate
                    ? moment(s.stagingDate).format("DD-MM-YYYY")
                    : null,
                  isSaved: true,
                  isModified: false, // Add this flag
                })),
              });
            }
          } else {
            // Initialize with empty detail based on user type
            if (isRestrictedUser) {
              this.setState({
                restrictedStagingDetails: [
                  {
                    cancerName: "",
                    cancerType: "",
                    t: "",
                    n: "",
                    m: "",
                    g: "",
                    location: "",
                    stageGroup: "",
                    isSaved: false,
                    isModified: false,
                  },
                ],
              });
            } else {
              this.setState({
                stagingDetails: [
                  {
                    type: "",
                    t: "",
                    n: "",
                    m: "",
                    stage: "",
                    date: null,
                    isSaved: false,
                    isModified: false, // Add this flag
                  },
                ],
              });
            }
          }
        }
      })
      .catch((err) => {
        swal({
          title: "Error!",
          text: "Failed to fetch staging details",
          icon: "error",
          buttons: false,
          timer: 2000,
        });
      });
  };

  // Method to add new staging detail
  addStagingDetail = () => {
    this.setState((prevState) => ({
      stagingDetails: [
        ...prevState.stagingDetails,
        {
          type: "",
          t: "",
          n: "",
          m: "",
          stage: "",
          date: null,
          isSaved: false,
          isModified: true, // Add this flag
        },
      ],
      stagingErrors: [],
    }));
  };

  validateStagingDetails = (isRestrictedUser = false) => {
    // If it's a restricted user, skip validation
    if (isRestrictedUser) {
      return true;
    }

    let formIsValid = true;
    let newStagingErrors = [];

    this.state.stagingDetails.forEach((detail, index) => {
      let rowErrors = {};

      // Existing standard user validations
      if (!detail.type) {
        rowErrors.type = "Please select type";
        formIsValid = false;
      }
      if (!detail.t) {
        rowErrors.t = "Please select T";
        formIsValid = false;
      }
      if (!detail.n) {
        rowErrors.n = "Please select N";
        formIsValid = false;
      }
      if (!detail.m) {
        rowErrors.m = "Please select M";
        formIsValid = false;
      }
      if (!detail.stage) {
        rowErrors.stage = "Please select stage";
        formIsValid = false;
      }
      if (!detail.date) {
        rowErrors.date = "Please select date";
        formIsValid = false;
      }

      newStagingErrors[index] = rowErrors;
    });

    this.setState({ stagingErrors: newStagingErrors });

    if (!formIsValid) {
      swal({
        title: "Warning!",
        text: "Please fill all required fields",
        icon: "warning",
        buttons: false,
        timer: 2000,
      });
    }

    return formIsValid;
  };

  saveStagingDetails = async () => {
    // Check if it's a restricted user
    const isRestrictedUser = this.isRestrictedStagingUser();

    // Choose which staging details to use based on user type
    const stagingDetailsToSave = isRestrictedUser
      ? this.state.restrictedStagingDetails
      : this.state.stagingDetails;

    // Validate only for standard users
    if (!isRestrictedUser && !this.validateStagingDetails()) {
      return;
    }

    // Check if there are any records to save
    const recordsToProcess = stagingDetailsToSave.filter(
      (detail) => detail.isModified || !detail.isSaved
    );

    if (recordsToProcess.length === 0) {
      swal({
        title: "Info",
        text: "No changes detected to save",
        icon: "info",
        buttons: false,
        timer: 2000,
      });
      return;
    }

    this.setState({ saveLoader: true });

    try {
      const patientId = this.state.patientId;

      if (!patientId) {
        throw new Error("Patient ID is required");
      }

      // For each patient, we should only have one active record
      // First, get all existing records
      const existingResponse = await fetch(
        `${C.getUrl()}/patientStaging/getByPatientId?patientId=${patientId}`
      );
      const existingResult = await existingResponse.json();

      let existingStagingId = null;

      // If we have existing records, use the first active one's ID
      if (existingResult.statusCode === 200 && existingResult.message) {
        const existingStaging = JSON.parse(existingResult.message);
        const activeStaging = existingStaging.filter(
          (s) => s.activeInd === "Y"
        );

        if (activeStaging.length > 0) {
          existingStagingId = activeStaging[0].stagingId;
        }
      }

      // Prepare data for API
      // Use the existing staging ID if available
      const stagingsData = recordsToProcess.map((detail) => {
        // Base object with common properties
        const stagingData = {
          stagingId: existingStagingId || detail.stagingId || null,
          patientId: parseInt(patientId, 10),
          activeInd: "Y",
          createdBy: existingStagingId ? null : 1, // Only set for new records
          updatedBy: 1,
          updatedDate: moment().format("YYYY-MM-DD"),
        };

        // Add user-specific properties
        if (isRestrictedUser) {
          // Restricted user fields
          return {
            ...stagingData,
            stagingType: "",
            tStage: detail.t || "",
            nStage: detail.n || "",
            mStage: detail.m || "",
            stage: "",
            stagingDate: null,
            stageGroup: detail.stageGroup || "",
            cancerName: detail.cancerName || "",
            cancerType: detail.cancerType || "",
            g: detail.g || "",
            location: detail.location || "",
          };
        } else {
          // Standard user fields
          return {
            ...stagingData,
            stagingType: detail.type || "",
            tStage: detail.t || "",
            nStage: detail.n || "",
            mStage: detail.m || "",
            stage: detail.stage || "",
            stagingDate:
              detail.date && moment(detail.date, "DD-MM-YYYY", true).isValid()
                ? moment(detail.date, "DD-MM-YYYY").format("YYYY-MM-DD")
                : null,
            stageGroup: "",
            cancerName: "",
            cancerType: "",
            g: "",
            location: "",
          };
        }
      });


      // Save each record
      for (const staging of stagingsData) {

        const response = await fetch(C.getUrl() + "/patientStaging/save", {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(staging),
        });

        const result = await response.json();
        if (result.statusCode !== 200) {
          throw new Error(result.message || "Failed to save staging");
        }
      }

      // Success - update local state
      if (isRestrictedUser) {
        this.setState({
          restrictedStagingDetails: this.state.restrictedStagingDetails.map(
            (detail) => ({
              ...detail,
              isModified: false,
              isSaved: true,
              stagingId: existingStagingId || detail.stagingId, // Make sure we update the ID
            })
          ),
        });
      } else {
        this.setState({
          stagingDetails: this.state.stagingDetails.map((detail) => ({
            ...detail,
            isModified: false,
            isSaved: true,
            stagingId: existingStagingId || detail.stagingId, // Make sure we update the ID
          })),
        });
      }

      // Show success message
      swal({
        title: "Success!",
        text: "Staging details saved successfully",
        icon: "success",
        buttons: false,
        timer: 2000,
      });

      // Refresh from server to get latest data
      await this.getPatientStaging(this.state.patientId);
    } catch (err) {
      swal({
        title: "Error!",
        text: "Failed to save staging details: " + err.message,
        icon: "error",
        buttons: false,
        timer: 2000,
      });
    } finally {
      this.setState({ saveLoader: false });
    }
  };

  getPatientStaging;
  // Update the date handler method
  updateStagingDate = (date, index) => {
    const updatedDetails = [...this.state.stagingDetails];
    updatedDetails[index].date = date;
    this.setState({ stagingDetails: updatedDetails });
  };
  handleTypeChange = (value, index) => {
    const updatedDetails = [...this.state.stagingDetails];
    updatedDetails[index].type = value;
    this.setState({ stagingDetails: updatedDetails });
  };
  // Add this helper method to validate patientId
  validatePatientId = () => {
    const { patientId } = this.state;
    if (!patientId) {
      swal({
        title: "Error!",
        text: "Patient ID is missing",
        icon: "error",
        buttons: false,
        timer: 2000,
      });
      return false;
    }
    return true;
  };

  validateStagingDetails = (isRestrictedUser = false) => {
    // If it's a restricted user, always return true and skip all validations
    if (isRestrictedUser) {
      return true;
    }

    let formIsValid = true;
    let newStagingErrors = [];

    this.state.stagingDetails.forEach((detail, index) => {
      let rowErrors = {};

      // Existing standard user validations
      if (!detail.type) {
        rowErrors.type = "Please select type";
        formIsValid = false;
      }
      if (!detail.t) {
        rowErrors.t = "Please select T";
        formIsValid = false;
      }
      if (!detail.n) {
        rowErrors.n = "Please select N";
        formIsValid = false;
      }
      if (!detail.m) {
        rowErrors.m = "Please select M";
        formIsValid = false;
      }
      if (!detail.stage) {
        rowErrors.stage = "Please select stage";
        formIsValid = false;
      }
      if (!detail.date) {
        rowErrors.date = "Please select date";
        formIsValid = false;
      }

      newStagingErrors[index] = rowErrors;
    });

    this.setState({ stagingErrors: newStagingErrors });

    if (!formIsValid) {
      swal({
        title: "Warning!",
        text: "Please fill all required fields",
        icon: "warning",
        buttons: false,
        timer: 2000,
      });
    }

    return formIsValid;
  };

  saveStagingDetails = async () => {
    // Check if it's a restricted user
    const isRestrictedUser = this.isRestrictedStagingUser();

    // Choose which staging details to use based on user type
    const stagingDetailsToSave = isRestrictedUser
      ? this.state.restrictedStagingDetails
      : this.state.stagingDetails;

    // Validate only for standard users
    if (!isRestrictedUser && !this.validateStagingDetails()) {
      return;
    }

    // Check if there are any records to save
    const recordsToProcess = stagingDetailsToSave.filter(
      (detail) => detail.isModified || !detail.isSaved
    );

    if (recordsToProcess.length === 0) {
      swal({
        title: "Info",
        text: "No changes detected to save",
        icon: "info",
        buttons: false,
        timer: 2000,
      });
      return;
    }

    this.setState({ saveLoader: true });

    try {
      const patientId = this.state.patientId;

      if (!patientId) {
        throw new Error("Patient ID is required");
      }

      // For each patient, we should only have one active record
      // First, get all existing records
      const existingResponse = await fetch(
        `${C.getUrl()}/patientStaging/getByPatientId?patientId=${patientId}`
      );
      const existingResult = await existingResponse.json();

      let existingStagingId = null;

      // If we have existing records, use the first active one's ID
      if (existingResult.statusCode === 200 && existingResult.message) {
        const existingStaging = JSON.parse(existingResult.message);
        const activeStaging = existingStaging.filter(
          (s) => s.activeInd === "Y"
        );

        if (activeStaging.length > 0) {
          existingStagingId = activeStaging[0].stagingId;
        }
      }

      // Prepare data for API
      // Use the existing staging ID if available
      const stagingsData = recordsToProcess.map((detail) => {
        // Base object with common properties
        const stagingData = {
          stagingId: existingStagingId || detail.stagingId || null,
          patientId: parseInt(patientId, 10),
          activeInd: "Y",
          createdBy: existingStagingId ? null : 1, // Only set for new records
          updatedBy: 1,
          updatedDate: moment().format("YYYY-MM-DD"),
        };

        // Add user-specific properties
        if (isRestrictedUser) {
          // Restricted user fields
          return {
            ...stagingData,
            stagingType: "",
            tStage: detail.t || "",
            nStage: detail.n || "",
            mStage: detail.m || "",
            stage: "",
            stagingDate: null,
            stageGroup: detail.stageGroup || "",
            cancerName: detail.cancerName || "",
            cancerType: detail.cancerType || "",
            g: detail.g || "",
            location: detail.location || "",
          };
        } else {
          // Standard user fields
          return {
            ...stagingData,
            stagingType: detail.type || "",
            tStage: detail.t || "",
            nStage: detail.n || "",
            mStage: detail.m || "",
            stage: detail.stage || "",
            stagingDate:
              detail.date && moment(detail.date, "DD-MM-YYYY", true).isValid()
                ? moment(detail.date, "DD-MM-YYYY").format("YYYY-MM-DD")
                : null,
            stageGroup: "",
            cancerName: "",
            cancerType: "",
            g: "",
            location: "",
          };
        }
      });


      // Save each record
      for (const staging of stagingsData) {

        const response = await fetch(C.getUrl() + "/patientStaging/save", {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(staging),
        });

        const result = await response.json();
        if (result.statusCode !== 200) {
          throw new Error(result.message || "Failed to save staging");
        }
      }

      // Success - update local state
      if (isRestrictedUser) {
        this.setState({
          restrictedStagingDetails: this.state.restrictedStagingDetails.map(
            (detail) => ({
              ...detail,
              isModified: false,
              isSaved: true,
              stagingId: existingStagingId || detail.stagingId, // Make sure we update the ID
            })
          ),
        });
      } else {
        this.setState({
          stagingDetails: this.state.stagingDetails.map((detail) => ({
            ...detail,
            isModified: false,
            isSaved: true,
            stagingId: existingStagingId || detail.stagingId, // Make sure we update the ID
          })),
        });
      }

      // Show success message
      swal({
        title: "Success!",
        text: "Staging details saved successfully",
        icon: "success",
        buttons: false,
        timer: 2000,
      });

      // Refresh from server to get latest data
      await this.getPatientStaging(this.state.patientId);
    } catch (err) {
      swal({
        title: "Error!",
        text: "Failed to save staging details: " + err.message,
        icon: "error",
        buttons: false,
        timer: 2000,
      });
    } finally {
      this.setState({ saveLoader: false });
    }
  };

  // Add this helper method to validate patientId
  validatePatientId = () => {
    const { patientId } = this.state;
    if (!patientId) {
      swal({
        title: "Error!",
        text: "Patient ID is missing",
        icon: "error",
        buttons: false,
        timer: 2000,
      });
      return false;
    }
    return true;
  };

  formatDate = (dateString) => {
    if (!dateString) return null;
    const date = new Date(dateString);
    return date instanceof Date && !isNaN(date) ? date : null;
  };

  toggleDischargeDate = () => {
    this.setState((prevState) => ({
      isEditingDischargeDate: !prevState.isEditingDischargeDate,
    }));
  };

  setDischargeDate = (date) => {
    this.setState({
      dischargeDate: date,
      isEditingDischargeDate: false,
    });
  };
  addRestrictedStagingDetail = () => {
    const newDetail = {
      cancerName: "",
      cancerType: "",
      t: "",
      n: "",
      m: "",
      g: "",
      location: "",
      stageGroup: "",
      isSaved: false,
      isModified: true, // Mark new records as modified
    };

    this.setState((prevState) => ({
      restrictedStagingDetails: [
        ...prevState.restrictedStagingDetails,
        newDetail,
      ],
    }));
  };

  removeRestrictedStagingDetail = (index) => {
    const updatedDetails = [...this.state.restrictedStagingDetails];
    updatedDetails.splice(index, 1);
    this.setState({ restrictedStagingDetails: updatedDetails });
  };

  validateRestrictedStagingDetails = () => {
    let formIsValid = true;
    let newStagingErrors = [];

    this.state.restrictedStagingDetails.forEach((detail, index) => {
      let rowErrors = {};

      // Add your validation logic here
      if (!detail.cancerName) {
        rowErrors.cancerName = "Please enter Cancer Name";
        formIsValid = false;
      }
      // Add more validations as needed

      newStagingErrors[index] = rowErrors;
    });

    this.setState({ restrictedStagingErrors: newStagingErrors });
    return formIsValid;
  };


  updatePatientHeightWeight = async (height, weight) => {
    try {
      // Get patient ID from localStorage or state
      const patientId = localStorage.getItem("PatientpatientId") || this.state.patientId;
      
      // Validate patient ID
      if (!patientId || isNaN(parseInt(patientId))) {
        return { success: false, error: "Invalid patient ID" };
      }
  
      // Get doctor ID from localStorage or state
      const doctorId = localStorage.getItem("userId") || this.state.doctorId || "1";
  
      // Get patient email and phone from state
      const patientEmail = this.state.emailId || "";
      const patientPhone = this.state.phoneNumber1 || "";
  
      // First, fetch the current patient details to preserve allergies and comorbidities
      const fetchResponse = await fetch(`${C.getUrl()}/userCase/getPatientSummaryDetails?patientId=${patientId}`);
      const fetchData = await fetchResponse.json();
      
      let patientAllergies = [];
      let patientComorbidities = [];
      let allergies = "";
      let otherComorbidities = "";
      let onGoingTreatment = "";
      let otherOngoingTreatment = "";
      let dob = this.state.dob || "";
      
      // Extract existing data if available
      if (fetchData && fetchData.message) {
        const patientDetails = JSON.parse(fetchData.message).patientDetailsDto;
        if (patientDetails) {
          patientAllergies = patientDetails.patientAllergies || [];
          patientComorbidities = patientDetails.patientComorbidities || [];
          allergies = patientDetails.allergies || "";
          otherComorbidities = patientDetails.otherComorbidities || "";
          onGoingTreatment = patientDetails.onGoingTreatment || "";
          otherOngoingTreatment = patientDetails.otherOngoingTreatment || "";
          if (!dob) dob = patientDetails.dob || "";
        }
      }
  
      // Create the payload for updating patient details, preserving existing data
      const payload = {
        patientID: parseInt(patientId),
        emailId: patientEmail,
        phoneNumber1: patientPhone,
        onGoingTreatment: onGoingTreatment,
        otherOngoingTreatment: otherOngoingTreatment,
        weight: weight,
        height: height,
        dob: dob,
        patientAllergies: patientAllergies,
        allergies: allergies,
        patientComorbidities: patientComorbidities,
        otherComorbidities: otherComorbidities,
        doctor: {
          userId: parseInt(doctorId)
        },
        referralDoctorName: this.state.referralDoctorName || "",
        referralHospital: this.state.referralHospital || "",
        status: this.state.status || "",
        dischargeDate: this.state.dischargeDate
      };
  
  
      // Make the API call
      const response = await fetch(`${C.getUrl()}/userCase/updatePatientdetails`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      });
  
      const data = await response.json();
  
      if (data.serviceStatus === "SUCCESS" || data.statusCode === 200) {
        return { success: true, message: "Patient height and weight updated successfully" };
      } else {
        throw new Error(data.message || "Failed to update patient details");
      }
    } catch (error) {
      return {
        success: false,
        error: error.message || "Failed to update patient details"
      };
    }
  };


  render() {
    // const [key, setKey] = useState('home');

    const onChange = (currentNode, selectedNodes) => {
    };
    const onAction = (node, action) => {
    };
    const onNodeToggle = (currentNode) => {
    };
    const { currentCardId, isConsentProvided } = this.state;
    const {
      context,
      protocolArr,
      scheduleMstArr,
      cancerStageMstArr,
      isCycleDelay,
      reportModal,
      reportMode,
      showHideDemo1,
      generatedScheduledArr,
      appointmentId,
      selectedApptReportData,
      redirectCasePage,
      isHospitalStaff,
      key,
      doctorLoggedIn,
      regProtocolIdTmt,
      patientId,
      treatmentPlanIdTmt,
      firstName,
      lastName,
      isEditing,
      height,
      isEditingHeight,
      dob,
      anyOngoingTreatmentArr,
      anyOngoingTreatment,
      isDragging,
      prescriptionFiles,
    } = this.state;
    const isPreviousDate =
      new Date(this.state.creationDateFP).setHours(0, 0, 0, 0) <
      new Date().setHours(0, 0, 0, 0);
    const isTodayDate =
      new Date(this.state.creationDateFP).setHours(0, 0, 0, 0) ===
      new Date().setHours(0, 0, 0, 0);
    const { newApptStarted } = this.state;
    const disableForSameDayNew =
      new Date(this.state.creationDateFP).setHours(0, 0, 0, 0) ===
      new Date().setHours(0, 0, 0, 0);
    const isChemoPastDate =
      this.state.chemoDtPC !== "" &&
      moment(this.state.chemoDtPC, ["DD/MM/YYYY", "DD/MM/yyyy", "YYYY-MM-DD", "MMM DD, YYYY"])
        .isBefore(moment(), "day");
    function disabledDate(current) {
      // Block only past dates; allow today and future.
      // Compare against startOf("day") so today's cell (which is at 00:00)
      // is not treated as "before now" and disabled.
      return current && current < moment().startOf("day");
    }
    if (redirectCasePage) {
      return <Redirect to="case" />;
    }

    return (
      <div className="d-flex" id="wrapper">
        {<Side />}
        <div id="content-wrapper" className="d-flex flex-column">
          <div id="content">
            {<Top />}
            <div className="container-fluid" style={{ width: "100%", maxWidth: "100%", overflow: "auto" }}>
              <div className="app-content" style={{ width: "100%", maxWidth: "100%" }}>
                <section className="section" id="accordion" style={{ width: "100%", maxWidth: "100%" }}>
                  <div className="row" style={{ width: "100%", margin: "0" }}>
                    <div className="col-md-12" style={{ width: "100%", padding: "0" }}>
                      <div style={{ display: "flex", alignItems: "center", marginBottom: "6px" }}>
                        <div className="form-button" style={{ margin: 0 }}>
                          <Button
                            type="button"
                            className="btn-lg btn btn-light"
                            onClick={() => this.cancelHandler()}
                          >
                            <FaArrowLeft
                              className="fs-18"
                              size="2.0rem"
                              style={{ verticalAlign: "bottom" }}
                            />{" "}
                          </Button>
                        </div>
                        <div className="ticker-wrapper">
                          <div className="ticker-track">
                            <span className="ticker-item">{this.state.tickerMessage}</span>
                            <span className="ticker-item">{this.state.tickerMessage}</span>
                          </div>
                        </div>
                      </div>
                      <Tabs
                        defaultActiveKey="summary"
                        activeKey={key}
                        onSelect={(k) => this.setKey(k)}
                        id="uncontrolled-tab-example"
                      >
                        <Tab eventKey="summary" title="Case Summary">
                          <Container fluid className="p-0 mt-2" style={{ width: "100%", maxWidth: "100%", paddingLeft: "0", paddingRight: "0" }}>
                            <Row className="g-4">
                              <Col lg="3" className="form-inline-left">
                                <Form.Group className="mb-0">
                                  <Form.Label className="mr-3">
                                    Case No.
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    className="readOnlyView inline"
                                    value={this.state.caseNo || ""}
                                    name="caseNo"
                                    onChange={this.handleChange}
                                    disabled={true}
                                  />
                                </Form.Group>
                              </Col>
                              <Col lg="3" className="form-inline-left">
                                <Form.Group className="mb-0">
                                  <Form.Label className="mr-3">
                                    Patient Name
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    className="readOnlyView inline"
                                    value={
                                      this.state.firstName +
                                      " " +
                                      this.state.lastName
                                    }
                                    name="firstName"
                                    onChange={this.handleChange}
                                    disabled={true}
                                  />
                                </Form.Group>
                              </Col>
                              <Col lg="3" className="form-inline-left">
                                <Form.Group className="mb-0">
                                  <Form.Label className="mr-3">Age</Form.Label>
                                  <Form.Control
                                    type="text"
                                    className="readOnlyView inline"
                                    value={(this.state.patientAge || "") + " Years"}
                                    name="patientAge"
                                    onChange={this.handleChange}
                                    disabled={true}
                                  />
                                </Form.Group>
                              </Col>
                              <Col lg="3" className="form-inline-left">
                                <Form.Group className="mb-0">
                                  <Form.Label className="mr-3">
                                    Gender
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    className="readOnlyView inline"
                                    value={this.state.genderName || ""}
                                    name="gender"
                                    onChange={this.handleChange}
                                    disabled={true}
                                  />
                                </Form.Group>
                              </Col>
                            </Row>
                            <Row className="g-2 mt-3">
                              <Col lg="3" className="form-inline-left">
                                <Form.Group className="mb-0">
                                  <Form.Label className="mr-3">
                                    Institute Name
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    className="readOnlyView inline"
                                    value={
                                      this.state.instituteDto.instituteName ||
                                      "N/A"
                                    }
                                    name="instituteName"
                                    onChange={this.handleChange}
                                    disabled={true}
                                  />
                                </Form.Group>
                              </Col>
                              <Col lg="3" className="form-inline-left">
                                <Form.Group className="mb-0">
                                  <Form.Label className="mr-3">
                                    Date Of Birth
                                  </Form.Label>
                                  {isEditing ? (
                                    <DatePicker
                                      value={this.parseDobForDatePicker(dob)}
                                      onChange={(date) => this.setDOB(date)}
                                      placeholder="Date of Birth"
                                      format={dateFormat}
                                      disabledDate={(d) =>
                                        !d || d.isAfter(moment())
                                      }
                                      className="form-control"
                                      style={{ width: "175px", height: "31px" }} // Ensures consistent dimensions
                                    />
                                  ) : (
                                    <Form.Control
                                      type="text"
                                      value={
                                        dob
                                          ? moment(dob, ['DD/MM/YYYY', 'YYYY-MM-DD', 'MMM DD, YYYY']).format(dateFormat)
                                          : ""
                                      }
                                      onClick={this.toggleEditing}
                                      readOnly={true}
                                      className="form-control"
                                      style={{ width: "175px", height: "31px" }} // Ensures consistent dimensions
                                    />
                                  )}
                                </Form.Group>
                              </Col>
                              <Col lg="3" className="form-inline-left">
                                <Form.Group className="mb-0">
                                  <Form.Label className="mr-3">
                                    Emergency Contact
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="Enter emergency contact person"
                                    name="emergencyContactPerson"
                                    value={this.state.emergencyContactPerson || ""}
                                    onChange={(e) => this.setState({ emergencyContactPerson: e.target.value })}
                                    className="inline"
                                    style={{ width: "175px", height: "31px" }}
                                  />
                                </Form.Group>
                              </Col>
                              <Col lg="3" className="form-inline-left">
                                <Form.Group className="mb-0">
                                  <Form.Label className="mr-3">Medical History</Form.Label>
                                  <a
                                    href="#"
                                    className="btn btn-link p-0"
                                    style={{ verticalAlign: "middle" }}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      sessionStorage.setItem('currentPatientId', this.state.patientId);
                                      const origin = window.location.origin;
                                      window.open(`${origin}/#/view-medical-history?patientId=${this.state.patientId}`, '_blank');
                                    }}
                                  >
                                    View
                                  </a>
                                </Form.Group>
                              </Col>
                            </Row>

                            <Row className="g-2 mt-2">
                              <Col lg="3" className="form-inline-left">
                                <Form.Group className="mb-0">
                                  <Form.Label className="mr-3">
                                    Phone Number
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    maxLength="10"
                                    placeholder="Enter phone number"
                                    name="phoneNumber1"
                                    value={this.state.phoneNumber1 || ""}
                                    onChange={(e) => {
                                      const value = e.target.value.replace(
                                        /\D/g,
                                        ""
                                      ); // Remove non-numeric characters
                                      if (value.length <= 10) {
                                        this.setState({ phoneNumber1: value });
                                      }
                                    }}
                                    id="phoneNumber1"
                                    isInvalid={
                                      !!this.state.patientRegErrors[
                                        "phoneNumber1"
                                      ]
                                    }
                                    style={{ width: "175px", height: "31px" }}
                                  />
                                  <div className="invalid-feedback">
                                    {
                                      this.state.patientRegErrors[
                                        "phoneNumber1"
                                      ]
                                    }
                                  </div>
                                </Form.Group>
                              </Col>
                              <Col lg="3" className="form-inline-left">
                                <Form.Group className="mb-0">
                                  <Form.Label className="mr-3">
                                    Email Address
                                    {/* <span className="text-red"> *</span> */}
                                  </Form.Label>
                                  <Form.Control
                                    type="email"
                                    placeholder="Enter email address"
                                    name="emailId"
                                    value={this.state.emailId || ""}
                                    onChange={(e) =>
                                      this.setState({ emailId: e.target.value })
                                    }
                                    id="emailId"
                                    isInvalid={
                                      !!this.state.patientRegErrors["emailId"]
                                    }
                                    style={{ width: "175px", height: "31px" }}
                                  />
                                  <div className="invalid-feedback">
                                    {this.state.patientRegErrors["emailId"]}
                                  </div>
                                </Form.Group>
                              </Col>
                              <Col lg="3" className="form-inline-left">
                                <Form.Group className="mb-0">
                                  <Form.Label className="mr-3">
                                    Emergency Mobile
                                  </Form.Label>
                                  <Form.Control
                                    type="text"
                                    maxLength="10"
                                    placeholder="Enter emergency mobile number"
                                    name="emergencyMobileNumber"
                                    value={this.state.emergencyMobileNumber || ""}
                                    onChange={(e) => {
                                      const value = e.target.value.replace(/\D/g, "");
                                      if (value.length <= 10) {
                                        this.setState({ emergencyMobileNumber: value });
                                      }
                                    }}
                                    className="inline"
                                    style={{ width: "175px", height: "31px" }}
                                  />
                                </Form.Group>
                              </Col>
                              <Col lg="3" className="form-inline-left">
                                <Form.Group className="mb-0">
                                  <Form.Label className="mr-3">Blood Group</Form.Label>
                                  <Form.Control
                                    as="select"
                                    id="bloodGroupId"
                                    name="bloodGroup"
                                    className="inline"
                                    value={this.state.bloodGroup || "Not known"}
                                    onChange={this.handleBloodGroupChange}
                                    style={{ width: "175px", height: "31px" }}
                                  >
                                    {this.state.bloodGroupArr.map((item) => (
                                      <option key={item.id} value={item.id} disabled={item.id === "Not known"}>
                                        {item.name}
                                      </option>
                                    ))}
                                  </Form.Control>
                                </Form.Group>
                              </Col>
                            </Row>

                            <Row className="g-2 mt-2">
                              <Col lg="3" className="form-inline-left">
                                <Form.Group className="mb-0">
                                  <Form.Label className="mr-3">Patient Type</Form.Label>
                                  <Form.Control
                                    as="select"
                                    name="patientType"
                                    value={this.state.patientType || ""}
                                    onChange={(e) => this.setState({ patientType: e.target.value })}
                                    className="inline"
                                    style={{ width: "175px", height: "31px" }}
                                  >
                                    <option value="">Select patient type</option>
                                    <option value="Inpatient">Inpatient</option>
                                    <option value="Outpatient">Outpatient</option>
                                    <option value="Emergency">Emergency</option>
                                  </Form.Control>
                                </Form.Group>
                              </Col>
                              <Col lg="3" className="form-inline-left">
                                <Form.Group className="mb-0">
                                  <Form.Label className="mr-3">ID Proof Type</Form.Label>
                                  <Form.Control
                                    as="select"
                                    name="idProofType"
                                    value={this.state.idProofType || ""}
                                    onChange={this.handleIdProofTypeChange}
                                    className="inline"
                                    style={{ width: "175px", height: "31px" }}
                                  >
                                    <option value="">Select ID Proof Type</option>
                                    <option value="Aadhaar Card">Aadhaar Card</option>
                                    <option value="PAN Card">PAN Card</option>
                                    <option value="Passport">Passport</option>
                                    <option value="Driving License">Driving License</option>
                                    <option value="Voter ID">Voter ID</option>
                                  </Form.Control>
                                </Form.Group>
                              </Col>
                              <Col lg="3" className="form-inline-left">
                                <Form.Group className="mb-0">
                                  <Form.Label className="mr-3">ID Proof Number</Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="Enter ID proof number"
                                    name="idProofNumber"
                                    value={this.state.idProofNumber || ""}
                                    onChange={(e) => this.setState({ idProofNumber: e.target.value })}
                                    className="inline"
                                    style={{ width: "175px", height: "31px" }}
                                  />
                                </Form.Group>
                              </Col>
                              {this.state.isRestrictedFieldsVisible && (
                                <Col lg="3" className="form-inline-left">
                                  <Form.Group className="mb-0">
                                    <Form.Label className="mr-3">
                                      MR Number
                                    </Form.Label>
                                    <Form.Control
                                      className="readOnlyView inline"
                                      type="text"
                                      value={this.state.mrNo || "N/A"}
                                      readOnly={true}
                                    />
                                  </Form.Group>
                                </Col>
                              )}
                            </Row>
                            <div className="dropdown-divider pb-1 mt-1"></div>
                            <Row>
                              {this.state.isCurrentTreatmentTerminated ==
                                "Y" && (
                                <Col lg="12" id="contentMsg">
                                  <Alert
                                    variant="danger"
                                    style={{ padding: "1.5rem" }}
                                  >
                                    <b>
                                      Previous treatment is terminated. Please
                                      start a new treatment.
                                    </b>
                                  </Alert>
                                </Col>
                              )}
                              <Col lg="8">
                                <Row>
                                  {/* Restricted Fields - Only shown for authorized users */}
                                  {this.state.isRestrictedFieldsVisible && (
                                    <>
                                      <Col lg="4">
                                        <Form.Group>
                                          <Form.Label>Category</Form.Label>
                                          <Form.Control
                                            className="readOnlyView inline"
                                            type="text"
                                            value={this.state.category || ""}
                                            readOnly={true}
                                          />
                                        </Form.Group>
                                      </Col>
                                      <Col lg="4">
                                        <Form.Group>
                                          <Form.Label>Pay Type</Form.Label>
                                          <Form.Control
                                            className="readOnlyView inline"
                                            type="text"
                                            value={this.state.payType || ""}
                                            readOnly={true}
                                          />
                                        </Form.Group>
                                      </Col>
                                      <Col lg="4">
                                        <Form.Group>
                                          <Form.Label>Status</Form.Label>
                                          <Form.Control
                                            as="select"
                                            value={this.state.status || ""}
                                            onChange={this.handleStatusChange}
                                            className="inline"
                                          >
                                            <option value="">
                                              Select Status
                                            </option>
                                            {this.state.statusOptions.map(
                                              (option) => (
                                                <option
                                                  key={option.id}
                                                  value={option.name}
                                                >
                                                  {option.name}
                                                </option>
                                              )
                                            )}
                                          </Form.Control>
                                        </Form.Group>
                                      </Col>
                                      <Col lg="4">
                                        <Form.Group>
                                          <Form.Label>Company</Form.Label>
                                          <Form.Control
                                            className="readOnlyView inline"
                                            type="text"
                                            value={this.state.company || ""}
                                            readOnly={true}
                                          />
                                        </Form.Group>
                                      </Col>
                                      <Col lg="4">
                                        <Form.Group>
                                          <Form.Label>Tarrif</Form.Label>
                                          <Form.Control
                                            className="readOnlyView inline"
                                            type="text"
                                            value={this.state.tarrif || ""}
                                            readOnly={true}
                                          />
                                        </Form.Group>
                                      </Col>
                                      <Col lg="4">
                                        <Form.Group className="mb-0">
                                          <Form.Label className="mr-3">
                                            Discharge Date
                                          </Form.Label>
                                          {(() => {
                                            const userId =
                                              localStorage.getItem("userId");
                                            const instituteId =
                                              this.state.instituteDto
                                                ?.instituteId;

                                            if (
                                              userId === "90" ||
                                              instituteId === 30 ||
                                              userId === "74" ||
                                              instituteId === 22
                                            ) {
                                              return (
                                                <div className="d-flex align-items-center">
                                                  {this.state
                                                    .isEditingDischargeDate ? (
                                                    <DatePicker
                                                      onChange={(date) =>
                                                        this.setDischargeDate(
                                                          date
                                                        )
                                                      }
                                                      placeholder="Enter Discharge Date"
                                                      format={dateFormat}
                                                      disabledDate={(d) =>
                                                        !d ||
                                                        d.isAfter(moment())
                                                      }
                                                      className="form-control"
                                                      style={{
                                                        width: "165px",
                                                        height: "31px",
                                                      }}
                                                      value={
                                                        this.state.dischargeDate
                                                          ? moment(
                                                              this.state
                                                                .dischargeDate
                                                            )
                                                          : null
                                                      }
                                                      open={true}
                                                    />
                                                  ) : (
                                                    <Form.Control
                                                      type="text"
                                                      placeholder="Enter Discharge Date"
                                                      value={
                                                        this.state.dischargeDate
                                                          ? moment(
                                                              this.state
                                                                .dischargeDate
                                                            ).format(dateFormat)
                                                          : ""
                                                      }
                                                      onClick={
                                                        this.toggleDischargeDate
                                                      }
                                                      readOnly={true}
                                                      className="form-control"
                                                      style={{
                                                        width: "165px",
                                                        height: "31px",
                                                        cursor: "pointer",
                                                      }}
                                                    />
                                                  )}
                                                </div>
                                              );
                                            } else {
                                              return (
                                                <Form.Control
                                                  className="readOnlyView inline"
                                                  type="text"
                                                  value={
                                                    this.state.dischargeDate
                                                      ? moment(
                                                          this.state
                                                            .dischargeDate
                                                        ).format(dateFormat)
                                                      : "N/A"
                                                  }
                                                  readOnly={true}
                                                />
                                              );
                                            }
                                          })()}
                                        </Form.Group>
                                      </Col>
                                    </>
                                  )}
                                </Row>
                              </Col>
                            </Row>
                            <Row className="g-2 mt-2">
                              <Col lg="3">
                                <Form.Group className="mb-2">
                                  <Form.Label>
                                    Any Ongoing Treatment
                                    <span className="text-red"> *</span>
                                  </Form.Label>
                                  <Form.Control
                                    as="select"
                                    id="ongoingTreatmentId"
                                    name="anyOngoingTreatment"
                                    value={this.state.anyOngoingTreatment || "DEFAULT"}
                                    onChange={this.handleOngoingTreatmentChange}
                                    style={{ width: "100%", height: "31px" }}
                                  >
                                    <option value="DEFAULT" disabled>
                                      - Select Any Ongoing Treatment -
                                    </option>
                                    {this.state.anyOngoingTreatmentArr.map((item) => (
                                      <option key={item.id} value={item.name}>{item.name}</option>
                                    ))}
                                  </Form.Control>
                                </Form.Group>
                                {this.state.isOngoingTreatmentSelected && (
                                  <Form.Group>
                                    <Form.Label>Please specify</Form.Label>
                                    <Form.Control
                                      as="textarea"
                                      placeholder="Any ongoing treatment, please specify"
                                      name="otherOngoingTreatment"
                                      value={this.state.otherOngoingTreatment}
                                      rows={3}
                                      onChange={this.handleOtherOngoingTreatmentChange}
                                      style={{ width: "100%" }}
                                    />
                                  </Form.Group>
                                )}
                              </Col>
                              <Col lg="3">
                                <Form.Group className="mb-2">
                                  <Form.Label>Allergies/ Hypersensitivity</Form.Label>
                                  <Multiselect
                                    options={this.state.allergiesArr}
                                    selectedValues={this.state.selectedAllergies}
                                    displayValue="name"
                                    placeholder="Select Allergies"
                                    onSelect={(selectedList) => {
                                      this.setState({ selectedAllergies: selectedList });
                                      const isOtherSelected = selectedList.some((item) => item.id === 9);
                                      this.setState({ isAllergiesSelected: isOtherSelected });
                                    }}
                                    onRemove={(selectedList) => {
                                      this.setState({ selectedAllergies: selectedList });
                                      const isOtherSelected = selectedList.some((item) => item.id === 9);
                                      this.setState({ isAllergiesSelected: isOtherSelected });
                                      if (!isOtherSelected) {
                                        this.setState({ otherAllergies: "" });
                                      }
                                    }}
                                  />
                                </Form.Group>
                                {this.state.isAllergiesSelected && (
                                  <Form.Group className="input-group mb-0">
                                    <span className="input-group-addon"><FaPlus /></span>
                                    <Form.Control
                                      as="textarea"
                                      placeholder="Other Allergies, Please specify"
                                      value={this.state.otherAllergies || ""}
                                      name="otherAllergies"
                                      rows={2}
                                      onChange={this.handleChange}
                                    />
                                  </Form.Group>
                                )}
                              </Col>
                              <Col lg="3">
                                <Form.Group className="mb-2">
                                  <Form.Label>Comorbidities</Form.Label>
                                  <Multiselect
                                    options={this.state.comorbiditiesArr}
                                    selectedValues={this.state.selectedComorbidities}
                                    displayValue="name"
                                    placeholder="Select Comorbidities"
                                    onSelect={(selectedList) => {
                                      this.setState({ selectedComorbidities: selectedList });
                                      const isOtherSelected = selectedList.some((item) => item.id === 39);
                                      this.setState({ isCommorbitiesSelected: isOtherSelected });
                                    }}
                                    onRemove={(selectedList) => {
                                      this.setState({ selectedComorbidities: selectedList });
                                      const isOtherSelected = selectedList.some((item) => item.id === 39);
                                      this.setState({ isCommorbitiesSelected: isOtherSelected });
                                    }}
                                  />
                                </Form.Group>
                                {this.state.isCommorbitiesSelected && (
                                  <Form.Group className="input-group mb-0">
                                    <span className="input-group-addon"><FaPlus /></span>
                                    <Form.Control
                                      as="textarea"
                                      placeholder="Other Comorbidities, Please specify"
                                      value={this.state.otherComorbidities || ""}
                                      name="otherComorbidities"
                                      rows={2}
                                      onChange={this.handleChange}
                                    />
                                  </Form.Group>
                                )}
                              </Col>
                              <Col lg="3">
                                <Form.Group>
                                  <Form.Label>Current Diagnosis</Form.Label>
                                  <Multiselect
                                    options={[]}
                                    selectedValues={this.state.canSiteIdIAD}
                                    displayValue="name"
                                    placeholder=""
                                    disable={true}
                                    showCheckbox={false}
                                    closeOnSelect={true}
                                    customCloseIcon={<span></span>}
                                    style={{
                                      chips: { background: "#1E90FF", color: "white" },
                                      multiselectContainer: { color: "#495057" },
                                      searchBox: { border: "none", padding: "0", background: "none" },
                                    }}
                                  />
                                </Form.Group>
                              </Col>
                            </Row>
                            <div className="dropdown-divider pb-1 mt-2"></div>
                            <Row className="mt-2">
                              {/* Col 1: Upload Prescription */}
                              <Col lg="3">
                                <Form.Group>
                                  <div className="d-flex align-items-center">
                                    <Form.Label className="mb-0 mr-2">Upload Reports</Form.Label>
                                    <div
                                      className={`prescription-upload-area d-flex align-items-center justify-content-center px-2 ml-auto border rounded ${this.state.isDragging ? "border-primary" : ""}`}
                                      onDragOver={this.handleDragOver}
                                      onDragLeave={this.handleDragLeave}
                                      onDrop={this.handleDrop}
                                      onClick={() => this.openPrescriptionModal()}
                                      style={{
                                        cursor: "pointer",
                                        height: "31px",
                                        width: "175px",
                                        whiteSpace: "nowrap",
                                      }}
                                    >
                                      <FaCloudUploadAlt fontSize="16" className="mr-1" />
                                      <span>Drag &amp; drop / Browse</span>
                                    </div>
                                  </div>
                                  <small className="text-muted d-block text-center mt-1">
                                    PDF, image, text/CSV/RTF &middot; up to 5 MB
                                  </small>
                                  {/* Progress indicators */}
                                  {Object.entries(this.state.uploadProgress).map(([fileName, progress]) => (
                                    <div key={fileName} className="mt-1">
                                      <small className="text-muted">{fileName}</small>
                                      <div className="progress" style={{ height: "6px" }}>
                                        <div
                                          className="progress-bar"
                                          style={{ width: `${progress}%` }}
                                        />
                                      </div>
                                    </div>
                                  ))}
                                  {/* Uploaded reports */}
                                  {this.state.documents && this.state.documents.length > 0 && (
                                    <div className="mt-2" style={{ overflowX: "auto" }}>
                                      <Table
                                        size="sm"
                                        bordered
                                        hover
                                        className="mb-0"
                                        style={{ fontSize: "14px" }}
                                      >
                                        <thead>
                                          <tr>
                                            <th>Type</th>
                                            <th>Date</th>
                                            <th className="text-center">Report</th>
                                            <th className="text-center"></th>
                                          </tr>
                                        </thead>
                                        <tbody>
                                          {this.state.documents.map((doc) => (
                                            <tr key={doc.id}>
                                              <td title={doc.documentType || ""}>
                                                {doc.documentType || "-"}
                                              </td>
                                              <td style={{ whiteSpace: "nowrap" }}>
                                                {doc.uploadDate && moment(doc.uploadDate).isValid()
                                                  ? moment(doc.uploadDate).format("DD-MMM-YYYY")
                                                  : "-"}
                                              </td>
                                              <td className="text-center">
                                                {(() => {
                                                  const isPdf = /\.pdf$/i.test(doc.fileName || "");
                                                  const FileIcon = isPdf ? FaFilePdf : FaFileAlt;
                                                  const size =
                                                    doc.fileSize > 0
                                                      ? ` (${this.formatFileSize(doc.fileSize)})`
                                                      : "";
                                                  return (
                                                    <FileIcon
                                                      fontSize="18"
                                                      color={isPdf ? "#d32f2f" : "#546e7a"}
                                                      title={`Download ${doc.fileName}${size}`}
                                                      style={{ cursor: "pointer" }}
                                                      onClick={() => this.downloadPrescription(doc)}
                                                    />
                                                  );
                                                })()}
                                              </td>
                                              <td className="text-center">
                                                <FaTrashAlt
                                                  fontSize="14"
                                                  title="Delete report"
                                                  style={{ cursor: "pointer" }}
                                                  onClick={() => this.confirmRemovePrescription(doc)}
                                                />
                                              </td>
                                            </tr>
                                          ))}
                                        </tbody>
                                      </Table>
                                    </div>
                                  )}
                                  <Form.Check
                                    type="checkbox"
                                    id="scan-reports-checkbox"
                                    label="Scan Reports"
                                    checked={this.state.scanReports}
                                    disabled={this.state.scanReportsLoading}
                                    onChange={this.handleScanReportsToggle}
                                    style={{ marginTop: "8px" }}
                                  />
                                  {this.state.scanReportsMsg && (
                                    <small
                                      className={`d-block mt-1 ${this.state.scanReportsMsgIsError ? "text-danger" : "text-muted"}`}
                                    >
                                      {this.state.scanReportsMsg}
                                    </small>
                                  )}
                                </Form.Group>
                              </Col>
                              {/* Col 2: Patient Weight Graph */}
                              <Col lg="3">
                                {(this.state.patientId != 0 || this.state.patientId != "") && (
                                  <Form.Group>
                                    <Form.Label>Patient Weight Graph</Form.Label>
                                    <PatientWeightChart patientId={this.state.patientId} />
                                  </Form.Group>
                                )}
                              </Col>
                              {/* Col 3: Primary Consultant + Referral Source */}
                              <Col lg="3">
                                <Form.Group className="mb-3">
                                  <Form.Label>Primary Consultant</Form.Label>
                                  <Form.Control
                                    type="text"
                                    placeholder="Enter primary consultant"
                                    name="primaryConsultant"
                                    value={this.state.primaryConsultant || ""}
                                    onChange={(e) => this.setState({ primaryConsultant: e.target.value })}
                                    className="inline"
                                    style={{ width: "175px", height: "31px" }}
                                  />
                                </Form.Group>
                                <Form.Group className="mb-3">
                                  <Form.Label>Referral Source</Form.Label>
                                  <Form.Control
                                    as="select"
                                    id="referralSourceId"
                                    name="referralSource"
                                    className="inline"
                                    value={this.state.referralSource || "DEFAULT"}
                                    onChange={this.handleReferralSourceChange}
                                    style={{ width: "175px", height: "31px" }}
                                  >
                                    <option value="DEFAULT" disabled>- Referral Source -</option>
                                    {this.state.referralSourceArr.map((item) => (
                                      <option key={item.id} value={item.name}>{item.name}</option>
                                    ))}
                                  </Form.Control>
                                  {this.state.referralErrors.referralSource && (
                                    <div className="text-danger small mt-1">{this.state.referralErrors.referralSource}</div>
                                  )}
                                </Form.Group>
                                {this.state.isReferralDoctorSelected && (
                                  <Form.Group className="mb-3">
                                    <Form.Label>Referring Doctor</Form.Label>
                                    <Form.Control
                                      type="text"
                                      className={`inline ${this.state.referralErrors.referralDoctorName ? "is-invalid" : ""}`}
                                      placeholder="Enter doctor's name"
                                      name="referralDoctorName"
                                      value={this.state.referralDoctorName || ""}
                                      onChange={this.handleReferralDoctorNameChange}
                                    />
                                    <div className="invalid-feedback">{this.state.referralErrors.referralDoctorName}</div>
                                  </Form.Group>
                                )}
                                {this.state.isReferralHospitalSelected && (
                                  <Form.Group className="mb-3">
                                    <Form.Label>Referring Hospital</Form.Label>
                                    <Form.Control
                                      type="text"
                                      className={`inline ${this.state.referralErrors.referralHospital ? "is-invalid" : ""}`}
                                      placeholder="Enter hospital name"
                                      name="referralHospital"
                                      value={this.state.referralHospital || ""}
                                      onChange={this.handleReferralHospitalChange}
                                    />
                                    <div className="invalid-feedback">{this.state.referralErrors.referralHospital}</div>
                                  </Form.Group>
                                )}
                              </Col>
                              {/* Col 4: Profile Picture + Upload Profile Pic */}
                              <Col lg="3">
                                <Form.Group className="mb-3">
                                  <Form.Label>Profile Picture</Form.Label>
                                  {this.state.patientProfilePictureData ? (
                                    <Image
                                      src={this.state.patientProfilePictureData}
                                      alt="Profile"
                                      style={{ width: "120px", height: "120px", display: "block", marginBottom: "0.5rem" }}
                                    />
                                  ) : (
                                    <Image
                                      src={this.getDefaultProfileImage()}
                                      alt="Default Profile"
                                      style={{ width: "120px", height: "120px", display: "block", marginBottom: "0.5rem" }}
                                    />
                                  )}
                                  <Form.File
                                    type="file"
                                    id="inputGroupFile01"
                                    label="Upload Profile Pic"
                                    onChange={this.profilePicHandler}
                                  />
                                </Form.Group>
                              </Col>
                            </Row>

                            <Row>
                              <Col lg="12" className="form-button text-center">
                                <Button
                                  type="button"
                                  className="btn btn-secondary"
                                  onClick={this.saveCaseSummary}
                              >
                                {this.state.saveLoader && (
                                  <Spinner
                                    className="mr-2"
                                    animation="border"
                                    size="1.5rem"
                                  />
                                )}
                                {!this.state.saveLoader &&
                                  isEditing &&
                                  isEditingHeight && (
                                    <FaSave
                                      className="mr-2"
                                      size="1.5rem"
                                      style={{ verticalAlign: "sub" }}
                                    />
                                  )}
                                Save
                              </Button>
                            </Col>
                          </Row>
                          </Container>
                        </Tab>
                         {/* <Tab eventKey="Investigation" title="investigation Report">
                        <Container fluid className="p-0 mt-4">
                        <InvestigationReport patientId={patientId} />
                        </Container>
                        </Tab> */}
                        <Tab
                          eventKey="initialAssessment"
                          title="Initial Assessment"
                        >
                          {/* <FaQuestionCircle id="assessmentHelp" /> */}
                          <Container fluid className="p-0 mt-2">
                            <Row>
                              <Col lg="3" className="form-inline">
                                <Form.Group className="mb-0">
                                  <Form.Label className="mr-3">
                                    Case No.
                                  </Form.Label>
                                  <Form.Control
                                    className="readOnlyView inline"
                                    type="text"
                                    value={this.state.caseNo}
                                    name="docName"
                                    onChange={this.handleChange}
                                    disabled={true}
                                  />
                                </Form.Group>
                              </Col>
                              <Col lg="3" className="form-inline">
                                <Form.Group className="mb-0">
                                  <Form.Label className="mr-3">
                                    Patient Name
                                  </Form.Label>
                                  <Form.Control
                                    className="readOnlyView inline"
                                    type="text"
                                    value={
                                      this.state.firstName +
                                      " " +
                                      this.state.lastName
                                    }
                                    name="firstName"
                                    onChange={this.handleChange}
                                    disabled={true}
                                  />
                                </Form.Group>
                              </Col>
                              <Col lg="3" className="form-inline">
                                <Form.Group className="mb-0">
                                  <Form.Label className="mr-3">Age</Form.Label>
                                  <Form.Control
                                    className="readOnlyView inline"
                                    type="text"
                                    value={this.state.patientAge + " Years"}
                                    name="firstName"
                                    onChange={this.handleChange}
                                    disabled={true}
                                  />
                                </Form.Group>
                              </Col>
                              <Col lg="3" className="form-inline">
                                <Form.Group className="mb-0">
                                  <Form.Label className="mr-3">
                                    Gender
                                  </Form.Label>
                                  <Form.Control
                                    className="readOnlyView inline"
                                    type="text"
                                    value={this.state.genderName}
                                    name="docName"
                                    onChange={this.handleChange}
                                    disabled={true}
                                  />
                                </Form.Group>
                              </Col>
                            </Row>
                            <div className="dropdown-divider my-1"></div>
                            <Row>
                              {/* <Col lg='3'>
                                                                <Form.Group>
                                                                    <Form.Label>Date of Diagnosis</Form.Label>
                                                                    <DatePicker value={moment(this.state.patientIniAssessmentDt)} format={dateFormat} disabled={true} className="form-control full-width25" />
                                                                </Form.Group>
                                                               
                                                            </Col> */}
                              {/* <Col lg='3'>
                                                                <Form.Group>
                                                                    <Form.Label>Pathology<span className="text-red"> *</span></Form.Label>
                                                                    <Form.Control
                                                                        type="text"
                                                                        placeholder="Enter Pathology"
                                                                        name="pathology"
                                                                        value={this.state.pathology || ""}
                                                                        onChange={this.handleChange}
                                                                        id="pathologyId"
                                                                    />
                                                                    <div className="invalid-feedback">{this.state.initialAssesmentErrors["pathology"]}</div>
                                                                </Form.Group>
                                                            </Col>
                                                            <Col lg='3'>
                                                                <Form.Group>
                                                                    <Form.Label>Cancer Stage<span className="text-red"> *</span></Form.Label>
                                                                    <Form.Control as="select" id="cancerStageId" name='cancerStage' value={this.state.cancerStage || ""} onChange={this.handleChange}>
                                                                        <option value="DEFAULT">- Select Cancer Stage -</option>
                                                                        {
                                                                            cancerStageMstArr.map((item, i) => {
                                                                                return (
                                                                                    <option key={item.key} value={item.id}>{`${item.label}`}</option>
                                                                                );
                                                                            })
                                                                        }
                                                                    </Form.Control>
                                                                    <div className="invalid-feedback">{this.state.initialAssesmentErrors["cancerStage"]}</div>                                                                </Form.Group>
                                                            </Col>
                                                            {(() => {
                                                                if (this.state.cancerStage == 4) {
                                                                    return (
                                                                        <Col lg='3'>
                                                                            <Form.Group>
                                                                                <Form.Label>Bone Metastasis</Form.Label>
                                                                                <Form.Control as="select" id="" name="boneMetasis" value={this.state.boneMetasis || ""} onChange={this.handleChange}>
                                                                                    <option value="N">No</option>
                                                                                    <option value="Y">Yes</option>
                                                                                </Form.Control>
                                                                                <div className="invalid-feedback">{this.state.initialAssesmentErrors["boneMetasis"]}</div>
                                                                            </Form.Group>
                                                                        </Col>
                                                                    )
                                                                }
                                                            })()}
                                                            {(() => {
                                                                if (this.state.cancerStage == 4) {
                                                                    return (
                                                                        <Col lg='3'>
                                                                            <Form.Group>
                                                                                <Form.Label>Brain Mets</Form.Label>
                                                                                <Form.Control as="select" id="" name="brainMets" value={this.state.brainMets || ""} onChange={this.handleChange}>
                                                                                    <option value="N">No</option>
                                                                                    <option value="Y">Yes</option>
                                                                                </Form.Control>
                                                                                <div className="invalid-feedback">{this.state.initialAssesmentErrors["brainMets"]}</div>
                                                                            </Form.Group>
                                                                        </Col>
                                                                    )
                                                                }
                                                            })()}
                                                            <Col lg='3'>
                                                                <Form.Group>
                                                                    <Form.Label>Limb Loss<span className="text-red"> *</span></Form.Label>
                                                                    <Multiselect
                                                                        options={this.state.limbLossArr}
                                                                        selectedValues={this.state.limbLossIdIAD}
                                                                        onSelect={this.setLimbLoss.bind(this)}
                                                                        onRemove={this.setLimbLoss.bind(this)}
                                                                        displayValue="name"
                                                                        placeholder="- Select all that apply -"
                                                                        closeOnSelect="true"
                                                                    />
                                                                </Form.Group>
                                                                <div className="invalid-feedback">{this.state.initialAssesmentErrors["limbLossIdIAD"]}</div>
                                                            </Col>
                                                            <Col lg='3'>
                                                                <Form.Group>
                                                                    <Form.Label>Mutation<span className="text-red"> *</span></Form.Label>
                                                                    <Multiselect
                                                                        options={this.state.mutationArr}
                                                                        selectedValues={this.state.mutationIdIA}
                                                                        onSelect={this.setMutations.bind(this)}
                                                                        onRemove={this.setMutations.bind(this)}
                                                                        displayValue="name"
                                                                        placeholder="- Select all that apply -"
                                                                        closeOnSelect="true"
                                                                    />
                                                                </Form.Group>
                                                                <div className="invalid-feedback">{this.state.initialAssesmentErrors["mutationIdIA"]}</div>
                                                            </Col>
                                                            <Col lg='3'>
                                                                <Form.Group>
                                                                    <Form.Label>Current Diagnosis<span className="text-red"> *</span></Form.Label>
                                                                    <Multiselect
                                                                        options={this.state.canSitesArr}
                                                                        selectedValues={this.state.canSiteIdIAD}
                                                                        onSelect={this.setCanserSites.bind(this)}
                                                                        onRemove={this.setCanserSites.bind(this)}
                                                                        displayValue="name"
                                                                        placeholder="- Select all that apply -"
                                                                        closeOnSelect="true"
                                                                    />
                                                                </Form.Group>
                                                                <div className="invalid-feedback">{this.state.initialAssesmentErrors["canSiteIdIAD"]}</div>
                                                            </Col>
                                                            <Col lg='3'>
                                                                <Form.Group>
                                                                    <Form.Label>Previous Cancer History<span className="text-red"> *</span></Form.Label>
                                                                    <Multiselect
                                                                        options={this.state.prevCanSitesArr}
                                                                        selectedValues={this.state.prevCanSiteIdIAD}
                                                                        onSelect={this.setPrevCanserSites.bind(this)}
                                                                        onRemove={this.setPrevCanserSites.bind(this)}
                                                                        displayValue="name"
                                                                        placeholder="- Select all that apply -"
                                                                        closeOnSelect="true"
                                                                    />
                                                                </Form.Group>
                                                                <div className="invalid-feedback">{this.state.initialAssesmentErrors["prevCanSiteIdIAD"]}</div>
                                                            </Col> */}
                              {/* <Col lg='3'>
                                                                <Form.Group>
                                                                    <Form.Label>Doctor Observation<span className="text-red"> *</span></Form.Label>
                                                                    <Form.Control as="textarea" defaultValue={this.state.doctorObservation} rows={2} name='doctorObservation' onChange={this.handleChange} />
                                                                    <div className="invalid-feedback">{this.state.initialAssesmentErrors["doctorObservation"]}</div>
                                                                </Form.Group>
                                                            </Col> */}

                              {/* <Col lg='3'>
                                                                <Form.Group>
                                                                    <Form.Label>Doctor Prescription<span className="text-red"> *</span></Form.Label>
                                                                    <Form.Control as="textarea" defaultValue={this.state.doctorPrescription} rows={2} name='doctorPrescription' onChange={this.handleChange} />
                                                                    <div className="invalid-feedback">{this.state.initialAssesmentErrors["doctorPrescription"]}</div>
                                                                </Form.Group>
                                                            </Col> */}
                              {/*
                                                            <Col lg='12'>
<h4 className="mb-3">Doctor Prescription</h4>
<hr className="mb-4"/>
    <div className="table-responsive">
        <table className="table table-bordered table-hover">
            <thead>
                <tr>
                    <th>#</th>
                    <th>Medicine<span className="text-red">*</span></th>
                    <th>Dose<span className="text-red">*</span></th>
                    <th>When<span className="text-red">*</span></th>
                    <th>Duration<span className="text-red">*</span></th>
                    <th>Instructions<span className="text-red">*</span></th>
                    <th>Remove</th>
                </tr>
            </thead>
            <tbody>
                {this.state.medicationDetails.map((detail, index) => (
                    <tr key={index}>
                        <td>{index + 1}</td>
                        <td>
                        <style>{customStyles}</style>
                        <Multiselect
  options={[...this.state.medicinesArr].sort((a, b) => a.name.localeCompare(b.name))}
  selectedValues={detail.medicine ? [detail.medicine] : []}
  onSelect={(selectedList, selectedItem) => {
    const updatedDetails = [...this.state.medicationDetails];
    updatedDetails[index].medicine = selectedItem;
    const newErrors = [...this.state.medicationErrors];
    newErrors[index] = {};
    this.setState({
      medicationDetails: updatedDetails,
      medicationErrors: newErrors,
    });
  }}
  onRemove={(selectedList, removedItem) => {
    const updatedDetails = [...this.state.medicationDetails];
    updatedDetails[index].medicine = null;
    const newErrors = [...this.state.medicationErrors];
    newErrors[index] = {};
    this.setState({
      medicationDetails: updatedDetails,
      medicationErrors: newErrors,
    });
  }}
  displayValue="name"
  placeholder="Search Medicine"
  onSearch={async (searchTerm) => {
    if (!searchTerm.trim()) {
      await this.getAllMedicines();
    }
  }}
  onDropdownOpen={async () => {
    await this.getAllMedicines();
  }}
  emptyRecordMsg={
    <div
      style={{ cursor: 'pointer', color: '#0066cc', padding: '8px' }}
      onClick={async (e) => {
        const searchBox = e.target.closest('.multiSelectContainer').querySelector('input.searchBox');
        const medicineName = searchBox ? searchBox.value.trim() : '';
        if (medicineName) {
          swal({
            title: "Add New Medicine",
            text: `Do you want to add "${medicineName}" to the medicine list?`,
            icon: "info",
            buttons: ["Cancel", "Yes, add it"],
          }).then(async (willAdd) => {
            if (willAdd) {
              await this.saveMedicine(medicineName, searchBox);
              // Fetch updated list immediately after saving
              await this.getAllMedicines();
              // Find the newly added medicine in the list
              const newMedicine = this.state.medicinesArr.find(med => med.name === medicineName);
              // Populate the new medicine in the search box and select it
              searchBox.value = newMedicine.name;
              const updatedDetails = [...this.state.medicationDetails];
              updatedDetails[index].medicine = newMedicine;
              const newErrors = [...this.state.medicationErrors];
              newErrors[index] = {};
              this.setState({
                medicationDetails: updatedDetails,
                medicationErrors: newErrors,
              });
              // Reopen dropdown to show updated list
              setTimeout(() => {
                const event = new MouseEvent('click', {
                  bubbles: true,
                  cancelable: true,
                  view: window
                });
                searchBox.dispatchEvent(event);
              }, 100);
            }
          });
        }
      }}
    >
      No records found. Click here to add.
    </div>
  }
/>



        {this.state.medicationErrors[index]?.medicine && (
        <div className="invalid-feedback d-block">
            {this.state.medicationErrors[index].medicine}
        </div>
    )}
                        </td>
                        <td>
                            <Form.Control
                                as="select"
                                value={detail.dose || ''}
                                onChange={(e) => {
                                    const updatedDetails = [...this.state.medicationDetails];
                                    updatedDetails[index].dose = e.target.value;
                                    this.setState({ medicationDetails: updatedDetails });
                                }}
                                className={detail.medicine && !detail.dose ? 'is-invalid' : ''}
                            >
                                <option value="">Select Dose</option>
                                <option value="0-0-1">0-0-1</option>
                                <option value="0-1-0">0-1-0</option>
                                <option value="1-0-0">1-0-0</option>
                                <option value="1-1-0">1-1-0</option>
                                <option value="1-0-1">1-0-1</option>
                                <option value="1-1-1">1-1-1</option>
                                <option value="Once">Once</option>
                                <option value="Twice">Twice</option>
                                <option value="Thrice">Thrice</option>
                                <option value="x-x-1">x-x-1</option>
                                <option value="x-1-x">x-1-x</option>
                                <option value="1-x-x">1-x-x</option>
                                <option value="1-1-x">1-1-x</option>
                                <option value="1-x-1">1-x-1</option>
                                <option value="1-1-x">1-1-x</option>
                                <option value="1-1-1">1-1-1</option>
                                <option value="1-1-1-1">1-1-1-1</option>
                            </Form.Control>
                            {detail.medicine && !detail.dose && (
                                <div className="invalid-feedback">
                                    Please select dose
                                </div>
                            )}
                        </td>
                        <td>
                            <Form.Control
                                as="select"
                                value={detail.when || ''}
                                onChange={(e) => {
                                    const updatedDetails = [...this.state.medicationDetails];
                                    updatedDetails[index].when = e.target.value;
                                    this.setState({ medicationDetails: updatedDetails });
                                }}
                                className={detail.medicine && !detail.when ? 'is-invalid' : ''}
                            >
                                <option value="">Select When</option>
                                <option value="Before Food">Before Food</option>
                                <option value="After Food">After Food</option>
                                <option value="Before Breakfast">Before Breakfast</option>
                                <option value="After Breakfast">After Breakfast</option>
                                <option value="Before Lunch">Before Lunch</option>
                                <option value="After Lunch">After Lunch</option>
                                <option value="Before Dinner">Before Dinner</option>
                                <option value="After Dinner">After Dinner</option>
                            </Form.Control>
                            {detail.medicine && !detail.when && (
                                <div className="invalid-feedback">
                                    Please select when to take
                                </div>
                            )}
                        </td>
                        <td>
                            <Form.Control
                                as="select"
                                value={detail.duration || ''}
                                onChange={(e) => {
                                    const updatedDetails = [...this.state.medicationDetails];
                                    updatedDetails[index].duration = e.target.value;
                                    this.setState({ medicationDetails: updatedDetails });
                                }}
                                className={detail.medicine && !detail.duration ? 'is-invalid' : ''}
                            >
                                <option value="">Select Duration</option>
                                <option value="Day">Day</option>
                                <option value="Week">Week</option>
                                <option value="Month">Month</option>
                                <option value="Year">Year</option>
                            </Form.Control>
                            {detail.medicine && !detail.duration && (
                                <div className="invalid-feedback">
                                    Please select duration
                                </div>
                            )}
                        </td>
                        <td>
                            <Form.Control
                                type="text"
                                value={detail.instructions || ''}
                                onChange={(e) => {
                                    const updatedDetails = [...this.state.medicationDetails];
                                    updatedDetails[index].instructions = e.target.value;
                                    this.setState({ medicationDetails: updatedDetails });
                                }}
                                placeholder="Add instructions"
                                className={detail.medicine && !detail.instructions ? 'is-invalid' : ''}
                            />
                            {detail.medicine && !detail.instructions && (
                                <div className="invalid-feedback">
                                    Please enter instructions
                                </div>
                            )}
                        </td>
                        <td>
                            <Button 
                                variant="danger" 
                                onClick={() => this.removeMedicationDetail(index)}
                            >
                                Remove
                            </Button>
                        </td>
                    </tr>
                ))}
                <tr>
                    <td colSpan="7" className="text-center" style={{ paddingTop: '180px' }}>
                        <Button 
                            variant="secondary" 
                            onClick={this.addMedicationDetail}
                            className="me-2"
                        >
                            Add New
                        </Button>
                        <Button 
                            variant="secondary"
                            onClick={this.saveMedicationDetails}
                            disabled={this.state.saveLoader}
                        >
                            {this.state.saveLoader ? (
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                    className="mr-2"
                                />
                            ) : null}
                            Save Medicines
                        </Button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</Col>      */}
                              {/*
<Col lg='12'>

    {this.isRestrictedStagingUser() ? (
    <div>
        <h4 className="mb-3">Staging</h4>
        <hr className="mb-4"/>
        <div className="table-responsive">
            <table className="table table-bordered table-hover">
                <thead>
                    <tr>
                        <th>#</th>
                        <th>Cancer Name</th>
                        <th>Cancer Type</th>
                        <th>T</th>
                        <th>N</th>
                        <th>M</th>
                        <th>G</th>
                        <th>Location</th>
                        <th>Stage Group</th>
                    </tr>
                </thead>
                <tbody>
                    {this.state.restrictedStagingDetails.map((detail, index) => (
                        <tr key={index}>
                            <td>{index + 1}</td>
                            <td>
                                <Form.Control
                                    type="text"
                                    value={detail.cancerName || ''}
                                    onChange={(e) => {
                                        const updatedDetails = [...this.state.restrictedStagingDetails];
                                        updatedDetails[index].cancerName = e.target.value;
                                        // Mark record as modified
                                        updatedDetails[index].isModified = true;
                                        this.setState({ restrictedStagingDetails: updatedDetails });
                                    }}
                                    placeholder="Enter Cancer Name"
                                />
                            </td>
                            <td>
                                <Form.Control
                                    type="text"
                                    value={detail.cancerType || ''}
                                    onChange={(e) => {
                                        const updatedDetails = [...this.state.restrictedStagingDetails];
                                        updatedDetails[index].cancerType = e.target.value;
                                        updatedDetails[index].isModified = true;
                                        this.setState({ restrictedStagingDetails: updatedDetails });
                                    }}
                                    placeholder="Enter Cancer Type"
                                />
                            </td>
                            <td>
                                <Form.Control
                                    type="text"
                                    value={detail.t || ''}
                                    onChange={(e) => {
                                        const updatedDetails = [...this.state.restrictedStagingDetails];
                                        updatedDetails[index].t = e.target.value;
                                        updatedDetails[index].isModified = true;
                                        this.setState({ restrictedStagingDetails: updatedDetails });
                                    }}
                                    placeholder="Enter T"
                                />
                            </td>
                            <td>
                                <Form.Control
                                    type="text"
                                    value={detail.n || ''}
                                    onChange={(e) => {
                                        const updatedDetails = [...this.state.restrictedStagingDetails];
                                        updatedDetails[index].n = e.target.value;
                                        updatedDetails[index].isModified = true;
                                        this.setState({ restrictedStagingDetails: updatedDetails });
                                    }}
                                    placeholder="Enter N"
                                />
                            </td>
                            <td>
                                <Form.Control
                                    type="text"
                                    value={detail.m || ''}
                                    onChange={(e) => {
                                        const updatedDetails = [...this.state.restrictedStagingDetails];
                                        updatedDetails[index].m = e.target.value;
                                        updatedDetails[index].isModified = true;
                                        this.setState({ restrictedStagingDetails: updatedDetails });
                                    }}
                                    placeholder="Enter M"
                                />
                            </td>
                            <td>
                                <Form.Control
                                    type="text"
                                    value={detail.g || ''}
                                    onChange={(e) => {
                                        const updatedDetails = [...this.state.restrictedStagingDetails];
                                        updatedDetails[index].g = e.target.value;
                                        updatedDetails[index].isModified = true;
                                        this.setState({ restrictedStagingDetails: updatedDetails });
                                    }}
                                    placeholder="Enter G"
                                />
                            </td>
                            <td>
                                <Form.Control
                                    type="text"
                                    value={detail.location || ''}
                                    onChange={(e) => {
                                        const updatedDetails = [...this.state.restrictedStagingDetails];
                                        updatedDetails[index].location = e.target.value;
                                        updatedDetails[index].isModified = true;
                                        this.setState({ restrictedStagingDetails: updatedDetails });
                                    }}
                                    placeholder="Enter Location"
                                />
                            </td>
                            <td>
                                <Form.Control
                                    type="text"
                                    value={detail.stageGroup || ''}
                                    onChange={(e) => {
                                        const updatedDetails = [...this.state.restrictedStagingDetails];
                                        updatedDetails[index].stageGroup = e.target.value;
                                        updatedDetails[index].isModified = true;
                                        this.setState({ restrictedStagingDetails: updatedDetails });
                                    }}
                                    placeholder="Enter Stage Group"
                                />
                            </td>
                            
                        </tr>
                    ))}
                    <tr>
                        <td colSpan="10" className="text-center">
                            
                            <Button 
                                variant="secondary"
                                onClick={this.saveStagingDetails}
                                disabled={this.state.saveLoader}
                            >
                                {this.state.saveLoader ? (
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                        className="me-2"
                                    />
                                ) : null}
                                Save Staging
                            </Button>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
) : (
<div>
    <h4 className="mb-3">Staging</h4>
    <hr className="mb-4"/>
    <div className="table-responsive">
        <table className="table table-bordered table-hover">
            <thead>
                <tr>
                    <th>#</th>
                    <th>Type<span className="text-red">*</span></th>
                    <th>T<span className="text-red">*</span></th>
                    <th>N<span className="text-red">*</span></th>
                    <th>M<span className="text-red">*</span></th>
                    <th>Stage<span className="text-red">*</span></th>
                    <th>Date<span className="text-red">*</span></th>
                </tr>
            </thead>
            <tbody>
                {this.state.stagingDetails.map((detail, index) => (
                    <tr key={index}>
                        <td>{index + 1}</td>
                        <td>
                            <Form.Control
                                as="select"
                                value={detail.type || ''}
                                onChange={(e) => {
                                    const updatedDetails = [...this.state.stagingDetails];
                                    updatedDetails[index].type = e.target.value;
                                    // Mark as modified if it has an ID (existing record)
                                    if (updatedDetails[index].stagingId) {
                                        updatedDetails[index].isModified = true;
                                    }
                                    this.setState({ stagingDetails: updatedDetails });
                                }}
                                className={this.state.stagingErrors[index]?.type ? 'is-invalid' : ''}
                            >
                                <option value="">Select Type</option>
                                <option value="c">c</option>
                                <option value="y">y</option>
                                <option value="p">p</option>
                                <option value="yc">yc</option>
                                <option value="yp">yp</option>
                            </Form.Control>
                            {this.state.stagingErrors[index]?.type && (
                                <div className="invalid-feedback">
                                    Please select type
                                </div>
                            )}
                        </td>
                        <td>
                            <Form.Control
                                as="select"
                                value={detail.t || ''}
                                onChange={(e) => {
                                    const updatedDetails = [...this.state.stagingDetails];
                                    updatedDetails[index].t = e.target.value;
                                    if (updatedDetails[index].stagingId) {
                                        updatedDetails[index].isModified = true;
                                    }
                                    this.setState({ stagingDetails: updatedDetails });
                                }}
                                className={this.state.stagingErrors[index]?.t ? 'is-invalid' : ''}
                            >
                                <option value="">Select T</option>
                                <option value="0">0</option>
                                <option value="1">1</option>
                                <option value="1a">1a</option>
                                <option value="1b">1b</option>
                                <option value="1c">1c</option>
                                <option value="2">2</option>
                                <option value="2a">2a</option>
                                <option value="2b">2b</option>
                                <option value="2c">2c</option>
                                <option value="3">3</option>
                                <option value="3a">3a</option>
                                <option value="3b">3b</option>
                                <option value="3c">3c</option>
                                <option value="4">4</option>
                                <option value="4a">4a</option>
                                <option value="4b">4b</option>
                                <option value="4c">4c</option>
                            </Form.Control>
                            {this.state.stagingErrors[index]?.t && (
                                <div className="invalid-feedback">
                                    Please select T
                                </div>
                            )}
                        </td>
                        <td>
                            <Form.Control
                                as="select"
                                value={detail.n || ''}
                                onChange={(e) => {
                                    const updatedDetails = [...this.state.stagingDetails];
                                    updatedDetails[index].n = e.target.value;
                                    if (updatedDetails[index].stagingId) {
                                        updatedDetails[index].isModified = true;
                                    }
                                    this.setState({ stagingDetails: updatedDetails });
                                }}
                                className={this.state.stagingErrors[index]?.n ? 'is-invalid' : ''}
                            >
                                <option value="">Select N</option>
                                <option value="0">0</option>
                                <option value="1">1</option>
                                <option value="1a">1a</option>
                                <option value="1b">1b</option>
                                <option value="1c">1c</option>
                                <option value="2">2</option>
                                <option value="2a">2a</option>
                                <option value="2b">2b</option>
                                <option value="2c">2c</option>
                                <option value="3">3</option>
                                <option value="3a">3a</option>
                                <option value="3b">3b</option>
                                <option value="3c">3c</option>
                                <option value="4">4</option>
                                <option value="4a">4a</option>
                                <option value="4b">4b</option>
                                <option value="4c">4c</option>
                            </Form.Control>
                            {this.state.stagingErrors[index]?.n && (
                                <div className="invalid-feedback">
                                    Please select N
                                </div>
                            )}
                        </td>
                        <td>
                            <Form.Control
                                as="select"
                                value={detail.m || ''}
                                onChange={(e) => {
                                    const updatedDetails = [...this.state.stagingDetails];
                                    updatedDetails[index].m = e.target.value;
                                    if (updatedDetails[index].stagingId) {
                                        updatedDetails[index].isModified = true;
                                    }
                                    this.setState({ stagingDetails: updatedDetails });
                                }}
                                className={this.state.stagingErrors[index]?.m ? 'is-invalid' : ''}
                            >
                                <option value="">Select M</option>
                                <option value="0">0</option>
                                <option value="1">1</option>
                                <option value="1a">1a</option>
                                <option value="1b">1b</option>
                                <option value="1c">1c</option>
                            </Form.Control>
                            {this.state.stagingErrors[index]?.m && (
                                <div className="invalid-feedback">
                                    Please select M
                                </div>
                            )}
                        </td>
                        <td>
                            <Form.Control
                                as="select"
                                value={detail.stage || ''}
                                onChange={(e) => {
                                    const updatedDetails = [...this.state.stagingDetails];
                                    updatedDetails[index].stage = e.target.value;
                                    if (updatedDetails[index].stagingId) {
                                        updatedDetails[index].isModified = true;
                                    }
                                    this.setState({ stagingDetails: updatedDetails });
                                }}
                                className={this.state.stagingErrors[index]?.stage ? 'is-invalid' : ''}
                            >
                                <option value="">Select Stage</option>
                                <option value="I">I</option>
                                <option value="IA">IA</option>
                                <option value="IB">IB</option>
                                <option value="IC">IC</option>
                                <option value="II">II</option>
                                <option value="IIA">IIA</option>
                                <option value="IIB">IIB</option>
                                <option value="IIC">IIC</option>
                                <option value="III">III</option>
                                <option value="IIIA">IIIA</option>
                                <option value="IIIB">IIIB</option>
                                <option value="IIIC">IIIC</option>
                                <option value="IV">IV</option>
                                <option value="IVA">IVA</option>
                                <option value="IVB">IVB</option>
                                <option value="IVC">IVC</option>
                            </Form.Control>
                            {this.state.stagingErrors[index]?.stage && (
                                <div className="invalid-feedback">
                                    Please select stage
                                </div>
                            )}
                        </td>
                        <td>
                            <DatePicker
                                value={detail.date ? moment(detail.date, "DD-MM-YYYY") : moment(new Date())}
                                onChange={(date, dateString) => {
                                    const updatedDetails = [...this.state.stagingDetails];
                                    updatedDetails[index].date = dateString;
                                    // Mark as modified if it has an ID (existing record)
                                    if (updatedDetails[index].stagingId) {
                                        updatedDetails[index].isModified = true;
                                    }
                                    this.setState({ stagingDetails: updatedDetails });
                                }}
                                format="DD-MM-YYYY"
                                placeholder="Select Date"
                                className={`form-control ${this.state.stagingErrors[index]?.date ? "is-invalid" : ""}`}
                            />
                            {this.state.stagingErrors[index]?.date && (
                                <div className="invalid-feedback">Please select a valid date</div>
                            )}
                        </td>
                        
                    </tr>
                ))}
                <tr>
                    <td colSpan="8" className="text-center">
                        
                        <Button 
                            variant="secondary"
                            onClick={this.saveStagingDetails}
                            disabled={this.state.saveLoader}
                        >
                            {this.state.saveLoader ? (
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                    className="me-2"
                                />
                            ) : null}
                            Save Staging
                        </Button>
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</div>
)}
        </Col>  */}
                            </Row>

                            {/* <Row>
                              <Col lg="12">
                                <h4 className="mb-3 bold"></h4>
                                <DiagnosisManagement
                                  patientId={this.state.patientId}
                                  ref={this.diagnosisManagementRef}
                                />
                              </Col>
                            </Row> */}
                            <Tabs
                              activeKey={this.state.initAssessmentInnerKey}
                              onSelect={(k) =>
                                this.setState({ initAssessmentInnerKey: k })
                              }
                              id="initial-assessment-inner-tabs"
                              className="mt-0"
                            >
                              <Tab eventKey="diagnosis" title="Diagnosis">
                                 {/* 🟦 Diagnosis content goes here */}
                                <Row>
                                  <Col lg="12" >
                                    <DiagnosisManagement
                                      patientId={this.state.patientId}
                                      ref={this.diagnosisManagementRef}
                                      onDiagnosisLoaded={this.handleDiagnosisLoaded}
                                    />
                                  </Col>
                                </Row>
                              </Tab>

                              <Tab eventKey="opvisit" title="OP Visit">
                                {/* 🟦 OpVisit content goes here */}
                                <Row>
                                  <Col lg="12" >
                                    <OPVisitManagement />
                                  </Col>
                                </Row>
                              </Tab>
                            </Tabs>
                            <Row>
                              {/* <Col lg='12' className="form-button text-center">
                                                                <Button type="button" className="btn btn-secondary" onClick={this.saveInitialAssesment.bind(this)}>
                                                                    {this.state.saveLoader && (
                                                                        <Spinner className='mr-2' animation='border' size='1.5rem' />
                                                                    )}
                                                                    {!this.state.saveLoader && (
                                                                        <FaSave className='mr-2' size='1.5rem' style={{ verticalAlign: "sub" }} />
                                                                    )}
                                                                    Save
                                                                </Button>
                                                            </Col> */}
                            </Row>
                          </Container>
                        </Tab>
                        <Tab eventKey="treatmentPlan" title="Treatment Plan">
                          {/* <FaQuestionCircle id="treatmentHelp" /> */}
                          <Container fluid className="p-0 mt-4">
                            <Row>
                              <Col lg="3" className="form-inline">
                                <Form.Group className="mb-0">
                                  <Form.Label className="mr-3">
                                    Case No.
                                  </Form.Label>
                                  <Form.Control
                                    className="readOnlyView inline"
                                    type="text"
                                    value={this.state.caseNo}
                                    name="docName"
                                    onChange={this.handleChange}
                                    disabled={true}
                                  />
                                </Form.Group>
                              </Col>
                              <Col lg="3" className="form-inline">
                                <Form.Group className="mb-0">
                                  <Form.Label className="mr-3">
                                    Patient Name
                                  </Form.Label>
                                  <Form.Control
                                    className="readOnlyView inline"
                                    type="text"
                                    value={
                                      this.state.firstName +
                                      " " +
                                      this.state.lastName
                                    }
                                    name="firstName"
                                    onChange={this.handleChange}
                                    disabled={true}
                                  />
                                </Form.Group>
                              </Col>
                              <Col lg="3" className="form-inline">
                                <Form.Group className="mb-0">
                                  <Form.Label className="mr-3">Age</Form.Label>
                                  <Form.Control
                                    className="readOnlyView inline"
                                    type="text"
                                    value={this.state.patientAge + " Years"}
                                    name="firstName"
                                    onChange={this.handleChange}
                                    disabled={true}
                                  />
                                </Form.Group>
                              </Col>
                              <Col lg="3" className="form-inline">
                                <Form.Group className="mb-0">
                                  <Form.Label className="mr-3">
                                    Gender
                                  </Form.Label>
                                  <Form.Control
                                    className="readOnlyView inline"
                                    type="text"
                                    value={this.state.genderName}
                                    name="docName"
                                    onChange={this.handleChange}
                                    disabled={true}
                                  />
                                </Form.Group>
                              </Col>
                            </Row>
                            <div className="dropdown-divider"></div>
                            <Row>
                              <Col lg="12">
                                <table
                                  className="table table-striped table-hover"
                                  role="grid"
                                >
                                  <thead className="thead-light">
                                    <tr role="row">
                                      <th
                                        className="sorting_asc"
                                        aria-controls="example"
                                        colSpan="1"
                                        aria-sort="ascending"
                                      >
                                        Active Treatments
                                      </th>
                                    </tr>
                                  </thead>
                                </table>
                              </Col>
                              {this.state.patTreatmentPlanSummary.map(
                                (d, idx) => {
                                  return (
                                    <Col lg="6" md="6" sm="6" key={idx}>
                                      <Card border="success" className="card">
                                        <div className="card-body card-link">
                                          <div className="pull-right">
                                            <Dropdown id="hideToggleIcon">
                                              <Dropdown.Toggle
                                                variant="Info"
                                                id=""
                                              >
                                                <FaEllipsisV className="side-menu" />
                                              </Dropdown.Toggle>
                                              <Dropdown.Menu>
                                                <Dropdown.Item
                                                  onClick={() =>
                                                    this.setTreatmentPlanIdForEdit(
                                                      d
                                                    )
                                                  }
                                                >
                                                  <FaEye
                                                    size="1.5rem"
                                                    style={{
                                                      color: "#ACACAC",
                                                      marginRight: "5px",
                                                    }}
                                                  />{" "}
                                                  View Treatment
                                                </Dropdown.Item>

                                                <Dropdown.Item
                                                  onClick={() =>
                                                    this.showConsentFormForSave(
                                                      d
                                                    )
                                                  }
                                                >
                                                  <FaFileContract
                                                    size="1.5rem"
                                                    style={{
                                                      color: "#ACACAC",
                                                      marginRight: "5px",
                                                    }}
                                                  />{" "}
                                                  Add Consent
                                                </Dropdown.Item>

                                                {/* <Dropdown>
                                                                                                {(() => {
                                                                                                    if (isHospitalStaff) {
                                                                                                        return (
                                                                                                            <Dropdown.Item disabled>
                                                                                                                <FaFileContract size="1.5rem" style={{ color: '#E0E0E0', marginRight: '5px' }} />
                                                                                                                Add Consent 
                                                                                                            </Dropdown.Item>
                                                                                                        );
                                                                                                    } else {
                                                                                                        return (
                                                                                                            <Dropdown.Item onClick={() => this.showConsentFormForSave(d)}>
                                                                                                                <FaFileContract size="1.5rem" style={{ color: '#ACACAC', marginRight: '5px' }} />
                                                                                                                Add Consent
                                                                                                            </Dropdown.Item>
                                                                                                        );
                                                                                                    }
                                                                                                })()}
                                                                                            </Dropdown> */}

                                                {/* <Dropdown.Item onClick={() => this.setState({ showTerminateProtocol: true, terminateTreatmentPlanId: d.patientTreatmentPlanId })}><FaTrashAlt size='1.5rem' style={{color: '#ACACAC', marginRight: '5px'}} /> Terminate Treatment</Dropdown.Item> */}
                                                <Dropdown>
                                                  {(() => {
                                                    if (isHospitalStaff) {
                                                      // If the user is hospital staff, disable or hide the option
                                                      return (
                                                        <Dropdown.Item disabled>
                                                          <FaTrashAlt
                                                            size="1.5rem"
                                                            style={{
                                                              color: "#ACACAC",
                                                              marginRight:
                                                                "5px",
                                                            }}
                                                          />
                                                          Terminate Treatment
                                                        </Dropdown.Item>
                                                      );
                                                    } else {
                                                      // If the user is not hospital staff, enable the option
                                                      return (
                                                        <Dropdown.Item
                                                          onClick={() =>
                                                            this.setState({
                                                              showTerminateProtocol: true,
                                                              terminateTreatmentPlanId:
                                                                d.patientTreatmentPlanId,
                                                            })
                                                          }
                                                        >
                                                          <FaTrashAlt
                                                            size="1.5rem"
                                                            style={{
                                                              color: "#ACACAC",
                                                              marginRight:
                                                                "5px",
                                                            }}
                                                          />
                                                          Terminate Treatment
                                                        </Dropdown.Item>
                                                      );
                                                    }
                                                  })()}
                                                </Dropdown>
                                              </Dropdown.Menu>
                                            </Dropdown>
                                          </div>
                                          <Row className="align-items-center">
                                            <div className="icon_file">
                                              <Image
                                                src={`${process.env.PUBLIC_URL}/img/Medical_Record.png`}
                                                style={{ width: "85px" }}
                                              />
                                            </div>
                                            <div className="vl"></div>
                                            <div className="product-details pl-3 ml-3">
                                              <p>
                                                <label>Regimen Planned:</label>{" "}
                                                {d.protocolMstDTO.protocolName}
                                              </p>
                                              <p>
                                                <label>Cycles Planned:</label>{" "}
                                                {d.cyclesPlanned}
                                              </p>
                                              <p>
                                                <label>
                                                  Schedule for Doctor's Visit:
                                                </label>{" "}
                                                {d.scheduleMstDTO.scheduleName}
                                              </p>
                                              <p>
                                                <label>Chemo Date:</label>{" "}
                                                {this.formatDateDDMMYYYY(
                                                  d.chemoStartDt
                                                )}
                                              </p>
                                              {(() => {
                                                const userId =
                                                  localStorage.getItem(
                                                    "userId"
                                                  );
                                                const instituteId =
                                                  d?.patientDetailsDto
                                                    ?.instituteDto?.instituteId;

                                                if (
                                                  userId === "90" ||
                                                  instituteId === 30 ||
                                                  userId === "74" ||
                                                  instituteId === 22
                                                ) {
                                                  return (
                                                    <>
                                                      <p>
                                                        <label>
                                                          Creation Time:
                                                        </label>{" "}
                                                        {d.creationDate
                                                          ? new Date(
                                                              d.creationDate
                                                            ).toLocaleTimeString(
                                                              "en-US",
                                                              {
                                                                hour: "2-digit",
                                                                minute:
                                                                  "2-digit",
                                                                hour12: true,
                                                              }
                                                            )
                                                          : "N/A"}
                                                      </p>
                                                      <p>
                                                        <label>
                                                          Plan Number:
                                                        </label>
                                                        {d.planNo || "N/A"}
                                                      </p>
                                                    </>
                                                  );
                                                }
                                                return null;
                                              })()}
                                            </div>
                                          </Row>
                                        </div>
                                      </Card>
                                    </Col>
                                  );
                                }
                              )}
                            </Row>

                            <Row>
                              <Col lg="12">
                                <table
                                  className="table table-striped table-hover"
                                  role="grid"
                                >
                                  <thead className="thead-light">
                                    <tr role="row">
                                      <th
                                        className="sorting_asc"
                                        aria-controls="example"
                                        colSpan="1"
                                        aria-sort="ascending"
                                      >
                                        Inactive Treatments
                                      </th>
                                    </tr>
                                  </thead>
                                </table>
                              </Col>
                              {this.state.patInactiveTreatmentPlan.map(
                                (d, idx) => {
                                  return (
                                    <Col lg="6" md="6" sm="6" key={idx}>
                                      <Card border="success" className="card">
                                        <div className="card-body card-link">
                                          <div className="pull-right">
                                            <Dropdown id="hideToggleIcon">
                                              <Dropdown.Toggle
                                                variant="Info"
                                                id=""
                                              >
                                                <FaEllipsisV className="side-menu" />
                                              </Dropdown.Toggle>
                                              <Dropdown.Menu>
                                                <Dropdown.Item
                                                  onClick={() =>
                                                    this.setTreatmentPlanIdForEdit(
                                                      d
                                                    )
                                                  }
                                                >
                                                  <FaEye
                                                    size="1.5rem"
                                                    style={{ color: "#ACACAC" }}
                                                  />{" "}
                                                  View Treatment
                                                </Dropdown.Item>
                                              </Dropdown.Menu>
                                            </Dropdown>
                                          </div>
                                          <Row className="align-items-center">
                                            <div className="icon_file">
                                              <Image
                                                src={`${process.env.PUBLIC_URL}/img/Medical_Record.png`}
                                                style={{ width: "70px" }}
                                              />
                                            </div>
                                            <div className="vl"></div>
                                            <div className="product-details pl-3 ml-3">
                                              <p>
                                                <label>Regimen Planned:</label>{" "}
                                                {d.protocolMstDTO.protocolName}
                                              </p>
                                              <p>
                                                <label>Cycles Planned:</label>{" "}
                                                {d.cyclesPlanned}
                                              </p>
                                              <p>
                                                <label>
                                                  Schedule for Doctor's Visit:
                                                </label>{" "}
                                                {d.scheduleMstDTO.scheduleName}
                                              </p>
                                              <p>
                                                <label>Chemo Date:</label>{" "}
                                                {this.formatDateDDMMYYYY(
                                                  d.chemoStartDt
                                                )}
                                              </p>
                                            </div>
                                          </Row>
                                        </div>
                                      </Card>
                                    </Col>
                                  );
                                }
                              )}
                            </Row>
                            <Row>
                              <Col lg="12">
                                <div className="footer form-button text-center mt-2">
                                  {/* <Button variant="secondary" className="btn mr-2" onClick={() => this.setTreatmentPlanIdForAdd()}>New Treatment Plan</Button> */}
                                  {/* <Button className="btn btn-info" title="View Previous Appointments" onClick={this.viewFollowupList} > View Previous Appt.</Button> */}
                                  {(() => {
                                    if (isHospitalStaff) {
                                      return (
                                        <Button
                                          variant="secondary"
                                          className="btn mr-2"
                                          onClick={() =>
                                            this.setTreatmentPlanIdForAdd()
                                          }
                                          disabled={true}
                                        >
                                          New Treatment Plan
                                        </Button>
                                      );
                                    } else {
                                      return this.state.canCreateTreatmentPlan ? (
                                          <Button
                                            variant="secondary"
                                            className="btn mr-2"
                                            onClick={() => this.setState({ showTreatmentPlanConfirm: true })}
                                          >
                                            New Treatment Plan
                                          </Button>
                                        ) : (
                                          <OverlayTrigger
                                            placement="top"
                                            overlay={<Tooltip id="tooltip-no-treatment">Diagnosis must be registered before creating a Treatment Plan.</Tooltip>}
                                          >
                                            <span
                                              style={{ display: 'inline-block', cursor: 'pointer' }}
                                              onClick={() => {
                                                this.setKey("initialAssessment");
                                                this.setState({ initAssessmentInnerKey: "diagnosis" });
                                              }}
                                            >
                                              <Button
                                                variant="secondary"
                                                className="btn mr-2"
                                                disabled={true}
                                                style={{ pointerEvents: 'none' }}
                                              >
                                                New Treatment Plan
                                              </Button>
                                            </span>
                                          </OverlayTrigger>
                                        );
                                    }
                                  })()}
                                </div>
                              </Col>
                            </Row>
                          </Container>
                        </Tab>
                        <Tab eventKey="report" title="Pre Chemotherapy Vitals">
                          {/* <FaQuestionCircle id="follwupHelp" /> */}
                          <Container
                            fluid
                            className="p-0 mt-4"
                            style={{ marginBottom: "80px" }}
                          >
                            <Row>
                              <Col lg="3" className="form-inline">
                                <Form.Group className="mb-0">
                                  <Form.Label className="mr-3">
                                    Case No.
                                  </Form.Label>
                                  <Form.Control
                                    className="readOnlyView inline"
                                    type="text"
                                    value={this.state.caseNo}
                                    name="docName"
                                    onChange={this.handleChange}
                                    disabled={true}
                                  />
                                </Form.Group>
                              </Col>
                              <Col lg="3" className="form-inline">
                                <Form.Group className="mb-0">
                                  <Form.Label className="mr-3">
                                    Patient Name
                                  </Form.Label>
                                  <Form.Control
                                    className="readOnlyView inline"
                                    type="text"
                                    value={
                                      this.state.firstName +
                                      " " +
                                      this.state.lastName
                                    }
                                    name="firstName"
                                    onChange={this.handleChange}
                                    disabled={true}
                                  />
                                </Form.Group>
                              </Col>
                              <Col lg="3" className="form-inline">
                                <Form.Group className="mb-0">
                                  <Form.Label className="mr-3">Age</Form.Label>
                                  <Form.Control
                                    className="readOnlyView inline"
                                    type="text"
                                    value={this.state.patientAge + " Years"}
                                    name="firstName"
                                    onChange={this.handleChange}
                                    disabled={true}
                                  />
                                </Form.Group>
                              </Col>
                              <Col lg="3" className="form-inline">
                                <Form.Group className="mb-0">
                                  <Form.Label className="mr-3">
                                    Gender
                                  </Form.Label>
                                  <Form.Control
                                    className="readOnlyView inline"
                                    type="text"
                                    value={this.state.genderName}
                                    name="docName"
                                    onChange={this.handleChange}
                                    disabled={true}
                                  />
                                </Form.Group>
                              </Col>
                            </Row>
                            <div className="dropdown-divider"></div>
                            <Row style={{ paddingBottom: "100px" }}>
                              <Col lg="9">
                                <Row>
                                  <Col lg="4">
                                    <Form.Group>
                                      <Form.Label>Follow-Up Date</Form.Label>
                                      <DatePicker
                                        defaultValue={moment()}
                                        value={moment(
                                          this.state.creationDateFP && this.state.creationDateFP !== ""
                                            ? new Date(this.state.creationDateFP)
                                            : new Date()
                                        )}
                                        format={dateFormat}
                                        disabled={true}
                                        className="form-control full-width25"
                                      />
                                    </Form.Group>
                                  </Col>
                                  <Col lg="4">
                                    <Form.Group style={{ marginBottom: "0px" }}>
                                      <Form.Label>Height CM</Form.Label>
                                      <div>
                                        <Form.Control
                                          type="number"
                                          placeholder="Height"
                                          name="heightFollowup"
                                          value={this.state.height || ""}
                                          style={{ width: "90%", float: "left" }}
                                          onChange={this.handleFollowupReportChange.bind(this)}
                                        />
                                      </div>
                                      <div className="invalid-feedback">
                                        {this.state.followupErrors["height"]}
                                      </div>
                                    </Form.Group>
                                  </Col>
                                  <Col lg="4">
                                    <Form.Group style={{ marginBottom: "0px" }}>
                                      <Form.Label>Weight KG</Form.Label>
                                      <div>
                                        <Form.Control
                                          type="number"
                                          placeholder="Weight"
                                          name="weightFollowup"
                                          style={{
                                            width: "90%",
                                            float: "left",
                                          }}
                                          value={this.state.weight || ""}
                                          onChange={this.handleFollowupReportChange.bind(
                                            this
                                          )}
                                        />
                                      </div>
                                      {/* <p style={{ display: 'inline-block', marginLeft: '10px', marginTop: '5px' }}>{this.state.weightUnit}</p> */}
                                    </Form.Group>
                                  </Col>
                                  <Col lg="2">
                                    <Form.Group>
                                      <Form.Label>BMI</Form.Label>
                                      <Form.Control
                                        type="text"
                                        readOnly
                                        value={
                                          this.state.height && this.state.weight
                                            ? (
                                                this.state.weight /
                                                Math.pow(
                                                  this.state.height / 100,
                                                  2
                                                )
                                              ).toFixed(2)
                                            : ""
                                        }
                                      />
                                    </Form.Group>
                                  </Col>
                                  <Col lg="2">
                                    <Form.Group>
                                      <Form.Label>BSA (m²)</Form.Label>
                                      <Form.Control
                                        type="text"
                                        readOnly
                                        value={
                                          this.state.height && this.state.weight
                                            ? Math.sqrt(
                                                (this.state.height *
                                                  this.state.weight) /
                                                  3600
                                              ).toFixed(2)
                                            : ""
                                        }
                                      />
                                    </Form.Group>
                                  </Col>

                                  <Col lg={4}>
                                    <Form.Group>
                                      <Form.Label>Pulse</Form.Label>
                                      <div className="d-flex">
                                        <Form.Control
                                          type="number"
                                          name="pulse"
                                          value={this.state.pulse || ""}
                                          onChange={this.handleInputChange}
                                          className="mr-2"
                                          min="0"
                                          max="210"
                                          required
                                        />
                                        <span className="align-self-center">
                                          bpm
                                        </span>
                                      </div>
                                    </Form.Group>
                                  </Col>
                                  <Col lg={4}>
                                    <Form.Group>
                                      <Form.Label>Temperature</Form.Label>
                                      <div className="d-flex">
                                        <Form.Control
                                          type="number"
                                          name="temperature"
                                          value={this.state.temperature || ""}
                                          onChange={this.handleInputChange}
                                          className="mr-2"
                                          min="0"
                                          max="109"
                                          required
                                        />
                                        <span className="align-self-center">
                                          °F
                                        </span>
                                      </div>
                                    </Form.Group>
                                  </Col>

                                  <Col lg={4}>
                                    <Form.Group>
                                      <Form.Label>Blood Pressure</Form.Label>
                                      <div className="d-flex">
                                        <Form.Control
                                          type="number"
                                          name="bpSystolic"
                                          value={this.state.bpSystolic || ""}
                                          onChange={this.handleInputChange}
                                          placeholder="Systolic"
                                          className="mr-2"
                                        />
                                        <span className="align-self-center">
                                          /
                                        </span>
                                        <Form.Control
                                          type="number"
                                          name="bpDiastolic"
                                          value={this.state.bpDiastolic || ""}
                                          onChange={this.handleInputChange}
                                          placeholder="Diastolic"
                                          className="mx-2"
                                        />
                                        <span className="align-self-center">
                                          mmHg
                                        </span>
                                      </div>
                                    </Form.Group>
                                  </Col>
                                  <Col lg={4}>
                                    <Form.Group>
                                      <Form.Label>SpO2</Form.Label>
                                      <div className="d-flex">
                                        <Form.Control
                                          type="number"
                                          name="spO2"
                                          value={this.state.spO2 || ""}
                                          onChange={this.handleInputChange}
                                          className="mr-2"
                                          min="0"
                                          max="100"
                                          required
                                        />
                                        <span className="align-self-center">
                                          %
                                        </span>
                                      </div>
                                    </Form.Group>
                                  </Col>
                                  <Col lg={4}>
                                    <Form.Group>
                                      <Form.Label>Blood Glucose</Form.Label>
                                      <div className="d-flex">
                                        <Form.Control
                                          type="number"
                                          name="bloodGlucose"
                                          value={this.state.bloodGlucose || ""}
                                          onChange={this.handleInputChange}
                                          className="mr-2"
                                          min="0"
                                          max="700"
                                          required
                                        />
                                        <span className="align-self-center">
                                          mg/dL
                                        </span>
                                      </div>
                                    </Form.Group>
                                  </Col>
                                  <Col lg={4}>
                                    <Form.Group>
                                      <Form.Label>Glucose Test Type</Form.Label>
                                      <Form.Control
                                        as="select"
                                        name="glucoseTestType"
                                        value={this.state.glucoseTestType || ""}
                                        onChange={this.handleInputChange}
                                      >
                                        <option value="">Select...</option>
                                        <option value="random">Random</option>
                                        <option value="fasting">Fasting</option>
                                        <option value="postPrandial">
                                          Pre Meal
                                        </option>
                                        <option value="postPrandial">
                                          Post Meal
                                        </option>
                                        <option value="random">
                                          Before Sleep
                                        </option>
                                      </Form.Control>
                                    </Form.Group>
                                  </Col>
                                  <Col lg="4">
                                    <Form.Group>
                                      <Form.Label>Adverse Effects</Form.Label>
                                      <Multiselect
                                        options={
                                          this.state.followupAdverseEffectArr
                                        }
                                        selectedValues={
                                          this.state.followupAdverseEffectIdIAD
                                        }
                                        onSelect={this.setFollowupAdverseEffect.bind(
                                          this
                                        )}
                                        onRemove={this.setFollowupAdverseEffect.bind(
                                          this
                                        )}
                                        displayValue="name"
                                        placeholder="- Select all that apply -"
                                        closeOnSelect="true"
                                        disable={this.state.patAllChemoSittings.length <= 1}
                                      />
                                    </Form.Group>
                                  </Col>
                                  <Col>
                                    <Form.Group>
                                      <Form.Label>
                                        Selected Adverse Effect Description
                                      </Form.Label>
                                      <Form.Control
                                        as="textarea"
                                        value={
                                          this.state.selectedAdverseEffectDesc
                                        }
                                        readOnly
                                        disabled={this.state.patAllChemoSittings.length <= 1}
                                        rows={
                                          this.state.selectedAdverseEffectDesc.split(
                                            "\n"
                                          ).length
                                        }
                                      />
                                    </Form.Group>
                                  </Col>
                                </Row>
                                <Row></Row>
                                <Row>
                                  <Col lg="6">
                                    <Form.Group>
                                      <Form.Label>
                                        Doctor Comments/ Observations
                                        <span className="text-red"> *</span>
                                      </Form.Label>
                                      <Form.Control
                                        as="textarea"
                                        placeholder=""
                                        value={this.state.observe || ""}
                                        name="observe"
                                        onChange={this.handleFollowupReportChange.bind(
                                          this
                                        )}
                                        rows={2}
                                        disabled={isPreviousDate}
                                      />
                                      <div className="invalid-feedback">
                                        {this.state.followupErrors["observe"]}
                                      </div>
                                    </Form.Group>
                                  </Col>
                                  <Col lg="6">
                                    <Form.Group>
                                      <Form.Label>
                                        Prescription
                                        <span className="text-red"> *</span>
                                      </Form.Label>
                                      <Form.Control
                                        as="textarea"
                                        placeholder=""
                                        value={this.state.prescription || ""}
                                        name="prescription"
                                        onChange={this.handleFollowupReportChange.bind(
                                          this
                                        )}
                                        rows={2}
                                        disabled={isPreviousDate}
                                      />
                                      <div className="invalid-feedback">
                                        {
                                          this.state.followupErrors[
                                            "prescription"
                                          ]
                                        }
                                      </div>
                                    </Form.Group>
                                  </Col>
                                </Row>
                              </Col>

                              {/* <Col lg='1'></Col> */}
                              <Col lg="3">
                                <table
                                  id=""
                                  className="table table-striped table-hover text-center generateSchedule"
                                  role="grid"
                                >
                                  <thead className="thead-light">
                                    <tr role="row">
                                      <th
                                        className="sorting_asc"
                                        aria-controls="example"
                                        colSpan="1"
                                        aria-sort="ascending"
                                      >
                                        Reports Submitted
                                      </th>
                                    </tr>
                                  </thead>
                                </table>
                                {this.state.appointmentReports.map(
                                  (data, index) => {
                                    return (
                                      <ul id="square" key={index}>
                                        <li className="squareList">
                                          <div className="mb-0">
                                            <a
                                              className="text-primary font-w500"
                                              onClick={() =>
                                                context.reportHandler(
                                                  Constants.MODE_VIEW_REPORT,
                                                  data
                                                )
                                              }
                                            >
                                              <h5>
                                                {
                                                  data.reportMasterDTO
                                                    .reportName
                                                }
                                              </h5>
                                            </a>
                                            <a
                                              className="text-primary font-w500"
                                              onClick={() =>
                                                this.deleteReport(data)
                                              }
                                            >
                                              <FaRegTrashAlt
                                                className="text-red ml-4"
                                                style={{
                                                  verticalAlign: "text-bottom",
                                                }}
                                              />
                                            </a>
                                          </div>
                                        </li>
                                      </ul>
                                    );
                                  }
                                )}
                              </Col>
                            </Row>
                            <Row>
                              <Col lg="12">
                                <div className="footer form-button text-center mt-2">
                                  <Button
                                    type="button"
                                    className="btn btn-secondary mr-2"
                                    onClick={() => this.submitFollowupReport()}
                                    disabled={isPreviousDate || (!newApptStarted && !isTodayDate)}
                                  >
                                    {this.state.saveLoader && (
                                      <Spinner
                                        className="mr-2"
                                        animation="border"
                                        size="1.5rem"
                                      />
                                    )}
                                    {!this.state.saveLoader && (
                                      <FaSave
                                        className="mr-2"
                                        size="1.5rem"
                                        style={{ verticalAlign: "text-bottom" }}
                                      />
                                    )}
                                    Save
                                  </Button>
                                  <Button
                                    className="btn btn-secondary mr-2"
                                    onClick={() =>
                                      this.reportHandler(
                                        Constants.MODE_NEW_REPORT,
                                        null
                                      )
                                    }
                                    disabled={!newApptStarted && !isTodayDate}
                                  >
                                    <FaPlus
                                      className="mr-2"
                                      size="1.5rem"
                                      style={{ verticalAlign: "sub" }}
                                    />
                                    Report{" "}
                                  </Button>
                                  {(() => {
                                    const noActiveTreatmentPlan =
                                      this.state.patTreatmentPlanSummary.length === 0 ||
                                      this.state.isCurrentTreatmentTerminated === "Y";
                                    const alreadyHasTodayAppt =
                                      this.formatDateDDMMYYYY(
                                        this.state.creationDateFP
                                      ) == this.formatDateDDMMYYYY(new Date());

                                    if (noActiveTreatmentPlan) {
                                      return (
                                        <span
                                          className="new-appt-tooltip-wrapper mr-2"
                                          onClick={() =>
                                            this.setKey("treatmentPlan")
                                          }
                                        >
                                          <span className="new-appt-tooltip-bubble">
                                            Please create a Treatment Plan
                                          </span>
                                          <Button
                                            className="btn btn-secondary"
                                            disabled={true}
                                            style={{ pointerEvents: "none" }}
                                          >
                                            <FaPlus
                                              className="mr-2"
                                              size="1.5rem"
                                              style={{ verticalAlign: "sub" }}
                                            />
                                            New Appt.
                                          </Button>
                                        </span>
                                      );
                                    } else if (alreadyHasTodayAppt) {
                                      return (
                                        <Button
                                          className="btn btn-secondary mr-2"
                                          onClick={this.addNewFollowup.bind(
                                            this
                                          )}
                                          disabled={true}
                                        >
                                          <FaPlus
                                            className="mr-2"
                                            size="1.5rem"
                                            style={{ verticalAlign: "sub" }}
                                          />
                                          New Appt.
                                        </Button>
                                      );
                                    } else {
                                      return (
                                        <Button
                                          className="btn btn-secondary mr-2"
                                          onClick={() =>
                                            this.handleNewApptClick()
                                          }
                                        >
                                          <FaPlus
                                            className="mr-2"
                                            size="1.5rem"
                                            style={{ verticalAlign: "sub" }}
                                          />
                                          New Appt.
                                        </Button>
                                      );
                                    }
                                  })()}
                                  {this.state.followupReports.length >= 1 && (
                                  <Button
                                    className="btn btn-info"
                                    title="View Previous Appointments"
                                    onClick={this.viewFollowupList}
                                  >
                                    {" "}
                                    View Previous Appt.
                                  </Button>
                                  )}
                                </div>
                              </Col>
                            </Row>
                          </Container>
                        </Tab>
                        <Tab
                          eventKey="chemotherapy"
                          title="Chemotherapy Sitting"
                        >
                          {/* <FaQuestionCircle id="chemoHelp" /> */}
                          <Container fluid className="p-0 mt-4">
                            <Row>
                              <Col lg="3" className="form-inline">
                                <Form.Group className="mb-0">
                                  <Form.Label className="mr-3">
                                    Case No.
                                  </Form.Label>
                                  <Form.Control
                                    className="readOnlyView inline"
                                    type="text"
                                    placeholder=""
                                    value={this.state.caseNo}
                                    name="docName"
                                    onChange={this.handleChange}
                                    disabled={true}
                                  />
                                </Form.Group>
                              </Col>
                              <Col lg="3" className="form-inline">
                                <Form.Group className="mb-0">
                                  <Form.Label className="mr-3">
                                    Patient Name
                                  </Form.Label>
                                  <Form.Control
                                    className="readOnlyView inline"
                                    type="text"
                                    placeholder=""
                                    value={
                                      this.state.firstName +
                                      " " +
                                      this.state.lastName
                                    }
                                    name="firstName"
                                    onChange={this.handleChange}
                                    disabled={true}
                                  />
                                </Form.Group>
                              </Col>
                              <Col lg="3" className="form-inline">
                                <Form.Group className="mb-0">
                                  <Form.Label className="mr-3">Age</Form.Label>
                                  <Form.Control
                                    className="readOnlyView inline"
                                    type="text"
                                    value={this.state.patientAge + " Years"}
                                    name="firstName"
                                    onChange={this.handleChange}
                                    disabled={true}
                                  />
                                </Form.Group>
                              </Col>
                              <Col lg="3" className="form-inline">
                                <Form.Group className="mb-0">
                                  <Form.Label className="mr-3">
                                    Gender
                                  </Form.Label>
                                  <Form.Control
                                    className="readOnlyView inline"
                                    type="text"
                                    value={this.state.genderName}
                                    name="docName"
                                    onChange={this.handleChange}
                                    disabled={true}
                                  />
                                </Form.Group>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg="3" className="form-inline">
                                <Form.Group className="mb-0">
                                  <Form.Label className="mr-3">
                                    Cycle Number
                                  </Form.Label>
                                  <Form.Control
                                    className="readOnlyView inline"
                                    type="text"
                                    placeholder=""
                                    value={this.state.chemoCycleNumberPC || "NA"}
                                    name="chemoCycleNumberPC"
                                    onChange={this.handleChange}
                                    disabled={true}
                                  />
                                </Form.Group>
                              </Col>
                              <Col lg="3" className="form-inline">
                                <Form.Group className="mb-0">
                                  <Form.Label className="mr-3">
                                    Treatment Day
                                  </Form.Label>
                                  <Form.Control
                                    className="readOnlyView inline"
                                    type="text"
                                    placeholder=""
                                    value={this.state.treatmentDayNumberPC || "NA"}
                                    name="treatmentDayNumberPC"
                                    onChange={this.handleChange}
                                    disabled={true}
                                  />
                                </Form.Group>
                              </Col>
                            </Row>
                            <div className="dropdown-divider pb-2"></div>
                            <Row>
                              <Col lg="8">
                                <Row>
                                  {(() => {
                                    if (this.state.patChemoSittingIdPC !== 0) {
                                      return (
                                        <Col lg="3">
                                          <Form.Group className="mb-0">
                                            <Form.Label className="mr-3">
                                              Khorana Score
                                            </Form.Label>
                                            <Form.Control
                                              type="text"
                                              placeholder=""
                                              value={this.state.khoronaScore ?? ""}
                                              name="khorana"
                                              onChange={this.handleChange}
                                              disabled
                                            />
                                          </Form.Group>
                                        </Col>
                                      );
                                    }
                                  })()}
                                  {(() => {
                                    if (this.state.patChemoSittingIdPC !== 0) {
                                      return (
                                        <Col lg="3">
                                          <Form.Group className="mb-0">
                                            <Form.Label className="mr-3">
                                              Creatinine Clearance
                                              {this.state.creatinineWarning ? (
                                                <OverlayTrigger
                                                  trigger="click"
                                                  rootClose
                                                  placement="top"
                                                  overlay={
                                                    <Tooltip id="tooltip-creatinine-capped">
                                                      {this.state.creatinineWarning}
                                                    </Tooltip>
                                                  }
                                                >
                                                  <span
                                                    role="button"
                                                    tabIndex={0}
                                                    aria-label="Why is this value capped?"
                                                    style={{
                                                      display: "inline-block",
                                                      marginLeft: "6px",
                                                      cursor: "pointer",
                                                      color: "#8a6d3b",
                                                      verticalAlign: "middle",
                                                      // The value field beside this icon is permanently
                                                      // disabled. This icon sits in the label, so it is
                                                      // unaffected by that — pointerEvents is pinned to
                                                      // auto only to defend against any inherited
                                                      // `pointer-events: none` from a .disabled ancestor.
                                                      pointerEvents: "auto",
                                                    }}
                                                  >
                                                    <FaInfoCircle />
                                                  </span>
                                                </OverlayTrigger>
                                              ) : null}
                                            </Form.Label>
                                            <Form.Control
                                              type="text"
                                              placeholder=""
                                              value={
                                                this.state.creatineClearance ?? ""
                                              }
                                              name="cc"
                                              onChange={this.handleChange}
                                              disabled={true}
                                            />
                                          </Form.Group>
                                        </Col>
                                      );
                                    }
                                  })()}
                                  {(() => {
                                    if (this.state.patChemoSittingIdPC !== 0) {
                                      return (
                                        <Col lg="3">
                                          <Form.Group>
                                            <Form.Label>
                                              Date of Chemotherapy
                                            </Form.Label>
                                            <DatePicker
                                              defaultValue={moment()}
                                              value={
                                                this.state.chemoDtPC && this.state.chemoDtPC !== ""
                                                  ? moment(this.state.chemoDtPC, ['DD/MM/yyyy', 'YYYY-MM-DD', 'MMM DD, YYYY'])
                                                  : moment(new Date())
                                              }
                                              format={dateFormat}
                                              disabledDate={disabledDate}
                                              onChange={
                                                this.handleChemoDtChange
                                              }
                                              className="form-control full-width25"
                                              disabled={isHospitalStaff || isChemoPastDate} // Disable if hospital staff or chemo date is in the past
                                            />
                                          </Form.Group>
                                        </Col>
                                      );
                                    }
                                    return null; // Optionally return null if the condition is not met
                                  })()}
                                </Row>

                                <Row>
                                  {(() => {
                                    if (this.state.patChemoSittingIdPC !== 0) {
                                      // Check if premedications or supplements are unlisted values
                                      const isPremedicationOther =
                                        this.state.premedications &&
                                        !premedicationOptions.some(
                                          (opt) =>
                                            opt.value ===
                                            this.state.premedications
                                        );
                                      const isSupplementOther =
                                        this.state.supplements &&
                                        !supplementOptions.some(
                                          (opt) =>
                                            opt.value === this.state.supplements
                                        );

                                      return (
                                        <>
                                          <Col lg="6">
                                            <Form.Group>
                                              <Form.Label>
                                                Pre-Medication
                                              </Form.Label>
                                              <Form.Control
                                                as="select"
                                                name="premedications"
                                                value={
                                                  isPremedicationOther
                                                    ? "Other"
                                                    : this.state.premedications
                                                }
                                                onChange={
                                                  this.handleMedicationChange
                                                }
                                                disabled={isChemoPastDate}
                                              >
                                                <option value="">Select</option>
                                                {premedicationOptions.map(
                                                  (option) => (
                                                    <option
                                                      key={option.value}
                                                      value={option.value}
                                                    >
                                                      {option.label}
                                                    </option>
                                                  )
                                                )}
                                              </Form.Control>
                                              {(this.state.premedications ===
                                                "Other" ||
                                                isPremedicationOther) && (
                                                <Form.Control
                                                  as="textarea"
                                                  placeholder="Please specify"
                                                  name="premedicationOther"
                                                  value={
                                                    this.state
                                                      .premedicationOther ||
                                                    (isPremedicationOther
                                                      ? this.state
                                                          .premedications
                                                      : "")
                                                  }
                                                  onChange={(e) =>
                                                    this.setState({
                                                      premedications:
                                                        e.target.value,
                                                    })
                                                  }
                                                  rows={3}
                                                  disabled={isChemoPastDate}
                                                />
                                              )}
                                            </Form.Group>
                                          </Col>
                                          <Col lg="6">
                                            <Form.Group>
                                              <Form.Label>
                                                Supplements
                                              </Form.Label>
                                              <Form.Control
                                                as="select"
                                                name="supplements"
                                                value={
                                                  isSupplementOther
                                                    ? "Other"
                                                    : this.state.supplements
                                                }
                                                onChange={
                                                  this.handleSupplementChange
                                                }
                                                disabled={isChemoPastDate}
                                              >
                                                <option value="">Select</option>
                                                {supplementOptions.map(
                                                  (option) => (
                                                    <option
                                                      key={option.value}
                                                      value={option.value}
                                                    >
                                                      {option.label}
                                                    </option>
                                                  )
                                                )}
                                              </Form.Control>
                                              {(this.state.supplements ===
                                                "Other" ||
                                                isSupplementOther) && (
                                                <Form.Control
                                                  as="textarea"
                                                  placeholder="Please specify"
                                                  name="supplementOther"
                                                  value={
                                                    this.state
                                                      .supplementOther ||
                                                    (isSupplementOther
                                                      ? this.state.supplements
                                                      : "")
                                                  }
                                                  onChange={(e) =>
                                                    this.setState({
                                                      supplements:
                                                        e.target.value,
                                                    })
                                                  }
                                                  rows={3}
                                                  disabled={isChemoPastDate}
                                                />
                                              )}
                                            </Form.Group>
                                          </Col>
                                        </>
                                      );
                                    }
                                  })()}
                                </Row>
                                <Row>
                                  {(() => {
                                    if (this.state.patChemoSittingIdPC !== 0) {
                                      return (
                                        <Col lg="12">
                                          <Form.Group>
                                            <Form.Label>
                                              Chemo Dosage Prescription
                                            </Form.Label>
                                            <Form.Control
                                              as="textarea"
                                              placeholder=""
                                              name="treatmentGivenPC"
                                              value={
                                                this.state.treatmentGivenPC
                                              }
                                              rows={3}
                                              onChange={
                                                this.handleChemoSittingChange
                                              }
                                              disabled={isChemoPastDate}
                                            />
                                          </Form.Group>
                                          <div className="invalid-feedback">
                                            {
                                              this.state.patChemoSittingErrors[
                                                "treatmentGivenPC"
                                              ]
                                            }
                                          </div>
                                        </Col>
                                      );
                                    }
                                  })()}

                                  {(() => {
                                    if (isHospitalStaff) {
                                      return (
                                        <Col lg="12">
                                          <Form.Group>
                                            <Form.Label>
                                              Chemo Dosage Prescription
                                            </Form.Label>
                                            <Form.Control
                                              as="textarea"
                                              placeholder=""
                                              disabled={true}
                                              name="treatmentGivenPC"
                                              value={
                                                this.state.treatmentGivenPC
                                              }
                                              rows={3}
                                              onChange={
                                                this.handleChemoSittingChange
                                              }
                                            />
                                          </Form.Group>
                                        </Col>
                                      );
                                    }
                                  })()}
                                  {(() => {
                                    if (this.state.patChemoSittingIdPC !== 0) {
                                      return (
                                        <Col lg="6">
                                          {(() => {
                                            if (
                                              this.state.antiemeticRiskLevel &&
                                              this.state.antiemeticRiskLevel !=
                                                ""
                                            ) {
                                              return (
                                                <Form.Group>
                                                  <OverlayTrigger
                                                    placement="bottom"
                                                    overlay={
                                                      <Tooltip id="tooltip-disabled_1">
                                                        Antiemetic risk level is{" "}
                                                        {
                                                          this.state
                                                            .antiemeticRiskLevel
                                                        }
                                                        .
                                                      </Tooltip>
                                                    }
                                                  >
                                                    <Form.Label>
                                                      Antiemetic Medication (
                                                      {
                                                        this.state
                                                          .antiemeticRiskLevel
                                                      }
                                                      )
                                                    </Form.Label>
                                                  </OverlayTrigger>
                                                  <Button
                                                    onClick={() =>
                                                      this.setState({
                                                        showAntimetic: true,
                                                        selectedOptions: {},
                                                      })
                                                    }
                                                    style={{
                                                      marginBottom: "5px",
                                                      padding: "0px",
                                                      float: "right",
                                                    }}
                                                    disabled={isChemoPastDate}
                                                  >
                                                    Click here{" "}
                                                  </Button>
                                                  <Form.Control
                                                    as="textarea"
                                                    placeholder=""
                                                    name="antiemeticRisks"
                                                    value={
                                                      this.state.antiemeticRisks
                                                    }
                                                    onChange={(e) =>
                                                      this.setState({
                                                        antiemeticRisks:
                                                          e.target.value,
                                                      })
                                                    }
                                                    rows={3}
                                                    disabled={isChemoPastDate}
                                                  />
                                                </Form.Group>
                                              );
                                            } else {
                                              return (
                                                <Form.Group>
                                                  <Form.Label>
                                                    Antiemetic Medication
                                                  </Form.Label>
                                                  <Button
                                                    onClick={() =>
                                                      this.setState({
                                                        showAntimetic: true,
                                                        selectedOptions: {},
                                                      })
                                                    }
                                                    style={{
                                                      marginBottom: "5px",
                                                      padding: "0px",
                                                      float: "right",
                                                    }}
                                                    disabled={isChemoPastDate}
                                                  >
                                                    Click here{" "}
                                                  </Button>
                                                  <Form.Control
                                                    as="textarea"
                                                    placeholder=""
                                                    name="antiemeticRisks"
                                                    value={
                                                      this.state.antiemeticRisks
                                                    }
                                                    onChange={(e) =>
                                                      this.setState({
                                                        antiemeticRisks:
                                                          e.target.value,
                                                      })
                                                    }
                                                    rows={3}
                                                    disabled={isChemoPastDate}
                                                  />
                                                </Form.Group>
                                              );
                                            }
                                          })()}
                                        </Col>
                                      );
                                    }
                                  })()}
                                  {(() => {
                                    if (
                                      this.state.gcsfMedicinePC !== "" &&
                                      this.state.patChemoSittingIdPC !== 0
                                    ) {
                                      return (
                                        <Col lg="6">
                                          <Form.Group>
                                            <Form.Label>
                                              GCSF Medication{" "}
                                            </Form.Label>
                                            <Button
                                              onClick={() =>
                                                this.setState({
                                                  showGCSF: true,
                                                })
                                              }
                                              style={{
                                                marginBottom: "5px",
                                                padding: "0px",
                                                float: "right",
                                              }}
                                              disabled={isChemoPastDate}
                                            >
                                              {" "}
                                              Click here{" "}
                                            </Button>
                                            <Form.Control
                                              as="textarea"
                                              placeholder=""
                                              name="gcsfMedicinePC"
                                              value={this.state.gcsfMedicinePC || ""}
                                              onChange={(e) =>
                                                this.setState({
                                                  gcsfMedicinePC:
                                                    e.target.value,
                                                })
                                              }
                                              rows={3}
                                              disabled={isChemoPastDate}
                                            />
                                          </Form.Group>
                                        </Col>
                                      );
                                    } else if (
                                      this.state.patChemoSittingIdPC !== 0 &&
                                      this.state.fnRiskTmt == "H"
                                    ) {
                                      return (
                                        <Col lg="6">
                                          <Form.Group>
                                            <Form.Label>
                                              GCSF Medication (Recommended As
                                              Risk Is High){" "}
                                            </Form.Label>
                                            <Button
                                              onClick={() =>
                                                this.setState({
                                                  showGCSF: true,
                                                })
                                              }
                                              style={{
                                                marginBottom: "5px",
                                                padding: "0px",
                                                float: "right",
                                              }}
                                              disabled={isChemoPastDate}
                                            >
                                              {" "}
                                              Click here{" "}
                                            </Button>
                                            <Form.Control
                                              as="textarea"
                                              placeholder=""
                                              name="gcsfMedicinePC"
                                              value={this.state.gcsfMedicinePC || ""}
                                              onChange={(e) =>
                                                this.setState({
                                                  gcsfMedicinePC:
                                                    e.target.value,
                                                })
                                              }
                                              rows={3}
                                              disabled={isChemoPastDate}
                                            />
                                          </Form.Group>
                                        </Col>
                                      );
                                    } else if (
                                      this.state.patChemoSittingIdPC !== 0 &&
                                      this.state.fnRiskTmt == "I"
                                    ) {
                                      return (
                                        <Col lg="6">
                                          <Form.Group>
                                            <Form.Label>
                                              GCSF Medication ({" "}
                                              <Button
                                                onClick={() =>
                                                  this.setState({
                                                    showAssessFNRisk: true,
                                                  })
                                                }
                                                style={{ padding: "0px" }}
                                                disabled={isChemoPastDate}
                                              >
                                                Assess FN Risk
                                              </Button>{" "}
                                              ){" "}
                                            </Form.Label>
                                            <Button
                                              onClick={() =>
                                                this.setState({
                                                  showGCSF: true,
                                                })
                                              }
                                              style={{
                                                marginBottom: "5px",
                                                padding: "0px",
                                                float: "right",
                                              }}
                                              disabled={isChemoPastDate}
                                            >
                                              {" "}
                                              Click here{" "}
                                            </Button>
                                            <Form.Control
                                              as="textarea"
                                              placeholder=""
                                              name="gcsfMedicinePC"
                                              value={this.state.gcsfMedicinePC || ""}
                                              onChange={(e) =>
                                                this.setState({
                                                  gcsfMedicinePC:
                                                    e.target.value,
                                                })
                                              }
                                              rows={3}
                                              disabled={isChemoPastDate}
                                            />
                                          </Form.Group>
                                        </Col>
                                      );
                                    } else if (
                                      this.state.patChemoSittingIdPC !== 0
                                    ) {
                                      return (
                                        <Col lg="6">
                                          <Form.Group>
                                            <Form.Label>
                                              GCSF Medication{" "}
                                            </Form.Label>
                                            <Button
                                              onClick={() =>
                                                this.setState({
                                                  showGCSF: true,
                                                })
                                              }
                                              style={{
                                                marginBottom: "5px",
                                                padding: "0px",
                                                float: "right",
                                              }}
                                              disabled={isChemoPastDate}
                                            >
                                              {" "}
                                              Click here{" "}
                                            </Button>
                                            <Form.Control
                                              as="textarea"
                                              placeholder=""
                                              name="gcsfMedicinePC"
                                              value={this.state.gcsfMedicinePC || ""}
                                              onChange={(e) =>
                                                this.setState({
                                                  gcsfMedicinePC:
                                                    e.target.value,
                                                })
                                              }
                                              rows={3}
                                              disabled={isChemoPastDate}
                                            />
                                          </Form.Group>
                                        </Col>
                                      );
                                    }
                                  })()}
                                  {(() => {
                                    if (
                                      this.state.patChemoSittingIdPC !== 0 &&
                                      this.state.boneMetasis == "Y"
                                    ) {
                                      return (
                                        <Col lg="6">
                                          <Form.Group>
                                            <OverlayTrigger
                                              placement="bottom"
                                              overlay={
                                                <Tooltip id="tooltip-disabled">
                                                  Check dental status before
                                                  administration !
                                                </Tooltip>
                                              }
                                            >
                                              <Form.Label>
                                                Bone Modification Medication
                                              </Form.Label>
                                            </OverlayTrigger>
                                            <Button
                                              onClick={() =>
                                                this.setState({
                                                  showBoneModification: true,
                                                })
                                              }
                                              style={{
                                                marginBottom: "5px",
                                                padding: "0px",
                                                float: "right",
                                              }}
                                              disabled={isChemoPastDate}
                                            >
                                              {" "}
                                              Click here{" "}
                                              <FaInfo
                                                className="collaspe-medicIcon"
                                                size="1.2rem"
                                              />
                                            </Button>
                                            <Form.Control
                                              as="textarea"
                                              placeholder=""
                                              name="boneMetasisDrug"
                                              defaultValue={
                                                this.state.boneMetasisDrug
                                              }
                                              rows={3}
                                              disabled={isChemoPastDate}
                                            />
                                          </Form.Group>
                                        </Col>
                                      );
                                    }
                                  })()}
                                  {(() => {
                                    if (
                                      this.state.patChemoSittingIdPC !== 0 &&
                                      this.state.khoronaScore >= 1
                                    ) {
                                      return (
                                        <Col lg="6">
                                          <Form.Group>
                                            <Form.Label>
                                              Antithrombotic Medication{" "}
                                            </Form.Label>
                                            <Button
                                              onClick={() =>
                                                this.setState({
                                                  showAntithrombotic: true,
                                                })
                                              }
                                              style={{
                                                marginBottom: "5px",
                                                padding: "0px",
                                                float: "right",
                                              }}
                                              disabled={isChemoPastDate}
                                            >
                                              {" "}
                                              Click here{" "}
                                              <FaInfo
                                                className="collaspe-medicIcon"
                                                size="1.2rem"
                                              />
                                            </Button>
                                            <Form.Control
                                              as="textarea"
                                              placeholder=""
                                              name="antithromboticDrugs"
                                              value={
                                                this.state.antithromboticDrugs
                                              }
                                              onChange={(e) =>
                                                this.setState({
                                                  antithromboticDrugs:
                                                    e.target.value,
                                                })
                                              }
                                              rows={3}
                                              disabled={isChemoPastDate}
                                            />
                                          </Form.Group>
                                        </Col>
                                      );
                                    }
                                  })()}
                                </Row>
                              </Col>
                              {/* <Col lg='1' style={{ maxWidth: '3%' }}></Col> */}
                              <Col lg="4">
                                {(() => {
                                  if (this.state.patChemoSittingIdPC !== 0) {
                                    return (
                                      <Form.Group className="mt-0">
                                        <div style={{ height: '180px', overflowY: 'auto' }}> 
                                        <table
                                          id=""
                                          className="table table-striped table-hover text-center"
                                          role="grid"
                                        >
                                          <thead className="thead-light">
                                            <tr role="row">
                                              <th
                                                className="sorting_asc"
                                                aria-controls="example"
                                                colSpan="1"
                                                aria-sort="ascending"
                                              >
                                                Suggestive Medicines
                                              </th>
                                            </tr>
                                          </thead>
                                        </table>
                                        {this.state.suggestiveTreatementArr.map(
                                          function (d, idx) {
                                            return (
                                              <DropdownTreeSelect
                                                key={idx}
                                                data={d}
                                                texts={{
                                                  placeholder: "",
                                                  inlineSearchPlaceholder: "",
                                                }}
                                                mode="hierarchical"
                                                keepOpenOnSelect="true"
                                                showDropdown="always"
                                                inlineSearchInput="true"
                                                onChange={this.onTreeDataChange}
                                                onAction={onAction}
                                                onNodeToggle={onNodeToggle}
                                                disabled={isChemoPastDate}
                                              />
                                            );
                                          }.bind(this)
                                        )}
                                        {this.state
                                          .errorMsgAdverseChemoTermination !=
                                          "" &&
                                          this.state
                                            .errorMsgAdverseChemoTermination !=
                                            "undefined" &&
                                          (this.state.patChemoSittingIdPC ===
                                            0 ||
                                            this.state.patChemoSittingIdPC ===
                                              "") && (
                                            <Col lg="12" id="contentMsg">
                                              <Alert
                                                variant="danger"
                                                style={{ padding: "1.5rem" }}
                                              >
                                                <b>
                                                  Chemo Treatment not
                                                  recommended
                                                </b>
                                                <h4 className="mt-1">
                                                  {
                                                    this.state
                                                      .errorMsgAdverseChemoTermination
                                                  }
                                                </h4>
                                              </Alert>
                                            </Col>
                                          )}
                                        {this.state
                                          .isCurrentTreatmentTerminated ==
                                          "N" &&
                                          this.state
                                            .isChemoTreatmentRecommended ==
                                            "N" &&
                                          (this.state.patChemoSittingIdPC ===
                                            0 ||
                                            this.state.patChemoSittingIdPC ===
                                              "") && (
                                            <Col lg="12" id="contentMsg">
                                              <Alert
                                                variant="danger"
                                                style={{ padding: "1.5rem" }}
                                              >
                                                <b>
                                                  Chemo Treatment not
                                                  recommended
                                                </b>
                                                <h4 className="mt-1">
                                                  Report parameter/Pre-condition
                                                  not satisfied :{" "}
                                                  {
                                                    this.state
                                                      .errorMsgChemoTreatRecommend
                                                  }
                                                </h4>
                                              </Alert>
                                            </Col>
                                          )}
                                          </div>
                                      </Form.Group>
                                    );
                                  }
                                })()}
                                {(() => {
                                  if (this.state.patChemoSittingIdPC !== 0) {
                                    return (
                                      <Form.Group className="mt-0">
                                        <div style={{ height: '180px', overflowY: 'auto' }}>
                                        {this.state.selectedMedicines.length >
                                          0 && (
                                          <>
                                            <table
                                              id=""
                                              className="table table-striped table-hover text-center"
                                              role="grid"
                                            >
                                              <thead className="thead-light">
                                                <tr role="row">
                                                  <th
                                                    className="sorting_asc"
                                                    aria-controls="example"
                                                    colSpan="1"
                                                    aria-sort="ascending"
                                                  >
                                                    Medicine Details
                                                  </th>
                                                </tr>
                                              </thead>
                                            </table>
                                            {this.state.medicineDetails.map(
                                              (d1, idx1) => (
                                                <DropdownTreeSelect
                                                  key={idx1}
                                                  data={d1}
                                                  texts={{
                                                    placeholder: "",
                                                    inlineSearchPlaceholder: "",
                                                  }}
                                                  mode="hierarchical"
                                                  keepOpenOnSelect="true"
                                                  showDropdown="always"
                                                  inlineSearchInput="true"
                                                  onChange={(
                                                    currentNode,
                                                    selectedNodes
                                                  ) => {
                                                    const isSelected =
                                                      selectedNodes.some(
                                                        (node) =>
                                                          node.value ===
                                                          currentNode.value
                                                      );
                                                    this.handleMedicineDetailSelect(
                                                      currentNode,
                                                      selectedNodes
                                                    );
                                                    this.handleMedicineSelect(
                                                      currentNode.value,
                                                      isSelected
                                                    );
                                                  }}
                                                  disabled={isChemoPastDate}
                                                />
                                              )
                                            )}
                                          </>
                                        )}
                                        </div>
                                      </Form.Group>
                                    );
                                  }
                                })()}
                              </Col>
                            </Row>
                          </Container>
                          <br />
                          <br />
                          {(() => {
                                   if (this.state.patChemoSittingIdPC !== 0) {
                                     return(
                           <Container fluid className="p-0 mt-4">
                            <Row>
                              <Col lg="12">
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                  <strong className="mb-3">
                                    Post chemo Medications
                                  </strong>
                                  <div>
                                  </div>
                                </div>
                                <div className="table-responsive">
                                  <table className="table table-bordered border">
                                    <thead>
                                      <tr>
                                        <th>#</th>
                                        <th>
                                          MEDICINE
                                          <span className="text-danger">*</span>
                                        </th>
                                        <th>
                                          DOSE
                                          <span className="text-danger">*</span>
                                        </th>
                                        <th>
                                          WHEN
                                          <span className="text-danger">*</span>
                                        </th>
                                        <th>
                                          DURATION
                                          <span className="text-danger">*</span>
                                        </th>
                                        <th>
                                          INSTRUCTIONS
                                          <span className="text-danger">*</span>
                                        </th>
                                        <th></th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {this.state.medicationDetails.map(
                                        (med, index) => (
                                          <tr
                                            key={`med-${index}`}
                                            className={
                                              this.isPrescriptionRowFilled(
                                                index
                                              )
                                                ? "row-with-content"
                                                : ""
                                            }
                                          >
                                            <td>{index + 1}</td>
                                            <td>
                                              <Select
                                                className={`w-100 ${
                                                  this.state.medicationErrors[
                                                    index
                                                  ]?.medicine
                                                    ? "is-invalid"
                                                    : ""
                                                }`}
                                                placeholder="Select Medicine"
                                                value={
                                                  med.medicine
                                                    ? med.medicine.name
                                                    : undefined
                                                }
                                                onChange={(value) => {
                                                  this.handlePrescriptionChange(
                                                    index,
                                                    "medicine",
                                                    value
                                                  );
                                                  this.setState({
                                                    openMedicineDropdownIndex:
                                                      -1,
                                                  });
                                                }}
                                                loading={
                                                  this.state.loadingMedicines
                                                }
                                                showSearch
                                                open={
                                                  this.state
                                                    .openMedicineDropdownIndex ===
                                                  index
                                                }
                                                onDropdownVisibleChange={(
                                                  open
                                                ) => {
                                                  this.setState({
                                                    openMedicineDropdownIndex:
                                                      open ? index : -1,
                                                  });
                                                  if (open)
                                                    this.getAllMedicines();
                                                }}
                                                filterOption={(
                                                  input,
                                                  option
                                                ) => {
                                                  if (!input) return true;
                                                  return option.children
                                                    .toLowerCase()
                                                    .includes(
                                                      input.toLowerCase()
                                                    );
                                                }}
                                                onSearch={(value) => {
                                                  this.setState((prev) => ({
                                                    newItemInput: {
                                                      ...prev.newItemInput,
                                                      medicine: value,
                                                    },
                                                  }));
                                                }}
                                                notFoundContent={
                                                  this.state.newItemInput
                                                    ?.medicine ? (
                                                    <div
                                                      style={{
                                                        padding: "5px",
                                                        cursor: "pointer",
                                                        background: "#f0f0f0",
                                                        borderRadius: "4px",
                                                      }}
                                                      onClick={(e) => {
                                                        e.preventDefault();
                                                        e.stopPropagation();

                                                        if (
                                                          this.state.newItemInput.medicine.trim()
                                                        ) {
                                                          this.saveMedicine(
                                                            this.state.newItemInput.medicine.trim()
                                                          ).then((result) => {
                                                            if (result) {
                                                              this.handlePrescriptionChange(
                                                                index,
                                                                "medicine",
                                                                result.name
                                                              );
                                                              this.setState(
                                                                (prev) => ({
                                                                  newItemInput:
                                                                    {
                                                                      ...prev.newItemInput,
                                                                      medicine:
                                                                        "",
                                                                    },
                                                                })
                                                              );
                                                            }
                                                          });
                                                        }
                                                      }}
                                                    >
                                                      Create "
                                                      {
                                                        this.state.newItemInput
                                                          .medicine
                                                      }
                                                      "
                                                    </div>
                                                  ) : (
                                                    <div
                                                      style={{ padding: "5px" }}
                                                    >
                                                      No data found
                                                    </div>
                                                  )
                                                }
                                                disabled={isChemoPastDate}
                                              >
                                                {this.state.medicinesArr.map(
                                                  (medicine) => (
                                                    <Option
                                                      key={medicine.id}
                                                      value={medicine.name}
                                                      data-medicineid={
                                                        medicine.medicineId
                                                      }
                                                    >
                                                      {medicine.name}
                                                    </Option>
                                                  )
                                                )}
                                              </Select>
                                              {this.state.medicationErrors[
                                                index
                                              ]?.medicine && (
                                                <div className="invalid-feedback d-block">
                                                  {
                                                    this.state.medicationErrors[
                                                      index
                                                    ].medicine
                                                  }
                                                </div>
                                              )}
                                            </td>
                                            <td>
                                              <Select
                                                className={`w-100 ${
                                                  this.state.medicationErrors[
                                                    index
                                                  ]?.dose
                                                    ? "is-invalid"
                                                    : ""
                                                }`}
                                                placeholder="Select Dose"
                                                value={med.dose || ""}
                                                onChange={(value) => {
                                                  this.handlePrescriptionChange(
                                                    index,
                                                    "dose",
                                                    value
                                                  );
                                                  this.setState({
                                                    openDoseDropdownIndex: -1,
                                                  });
                                                }}
                                                loading={
                                                  this.state.loadingDoses
                                                }
                                                showSearch
                                                open={
                                                  this.state
                                                    .openDoseDropdownIndex ===
                                                  index
                                                }
                                                onDropdownVisibleChange={(
                                                  open
                                                ) => {
                                                  this.setState({
                                                    openDoseDropdownIndex: open
                                                      ? index
                                                      : -1,
                                                  });
                                                  if (open) this.getAllDoses();
                                                }}
                                                filterOption={(
                                                  input,
                                                  option
                                                ) => {
                                                  if (!input) return true;
                                                  return option.children
                                                    .toLowerCase()
                                                    .includes(
                                                      input.toLowerCase()
                                                    );
                                                }}
                                                onSearch={(value) => {
                                                  this.setState((prev) => ({
                                                    newItemInput: {
                                                      ...prev.newItemInput,
                                                      dose: value,
                                                    },
                                                  }));
                                                }}
                                                notFoundContent={
                                                  this.state.newItemInput
                                                    ?.dose ? (
                                                    <div
                                                      style={{
                                                        padding: "5px",
                                                        cursor: "pointer",
                                                        background: "#f0f0f0",
                                                        borderRadius: "4px",
                                                      }}
                                                      onClick={() => {
                                                        if (
                                                          this.state.newItemInput.dose.trim()
                                                        ) {
                                                          this.setState({
                                                            loadingDoses: true,
                                                          });
                                                          this.setState({
                                                            openDoseDropdownIndex:
                                                              -1,
                                                          });

                                                          const doseName =
                                                            this.state.newItemInput.dose.trim();

                                                          this.saveDose(
                                                            doseName
                                                          )
                                                            .then((result) => {
                                                              if (result) {
                                                                this.handlePrescriptionChange(
                                                                  index,
                                                                  "dose",
                                                                  result.name
                                                                );
                                                                this.setState(
                                                                  (prev) => ({
                                                                    newItemInput:
                                                                      {
                                                                        ...prev.newItemInput,
                                                                        dose: "",
                                                                      },
                                                                  })
                                                                );

                                                                swal({
                                                                  title:
                                                                    "Success!",
                                                                  text: `Dose "${doseName}" added successfully`,
                                                                  icon: "success",
                                                                  buttons: false,
                                                                  timer: 2000,
                                                                });
                                                              }
                                                            })
                                                            .finally(() => {
                                                              this.setState({
                                                                loadingDoses: false,
                                                              });
                                                            });
                                                        }
                                                      }}
                                                    >
                                                      Create "
                                                      {
                                                        this.state.newItemInput
                                                          .dose
                                                      }
                                                      "
                                                    </div>
                                                  ) : (
                                                    <div
                                                      style={{ padding: "5px" }}
                                                    >
                                                      No data found
                                                    </div>
                                                  )
                                                }
                                                disabled={isChemoPastDate}
                                              >
                                                {this.state.dosesArr.map(
                                                  (dose) => (
                                                    <Option
                                                      key={dose.id}
                                                      value={dose.name}
                                                    >
                                                      {dose.name}
                                                    </Option>
                                                  )
                                                )}
                                              </Select>
                                              {this.state.medicationErrors[
                                                index
                                              ]?.dose && (
                                                <div className="invalid-feedback d-block">
                                                  {
                                                    this.state.medicationErrors[
                                                      index
                                                    ].dose
                                                  }
                                                </div>
                                              )}
                                            </td>
                                            <td>
                                              <Select
                                                className={`w-100 ${
                                                  this.state.medicationErrors[
                                                    index
                                                  ]?.when
                                                    ? "is-invalid"
                                                    : ""
                                                }`}
                                                placeholder="Select When"
                                                value={med.when || ""}
                                                onChange={(value) => {
                                                  this.handlePrescriptionChange(
                                                    index,
                                                    "when",
                                                    value
                                                  );
                                                  this.setState({
                                                    openWhenDropdownIndex: -1,
                                                  });
                                                }}
                                                loading={
                                                  this.state.loadingWhens
                                                }
                                                showSearch
                                                open={
                                                  this.state
                                                    .openWhenDropdownIndex ===
                                                  index
                                                }
                                                onDropdownVisibleChange={(
                                                  open
                                                ) => {
                                                  this.setState({
                                                    openWhenDropdownIndex: open
                                                      ? index
                                                      : -1,
                                                  });
                                                  if (open) this.getAllWhens();
                                                }}
                                                filterOption={(
                                                  input,
                                                  option
                                                ) => {
                                                  if (!input) return true;
                                                  return option.children
                                                    .toLowerCase()
                                                    .includes(
                                                      input.toLowerCase()
                                                    );
                                                }}
                                                onSearch={(value) => {
                                                  this.setState((prev) => ({
                                                    newItemInput: {
                                                      ...prev.newItemInput,
                                                      when: value,
                                                    },
                                                  }));
                                                }}
                                                notFoundContent={
                                                  this.state.newItemInput
                                                    ?.when ? (
                                                    <div
                                                      style={{
                                                        padding: "5px",
                                                        cursor: "pointer",
                                                        background: "#f0f0f0",
                                                        borderRadius: "4px",
                                                      }}
                                                      onClick={() => {
                                                        if (
                                                          this.state.newItemInput.when.trim()
                                                        ) {
                                                          this.setState({
                                                            loadingWhens: true,
                                                          });
                                                          this.setState({
                                                            openWhenDropdownIndex:
                                                              -1,
                                                          });

                                                          const whenName =
                                                            this.state.newItemInput.when.trim();

                                                          this.saveWhen(
                                                            whenName
                                                          )
                                                            .then((result) => {
                                                              if (result) {
                                                                this.handlePrescriptionChange(
                                                                  index,
                                                                  "when",
                                                                  result.name
                                                                );
                                                                this.setState(
                                                                  (prev) => ({
                                                                    newItemInput:
                                                                      {
                                                                        ...prev.newItemInput,
                                                                        when: "",
                                                                      },
                                                                  })
                                                                );

                                                                swal({
                                                                  title:
                                                                    "Success!",
                                                                  text: `When "${whenName}" added successfully`,
                                                                  icon: "success",
                                                                  buttons: false,
                                                                  timer: 2000,
                                                                });
                                                              }
                                                            })
                                                            .finally(() => {
                                                              this.setState({
                                                                loadingWhens: false,
                                                              });
                                                            });
                                                        }
                                                      }}
                                                    >
                                                      Create "
                                                      {
                                                        this.state.newItemInput
                                                          .when
                                                      }
                                                      "
                                                    </div>
                                                  ) : (
                                                    <div
                                                      style={{ padding: "5px" }}
                                                    >
                                                      No data found
                                                    </div>
                                                  )
                                                }
                                                disabled={isChemoPastDate}
                                              >
                                                {this.state.whensArr.map(
                                                  (when) => (
                                                    <Option
                                                      key={when.id}
                                                      value={when.name}
                                                    >
                                                      {when.name}
                                                    </Option>
                                                  )
                                                )}
                                              </Select>
                                              {this.state.medicationErrors[
                                                index
                                              ]?.when && (
                                                <div className="invalid-feedback d-block">
                                                  {
                                                    this.state.medicationErrors[
                                                      index
                                                    ].when
                                                  }
                                                </div>
                                              )}
                                            </td>
                                            <td>
                                              <div className="d-flex">
                                                <input
                                                  type="text"
                                                  className="form-control"
                                                  value={
                                                    med.durationValue || ""
                                                  }
                                                  onChange={(e) => {
                                                    const value =
                                                      e.target.value.replace(
                                                        /[^0-9]/g,
                                                        ""
                                                      );
                                                    this.handlePrescriptionChange(
                                                      index,
                                                      "durationValue",
                                                      value
                                                    );
                                                  }}
                                                  placeholder="e.g., 20"
                                                  style={{
                                                    flexGrow: 1,
                                                    borderTopRightRadius: 0,
                                                    borderBottomRightRadius: 0,
                                                  }}
                                                  disabled={isChemoPastDate}
                                                />

                                                <select
                                                  className="form-control"
                                                  value={
                                                    med.durationUnit || "Days"
                                                  }
                                                  onChange={(e) => {
                                                    this.handlePrescriptionDurationUnitSelect(
                                                      index,
                                                      e.target.value
                                                    );
                                                  }}
                                                  style={{
                                                    width: "auto",
                                                    borderTopLeftRadius: 0,
                                                    borderBottomLeftRadius: 0,
                                                  }}
                                                  disabled={isChemoPastDate}
                                                >
                                                  <option value="Days">
                                                    Days
                                                  </option>
                                                  <option value="Weeks">
                                                    Weeks
                                                  </option>
                                                  <option value="Months">
                                                    Months
                                                  </option>
                                                  <option value="Years">
                                                    Years
                                                  </option>
                                                </select>
                                              </div>
                                              {this.state.medicationErrors[
                                                index
                                              ]?.durationValue && (
                                                <div className="invalid-feedback d-block">
                                                  {
                                                    this.state.medicationErrors[
                                                      index
                                                    ].durationValue
                                                  }
                                                </div>
                                              )}
                                            </td>
                                            <td>
                                              <Form.Control
                                                type="text"
                                                value={med.instructions || ""}
                                                onChange={(e) =>
                                                  this.handlePrescriptionChange(
                                                    index,
                                                    "instructions",
                                                    e.target.value
                                                  )
                                                }
                                                placeholder="Add instructions"
                                                className={
                                                  this.state.medicationErrors[
                                                    index
                                                  ]?.instructions
                                                    ? "is-invalid"
                                                    : ""
                                                }
                                                disabled={isChemoPastDate}
                                              />
                                              {this.state.medicationErrors[
                                                index
                                              ]?.instructions && (
                                                <div className="invalid-feedback d-block">
                                                  {
                                                    this.state.medicationErrors[
                                                      index
                                                    ].instructions
                                                  }
                                                </div>
                                              )}
                                            </td>
                                            <td>
                                              {!isChemoPastDate && (
                                              <span
                                                className="delete-icon1"
                                                onClick={() => {
                                                  if (
                                                    med.medicine
                                                      ?.medicineListXrefId
                                                  ) {
                                                    this.deletePatientMedicine(
                                                      med.medicine
                                                        .medicineListXrefId
                                                    ).then((success) => {
                                                      if (success) {
                                                        this.removePrescriptionRow(
                                                          index
                                                        );
                                                      }
                                                    });
                                                  } else {
                                                    this.removePrescriptionRow(
                                                      index
                                                    );
                                                  }
                                                }}
                                                style={{
                                                  cursor: "pointer",
                                                  color: "#dc3545",
                                                  fontSize: "18px",
                                                  padding: "4px 8px",
                                                }}
                                              >
                                                ✕
                                              </span>
                                              )}
                                            </td>
                                          </tr>
                                        )
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg="12" className="mt-2">
                                <Button
                                  variant="secondary"
                                  className="mr-2"
                                  onClick={this.handleSaveMedicinesClick}
                                  disabled={this.state.saveLoader || isChemoPastDate}
                                >
                                  {this.state.saveLoader ? (
                                    <>
                                      <span
                                        className="spinner-border spinner-border-sm mr-2"
                                        role="status"
                                        aria-hidden="true"
                                      ></span>
                                      <span>Saving...</span>
                                    </>
                                  ) : (
                                    "Save Medicines"
                                  )}
                                </Button>
                                <Button
                                  variant="outline-secondary"
                                  onClick={this.handleAddPrescriptionRow}
                                  disabled={isChemoPastDate}
                                >
                                  Add Medicine
                                </Button>
                              </Col>
                            </Row>
                          </Container> 
                          );
                        }
                      })()}
                       {(() => {
                                if (this.state.patChemoSittingIdPC !== 0) {
                                  return(
                          <Container fluid className="p-0 mt-4">
                            <Row>
                              <Col lg="12">
                                <div className="d-flex justify-content-between align-items-center mb-3">
                                  <strong className="mb-3">
                                    Post Discharge Medication
                                  </strong>
                                  <div>
                                  </div>
                                </div>
                                <div className="table-responsive">
                                  <table className="table table-bordered border">
                                    <thead>
                                      <tr>
                                        <th>#</th>
                                        <th>
                                          MEDICINE
                                          <span className="text-danger">*</span>
                                        </th>
                                        <th>
                                          DOSE
                                          <span className="text-danger">*</span>
                                        </th>
                                        <th>
                                          WHEN
                                          <span className="text-danger">*</span>
                                        </th>
                                        <th>
                                          DURATION
                                          <span className="text-danger">*</span>
                                        </th>
                                        <th>
                                          INSTRUCTIONS
                                          <span className="text-danger">*</span>
                                        </th>
                                        <th></th>
                                      </tr>
                                    </thead>
                                    <tbody>
                                      {this.state.postDischargeMedDetails.map(
                                        (med, index) => (
                                          <tr
                                            key={`postmed-${index}`}
                                            className={
                                              this.isPostDischargeRowFilled(
                                                index
                                              )
                                                ? "row-with-content"
                                                : ""
                                            }
                                          >
                                            <td>{index + 1}</td>
                                            <td>
                                              <Select
                                                className={`w-100 ${
                                                  this.state
                                                    .postDischargeMedErrors[
                                                    index
                                                  ]?.medicine
                                                    ? "is-invalid"
                                                    : ""
                                                }`}
                                                placeholder="Select Medicine"
                                                value={
                                                  med.medicine
                                                    ? med.medicine.name
                                                    : undefined
                                                }
                                                onChange={(value) => {
                                                  this.handlePostDischargeChange(
                                                    index,
                                                    "medicine",
                                                    value
                                                  );
                                                  this.setState({
                                                    openPostMedDropdownIndex:
                                                      -1,
                                                  });
                                                }}
                                                loading={
                                                  this.state.loadingMedicines
                                                }
                                                showSearch
                                                open={
                                                  this.state
                                                    .openPostMedDropdownIndex ===
                                                  index
                                                }
                                                onDropdownVisibleChange={(
                                                  open
                                                ) => {
                                                  this.setState({
                                                    openPostMedDropdownIndex:
                                                      open ? index : -1,
                                                  });
                                                  if (open)
                                                    this.getAllPostDischargeMedicines();
                                                }}
                                                filterOption={(
                                                  input,
                                                  option
                                                ) => {
                                                  if (!input) return true;
                                                  return option.children
                                                    .toLowerCase()
                                                    .includes(
                                                      input.toLowerCase()
                                                    );
                                                }}
                                                onSearch={(value) => {
                                                  this.setState((prev) => ({
                                                    newPostMedInput: {
                                                      ...prev.newPostMedInput,
                                                      medicine: value,
                                                    },
                                                  }));
                                                }}
                                                notFoundContent={
                                                  this.state.newPostMedInput
                                                    ?.medicine ? (
                                                    <div
                                                      style={{
                                                        padding: "5px",
                                                        cursor: "pointer",
                                                        background: "#f0f0f0",
                                                        borderRadius: "4px",
                                                      }}
                                                      onClick={(e) => {
                                                        e.preventDefault();
                                                        e.stopPropagation();

                                                        if (
                                                          this.state.newPostMedInput.medicine.trim()
                                                        ) {
                                                          this.savePostDischargeMedicine(
                                                            this.state.newPostMedInput.medicine.trim()
                                                          ).then((result) => {
                                                            if (result) {
                                                              this.handlePostDischargeChange(
                                                                index,
                                                                "medicine",
                                                                result.name
                                                              );
                                                              this.setState(
                                                                (prev) => ({
                                                                  newPostMedInput:
                                                                    {
                                                                      ...prev.newPostMedInput,
                                                                      medicine:
                                                                        "",
                                                                    },
                                                                })
                                                              );
                                                            }
                                                          });
                                                        }
                                                      }}
                                                    >
                                                      Create "
                                                      {
                                                        this.state
                                                          .newPostMedInput
                                                          .medicine
                                                      }
                                                      "
                                                    </div>
                                                  ) : (
                                                    <div
                                                      style={{ padding: "5px" }}
                                                    >
                                                      No data found
                                                    </div>
                                                  )
                                                }
                                                disabled={isChemoPastDate}
                                              >
                                                {this.state.postDischargeMedArr
                                                  ? this.state.postDischargeMedArr.map(
                                                      (medicine) => (
                                                        <Option
                                                          key={medicine.id}
                                                          value={medicine.name}
                                                          data-medicineid={
                                                            medicine.medicineId
                                                          }
                                                        >
                                                          {medicine.name}
                                                        </Option>
                                                      )
                                                    )
                                                  : []}
                                              </Select>
                                              {this.state
                                                .postDischargeMedErrors[index]
                                                ?.medicine && (
                                                <div className="invalid-feedback d-block">
                                                  {
                                                    this.state
                                                      .postDischargeMedErrors[
                                                      index
                                                    ].medicine
                                                  }
                                                </div>
                                              )}
                                            </td>
                                            <td>
                                              <Select
                                                className={`w-100 ${
                                                  this.state
                                                    .postDischargeMedErrors[
                                                    index
                                                  ]?.dose
                                                    ? "is-invalid"
                                                    : ""
                                                }`}
                                                placeholder="Select Dose"
                                                value={med.dose || ""}
                                                onChange={(value) => {
                                                  this.handlePostDischargeChange(
                                                    index,
                                                    "dose",
                                                    value
                                                  );
                                                  this.setState({
                                                    openDoseDropdownIndex: -1,
                                                  });
                                                }}
                                                loading={
                                                  this.state.loadingDoses
                                                }
                                                showSearch
                                                open={
                                                  this.state
                                                    .openPostDischargeDoseIndex ===
                                                  index
                                                }
                                                onDropdownVisibleChange={(
                                                  open
                                                ) => {
                                                  this.setState({
                                                    openPostDischargeDoseIndex:
                                                      open ? index : -1,
                                                  });
                                                  if (open) this.getAllDoses();
                                                }}
                                                filterOption={(
                                                  input,
                                                  option
                                                ) => {
                                                  if (!input) return true;
                                                  return option.children
                                                    .toLowerCase()
                                                    .includes(
                                                      input.toLowerCase()
                                                    );
                                                }}
                                                onSearch={(value) => {
                                                  this.setState((prev) => ({
                                                    newPostMedInput: {
                                                      ...prev.newPostMedInput,
                                                      dose: value,
                                                    },
                                                  }));
                                                }}
                                                notFoundContent={
                                                  this.state.newPostMedInput
                                                    ?.dose ? (
                                                    <div
                                                      style={{
                                                        padding: "5px",
                                                        cursor: "pointer",
                                                        background: "#f0f0f0",
                                                        borderRadius: "4px",
                                                      }}
                                                      onClick={() => {
                                                        if (
                                                          this.state.newPostMedInput.dose.trim()
                                                        ) {
                                                          this.setState({
                                                            loadingDoses: true,
                                                          });
                                                          this.setState({
                                                            openDoseDropdownIndex:
                                                              -1,
                                                          });

                                                          const doseName =
                                                            this.state.newPostMedInput.dose.trim();

                                                          this.saveDose(
                                                            doseName
                                                          )
                                                            .then((result) => {
                                                              if (result) {
                                                                this.handlePostDischargeChange(
                                                                  index,
                                                                  "dose",
                                                                  result.name
                                                                );
                                                                this.setState(
                                                                  (prev) => ({
                                                                    newPostMedInput:
                                                                      {
                                                                        ...prev.newPostMedInput,
                                                                        dose: "",
                                                                      },
                                                                  })
                                                                );

                                                                swal({
                                                                  title:
                                                                    "Success!",
                                                                  text: `Dose "${doseName}" added successfully`,
                                                                  icon: "success",
                                                                  buttons: false,
                                                                  timer: 2000,
                                                                });
                                                              }
                                                            })
                                                            .finally(() => {
                                                              this.setState({
                                                                loadingDoses: false,
                                                              });
                                                            });
                                                        }
                                                      }}
                                                    >
                                                      Create "
                                                      {
                                                        this.state
                                                          .newPostMedInput.dose
                                                      }
                                                      "
                                                    </div>
                                                  ) : (
                                                    <div
                                                      style={{ padding: "5px" }}
                                                    >
                                                      No data found
                                                    </div>
                                                  )
                                                }
                                                disabled={isChemoPastDate}
                                              >
                                                {this.state.dosesArr.map(
                                                  (dose) => (
                                                    <Option
                                                      key={dose.id}
                                                      value={dose.name}
                                                    >
                                                      {dose.name}
                                                    </Option>
                                                  )
                                                )}
                                              </Select>
                                              {this.state
                                                .postDischargeMedErrors[index]
                                                ?.dose && (
                                                <div className="invalid-feedback d-block">
                                                  {
                                                    this.state
                                                      .postDischargeMedErrors[
                                                      index
                                                    ].dose
                                                  }
                                                </div>
                                              )}
                                            </td>
                                            <td>
                                              <Select
                                                className={`w-100 ${
                                                  this.state
                                                    .postDischargeMedErrors[
                                                    index
                                                  ]?.when
                                                    ? "is-invalid"
                                                    : ""
                                                }`}
                                                placeholder="Select When"
                                                value={med.when || ""}
                                                onChange={(value) => {
                                                  this.handlePostDischargeChange(
                                                    index,
                                                    "when",
                                                    value
                                                  );
                                                  this.setState({
                                                    openWhenDropdownIndex: -1,
                                                  });
                                                }}
                                                loading={
                                                  this.state.loadingWhens
                                                }
                                                showSearch
                                                open={
                                                  this.state
                                                    .openPostDischargeWhenIndex ===
                                                  index
                                                }
                                                onDropdownVisibleChange={(
                                                  open
                                                ) => {
                                                  this.setState({
                                                    openPostDischargeWhenIndex:
                                                      open ? index : -1,
                                                  });
                                                  if (open) this.getAllWhens();
                                                }}
                                                filterOption={(
                                                  input,
                                                  option
                                                ) => {
                                                  if (!input) return true;
                                                  return option.children
                                                    .toLowerCase()
                                                    .includes(
                                                      input.toLowerCase()
                                                    );
                                                }}
                                                onSearch={(value) => {
                                                  this.setState((prev) => ({
                                                    newPostMedInput: {
                                                      ...prev.newPostMedInput,
                                                      when: value,
                                                    },
                                                  }));
                                                }}
                                                notFoundContent={
                                                  this.state.newPostMedInput
                                                    ?.when ? (
                                                    <div
                                                      style={{
                                                        padding: "5px",
                                                        cursor: "pointer",
                                                        background: "#f0f0f0",
                                                        borderRadius: "4px",
                                                      }}
                                                      onClick={() => {
                                                        if (
                                                          this.state.newPostMedInput.when.trim()
                                                        ) {
                                                          this.setState({
                                                            loadingWhens: true,
                                                          });
                                                          this.setState({
                                                            openWhenDropdownIndex:
                                                              -1,
                                                          });

                                                          const whenName =
                                                            this.state.newPostMedInput.when.trim();

                                                          this.saveWhen(
                                                            whenName
                                                          )
                                                            .then((result) => {
                                                              if (result) {
                                                                this.handlePostDischargeChange(
                                                                  index,
                                                                  "when",
                                                                  result.name
                                                                );
                                                                this.setState(
                                                                  (prev) => ({
                                                                    newPostMedInput:
                                                                      {
                                                                        ...prev.newPostMedInput,
                                                                        when: "",
                                                                      },
                                                                  })
                                                                );

                                                                swal({
                                                                  title:
                                                                    "Success!",
                                                                  text: `When "${whenName}" added successfully`,
                                                                  icon: "success",
                                                                  buttons: false,
                                                                  timer: 2000,
                                                                });
                                                              }
                                                            })
                                                            .finally(() => {
                                                              this.setState({
                                                                loadingWhens: false,
                                                              });
                                                            });
                                                        }
                                                      }}
                                                    >
                                                      Create "
                                                      {
                                                        this.state
                                                          .newPostMedInput.when
                                                      }
                                                      "
                                                    </div>
                                                  ) : (
                                                    <div
                                                      style={{ padding: "5px" }}
                                                    >
                                                      No data found
                                                    </div>
                                                  )
                                                }
                                                disabled={isChemoPastDate}
                                              >
                                                {this.state.whensArr.map(
                                                  (when) => (
                                                    <Option
                                                      key={when.id}
                                                      value={when.name}
                                                    >
                                                      {when.name}
                                                    </Option>
                                                  )
                                                )}
                                              </Select>
                                              {this.state
                                                .postDischargeMedErrors[index]
                                                ?.when && (
                                                <div className="invalid-feedback d-block">
                                                  {
                                                    this.state
                                                      .postDischargeMedErrors[
                                                      index
                                                    ].when
                                                  }
                                                </div>
                                              )}
                                            </td>
                                            <td>
                                              <div className="d-flex">
                                                <input
                                                  type="text"
                                                  className={`form-control ${
                                                    this.state
                                                      .postDischargeMedErrors[
                                                      index
                                                    ]?.durationValue
                                                      ? "is-invalid"
                                                      : ""
                                                  }`}
                                                  value={
                                                    med.durationValue || ""
                                                  }
                                                  onChange={(e) => {
                                                    const value =
                                                      e.target.value.replace(
                                                        /[^0-9]/g,
                                                        ""
                                                      );
                                                    this.handlePostDischargeChange(
                                                      index,
                                                      "durationValue",
                                                      value
                                                    );
                                                  }}
                                                  placeholder="e.g., 20"
                                                  style={{
                                                    flexGrow: 1,
                                                    borderTopRightRadius: 0,
                                                    borderBottomRightRadius: 0,
                                                  }}
                                                  disabled={isChemoPastDate}
                                                />

                                                <select
                                                  className="form-control"
                                                  value={
                                                    med.durationUnit || "Days"
                                                  }
                                                  onChange={(e) => {
                                                    this.handlePostDischargeDurationUnitSelect(
                                                      index,
                                                      e.target.value
                                                    );
                                                  }}
                                                  style={{
                                                    width: "auto",
                                                    borderTopLeftRadius: 0,
                                                    borderBottomLeftRadius: 0,
                                                  }}
                                                  disabled={isChemoPastDate}
                                                >
                                                  <option value="Days">
                                                    Days
                                                  </option>
                                                  <option value="Weeks">
                                                    Weeks
                                                  </option>
                                                  <option value="Months">
                                                    Months
                                                  </option>
                                                  <option value="Years">
                                                    Years
                                                  </option>
                                                </select>
                                              </div>
                                              {this.state
                                                .postDischargeMedErrors[index]
                                                ?.durationValue && (
                                                <div className="invalid-feedback d-block">
                                                  {
                                                    this.state
                                                      .postDischargeMedErrors[
                                                      index
                                                    ].durationValue
                                                  }
                                                </div>
                                              )}
                                            </td>
                                            <td>
                                              <Form.Control
                                                type="text"
                                                value={med.instructions || ""}
                                                onChange={(e) =>
                                                  this.handlePostDischargeChange(
                                                    index,
                                                    "instructions",
                                                    e.target.value
                                                  )
                                                }
                                                placeholder="Add instructions"
                                                className={
                                                  this.state
                                                    .postDischargeMedErrors[
                                                    index
                                                  ]?.instructions
                                                    ? "is-invalid"
                                                    : ""
                                                }
                                                disabled={isChemoPastDate}
                                              />
                                              {this.state
                                                .postDischargeMedErrors[index]
                                                ?.instructions && (
                                                <div className="invalid-feedback d-block">
                                                  {
                                                    this.state
                                                      .postDischargeMedErrors[
                                                      index
                                                    ].instructions
                                                  }
                                                </div>
                                              )}
                                            </td>
                                            <td>
                                              {!isChemoPastDate && (
                                              <span
                                                className="delete-icon1"
                                                onClick={() => {
                                                  if (
                                                    med.medicine
                                                      ?.medicineListXrefId
                                                  ) {
                                                    this.deletePatientPostDischargeMedicine(
                                                      med.medicine
                                                        .medicineListXrefId
                                                    ).then((success) => {
                                                      if (success) {
                                                        this.removePostDischargeRow(
                                                          index
                                                        );
                                                      }
                                                    });
                                                  } else {
                                                    this.removePostDischargeRow(
                                                      index
                                                    );
                                                  }
                                                }}
                                                style={{
                                                  cursor: "pointer",
                                                  color: "#dc3545",
                                                  fontSize: "18px",
                                                  padding: "4px 8px",
                                                }}
                                              >
                                                ✕
                                              </span>
                                              )}
                                            </td>
                                          </tr>
                                        )
                                      )}
                                    </tbody>
                                  </table>
                                </div>
                              </Col>
                            </Row>
                            <Row>
                              <Col lg="12" className="mt-2">
                                <Button
                                  variant="secondary"
                                  className="mr-2"
                                  onClick={
                                    this.handleSavePostDischargeMedsClick
                                  }
                                  disabled={this.state.saveLoader || isChemoPastDate}
                                >
                                  {this.state.saveLoader ? (
                                    <>
                                      <span
                                        className="spinner-border spinner-border-sm mr-2"
                                        role="status"
                                        aria-hidden="true"
                                      ></span>
                                      <span>Saving...</span>
                                    </>
                                  ) : (
                                    "Save Medicines"
                                  )}
                                </Button>
                                <Button
                                  variant="outline-secondary"
                                  onClick={this.handleAddPostDischargeRow}
                                  disabled={isChemoPastDate}
                                >
                                  Add Medicine
                                </Button>
                              </Col>
                            </Row>
                          </Container>
                            );
                          }
                        })()}
                          <br />
                          <br />
                          <br />
                          <br />
                          <br />
                          <br />

                          <Container
                            fluid
                            className="p-0 mt-4"
                            style={{ marginTop: "4rem !important" }}
                          >
                            <Row>
                              <Col lg="12">
                                <div className="footer form-button text-center mt-2">
                                  {/* <Button type="button" className="btn btn-secondary mr-2" onClick={this.submitChemoSitting.bind(this)}>
                                                                        {this.state.saveLoader && (
                                                                            <Spinner className='mr-3' animation='border' size='1.5rem' />
                                                                        )}
                                                                        {!this.state.saveLoader && (
                                                                            <FaSave className='mr-2' size='1.5rem' style={{ verticalAlign: "sub" }} />
                                                                        )}
                                                                        Save
                                                                    </Button> */}
                                  {this.state.patChemoSittingIdPC != "0" &&
                                    this.state.patChemoSittingIdPC != "" && (
                                      <Form.Check
                                        className="mr-2"
                                        type="checkbox"
                                        id="chemo-given-checkbox"
                                        disabled={isChemoPastDate}
                                        style={{
                                          display: "inline-flex",
                                          alignItems: "center",
                                          verticalAlign: "middle",
                                        }}
                                      >
                                        <Form.Check.Input
                                          type="checkbox"
                                          checked={this.state.chemoGivenPC}
                                          onChange={(e) => {
                                            this.setState({
                                              chemoGivenPC: e.target.checked,
                                            });
                                          }}
                                          disabled={isChemoPastDate}
                                          style={{
                                            position: "static",
                                            margin: 0,
                                          }}
                                        />
                                        <Form.Check.Label
                                          style={{
                                            marginBottom: 0,
                                            marginLeft: "3px",
                                          }}
                                        >
                                          Chemo Given
                                        </Form.Check.Label>
                                      </Form.Check>
                                    )}

                                  {(() => {
                                    if (isHospitalStaff) {
                                      // If the user is hospital staff, disable the button
                                      return (
                                        <Button
                                          type="button"
                                          className="btn btn-secondary mr-2"
                                          onClick={this.submitChemoSitting.bind(
                                            this
                                          )}
                                          disabled={true} // Disable the button
                                        >
                                          {this.state.saveLoader && (
                                            <Spinner
                                              className="mr-3"
                                              animation="border"
                                              size="1.5rem"
                                            />
                                          )}
                                          {!this.state.saveLoader && (
                                            <FaSave
                                              className="mr-2"
                                              size="1.5rem"
                                              style={{ verticalAlign: "sub" }}
                                            />
                                          )}
                                          Save
                                        </Button>
                                      );
                                    } else {
                                      // If the user is not hospital staff, enable the button (unless chemo date is in the past)
                                      return (
                                        <Button
                                          type="button"
                                          className="btn btn-secondary mr-2"
                                          onClick={this.submitChemoSitting.bind(
                                            this
                                          )}
                                          disabled={isChemoPastDate}
                                        >
                                          {this.state.saveLoader && (
                                            <Spinner
                                              className="mr-3"
                                              animation="border"
                                              size="1.5rem"
                                            />
                                          )}
                                          {!this.state.saveLoader && (
                                            <FaSave
                                              className="mr-2"
                                              size="1.5rem"
                                              style={{ verticalAlign: "sub" }}
                                            />
                                          )}
                                          Save
                                        </Button>
                                      );
                                    }
                                  })()}

                                  {(() => {
                                    if (
                                      isHospitalStaff ||
                                      (this.state.patChemoSittingIdPC === "" &&
                                        this.state.chemoDtPC === "")
                                    ) {
                                      return (
                                        <Button
                                          className="btn-secondary mr-2  "
                                          onClick={() =>
                                            this.getTreatmentDataForNewChemo()
                                          }
                                          disabled={true}
                                        >
                                          New Chemo
                                        </Button>
                                      );
                                    } else if (
                                      isHospitalStaff ||
                                      (this.formatDateDDMMYYYY(
                                        this.state.chemoDtPC
                                      ) == this.formatDateDDMMYYYY(new Date()) &&
                                        this.state.chemoDtPC != "")
                                    ) {
                                      return (
                                        <Button
                                          className="btn-secondary mr-2  "
                                          onClick={() =>
                                            this.getTreatmentDataForNewChemo()
                                          }
                                          disabled={true}
                                        >
                                          New Chemo
                                        </Button>
                                      );
                                    } else {
                                      return (
                                        //<Button type="button" className="btn btn-secondary mr-2" onClick={this.addNewChemoSitting.bind(this)}><FaPlus className='mr-2' size='1.5rem' style={{ verticalAlign: "sub" }} />New Chemo</Button>
                                        <Button
                                          className="btn-secondary mr-2  "
                                          onClick={() =>
                                            this.getTreatmentDataForNewChemo()
                                          }
                                        >
                                          New Chemo
                                        </Button>
                                      );
                                    }
                                  })()}
                                  {(() => {
                                    if (
                                      this.state.patChemoSittingIdPC != "0" &&
                                      this.state.patChemoSittingIdPC != ""
                                    ) {
                                      return (
                                        <span className="output">
                                          <Dropdown>
                                            <Dropdown.Toggle
                                              className="btn btn-info mr-2"
                                              id="dropdown-basic"
                                            >
                                              Send Chemo Treatment
                                            </Dropdown.Toggle>
                                            <Dropdown.Menu>
                                              <Link
                                                className="dropdown-item"
                                                target="_blank"
                                                to={{
                                                  pathname: "/ChemoTemplate",
                                                  search:
                                                    "p=" +
                                                    this.state
                                                      .patChemoSittingIdPC,
                                                }}
                                              >
                                                To Doctor
                                              </Link>
                                              <Link
                                                className="dropdown-item"
                                                target="_blank"
                                                to={{
                                                  pathname:
                                                    "/ChemoTemplateForNurse",
                                                  search:
                                                    "p=" +
                                                    this.state
                                                      .patChemoSittingIdPC,
                                                }}
                                              >
                                                To Nurse
                                              </Link>
                                              <Link
                                                className="dropdown-item"
                                                target="_blank"
                                                to={{
                                                  pathname:
                                                    "/ChemoTemplateForPatient",
                                                  search:
                                                    "p=" +
                                                    this.state
                                                      .patChemoSittingIdPC,
                                                }}
                                              >
                                                To Patient
                                              </Link>
                                              <Link
                                                className="dropdown-item"
                                                target="_blank"
                                                to={{
                                                  pathname:
                                                    "/ChemoTemplateForPharmacist",
                                                  search:
                                                    "p=" +
                                                    this.state
                                                      .patChemoSittingIdPC,
                                                }}
                                              >
                                                To Pharmacist
                                              </Link>
                                              {this.isAOCUser() && (
                                                <Link
                                                  className="dropdown-item"
                                                  target="_blank"
                                                  to={{
                                                    pathname:
                                                      "/ChemoTemplateToAOC",
                                                    search:
                                                      "p=" +
                                                      this.state
                                                        .patChemoSittingIdPC,
                                                  }}
                                                >
                                                  {" "}
                                                  To AOC
                                                </Link>
                                              )}
                                              <Link
                                                className="dropdown-item"
                                                target="_blank"
                                                to={{
                                                  pathname: "/CurrentDischargeSummary",
                                                  search:
                                                    "p=" +
                                                    this.state
                                                      .patChemoSittingIdPC,
                                                }}
                                              >
                                                Discharge Summary
                                              </Link>
                                            </Dropdown.Menu>
                                          </Dropdown>
                                        </span>
                                      );
                                    }
                                  })()}
                                  {/* {(() => {
                                                                        if (isHospitalStaff) {
                                                                            return (
                                                                                <Button className="btn btn-info mr-2" onClick={() => this.setState({ showAssessFNRisk: true })} disabled={true}>
                                                                                    <FaPlus className='mr-2' size='1.5rem' style={{ verticalAlign: "sub" }} />Assess FN Risk (Intermediate)
                                                                                </Button>
                                                                            )
                                                                        } else if (this.state.fnRiskTmt === 'I' && this.state.assesFNRiskFlag === 'N') {
                                                                            return (
                                                                                <Button className="btn btn-info mr-2" onClick={() => this.setState({ showAssessFNRisk: true })}>
                                                                                    <FaPlus className='mr-2' size='1.5rem' style={{ verticalAlign: "sub" }} />Assess FN Risk (Intermediate)
                                                                                </Button>
                                                                            )
                                                                        }
                                                                    })()} */}
                                  {this.state.patAllChemoSittings.length >= 1 && (
                                  <Button
                                    className="btn btn-info"
                                    title="View Previous Chemo"
                                    onClick={this.viewChemoList}
                                  >
                                    View Previous Chemo
                                  </Button>
                                  )}
                                </div>
                              </Col>
                            </Row>
                          </Container>
                        </Tab>
                      </Tabs>

                      <Modal
                        id=""
                        show={this.state.showAntimetic}
                        centered
                        animation={true}
                        scrollable={true}
                        size="xl"
                      >
                        <Modal.Header
                          closeButton
                          onClick={() =>
                            this.setState({ showAntimetic: false })
                          }
                        >
                          <Modal.Title>
                            <h3 className="fs-18 header_title mb-0 text-black">
                              Antiemetic Medication
                            </h3>
                          </Modal.Title>
                        </Modal.Header>

                        <Modal.Body>
                          <Container fluid>
                            <Row>
                              <Col lg="2" className="pl-0">
                                <Form.Group>
                                  <Form.Label>Antiemetic Treatment</Form.Label>
                                  <Form.Control
                                    as="select"
                                    id="antiemeticTreatment"
                                    name="antiemeticTreatment"
                                    value={this.state.antiemeticRegimensId || ""}
                                    onChange={this.handleOptionChange}
                                  >
                                    <option value="-1">
                                      - Select Antiemetic Treatment -
                                    </option>
                                    {this.state.antiemeticRegimensMstArr.map(
                                      (item, i) => {
                                        return (
                                          <option
                                            key={item.key}
                                            value={item.id}
                                          >{`${item.label}`}</option>
                                        );
                                      }
                                    )}
                                  </Form.Control>
                                </Form.Group>
                              </Col>
                              <Col lg="12">
                                <Row>
                                  {this.state.showOptionOne &&
                                    this.state.antiemeticTreatmentMstArr.map(
                                      (item, i) => {
                                        return (
                                          <AntiemeticTreatmentOption
                                            key={i}
                                            itemData={item}
                                            onChange={
                                              this.setAntiemeticRisksValue
                                            }
                                            selectedOptions={
                                              this.state.selectedOptions
                                            }
                                            disableForDexamethasone={
                                              this.state.disableForDexamethasone
                                            }
                                            onSave={(selectedTreatment) =>
                                              this.setState({
                                                antiemeticRisks:
                                                  selectedTreatment,
                                              })
                                            }
                                          />
                                        );
                                      }
                                    )}
                                </Row>
                              </Col>
                            </Row>
                          </Container>
                        </Modal.Body>
                        <Modal.Footer>
                          <Row>
                            <Col
                              lg="12"
                              className="form-button text-center mt-2"
                            >
                              <Button
                                className="btn btn-info mr-1"
                                onClick={this.handleSaveAntiemeticTreatment}
                              >
                                Save
                              </Button>
                            </Col>
                          </Row>
                        </Modal.Footer>
                      </Modal>
                      <Modal
                        id=""
                        show={this.state.showAntithrombotic}
                        centered
                        animation={true}
                        scrollable={true}
                        size="md"
                      >
                        <Modal.Header
                          closeButton
                          onClick={() =>
                            this.setState({ showAntithrombotic: false })
                          }
                        >
                          <Modal.Title>
                            <h3 className="fs-18 header_title mb-0 text-black">
                              Antithrombotic Medication
                            </h3>
                          </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <Container fluid>
                            <Row>
                              <Col lg="12">
                                <div className="">
                                  <Form.Check
                                    name="groupThree"
                                    type="radio"
                                    id="antithrombotic-option-1"
                                    onChange={this.radioChange}
                                    value="Apixaban 2.5 mg PO BID (for 6 months)"
                                    checked={this.state.antithromboticDrugs === "Apixaban 2.5 mg PO BID (for 6 months)"}
                                    label="Apixaban 2.5 mg PO BID (for 6 months)"
                                  />
                                  <Form.Check
                                    name="groupThree"
                                    type="radio"
                                    id="antithrombotic-option-2"
                                    onChange={this.radioChange}
                                    value="Rivaroxaban 10 mg PO QD (for 6 months)"
                                    checked={this.state.antithromboticDrugs === "Rivaroxaban 10 mg PO QD (for 6 months)"}
                                    label="Rivaroxaban 10 mg PO QD (for 6 months)"
                                  />
                                </div>
                              </Col>
                            </Row>
                          </Container>
                        </Modal.Body>
                        <Modal.Footer>
                          <Row>
                            <Col
                              lg="12"
                              className="form-button text-center mt-2"
                            >
                              <Button
                                className="btn btn-info mr-1"
                                onClick={() =>
                                  this.setState({ showAntithrombotic: false })
                                }
                              >
                                {" "}
                                Save{" "}
                              </Button>
                            </Col>
                          </Row>
                        </Modal.Footer>
                      </Modal>
                      <Modal
                        id=""
                        show={this.state.showGCSF}
                        centered
                        animation={true}
                        scrollable={true}
                        size="lg"
                      >
                        <Modal.Header
                          closeButton
                          onClick={() => this.setState({ showGCSF: false })}
                        >
                          <Modal.Title>
                            <h3 className="fs-18 header_title mb-0 text-black">
                              GCSF Medication
                            </h3>
                          </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <Container fluid>
                            <Row>
                              <Col lg="12">
                                <div className="">
                                  <Form.Check
                                    name="groupTwo"
                                    type="radio"
                                    id="gcsf-option-1"
                                    value="Injection GCSF 300 microgram subcutaneous start on 24hrs after chemo theraphy"
                                    checked={this.state.gcsfMedicinePC === "Injection GCSF 300 microgram subcutaneous start on 24hrs after chemo theraphy"}
                                    onChange={this.radioGCSFChange}
                                    label="Injection GCSF 300 microgram subcutaneous start on 24hrs after chemo theraphy"
                                  />

                                  <Form.Check
                                    name="groupTwo"
                                    type="radio"
                                    id="gcsf-option-2"
                                    label="Injection Peglyated GCSF 6mg subcutaneous OD on 24hrs after chemo theraphy"
                                    checked={this.state.gcsfMedicinePC === "Injection Peglyated GCSF 6mg subcutaneous OD on 24hrs after chemo theraphy"}
                                    onChange={this.radioGCSFChange}
                                    value="Injection Peglyated GCSF 6mg subcutaneous OD on 24hrs after chemo theraphy"
                                  />
                                </div>
                              </Col>
                            </Row>
                          </Container>
                        </Modal.Body>
                        <Modal.Footer>
                          <Row>
                            <Col
                              lg="12"
                              className="form-button text-center mt-2"
                            >
                              <Button
                                className="btn btn-info mr-1"
                                onClick={() =>
                                  this.setState({ showGCSF: false })
                                }
                              >
                                {" "}
                                Save{" "}
                              </Button>
                            </Col>
                          </Row>
                        </Modal.Footer>
                      </Modal>
                      <Modal
                        id=""
                        show={this.state.showBoneModification}
                        centered
                        animation={true}
                        scrollable={true}
                        size="lg"
                      >
                        <Modal.Header
                          closeButton
                          onClick={() =>
                            this.setState({ showBoneModification: false })
                          }
                        >
                          <Modal.Title>
                            <h3 className="fs-18 header_title mb-0 text-black">
                              Bone Modification Medication
                            </h3>
                          </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <Container fluid>
                            <Row>
                              <Col lg="12">
                                <div className="">
                                  <Form.Check
                                    name="groupOne"
                                    type="radio"
                                    onChange={this.radioButtonBone}
                                    value="Denosumab (Xgeva) at 120 mg subcutaneously every 4 weeks"
                                    label="Denosumab (Xgeva) at 120 mg subcutaneously every 4 weeks"
                                  />
                                  <Form.Check
                                    name="groupOne"
                                    type="radio"
                                    onChange={this.radioButtonBone}
                                    value="Pamidronate at 90 mg intravenously (IV) every 3 to 4 weeks"
                                    label="Pamidronate at 90 mg intravenously (IV) every 3 to 4 weeks"
                                  />
                                  <Form.Check
                                    name="groupOne"
                                    type="radio"
                                    onChange={this.radioButtonBone}
                                    value="Zoledronate at 4 mg IV every 12 weeks or every 3 to 4 weeks"
                                    label="Zoledronate at 4 mg IV every 12 weeks or every 3 to 4 weeks. "
                                  />
                                </div>
                              </Col>
                            </Row>
                          </Container>
                        </Modal.Body>
                        <Modal.Footer>
                          <Row>
                            <Col
                              lg="12"
                              className="form-button text-center mt-2"
                            >
                              <Button
                                className="btn btn-info mr-1"
                                onClick={() =>
                                  this.setState({ showBoneModification: false })
                                }
                              >
                                {" "}
                                Save{" "}
                              </Button>
                            </Col>
                          </Row>
                        </Modal.Footer>
                      </Modal>

                      <Modal
                        show={this.state.alertModalshow}
                        animation={true}
                        centered
                        id="alertBox"
                        size="md"
                      >
                        <Modal.Body
                          onClick={() =>
                            this.setState({ alertModalshow: false })
                          }
                        >
                          <Container className="p-2">
                            <Alert>
                              <Alert.Heading className="mb-0 fs-20">
                                <FaRegCheckCircle
                                  className="mb-2 pb-4 checkIcon"
                                  style={{ fontSize: "80px" }}
                                />
                                <p className="mb-2">Success !!</p>
                              </Alert.Heading>
                              <p className="justify-content-center d-flex">
                                Initial assesment saved succesfully.
                              </p>
                            </Alert>
                          </Container>
                        </Modal.Body>
                      </Modal>
                      <Modal
                        show={this.state.treatmentPlanshow}
                        animation={true}
                        centered
                        id="alertBox"
                        size="md"
                      >
                        <Modal.Body
                          onClick={() =>
                            this.setState({ treatmentPlanshow: false })
                          }
                        >
                          <Container className="p-2">
                            <Alert>
                              <Alert.Heading className="mb-0 fs-20">
                                <FaRegCheckCircle
                                  className="mb-2 pb-4 checkIcon"
                                  style={{ fontSize: "80px" }}
                                />
                                <p className="mb-2">Success !!</p>
                              </Alert.Heading>
                              <p className="justify-content-center d-flex">
                                Treatment plan saved successfully.
                              </p>
                            </Alert>
                          </Container>
                        </Modal.Body>
                      </Modal>
                      <Modal
                        show={this.state.chemoshow}
                        animation={true}
                        centered
                        id="alertBox"
                        size="md"
                      >
                        <Modal.Body
                          onClick={() => this.setState({ chemoshow: false })}
                        >
                          <Container className="p-2">
                            <Alert>
                              <Alert.Heading className="mb-0 fs-20">
                                <FaRegCheckCircle
                                  className="mb-2 pb-4 checkIcon"
                                  style={{ fontSize: "80px" }}
                                />
                                <p className="mb-2">Success !!</p>
                              </Alert.Heading>
                              <p className="justify-content-center d-flex">
                                Chemo sitting saved successfully.
                              </p>
                            </Alert>
                          </Container>
                        </Modal.Body>
                      </Modal>
                      <Modal
                        show={this.state.followupshow}
                        animation={true}
                        centered
                        id="alertBox"
                        size="md"
                      >
                        <Modal.Body
                          onClick={() => this.setState({ followupshow: false })}
                        >
                          <Container className="p-2">
                            <Alert>
                              <Alert.Heading className="mb-0 fs-20">
                                <FaRegCheckCircle
                                  className="mb-2 pb-4 checkIcon"
                                  style={{ fontSize: "80px" }}
                                />
                                <p className="mb-2">Success !!</p>
                              </Alert.Heading>
                              <p className="justify-content-center d-flex">
                                Followup appointment saved successfully.
                              </p>
                            </Alert>
                          </Container>
                        </Modal.Body>
                      </Modal>

                      <Modal
                        show={this.state.consentMsgshow}
                        animation={true}
                        centered
                        id="alertBox"
                        size="md"
                      >
                        <Modal.Body
                          onClick={() =>
                            this.setState({ consentMsgshow: false })
                          }
                        >
                          <Container className="p-2">
                            <Alert>
                              <Alert.Heading className="mb-0 fs-20">
                                <FaRegCheckCircle
                                  className="mb-2 pb-4 checkIcon"
                                  style={{ fontSize: "80px" }}
                                />
                                <p className="mb-2">Success !!</p>
                              </Alert.Heading>
                              <p className="justify-content-center d-flex">
                                Consent uploaded successfully.
                              </p>
                            </Alert>
                          </Container>
                        </Modal.Body>
                      </Modal>
                      <MultipleChemoPopup
                        showMultipleChemoPopup={
                          this.state.showMultipleChemoPopup
                        }
                        closeModal={() => this.closeTerminateProtocol()}
                      />
                      <NewReport
                        show={reportModal}
                        data={selectedApptReportData}
                        protocolId={regProtocolIdTmt}
                        mode={reportMode}
                        appointmentId={appointmentId}
                        patientId={patientId}
                        closeModal={() => this.closeReportHandler()}
                        reportSavedSuccess={() =>
                          this.reportSavedSuccessHandler()
                        }
                      />
                      {this.state.fnRiskTmt == "I" &&
                        this.state.assesFNRiskFlag == "N" && (
                          <AssessFNRisk
                            onConfirm={this.setAssesFNRiskFlag}
                            showAssessFNRisk={this.state.showAssessFNRisk}
                            closeModal={() => this.closeAssessFNRiskModal()}
                          />
                        )}
                      <Modal
                        show={this.state.showPrescriptionModal}
                        onHide={this.closePrescriptionModal}
                        centered
                      >
                        <Modal.Header closeButton>
                          <Modal.Title>Upload Report</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <Form.Group className="mb-2">
                            <Form.Label>Type</Form.Label>
                            {this.state.documentTypeOptions.length > 0 ? (
                              <Form.Control
                                as="select"
                                value={this.state.prescriptionTypeId}
                                autoFocus
                                isInvalid={!!this.state.prescriptionTypeError}
                                onChange={(e) =>
                                  this.setState({
                                    prescriptionTypeId: e.target.value,
                                    prescriptionTypeError: "",
                                  })
                                }
                              >
                                <option value="">- Select type of report -</option>
                                {this.state.documentTypeOptions.map((item) => (
                                  <option
                                    key={item.documentTypeId}
                                    value={item.documentTypeId}
                                  >
                                    {item.documentType}
                                  </option>
                                ))}
                              </Form.Control>
                            ) : (
                              /* Falls back to free text when the type master is
                                 unavailable; the backend resolves it by name. */
                              <Form.Control
                                type="text"
                                placeholder="Enter type of report"
                                maxLength={50}
                                value={this.state.prescriptionType}
                                autoFocus
                                isInvalid={!!this.state.prescriptionTypeError}
                                onChange={(e) =>
                                  this.setState({
                                    prescriptionType: e.target.value,
                                    prescriptionTypeError: "",
                                  })
                                }
                              />
                            )}
                            {this.state.prescriptionTypeError && (
                              <div className="text-danger mt-1">
                                {this.state.prescriptionTypeError}
                              </div>
                            )}
                          </Form.Group>
                          <Form.Group className="mb-2">
                            <Form.Label>File</Form.Label>
                            <div>
                              <input
                                ref={(input) => {
                                  this.fileInput = input;
                                }}
                                type="file"
                                multiple
                                accept={this.getDocumentAcceptAttr()}
                                onChange={this.handleFileSelect}
                                style={{ display: "none" }}
                              />
                              <Button
                                variant="secondary"
                                onClick={this.triggerFileInput}
                              >
                                Browse
                              </Button>
                            </div>
                            {this.state.prescriptionPendingFiles.length > 0 && (
                              <ul className="list-unstyled mt-2 mb-0">
                                {this.state.prescriptionPendingFiles.map((file) => (
                                  <li key={file.name} className="text-truncate" title={file.name}>
                                    📄 {file.name}
                                  </li>
                                ))}
                              </ul>
                            )}
                            {this.state.prescriptionFileError && (
                              <div className="text-danger mt-1">
                                {this.state.prescriptionFileError}
                              </div>
                            )}
                          </Form.Group>
                        </Modal.Body>
                        <Modal.Footer>
                          <Button
                            variant="secondary"
                            onClick={this.submitPrescriptionUpload}
                          >
                            Upload
                          </Button>
                          <Button
                            variant="outline-secondary"
                            onClick={this.closePrescriptionModal}
                          >
                            Cancel
                          </Button>
                        </Modal.Footer>
                      </Modal>
                      <ProtocolSelectionPopup
                        show={this.state.showTreatmentPlanConfirm}
                        onHide={() => this.setState({ showTreatmentPlanConfirm: false })}
                        onConfirm={this.handleProtocolConfirmed}
                        firstName={this.state.firstName}
                        lastName={this.state.lastName}
                        diagnosisDate={this.state.diagnosisDate}
                        diagnosisPrimarySite={this.state.diagnosisPrimarySite}
                        diagnosisPrimarySites={this.state.diagnosisPrimarySites}
                      />
                      <NewTreatmentPlan
                        showNewTreatment={this.state.showNewTreatment}
                        closeModal={() => this.closeNewTreatmentPlan()}
                        patientId={this.state.patientId}
                        patTreatPlanId={this.state.treatmentPlanIdTmt}
                        genderName={this.state.genderName}
                        patChemoSittingIdPC={this.state.patChemoSittingIdPC}
                        isHospitalStaff={this.state.isHospitalStaff}
                        treatmentPlanSavedSuccess={(obj) =>
                          this.treatmentPlanSavedSuccessHandler(obj)
                        }
                        doctorId={this.state.doctorId}
                        ref={this.treatmentPlanChild}
                        formattedAllergies={this.state.formattedAllergies}
                        formattedComorbidities={
                          this.state.formattedComorbidities
                        }
                        otherComorbidities={this.state.otherComorbidities}
                        otherAllergies={this.state.otherAllergies}
                        diagnosisDate={this.state.diagnosisDate}
                        preselectedProtocol={this.state.preselectedProtocol}
                        protocolFilterSiteIds={this.state.protocolFilterSiteIds}
                        prefetchedProtocols={this.state.prefetchedProtocols}
                      />
                      <TerminateProtocol
                        showTerminateProtocol={this.state.showTerminateProtocol}
                        patientId={this.state.patientId}
                        doctorId={this.state.doctorId}
                        treatPlanId={this.state.terminateTreatmentPlanId}
                        closeModal={() => this.closeTerminateProtocol()}
                      />
                      <MultipleTreatmentPopup
                        showMultipleTreatmentPopup={
                          this.state.showMultipleTreatmentPopup
                        }
                        closeModal={() => this.closeMultipleTreatmentPopup()}
                        patientId={this.state.patientId}
                        multipleTreatmentSavedSuccess={(
                          objTreatment,
                          objProtocol,
                          cascadeTreatPlanIds,
                          warningMsgConsent
                        ) =>
                          this.setMultipleTreatmentPlanIdHandler(
                            objTreatment,
                            objProtocol,
                            cascadeTreatPlanIds,
                            warningMsgConsent
                          )
                        }
                        ref={this.chemoNewButtonChild}
                      />
                      <SkippedCyclesPopup
                        showSkippedCyclesPopup={
                          this.state.showSkippedCyclesPopup
                        }
                        closeModal={() => this.closeSkippedCyclesPopup()}
                        patientId={this.state.patientId}
                        registerDeviationSuccess={() => {
                          this.closeSkippedCyclesPopup();
                          this.addNewFollowup();
                        }}
                        ref={this.skippedCyclesChild}
                      />
                      {this.state.showTreatmentList ? (
                        <>
                          <TreatmentList
                            patientId={this.state.patientId}
                            showTreatmentList={this.state.showTreatmentList}
                            closeModal={() => this.closeTreatmentList()}
                          />
                        </>
                      ) : null}
                      {this.state.showFollowupList ? (
                        <>
                          <FollowupList
                            followupReports={this.state.followupReports}
                            patientId={this.state.patientId}
                            selectedApptReportData={
                              this.state.selectedApptReportData
                            }
                            appointmentId={this.state.appointmentId}
                            mode={this.state.reportMode}
                            showFollowupList={this.state.showFollowupList}
                            closeModal={() => this.closeFollowupList()}
                          />
                        </>
                      ) : null}
                      {this.state.showChemoList ? (
                        <>
                          <ChemoList
                            patAllChemoSittings={this.state.patAllChemoSittings}
                            patientId={this.state.patientId}
                            showChemoList={this.state.showChemoList}
                            closeModal={() => this.closeChemoList()}
                          />
                        </>
                      ) : null}
                      <CasePreview
                        show={this.state.previewModal}
                        closeModal={() => this.closePreviewModalHandler()}
                      />
                      <Loader show={this.state.loaderModal} />
                      <ErrorAlert
                        show={this.state.errorAlertshow}
                        alertBody={"Something went wrong. Please try again"}
                      />

                      <Modal
                        show={this.state.showConsent}
                        animation={true}
                        scrollable={true}
                        centered
                        size="md"
                      >
                        <Modal.Header
                          closeButton
                          onClick={() => this.setState({ showConsent: false })}
                        >
                          <Modal.Title>
                            <h3 className="fs-18 header_title mb-0 text-black">
                              Upload Consent
                            </h3>
                          </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                          <Container fluid>
                            <Row>
                              <Col lg="12" className="mb-2 pb-4">
                                {(() => {
                                  if (this.state.genderName == "Female") {
                                    return (
                                      <Link
                                        target="_blank"
                                        to={{
                                          pathname: "/ConsentFormFemale",
                                          search:
                                            "p=" +
                                            this.state.treatmentPlanIdTmt,
                                        }}
                                      >
                                        <FaDownload /> Click to download consent
                                        form and upload it below
                                      </Link>
                                    );
                                  } else {
                                    return (
                                      <Link
                                        target="_blank"
                                        to={{
                                          pathname: "/ConsentFormMale",
                                          search:
                                            "p=" +
                                            this.state.treatmentPlanIdTmt,
                                        }}
                                      >
                                        <FaDownload /> Click to download consent
                                        form and upload it below
                                      </Link>
                                    );
                                  }
                                })()}
                              </Col>
                              <Col lg="12" className="text-center">
                                <Form.Group>
                                  <Form.File
                                    ref={this.fileInputRef} // Use ref to access file input
                                    type="file"
                                    className="p-0"
                                    id="inputGroupFile01"
                                    accept="image/*, video/*, application/pdf"
                                    onChange={(e) =>
                                      this.consentAttachmentHandler(
                                        e,
                                        "someCardId"
                                      )
                                    }
                                  />
                                  <div className="invalid-feedback">
                                    {
                                      this.state.treatmentPlanErrors[
                                        "consentAttachment"
                                      ]
                                    }
                                  </div>
                                </Form.Group>
                              </Col>
                              <Button
                                className="Primary"
                                style={{ fontWeight: "bold" }}
                                onClick={() =>
                                  this.setState({ showVideoConsent: true })
                                }
                              >
                                Video Consent
                              </Button>

                              <Col lg="12" className="text-center">
                                Or
                              </Col>
                              <Col lg="12">
                                <Form.Check
                                  className="pt-4 pl-0"
                                  type="checkbox"
                                  id="check-terms"
                                  label="Physical consent has been taken."
                                  onClick={(e) =>
                                    this.consentWaive(
                                      e,
                                      this.state.currentCardId
                                    )
                                  }
                                ></Form.Check>
                              </Col>
                              {this.state.waiverConsent && ( // Simplified conditional rendering
                                <Col lg="12">
                                  <Form.Group>
                                    <Form.Control
                                      as="textarea"
                                      placeholder="Additional comments"
                                      name="waiverComments"
                                      value={this.state.waiverComments || ""} // Use value instead of defaultValue
                                      rows={2}
                                      onChange={this.handleTreatPlanChange} // Handle change to update state
                                    />
                                  </Form.Group>
                                </Col>
                              )}
                            </Row>
                          </Container>
                        </Modal.Body>
                        <Modal.Footer>
                          <Row>
                            <Col lg="12" className="text-center">
                              <Button
                                className="btn btn-secondary"
                                onClick={this.saveConsentForm.bind(this)}
                                disabled={
                                  !this.state.isConsentProvided[
                                    this.state.currentCardId
                                  ]
                                }
                              >
                                Upload
                              </Button>

                              <Button
                                variant="outline-danger"
                                className="mr-1"
                                onClick={() =>
                                  this.setState({ showConsent: false })
                                }
                              >
                                Cancel
                              </Button>
                            </Col>
                          </Row>
                        </Modal.Footer>
                        {this.state.showVideoConsent && (
                          <VideoConsent
                            patientId={patientId}
                            treatmentPlanIdTmt={treatmentPlanIdTmt}
                            firstName={firstName}
                            lastName={lastName}
                            onClose={this.closeVideoConsent}
                            onSelectVideo={this.onSelectVideo}
                          />
                        )}
                      </Modal>
                    </div>
                  </div>
                </section>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
